// AUTO-GENERATED FILE — DO NOT EDIT DIRECTLY
// Source of truth: config/locales/*.yml
// Regenerate: bundle exec rake i18n:js:export

export const translations = {
  "es": {
    "terms": {
      "head": {
        "conditions": "Términos del Servicio",
        "privacy": "Políticas de Privacidad",
        "cookies": "Políticas sobre Cookies.",
        "you_as_a_consumer": "Ud. como consumidor tiene el deber de informarse sobre la documentación que podría necesitar para poder realizar su viaje conforme a lo planeado. Verifique con tiempo si requiere pasaporte, visa, vacunas, permiso para menores u otras exigencias de documentos tanto para la entrada a Chile, como los países en tránsito. Si la requiere y no dispone de ella, haga los trámites necesarios para obtenerla con anticipación."
      }
    },
    "devise": {
      "google_sign_in": "Conectarse con Google",
      "facebook_sign_in": "Conectarse con Facebook",
      "apple_sign_in": "Conectarse con Apple",
      "already_have_an_account?": "¿Ya tienes una cuenta?",
      "didn't_receive_confirmation_instructions?": "¿No recibiste las instrucciones de confirmación?",
      "didn't_receive_unlock_instructions?": "¿No recibiste las instrucciones de desbloqueo?",
      "forgot_your_password?": "¿Olvidaste tu contraseña?",
      "don't_have_an_account?": "¿No tienes una cuenta?",
      "enter_email_associated": "Ingresa el correo electrónico asociado a tu cuenta y te enviaremos un email con un enlace para restablecer tu contraseña.",
      "passwordless": {
        "not_found_in_database": "No se encontró un usuario para esa dirección de correo electrónico",
        "magic_link_sent": "Se le ha enviado un enlace de inicio de sesión a su dirección de correo electrónico. Por favor siga el enlace para iniciar sesión en su cuenta.",
        "magic_link_sent_paranoid": "Si su cuenta existe, recibirá un correo electrónico con un enlace de inicio de sesión. Por favor siga el enlace para iniciar sesión en su cuenta."
      },
      "confirmations": {
        "confirmed": "Tu cuenta ya ha sido confirmada. Has sido indentificado.",
        "send_instructions": "Recibirás un correo electrónico en unos minutos con instrucciones sobre cómo reestablecer tu contraseña.",
        "send_paranoid_instructions": "Si tu correo electrónico existe en nuestra base de datos, recibirás un correo electrónico en unos minutos con instrucciones sobre cómo reiniciar tu contraseña."
      },
      "failure": {
        "magic_link_invalid": "Enlace de inicio de sesión inválido o expirado.",
        "already_authenticated": "Ya estás identificado.",
        "inactive": "Tu cuenta aún no ha sido activada.",
        "invalid": "Correo o contraseña inválidos.",
        "invalid_token": "Cadena de autenticación invalida.",
        "locked": "Tu cuenta está bloqueada.",
        "not_found_in_database": "Correo o contraseña inválidos.",
        "timeout": "Tu sesión ha expirado, por favor identifícate de nuevo para continuar.",
        "unauthenticated": "Necesitas iniciar sesión o registrarte para continuar.",
        "unconfirmed": "Debes de confirmar tu cuenta para continuar."
      },
      "mailer": {
        "magic_link": {
          "subject": "Link de inicio de sesión",
          "greeting": "¡Hola %{email}!",
          "instructions": "Puedes iniciar sesión usando el siguiente enlace:",
          "login_button": "Iniciar sesión en mi cuenta",
          "expiration_notice": "Ten en cuenta que el enlace expirará en %{expiration_time}."
        },
        "confirmation_instructions": {
          "subject": "Instrucciones de confirmación"
        },
        "reset_password_instructions": {
          "subject": "Instrucciones para reestablecer tu contraseña"
        },
        "unlock_instructions": {
          "subject": "Instrucciones de desbloqueo"
        }
      },
      "omniauth_callbacks": {
        "failure": "No se te pudo autorizar de %{kind} debido a \"%{reason}\".",
        "success": "Identificado correctamente de %{kind}."
      },
      "passwords": {
        "no_token": "No puedes acceder a esta página sino es por medio de un enlace para reestablecer de contraseña envíado a tu correo. Si accediste desde el enlace para reestablecer la contraseña, asegúrate de que la URL esté completa.",
        "send_instructions": "Recibirás un correo electrónico con instrucciones sobre cómo reestablecer tu contraseña en unos minutos.",
        "send_paranoid_instructions": "Si tu correo electrónico existe en nuestra base de datos, recibirás un enlace para reestablecer la contraseña en unos minutos.",
        "updated": "Tu contraseña se cambió correctamente. Has sido identificado.",
        "updated_not_active": "Tu contraseña se cambió correctamente."
      },
      "registrations": {
        "destroyed": "¡Adiós! Tu cuenta ha sido cancelada. Esperamos volver a verte pronto.",
        "signed_up": "¡Bienvenido(a)! Has sido identificado.",
        "signed_up_but_inactive": "Te has registrado correctamente. Pero no has podido iniciar sesión porque no has activado tu cuenta.",
        "signed_up_but_locked": "Te has registrado correctamente. Pero no has podido iniciar sesión porque tu cuenta está bloqueada.",
        "signed_up_but_unconfirmed": "Se te ha enviado un mensaje con un enlace de confirmación. Por favor visita el enlace para activar tu cuenta.",
        "update_needs_confirmation": "Actualizaste tu cuenta correctamente, pero necesitamos verificar tu nueva cuenta de correo. Por favor revisa tu correo electrónico y visita el enlace para finalizar la confirmación de tu nueva dirección de correo electrónico.",
        "updated": "Has actualizado tu cuenta correctamente."
      },
      "sessions": {
        "signed_in": "Has ingresado iniciado sesión.",
        "signed_out": "Has cerrado la sesión."
      },
      "unlocks": {
        "send_instructions": "Recibirás un correo electrónico en unos minutos con instrucciones sobre cómo desbloquear tu cuenta.",
        "send_paranoid_instructions": "Si tu cuenta existe, recibirás un correo electrónico en unos minutos con instrucciones sobre cómo desbloquear tu cuenta.",
        "unlocked": "Tu cuenta ha sido desbloqueada. Por favor inicia sesión para continuar."
      }
    },
    "errors": {
      "messages": {
        "already_confirmed": "ya ha sido confirmado, por favor intenta iniciar sesión",
        "confirmation_period_expired": "necesita ser confirmado en %{period}, por favor vuelve a solicitarla",
        "expired": "ha expirado, por favor vuelve a solicitarla",
        "not_found": "no se encontró",
        "not_locked": "no estaba bloqueado",
        "not_saved": {
          "one": "1 error impidió que este %{resource} fuese guardado:",
          "other": "%{count} errores impidieron que este %{resource} fuese guardado:",
          "something_went_wrong": "Algo salió mal"
        },
        "accepted": "debe ser aceptado",
        "blank": "no puede estar en blanco",
        "confirmation": "no coincide",
        "empty": "no puede estar vacío",
        "equal_to": "debe ser igual a %{count}",
        "even": "debe ser par",
        "exclusion": "está reservado",
        "greater_than": "debe ser mayor que %{count}",
        "greater_than_or_equal_to": "debe ser mayor que o igual a %{count}",
        "inclusion": "no está incluido en la lista",
        "invalid": "no es válido",
        "less_than": "debe ser menor que %{count}",
        "less_than_or_equal_to": "debe ser menor que o igual a %{count}",
        "model_invalid": "La validación falló: %{errors}",
        "not_a_number": "no es un número",
        "not_an_integer": "debe ser un entero",
        "odd": "debe ser impar",
        "other_than": "debe ser distinto de %{count}",
        "present": "debe estar en blanco",
        "required": "debe existir",
        "taken": "ya está en uso",
        "must_contain_number": " debe contener al menos un número y una letra",
        "must_contain_special": "debe contener un carácter especial",
        "must_contain_lower": "debe contener al menos 1 minúscula",
        "must_contain_upper": "debe contener al menos 1 mayúscula",
        "too_long": {
          "one": "es demasiado largo (1 carácter máximo)",
          "other": "es demasiado largo (%{count} caracteres máximo)"
        },
        "too_short": {
          "one": "es demasiado corto (1 carácter mínimo)",
          "other": "es demasiado corto (%{count} caracteres mínimo)"
        },
        "wrong_length": {
          "one": "no tiene la longitud correcta (1 carácter exactos)",
          "other": "no tiene la longitud correcta (%{count} caracteres exactos)"
        }
      },
      "template": {
        "body": "Se encontraron problemas con los siguientes campos:",
        "header": {
          "one": "No se pudo guardar este/a %{model} porque se encontró 1 error",
          "other": "No se pudo guardar este/a %{model} porque se encontraron %{count} errores"
        }
      },
      "format": "%{attribute} %{message}"
    },
    "meta_tags": {
      "default": {
        "description": "Descubre Chile con programas de aventura exclusivos y guías expertos. ¡Vive una experiencia única! Reserva tu viaje inolvidable.",
        "keywords": "Patagonia, Chile, tours aventura, tours aventura Patagonia, tours aventura Chile, tours Torres del Paine, tours senderismo Patagonia, tours kayak Patagonia, tours cabalgata Patagonia, tours multideporte Patagonia, tours aventura familia Patagonia, tours aventura lujo Patagonia, tours aventura económico Patagonia, mejores tours aventura Patagonia, viajes aventura Patagonia, actividades aventura Patagonia, excursiones aventura Patagonia, programas aventura Patagonia",
        "name": "Outdoor Index"
      },
      "help": {
        "title": "Outdoor Index - Ayuda",
        "description": "¿Tienes alguna duda para tu viaje a la Patagonia? Entra en Outdoor Index y habla con guías locales y expertos en la zona.",
        "keywords": null
      }
    },
    "views": {
      "pagination": {
        "truncate": "…"
      }
    },
    "activerecord": {
      "models": {
        "season": "Temporada",
        "seasons": "Temporadas",
        "agency": "Operador",
        "agencies": "Operadores",
        "agency_type": "Tipo de operador",
        "agency_types": "Tipos de operadores"
      },
      "attributes": {
        "season": {
          "name": "Nombre",
          "valid_from": "Válido desde",
          "valid_until": "Válido hasta",
          "start_time": "Hora de inicio",
          "product": "Excursión",
          "mon_check": "Lunes",
          "tue_check": "Martes",
          "wed_check": "Miercoles",
          "thu_check": "Jueves",
          "fri_check": "Viernes",
          "sat_check": "Sábado",
          "sun_check": "Domingo"
        },
        "order": {
          "clp_charge": "Cargo CLP",
          "usd_charge": "Cargo USD",
          "username": "Cliente:",
          "email": "Email:",
          "product": "Producto:",
          "product_name": "Producto",
          "manual_pax": "Nro Pax:",
          "manual_total": "Pagado:",
          "manual_currency": "Moneda:",
          "partial_payment": "Pago:",
          "payment_method": "Metodo:",
          "channel": "Canal:",
          "confirmed_at": "Compra:",
          "departure_at": "Partida:",
          "starting_datetime": "Hora partida:",
          "customer_phone": "Teléfono:",
          "extra": "Extra:",
          "instructions": "Instrucciones:",
          "language": "Idioma:",
          "weather_link": "Link de clima",
          "post_link": "Link al post",
          "itinerary_document": "Documento de itinerario",
          "show_itinerary_document": "Mostrar"
        }
      }
    },
    "promotions": {
      "coupon_code_ok": "Cupón aplicado correctamente",
      "coupon_code_error": "El cupón no existe",
      "coupon_code_already": "El cupón ya ha sido aplicado",
      "coupon_code_max": "Máximo un cupón por órden",
      "coupon_code_destroy_ok": "Código eliminado satisfactoriamente",
      "coupon_code_destroy_error": "No se ha podido eliminar el código",
      "coupon_code_destroy_confirm": "¿Esta seguro que quiere eliminarlo?",
      "coupon_have_a_coupon": "¿Tiene un cupón de descuento?",
      "coupon_form_palceholder": "Código de descuento",
      "coupon_apply": "Aplicar"
    },
    "home_collections": {
      "home_reviews": "350+ personas al año viajan con Outdoor Index",
      "find_your_experience": "Busca tu excursión",
      "carousel_region": "Aventuras por región",
      "carousel_activities": "Aventuras por actividades",
      "carousel_time_preference": "Aventuras por preferencia de tiempo",
      "sub-landing": "Descubre las mejores opciones turísticas en Chile con Outdoor Index. Compara y explora una amplia variedad de programas desde Atacama hasta la Patagonia. ¡Reserva hoy para vivir experiencias únicas!",
      "title": "Tours de aventura en Chile y Patagonia",
      "subtitle": "Encuentra aventuras con los mejores guías locales"
    },
    "products_search": {
      "activities": "Actividades",
      "regions": "Regiones",
      "time": "Tiempo",
      "date_sub_label": "¿Cuando quieres ir?",
      "activities_sub_label": "Escoge tu actividad",
      "regions_sub_label": "¿Qué región quieres visitar?",
      "time_sub_label": "Selecciona tu preferencia de horario!",
      "date": "Fecha",
      "all_adventures": "Todas las aventuras",
      "search_placeholder": "Buscar aventuras en todo Chile",
      "most_popular_searches": "Búsquedas más populares",
      "see_all_adventures": "Ver todas las aventuras",
      "help_me_choose": "Ayúdame a elegir",
      "help_me_choose_url": "https://api.whatsapp.com/send?phone=56981785011&text=Hola%2C%20necesito%20ayuda%20para%20elegir%20una%20aventura",
      "popular_search_items": {
        "circuito_w": {
          "label": "Circuito W",
          "icon": "search",
          "landing_slug": "circuito-w"
        },
        "circuito_o": {
          "label": "Circuito O",
          "icon": "search",
          "landing_slug": "circuito-o"
        },
        "torres_del_paine": {
          "label": "Torres del Paine",
          "icon": "map-pin",
          "zone_id": 1
        },
        "pucon": {
          "label": "Pucón",
          "icon": "map-pin",
          "zone_id": 16
        },
        "san_pedro_atacama": {
          "label": "San Pedro de Atacama",
          "icon": "map-pin",
          "zone_id": 15
        },
        "puerto_natales": {
          "label": "Puerto Natales",
          "icon": "map-pin",
          "zone_id": 2
        }
      },
      "search": "Buscar",
      "clear": "Limpiar selección",
      "tours": "tours",
      "subtext": "Planifica tu próxima aventura.\nExplora, reserva y disfruta lo natural.",
      "in": "en",
      "showing_count": "Mostrando %{loaded} de %{total} aventuras",
      "load_more": "Cargar más"
    },
    "comments": {
      "comments": "Comentarios",
      "replies": "Respuestas",
      "post_a_comment": "Publica un comentario!",
      "submit": "Enviar",
      "reply": "Responder",
      "body": "Escribe tu comentario aqui..."
    },
    "order": {
      "confirmed": "Confirmado",
      "mail_thanks": "gracias por tu compra en Outdoor Index",
      "mail__hi": "Hola!",
      "mail_subject": "Outdoor Index Orden N°",
      "order_t": "Orden",
      "see_purchase": "Revisa tus compras",
      "already_paid": "Esta orden ya ha sido pagada",
      "confirm_payment": "Confirmar",
      "cancel_order": "Cancelar",
      "recover_order": "Recuperar",
      "send_confirm": "Confirmar (1)",
      "send_reminder": "Recordar (2)",
      "send_last_reminder": "Re-recordar (3)",
      "send_review": "Review (4)",
      "email_title": "Recordatorio de excursión",
      "email_footer": "a continuación te enviamos un recordatorio de tu excursión. Si tienes alguna pregunta, no dudes en contactarnos a info@outdoorindex.cl o al +56981785011.",
      "promo": "Visita www.outdoorindex.cl para más excursiones y programas.",
      "edit": "Editar",
      "departure_date": "Fecha partida",
      "reservation": "Reserva",
      "code": "Código",
      "departure": "Partida",
      "contact_info": "Información de contacto",
      "customer_phone": "Número de contacto",
      "travelers": "Viajeros",
      "itinerary": "Itinerario",
      "view_itinerary": "Descarga tu itinerario",
      "view_itinerary_file": "aqui",
      "voucher": "Ver el voucher",
      "confirmation_email_title": "Ya está confirmada tu reserva para %{excursion}",
      "view_weather_link": "Revisa el clima",
      "instruction_exerpt": "Sabemos que se acerca tu excursión y ya te debes estar preparando",
      "here_some_instructions": "Instrucciones",
      "view_post_link": "Nuestro blog",
      "review_email_title": "Cuéntanos cómo fue tu excursión %{excursion}",
      "review_link": "Responder encuesta post viaje",
      "review_trustpilot_intro": "Si quieres que otros viajeros conozcan tu experiencia, también puedes dejar una reseña pública en Trustpilot.",
      "review_trustpilot_link": "Dejar una reseña en Trustpilot",
      "review_question": "¿Qué tal fue tu excursión?",
      "review_explain_title": "Por qué es importante completar la encuesta",
      "rewview_explain_body": "<p>Tu opinión nos ayuda a mejorar cada excursión. La encuesta post viaje es confidencial y nos permite conocer cómo fue tu experiencia: la organización, el guía, las actividades y los detalles que marcaron la diferencia.</p>\n<p>Reflexiona sobre tu viaje antes, durante y después de la excursión. Solo te tomará unos minutos responder con sinceridad.</p>\n<p>Tus respuestas nos ayudan a cuidar la calidad de nuestro servicio y a seguir mejorando para futuros viajeros.</p>\n",
      "review_terrible": "Pésima",
      "review_bad": "Mala",
      "review_acceptable": "Aceptable",
      "review_good": "Buena",
      "review_great": "Genial",
      "new_order_excerpt": "Aquí puedes completar toda la información necesaria para crear una orden. Escribe instrucciones claras y precisas indicando los horarios y los puntos de encuentro para cada reserva. Además recuerda contactar a los operadores por orden de prioridad."
    },
    "ondemand": {
      "explanation": "!Excursión exclusiva! contáctate con nuestro especialista en terreno.",
      "label": "Privado"
    },
    "request": {
      "greeting": "Hola! Esta informacción ha sido enviada a tu bandeja de correo registrada con copia a uno de nuestros agentes. Nos contactaremos contigo lo antes posible a través de la información que nos enviaste.",
      "order_mail": {
        "header": {
          "hi": "Hola! Tenemos noticias sobre tu solicitud de excursión!",
          "title": "Tu solicitud ha sido aceptada por el operador local. Por favor, lee la información que se muestra a continuación y asegúrate que todo esté correcto.",
          "your_order": "Tu orden N°",
          "ready": "está disponible para ser pagada."
        },
        "footer": "Ahora puedes ir a la sección de pagos con el botón de pago.                                                                                                                                                                                                                                                       .",
        "disclaimer": "Serás redirigido a la ventana de pagos de Outdoor Index a través de una conexión segura.",
        "pay": "Pagar",
        "excursion": {
          "title": "Excursión",
          "agency": "Operador local"
        },
        "manual_order": {
          "observations": "Lee los comentarios que te dejó el agente Outdoor Index!",
          "price": "Precio",
          "price_clp": "Precio CLP",
          "price_usd": "Precio USD"
        },
        "request_details": "Los detalles de tu solicitud"
      },
      "singular": "Solicitud",
      "requester": "Solicitante",
      "product_required": "Para solicitar pedido, debes hacer login previamente",
      "excursion": "Excursion",
      "applicants": "Participantes",
      "from": "Desde",
      "to": "Hasta",
      "comments": "Comentarios",
      "comments_placeholder": "Deja tus preguntas, dudas o lo que sea que quieras decirnos. Te contactaremos lo antes posible!",
      "submit": "Enviar Solicitud",
      "modal_success_title": "Solicitud enviada",
      "modal_success_body": "Recibimos tus datos. Nos pondremos en contacto contigo pronto con la información que nos enviaste.",
      "modal_close": "Cerrar",
      "email_title": "Solicitud de Excursión Privada",
      "email_footer": "Este formulario ha sido enviado a nuestros ejecutivos. Serás contactado a través de los datos que ingresaste en el formulario de contacto. Si existe algún error u observación en el formulario, por favor, envíanos un correo a info@outdoorindex.cl y te responderemos a la brevedad.",
      "contact_name": "Nombre contacto",
      "contact_email": "Correo contacto",
      "contact_phone": "Teléfono contacto",
      "must_log_in": "Debes iniciar sesión antes de poder pagar",
      "phone": "Teléfono de contacto",
      "name": "Nombre",
      "last_name": "Apellido"
    },
    "applicants": {
      "applicants_number": "2) ¿Cuánta gente participará de la Excursión?",
      "dates_sub": "3) ¿Durante qué fechas quieres realizar la Excursión?",
      "additional_info": "4) Información adicional",
      "applicants_phone": "1) Déjanos tus datos para contactarte",
      "phone_placeholder": "Teléfono",
      "email": "Email",
      "name": "Nombre",
      "lastname": "Apellido"
    },
    "active_admin": {
      "observed_dollar_update": "Actualizar",
      "agency": "Operadores",
      "agencies": "Agencias",
      "settings": "Ajustes",
      "users": "Usuarios",
      "admin_users": "Administradores",
      "orders": "Ordenes",
      "pages": "Páginas",
      "sales": "Ventas",
      "sale_goals": "Objetivos venta",
      "reviews": "Reseñas",
      "blog": "Blog",
      "suppliers": "Proveedores",
      "covers": "Colecciones",
      "excursions": "Excursiones",
      "categories": "Categorias",
      "comments_tab": "Comentarios",
      "excursion_images": "Imágenes Excursiones",
      "home": "Inicio",
      "home_collections": "Colecciones",
      "save_home_collections": "Guardar Colección",
      "images": "Post images",
      "mailer": "Creador mails",
      "newsletter_covers": "Portadas News",
      "notifications": "Notificaciones",
      "payment_methods": "Metodos de pago",
      "private": "Privado",
      "products": "Productos",
      "profiles": "Perfiles",
      "properties": "Propiedades",
      "promotions": "Promociones",
      "question_subjects": "Preguntas Ayuda",
      "questions": "Preguntas",
      "tourists": "Turistas",
      "requests": "Solicitudes",
      "tags": "Etiquetas",
      "visits": "Visitas",
      "zones": "Zonas",
      "seasons": "Temporadas",
      "macro_zones": "Macro Zonas",
      "landings": "Landings",
      "post": {
        "title": "Título",
        "subtitle": "Subtítulo",
        "label": "Etiqueta",
        "author_name": "Autor",
        "author_sm": "Autor red social",
        "content": "Contenido",
        "cover": "Portada",
        "published": "Publicada",
        "unpublished": "No publicada",
        "tags": "Etiquetas",
        "recommended_posts": "Publicaciones recomendadas",
        "products": "Tours y Excursiones",
        "explore_chile": "Explora Chile y sus rincones con Outdoor Index"
      },
      "zone": {
        "name": "Nombre",
        "description": "Descripción",
        "sort_order": "Orden",
        "country": "País",
        "state": "Región",
        "masonry_cover": "Foto masonry (home)",
        "masonry_cover_hint": "Opcional. Se usa en las tarjetas de colección tipo masonry. Si no subes imagen, se toma una foto de una excursión de la zona."
      },
      "review": {
        "tilte1": "Crear Reseña",
        "title2": "Portada",
        "author": "Nombre",
        "country": "País",
        "review_date": "Fecha de la reseña",
        "language": "Idioma",
        "save_review": "Guardar reseña",
        "body": "Texto review",
        "cover": "Cover",
        "rating": "Rating",
        "url": "Url",
        "excerpt": "Aquí puedes completar toda la información necesaria para crear una Reseña. Asegúrate siempre de que la foto de portada que subas tenga una buena resolución y sea correcta. Recuerda leer y verificar la información."
      },
      "landing": {
        "tilte1": "Crear Landing",
        "title2": "Meta",
        "title3": "Portada",
        "title4": "Reviews",
        "title5": "FAQ",
        "save_landing": "Guardar landing",
        "title": "Título",
        "place": "Lugar",
        "body": "Contenido",
        "cover": "Portada",
        "review": "Review",
        "meta_title": "Título meta",
        "meta_description": "Descripción meta",
        "product": "Excursión",
        "excerpt": "Aquí puedes completar toda la información necesaria para crear una Landing. Asegúrate siempre de que la foto de portada que subas tenga una buena resolución y sea atractiva para el turista. Recuerda brindar información clara y confiable.",
        "more_info": "Más info"
      },
      "season": {
        "name": "Nombre",
        "valid_from": "Desde",
        "valid_until": "Hasta",
        "start_time": "Hora de inicio",
        "product": "Excursión",
        "child_usd_price": "Niños en dolares",
        "child_clp_price": "Niños en CLP",
        "single_supplement_usd_price": "Dólares",
        "single_supplement_clp_price": "CLP",
        "guardar_temporada": "Guardar",
        "daily_quota": "Disponibilidad",
        "title_days": "Días",
        "title_ages": "Edades",
        "title_prices_kids": "Precios niños",
        "title_prices_adults": "Precios adultos",
        "title_single_supplement": "Suplemento individual"
      },
      "kpis": {
        "observed_dollar": "Valor dolar observado",
        "observed_dollar_subtitle": "Valor dolar definido por el Banco Central",
        "visits_today_title": "Visitas de hoy",
        "visits_today_subtitle": "Flujos para el día de hoy",
        "visitors": "Visitantes",
        "last_day": "Día anterior",
        "show_more": "Ver más",
        "countries": "Países",
        "countries_subtitle": "Los que más nos visitan",
        "country_anon": "Anónimo",
        "abandoned_cart_title": "Mochila de viajes abandonada",
        "abandoned_cart_subtitle": "Órdenes en tu mochila de viajes",
        "products_viewed_title": "Productos más vistos",
        "products_viewed_subtitle": "Los más populares por ahora",
        "posts_viewed_title": "Post más vistos",
        "posts_viewed_subtitle": "Los más populares por ahora",
        "products_selled_title": "Productos más vendidos",
        "products_selled_subtitle": "En el último año",
        "today_excursions_title": "Excursiones hoy",
        "today_excursions_subtitle": "Turistas que hoy parten su tour.",
        "users_month_title": "Estadística mensual",
        "users_month_subtitle": "Balance estadístico de usuarios mensuales.",
        "users_number": "Número de usuarios",
        "new_users_title": "Nuevos Usuarios",
        "new_users_subtitle": "Registrados el último mes",
        "users_total_title": "Total Usuarios",
        "users_total_subtitle": "Registrados desde el inicio",
        "new_users_title_box": "Usuarios de hoy",
        "new_users_subtitle_box": "Flujos para el día de hoy",
        "users": "Usuarios",
        "new_orders_title": "Nuevas Órdenes",
        "new_orders_subtitle": "Registrados este mes",
        "paid_orders_title": "Órdenes Pagadas",
        "paid_orders_subtitle": "Registrados este mes",
        "sale_goals_title": "Objetivo de ventas",
        "sale_goals_subtitle": "Rendimiento total de este mes",
        "goals": "Objetivo",
        "to": "hasta",
        "no_sale_goal": "No se ha definido un objetivo de venta",
        "conversion_chart_title": "Gráfico de conversión",
        "conversion_chart_subtitle": "Indice de conversión el último año",
        "conversion_last_year": "Indice de conversión el último año",
        "conversion_title": "Tasa de conversión",
        "conversion_subtitle": "Actualizada a la fecha"
      }
    },
    "mercado_pago": {
      "error_alert": "Ha ocurrido un error con Mercado Pago, por favor verifique si su orden se encuentra pagada.",
      "error_title": "Transacción rechazada",
      "error_dec": "Hubo un error en el procesamiento del pago, por favor inténtalo nuevamente. Si el problema persiste ponte en contacto con nosotros.",
      "pending_title": "Transacción pendiente",
      "pending_dec": "Su pago se encuentra pendiente de verificación en Mercado Pago. Una vez verificado pongase en contacto con nosotos para validar su Orden."
    },
    "webpay": {
      "error_alert": "Ha ocurrido un error con Webpay, por favor verifique si su orden se encuentra pagada.",
      "error_title": "Transacción rechazada",
      "error_dec": "Hubo un error en el procesamiento del pago, por favor inténtalo nuevamente. Si el problema persiste ponte en contacto con nosotros."
    },
    "back": "Volver",
    "chat_title": "¿Como podemos ayudarte?",
    "chat_subtitle": "Usualmente respondemos en unas horas",
    "chat_name": "Nombre",
    "chat_email": "Email",
    "chat_phone": "Teléfono",
    "chat_subject": "Asunto",
    "chat_body": "Mensaje",
    "chat_btn": "Enviar",
    "menu_welcome": "Bienvenido(a), %{user_name}",
    "meesage_sended": "Mensaje Enviado",
    "meesage_captcha": "Debe verificar el captcha",
    "view_more": "Ver más...",
    "view_more_excursions": "Ver más excursiones...",
    "view_more_suggestions": "Ver más sugerencias...",
    "location": "Ubicación",
    "zone": "Zona",
    "category": "Categoría",
    "select_one": "Selecciona uno",
    "select_multiple": "Selecciona varios",
    "select_two": "2 max",
    "price": "Precio",
    "vacancies": "Cupos",
    "key": "Ej: Elevación",
    "value": "1300 mt",
    "value_included": "Ej: Guía bilingue",
    "profiles": "Perfiles",
    "optional": "Opcional",
    "email": "Email",
    "phone": "Teléfono",
    "address": "Dirección",
    "pending": "Pendiente",
    "edit": "Editar",
    "soon": "Próximamente",
    "password": "Contraseña (min 8 caracteres, letra, número)",
    "password_confirmation": "Confirmación de la contraseña",
    "remember_me": "Recuérdame",
    "log_in": "Iniciar sesión",
    "sign_up": "Regístrate",
    "create_an_account": "Crea tu cuenta",
    "name": "Nombre",
    "last_name": "Apellido",
    "back_to": "Volver a",
    "reset_password": "Restablecer contraseña",
    "send": "Enviar",
    "guests": "Adultos",
    "guest": "Adulto",
    "child_guest": "Niño",
    "child_guests": "Niños",
    "products": "Productos",
    "products_show_photos": "Ver (%{n}) fotos",
    "delete": "Borrar",
    "continue": "Continuar",
    "total_only": "Total",
    "total": "Total a pagar:",
    "total_paid": "Total pagado",
    "charges": "Cargos:",
    "subtotal": "Subtotal:",
    "total_final": "Total final",
    "coupon": "Cupón",
    "image_not_found": "Imagen no encontrada",
    "usd": "USD",
    "clp": "CLP",
    "departure": "Partida",
    "when": "¿Cuando?",
    "what": "¿Qué?",
    "where": "¿Dónde?",
    "search": "Buscar",
    "language": "Lenguage",
    "puerto_natales": "Puerto Natales",
    "punta_arenas": "Punta Arenas",
    "tierra_del_fuego": "Tierra del Fuego",
    "puerto_williams": "Puerto Williams",
    "in": "en",
    "or": "o",
    "help": "Preguntas frecuentes",
    "go_to_home_page": "Volver al inicio",
    "add_row": "+ Agregar",
    "from": "Desde ",
    "days": "días",
    "hours": "horas",
    "home": {
      "site_title": "Outdoor Index: Reserva tours de aventura en Patagonia y Chile",
      "things_to_do_in": "Sugerencias en",
      "scientific_excursions": "En profundo contacto con la naturaleza",
      "luxury_experience": "Vive exclusivo, solo para ti",
      "adventure_excursions": "Da más de ti mismo",
      "the_best_excursions": "Las mejores excursiones para ésta temporada",
      "explore_your_interests": "Explora tus intereses",
      "excursions": "Excursiones",
      "products": "productos",
      "suggestions": "Sugerencias",
      "hard_adventurous": "Activos",
      "soft_adventurous": "Transformador",
      "scientific": "Descubrimiento",
      "family": "Grupos",
      "luxury": "Sofisticados",
      "promotions": "Promocionales",
      "download": "Descarga",
      "adventures_by_region": "Aventuras por región",
      "north_patagonia": "Patagonia Norte",
      "south_patagonia": "Patagonia Sur",
      "masonry_zone_count": "%{count} aventuras"
    },
    "masonry_zones": {
      "names": {
        "1": "Torres del Paine",
        "2": "Puerto Natales",
        "3": "Punta Arenas",
        "4": "Tierra del Fuego",
        "5": "Puerto Williams",
        "6": "Antártica"
      }
    },
    "survey_page": {
      "title": "Outdoor Index - Encuesta de postventa",
      "description": "Nos gustaría conocer tu opinión sobre el servicio que recibiste. Tu retroalimentación es muy importante para nosotros.",
      "main_heading": "Encuesta post viaje Outdoor Index"
    },
    "header": {
      "agency_panel": "Panel agencia",
      "supplier_panel": "Panel proveedor",
      "ask_us_a_question": "Contáctanos",
      "help": "Ayuda",
      "itinerary": "Itinerario",
      "sign_out": "Salir",
      "sign_up": "Regístrate",
      "log_in": "Entrar",
      "join_our_newsletter": "Unirte al newsletter",
      "partner": "Partner",
      "blog": "Historias exclusivas:",
      "your_blog": "tu blog 🔥",
      "config": "Ajustes",
      "orders": "Vouchers",
      "cart": "Carrito"
    },
    "header_cat": {
      "excursions": "Excursiones",
      "recommendations": "Sugerencias",
      "accommodation": "Alojamientos",
      "other": "Otros"
    },
    "agencies": {
      "address": "Dirección",
      "review": "Revisión",
      "agency_type": "Tipo de agencia",
      "owner": "Dueño",
      "holder_name": "Nombre del titular",
      "holder_id": "ID del titular",
      "holder_email": "Email del titular",
      "phone": "Teléfono",
      "bank_name": "Nombre del banco",
      "account_type": "Tipo de cuenta",
      "account_number": "Número de cuenta",
      "agency": "Agencia",
      "country": "País",
      "state": "Región",
      "zone": "Zona",
      "duration": "Duración",
      "created_at": "Fecha creación",
      "agency_info": "Información",
      "supplier_info": "Información",
      "numbers": "Números",
      "products": "Productos",
      "list_title": "Lista de todas tus fechas",
      "no_dates": "Aún no hay fechas, por favor haz clic en el calendario para crear una.",
      "change_availability": "Maneja tus fechas",
      "date_range": "Modifica según rango de fechas",
      "set_price": "Definir precio",
      "rooms_to_add": "Agregar habitaciones",
      "rooms_to_remove": "Quitar habitaciones",
      "products_to_add": "Agregar productos",
      "products_to_remove": "Quitar productos",
      "apply_changes": "Aplicar cambios",
      "edit_excerpt": "Toda la información solicitada para crear el perfil del proveedor es de vital importancia para establecer el vínculo comercial con Outdoor Index. Por favor ingresa la información lo más precisa posible.",
      "agency_information": "Información agencia",
      "supplier_information": "Información proveedor",
      "max_words": "150 palabras",
      "for_booking": "para reservar",
      "supplier_review": "Reseña proveedor ",
      "website_url": "Dirección web",
      "person_in_charge": "Persona a cargo",
      "name": "Nombre",
      "update_info": "Guardar perfil",
      "commercial_information": {
        "self": "Información comercial",
        "name": "Nombre",
        "bank_name": "Nombre banco",
        "bank_account": "Cuenta",
        "account_type": "Tipo de cuenta",
        "commercial_name": "Nombre Comercial",
        "id_rut": "ID / Rut"
      },
      "excursions": "Excursiones",
      "actions": "Acciones",
      "manage_dates": "Fechas",
      "active": "Aprobada",
      "pending_changes": "Pendiente",
      "index_excerpt": "Aquí tienes una lista de todos tus productos. Puedes crear, editar y administrar las fechas de estos. Cada producto creado permanecerá en el estado \"Pendiente\" hasta que sea revisado por el equipo de Outdoor Index.",
      "manage_dates_excerpt": "Aquí tienes un calendario para agregar todos tus productos. Puedes crear, editar y administrar las fechas de estos. Cada producto creado permanecerá en el estado \"Pendiente\" hasta que sea revisado por el equipo de Outdoor Index.",
      "create_excursion": "Crear excursión",
      "create_product": "Crear producto",
      "create_activity": "Crear actividad",
      "create_post": "Crear post",
      "new_excursion_excerpt": "Aquí puedes completar toda la información necesaria para crear un producto. Siempre asegúrate de que las fotos que subas tengan buena resolución y sean atractivas para el turista. Recuerda dar información clara y confiable.",
      "english": "Traducir al ingles →",
      "spanish": "Translate to spanish →",
      "create_agency": "Crear nueva agencia",
      "agency_bank": "Datos de transferencia"
    },
    "error": {
      "sorry": "Lo sentimos, esta página no existe.",
      "opps": "Puede que hayas escrito mal la dirección o que la página se haya movido.",
      "go": "ir al inicio",
      "went_wrong": "Lo sentimos, pero algo salió mal.",
      "improvements": "Si ves este mensaje es por que quizás escribiste mal la dirección web o por que estamos actualizando el sitio con nuevas funcionalidades y mejoras. Espera unos minutos y recarga la página nuevamente. Gracias!"
    },
    "excursions": {
      "title": "Título",
      "location": "Lugar",
      "zone": "Zona",
      "category": "Categoría",
      "profiles": "Tipo de viaje",
      "price": "Precio (en dólares)",
      "vacancies": "Cupos",
      "duration": "Duración",
      "half_day": "Medio día",
      "full_day": "Día completo",
      "multiple_days": "Varios días",
      "duration_days": "Días",
      "duration_hours": "Horas",
      "itinerary": {
        "body": "Cuerpo"
      },
      "faq": {
        "body": "Cuerpo"
      },
      "days": {
        "zero": "Día",
        "one": "Día",
        "other": "Días"
      },
      "hours": {
        "zero": "Hora",
        "one": "Hora",
        "other": "Horas"
      },
      "add_images_(minimum_3)": "Fotos (mínimo 3)",
      "disclaimer": "Disclaimer",
      "description": "Visión general",
      "body": "Nuestro Itinerario",
      "useful_information": "Info de utilidad",
      "what's_included?": "Incluido",
      "what's_not_included?": "No incluido",
      "meeting_instruction": "Lugar de partida",
      "meeting_address": "Dirección",
      "policies": "Políticas de cancelación",
      "save_excursion": "Salvar excursión",
      "what_we'll_do": "Visión general",
      "our_itinerary": "Itinerario",
      "faqs": "FAQs",
      "images": "Imágenes",
      "edit_excerpt": "Toda la información solicitada para crear el perfil del proveedor es de vital importancia para establecer el vínculo comercial con Outdoor Index. Por favor ingresa la información lo más precisa posible.",
      "other_excursions_from_this_tour_company": "Otras experiencias de este proveedor",
      "create_excursions": "Crear excursión",
      "more": "Más",
      "less": "Menos",
      "best_excursions_for_the_next_season": "Recomendados para esta temporada",
      "add_extras": "Agregar extras",
      "price_per_reservations": "Precio por reserva",
      "extra_description": "Actividad",
      "macro_zone": "Macro Zona",
      "meta_title": "Meta título",
      "meta_description": "Meta descripción",
      "time": "Tiempo",
      "prices": "Precios",
      "included": "¿Qué está incluido?",
      "locations": "Locación",
      "alternative_names": "Excursión también conocida por los siguientes nombres",
      "breadcrumb_catalog": "Tours y excursiones"
    },
    "hotels": {
      "twin": "Individual",
      "double": "Matrimonial",
      "double_twins": "Dos individuales",
      "room_reserved": "habitación reservada",
      "edit_your_booking": "Edita tu reserva"
    },
    "reservations": {
      "add_guest_details": "Agregar info turista",
      "traveler_data_card_title": "Datos del viajero",
      "traveler_data_badge_missing": "Falta info",
      "traveler_data_badge_complete": "Completo",
      "traveler_data_badge_ready_details": "Info lista",
      "traveler_data_intro": "Necesitamos esta información para confirmar tu reserva.",
      "traveler_data_complete_button": "Info del viajero",
      "detach_guest_confirm": "¿Quitar a este viajero de esta reserva?",
      "guest_slots_full": "Esta reserva ya tiene asignados todos los viajeros.",
      "organize_your_itinerary": "1) Itinerario >",
      "create_your_travel_group": "2) Grupo de viaje >",
      "assign_tourists": "3) Asigna turistas",
      "new_checkout_excerpt": "Aquí tienes la lista de productos en tu mochila de viajes. No te olvides de agregar a las o los pasajeros en las Excursiones en que participarán. Antes de comprar, revisa bien la cantidad de reservaciones y sus costos. Recuerda leer nuestra Política de cancelación.",
      "cart_title": "Información de tu viaje",
      "checkout_page_title": "Confirma tu reserva y realiza el pago",
      "checkout_page_intro": "Revisa los datos de tu excursión, completa la información del viajero y elige tu método de pago.",
      "checkout_trip_summary_heading": "Resumen de tu viaje",
      "pay_with": "Pagar con",
      "cart_subtitle": "Lista de productos en tu mochila de viajes",
      "itinerary_excerpt": "Aquí puedes encontrar una lista de todos tus productos. Asegúrate de que toda la información sea correcta para continuar con los próximos pasos. Importante: todas las horas y fechas se muestran en el horario chileno.",
      "assign_excerpt": "En esta sección debes indicar qué viajero va a qué excursión. De esta manera, tendremos toda la información necesaria para brindarte la mejor experiencia posible.",
      "list_of_products": "Lista de productos",
      "reservations_made": "#",
      "assing_tourists": "Asigna turistas",
      "go_to_checkout": "Continuar",
      "a_list_of_all_your_reservations": "Todas tus reservas",
      "my_group": "Mi grupo",
      "people_(including_you)": "Participantes (Incluido tu)",
      "(me)": "(Yo)",
      "team_member": "Miembros del grupo",
      "actions": "Acciones",
      "you_have_no_reservations": "No tienes ninguna reserva",
      "tourists_group": "En esta sección tienes que agregar la información de todas las personas que te acompañarán. Es muy importante que la información adjunta sea lo más confiable posible.",
      "edit_your_reservation": "Edita tu reserva",
      "cancel_date": "Cancelar reserva",
      "departure_date": "Día de partida",
      "reserves": "Reservas",
      "update": "Actualizar",
      "not_enough": "no tiene suficientes",
      "too_many": "tiene demasiados",
      "product_for": "El producto",
      "tourists_assigned": "turistas asignados",
      "many_few_tourists": "Los turistas asignados no coincide con el número de reservas",
      "select_your_extras": "Selecciona tus extras:",
      "product_variants": "Opciones",
      "select_date_first": "Primero selecciona una fecha",
      "total_price": "Precio total",
      "see_details": "Ver detalles",
      "price_chilean": "Valor total residentes en Chile:",
      "price_no_chilean": "Valor total no residentes en Chile:",
      "single_supplement": "Suplemento individual:",
      "people": "Pasajeros:",
      "details_of_purchase": "Detalle de tu compra",
      "confirmed_excerpt": "¡Gracias por viajar con nosotros!",
      "confirmed_excerpt_litle": "Consulta el voucher para ver los detalles de tu compra.",
      "cart_empty": "Tu mochila de viajes está vacía"
    },
    "checkout": {
      "do_checkout": "Realizar pedido",
      "confirm_checkout_excerpt": "Antes de continuar, comprueba que todo este correcto. Una vez que aceptes este pedido, no podrás cambiarlo.",
      "confirm_checkout_excerpt_2": "(Todavía puedes crear un nuevo pedido.)",
      "please_confirm_your_details": "Por favor confirma tu información",
      "i_need_to_change_something": "Necesito cambiar algo",
      "everything_looks_fine": "Todo se ve bien",
      "after_this_step": "Después de este paso, Outdoor Index se pondrá en contacto con todos los proveedores.",
      "providers_confirm_availability": "Cuando todos los proveedores confirmen tu disponibilidad, seras contactado.",
      "payment_excerpt": "Antes de comprar, asegúrate de que todos los detalles de tus productos sean correctos. Verifica el número de reservas y los valores de estos. Recuerda leer nuestras políticas de cancelación.",
      "your_details_confirmation_and_payment": "Detalle de tus productos y pago",
      "important!": "Importante",
      "all_transactions_have_an_extra": "Podrás pagar usando tu tarjeta de debito o crédito en las cuotas que pactes con tu banco. Outdoor Index recibirá el importe completo de la venta.",
      "get_a_refund_if": "Obten el reembolso de tu dinero si cancelas dentro de las 24 horas posteriores a la compra.",
      "pay_now": "Confirmar pago",
      "confirm_and_pay": "Confirmar y pagar",
      "wetravel_link_not_ready": "Espera un momento e inténtalo de nuevo, o vuelve a elegir WeTravel para cargar el enlace de pago.",
      "mercado_wallet_not_ready": "El botón de Mercado Pago aún se está cargando. Espera unos segundos e inténtalo de nuevo.",
      "payment_summary": "Resumen de pago",
      "payment_method_title": "Método de pago",
      "payment_methods_locked_until_traveler_details": "Completa los datos de los viajeros antes de elegir un método de pago.",
      "payment_method_recommended": "Recomendado",
      "payment_method_blurb": {
        "wetravel": "Pago internacional en USD",
        "mercado_pago": "Pago local con tarjeta y cuotas según tu banco",
        "webpay": "Pago con tarjeta bancaria vía Webpay",
        "payu": "Pago con PayU",
        "paypal": "Pago con PayPal",
        "google_pay": "Pago con Google Pay",
        "apple_pay": "Pago con Apple Pay"
      },
      "total_to_pay": "Total a pagar",
      "secure_payment_note": "Pago 100% seguro y encriptado",
      "help_widget_title": "¿Necesitas asistencia?",
      "help_widget_body": "Habla con un guía de Outdoor Index para obtener una asistencia personalizada.",
      "help_widget_cta": "Hablar con un especialista",
      "help_widget_online": "En línea",
      "terms_toggle_line_html": "Acepto los %{terms} y la %{policy}.",
      "terms_toggle_word_terms": "Términos",
      "terms_toggle_word_policy": "Política",
      "review": "Reseña",
      "ready": "Listo",
      "choose_payment": "Elija el pago que desee",
      "only_for_reservation": "Reserva",
      "complete_payment": "Pago completo",
      "30_p": "30%",
      "30_per": "Pagado el 30%",
      "30_pers": "Pagado el 30%",
      "100_p": "100%",
      "100_per": "Pagado el 100%",
      "100_pers": "Pagado el 100%",
      "i_hereby_accept": "Al hacer clic en \"Confirmar pago\", aceptas nuestros",
      "and_confirm": "y confirmas haber leído y entendido nuestra",
      "and_our": "y nuestra",
      "your_itinerary": "Tu itinerario en detalle",
      "continue_shopping": "Continuar comprando",
      "not_available": "No disponible",
      "some_products_deleted": "Algunos productos han dejado de estar disponibles",
      "disclaimer": "Sobre tu reserva",
      "accept": "Acepto",
      "cancel": "Cancelar",
      "must_have_tourist": "Debe tener al menos 1 turista con email y telefono agregados.",
      "wetravel_partial_error": "El pago parcial no está disponible porque la fecha de la excursión es demasiado cercana. Por favor, seleccione el pago completo."
    },
    "vouchers": {
      "active_excerpt": "Aquí se muestra un detalle de tus vouchers. Puedes verlos e imprimirlos. Recuerda presentarte el día de la reserva con tu voucher impreso, indicando el número de registro de este.",
      "all_of_your_vouchers": "Todos tus comprobantes",
      "confirmed_excerpt": "Muchas gracias por tu compra. Esperamos que tengas un hermoso viaje. No olvides imprimir tu comprobante y siempre llévalo contigo. Ante cualquier consulta o situación inesperada no dudes en contactarnos.",
      "active_vouchers": "Vouchers activos",
      "disclaimer": "En este PDF tienes toda la información de tus productos. Por favor revisa el documento y si tienes alguna pregunta, contáctanos. Disfruta tu viaje.",
      "get_your_voucher": "Obten tu voucher",
      "voucher": "Comprobante",
      "payment_error": "Error de pago",
      "error": "Algo salió mal con el proceso de pago. Vuelve a intentarlo más tarde o contáctenos para ver otras opciones de pago.",
      "restart_payment": "Volver a realizar pago",
      "payment_rejected": "Pago rechazado",
      "rejected": "PayU / Paypal ha indicado que tu pago fue rechazado, verifica tus datos y vuelve a intentarlo, o contáctanos para otras opciones de pago.",
      "home": "Inicio",
      "order_number": "Nro Orden:",
      "view": "Ver",
      "print": "Imprimir",
      "complete": "Completo",
      "incomplete": "Incompleto",
      "activities": "Actividades",
      "was_partial_payment": "(2)"
    },
    "categories": {
      "search": "búsqueda",
      "general": "general",
      "general_category_search": "Búsqueda general de %{category_name}",
      "other_excursions_to_do": "Otras experiencias para hacer en %{zone_name}",
      "general_zone_search": "Búsqueda sugerencias en %{zone_name}",
      "recommended_for_you": "Experiencias para hacer en %{zone_name}"
    },
    "tourist": {
      "new_tourist_excerpt": "En esta sección puedes agregar la información de todas las personas que te acompañarán. Es muy importante que la información adjunta sea lo más confiable posible.",
      "personal_info": "Información personal",
      "checkout_minimum_one_pax_notice": "Se requiere al menos la información de 1 pax. El resto puede completarse después si lo deseas.",
      "add_another_pax": "Agregar otro pasajero",
      "info_pax_card_title": "Info pasajero",
      "name": "Nombre",
      "last_name": "Apellido",
      "date_of_birth": "Fecha de nacimiento",
      "nationality": "Nacionalidad",
      "passport": "Número de pasaporte",
      "hometown": "Ciudad donde vive",
      "phone": "Teléfono",
      "email": "Email",
      "emergency_contact": "Contacto de emergencia",
      "allergies": "Alergias",
      "medical_conditions": "Condición medica",
      "food_restrictions": "Restricciones alimenticias",
      "pending": "Pendiente",
      "ready": "Listo",
      "you_have_no_vouchers": "No tienes vouchers activos",
      "no_reservations_to_assign": "No hay reservas para asignar"
    },
    "footer": {
      "about_us": "Nosotros",
      "statement": "Lee sobre nuestros pilares",
      "go_to_suscribe": "Ir a suscribirme",
      "suscribe_text": "Enviamos actualizaciones quincenales sobre nuevas historias y descuentos en viajes",
      "terms_&_conditions": "Términos",
      "privacy_&_cookies": "Privacidad",
      "contact_us": "Contáctanos",
      "edit_endorsement": "Outdoor Index tiene sede en Puerto Natales (Patagonia Chilena Sur) y cuenta con el apoyo de más de 40 proveedores.",
      "all_rights_reserved": "Todos los derechos reservados. Ninguna parte de este sitio puede ser reproducida sin el permiso correspondiente.",
      "spanish": "Español",
      "english": "Inglés",
      "portuguese": "Portugués",
      "french": "Francés",
      "german": "Alemán",
      "english_corto": "EN",
      "spanish_corto": "ES",
      "portuguese_corto": "PT",
      "french_corto": "FR",
      "german_corto": "DE",
      "clp": "$ Pesos Chilenos (CLP)",
      "usd": "$ Dólares Americanos (USD)",
      "survey": "Encuesta",
      "endorsement": {
        "support_local_comunity": "Apoya la economía local, fomenta enfoques sustentantes",
        "when_you_buy": "Al comprar con nosotros fomentas más de 35 proveedores en su gestión sustentable y de calidad.",
        "instant_booking": "Guías certificados 100% disponibles para tu asistencia",
        "by_entering_your": "Antes, durante y después para todas tus dudas y ayudarte en la planificación de tu próxima aventura.",
        "payment_protection": "Confirma tu reserva pagando sólo el 30%",
        "we_comply_with_all": "Planifica tu aventura sin stress, de forma más liviana pagando sólo una parte ahora y el resto más cerca de la fecha."
      },
      "covid": "Covid",
      "secure": "Las reservas procesadas a través de este sitio web están protegidas por nuestros socios.",
      "titles": {
        "book": "Reserva con Confianza",
        "destinations": "Destinos populares",
        "activities": "Actividades populares"
      },
      "lang-currency": "Language & Currency"
    },
    "chat": {
      "hi": "Hola",
      "our_chat_service": "Nuestro servicio de chat está disponible de lunes a viernes desde las 10 am a las 6 pm (UTC/GMT -3). Si nos escribes en estos horarios te responderemos en unos minutos.",
      "new-message": "Nuevo mensaje",
      "messages": "Mensajes",
      "enter_your_name": "Ingresa tu nombre",
      "enter_email": "Ingresa tu email",
      "enter_message": "Ingresa un mensaje...",
      "create_message": "Enviar mensaje",
      "begin": "Iniciar",
      "user": "Usuario",
      "need_help": "Necesitas ayuda?",
      "talk_to_local_guide": "Habla con un guía local"
    },
    "registration": {
      "edit_user": "Editar usuario",
      "email": "Email",
      "name": "Nombre",
      "lastname": "Apellido",
      "confirm_password": "Confirmar contraseña",
      "current_password": "Contraseña actual",
      "new_password": "Nueva contraseña",
      "profile_picture": "Foto perfil",
      "profiles": "Perfiles (Puedes escoger más de uno)",
      "interests": "Intereses (Puedes escoger más de uno)",
      "notification": "Configuración de notificaciones",
      "save_settings": "Guardar",
      "update_account": "Actualizar cuenta",
      "registration_excerpt": "Administra tu perfil de la manera que quieras. Habilita o deshabilita tus notificaciones. De esta forma, podrás personalizar los contenidos que recibes de Outdoor Index.",
      "vouchers": "Vouchers",
      "all_vouchers": "Mis vouchers",
      "change_your_password": "Restablecer o Cambiar Contraseña",
      "change_my_password": "Cambiar contraseña",
      "confirm_new_password": "Confirmar contraseña",
      "subtitle_password": "Ingresa una nueva contraseña para tu cuenta. Debe ser al menos 8 caracteres y incluir letras y números.",
      "password_requirements": "La contraseña es inválida.",
      "passwords_dont_match": "Las contraseñas no coinciden."
    },
    "responsive": {
      "more": "Más..."
    },
    "uploader": {
      "upload_a_file": "Sube un archivo",
      "drop_files_here": "Arrastra tu archivo aquí",
      "processing_dropped_files": "Procesando archivos..."
    },
    "sidebar_single": {
      "no_dates_available": "No hay fechas disponibles",
      "disclaimer": "Asegura tu lugar ahora pagando solo <strong>el 30% del valor total de la reserva.</strong>",
      "select_dates": "Reserva ahora",
      "share": "Preguntas sobre la excursión?",
      "to_make_a": "Para hacer una reserva por favor ",
      "log_in": "Inicia sesión",
      "or": "o",
      "sign_up": "Regístrate",
      "if_you_are": "si eres nuevo.",
      "price_for": "Por persona",
      "from": "Precio desde",
      "contact_viewnia": "Contáctanos",
      "rates": "Tarifas CLP incluyen IVA. Tarifas USD no incluyen IVA; extranjeros no residentes quedan exentos si pagan en USD."
    },
    "request_form": {
      "title": "Solicitar Excursión",
      "contact_viewnia_subtitle": "Completa este formulario para empezar el proceso que nos permitirá coordinar tu excursión con nuestro especialista en terreno."
    },
    "modal_manage_date": {
      "discount": "Agrega un descuento",
      "manage_date": "Administrar fecha",
      "date": "Fecha",
      "starting_time": "Hora de partida",
      "price": "Precio",
      "vacancies": "Cupos",
      "save": "Guardar",
      "cancel_date": "Cancelar fecha",
      "available_ammount": "Cantidad disponible",
      "month_form": {
        "edit_month": "Editar mes",
        "delete_month": "Borrar mes",
        "populate_month": "Llenar mes",
        "disclaimer_1": "Estas a punto de editar <strong>un mes completo</strong>, esta acción es <strong>dificil de revertir</strong>.",
        "disclaimer_2": "Por favor revisa tu calendario actual antes de continuar para así evitar duplicados u otros problemas.",
        "accept": "Aceptar",
        "month": "Mes",
        "week_days": "Días de la semana",
        "continue": "Continuar",
        "final_notice_header": "Por favor lee con atención:",
        "final_notice_1": "Añadir una fecha de salida para la excursión <strong id='fn_title'></strong>, cada <strong id='fn_week_days'></strong>  de <strong id='fn_month'></strong>.",
        "final_notice_2": "Cada salida comenzará a las <strong><span id='fn_starting_time_4i'></span>:<span id='fn_starting_time_5i'></span></strong>, tiene <strong id='fn_vacancies'></strong> y un descuento de <strong id='fn_discount'></strong>.",
        "confirm": "Guardar",
        "back": "Volver",
        "delete_month_disclaimer": "Estás a punto de eliminar todas las salidas del mes, esta acción es <strong>irreversible</strong>.",
        "vacancies": "cupos"
      }
    },
    "checkout_bar": {
      "itinerary": "Itinerario",
      "tourists": "Grupo",
      "assign_tourists": "Asigna",
      "checkout": "Pago",
      "voucher": "Comprobante"
    },
    "reviews": {
      "title": "Reseñas",
      "more": "Más",
      "reviewing_excursion": "Deja tu reseña",
      "thanks_for_submitting": "Gracias por tu reseña",
      "review": "Reseña",
      "footer": "Ver en TrustPilot"
    },
    "newsletter": {
      "sign_up_at": "La solución local para viajes de aventura en la Patagonia",
      "we_value_your_privacy": "Sostenible, personalizado y lleno de aventuras para que disfrutes",
      "sign_up_now": "Regístrate",
      "view_preferences": "Preferencias",
      "subscribe_to_our": "Suscríbete a nuestro Newsletter",
      "email_address": "Dirección Email",
      "subscribe": "Suscríbete",
      "we_are_travel_and_growth": "Conoce Chile y sus paisajes con los mejores tours y excursiones. Vive experiencias locales en entornos inolvidables haciendo lo que te gusta."
    },
    "modal": {
      "first_section": "Selecciona fecha",
      "product_variants": "Selecciona opción",
      "second_section": "Pasajeros",
      "no_daily_quota": "No hay hay suficientes cupos para este día",
      "date": "Fecha",
      "wrong_name": "Nombre o contraseña equivocada",
      "per_person": " c/u",
      "departure_time": "Salida:",
      "spot_left": "Cupos disponibles",
      "add_reserves": "Número de reservas",
      "select": "Elegir",
      "select_date": "Selecciona Fecha",
      "select_date_text": "Selecciona una fecha disponible en el calendario y sigue con los pasos para generar tu reserva.",
      "check_in": "Llegada",
      "check_out": "Salida",
      "guests": "Adultos",
      "child_guests": "Niños",
      "guest_text": "Edad 13 años o más",
      "child_text": "De a a 12 años",
      "twins": "Simple",
      "doubles": "Dobles",
      "doubles_twin": "2 simples'",
      "add_rooms_for": "Agrega tus habitaciones para",
      "guest": "huéspedes",
      "add_to_itinerary": "Elegir",
      "start": "Comienzo",
      "ends": "Término",
      "leave_your_review": "Deja tu reseña",
      "describe_your_experience": "Describe tu experiencia en general",
      "add": "Agregar",
      "next": "Siguiente",
      "load_earlier_dates": "Cargar fechas anteriores ...",
      "load_later_dates": "Cargar fechas posteriores ...",
      "is_resident": "Residentes en Chile",
      "is_not_resident": "No residentes en Chile",
      "language_title": "Escoge país y moneda",
      "language_subtitle": "Selecciona entre la lista de idiomas",
      "currency_subtitle": "Selecciona tu moneda",
      "current_language": "País e idioma actual",
      "other_languages": "Otros países e idiomas"
    },
    "alert": {
      "invalid_changes": "Cambios inválidos",
      "invalid_action": "Acción inválida: la cantidad no puede ser menor que 0",
      "not_enough_availability": "No hay suficiente disponibilidad para ese rango de fechas. Verifica otras acomodaciones o reserva menos unidades.",
      "something_went_wrong": "Algo salió mal. Por favor intentalo de nuevo o contáctanos para ayudarte.",
      "review_already_submitted": "Reseña ya enviada",
      "couldn't_send_review": "No se pudo enviar la reseña",
      "you_must_agree_to": "Debes aceptar nuestros términos y condiciones",
      "no_products_in_your_order": "No hay productos en tu orden",
      "please_sign_the_waiver": "Por favor firma el waiver con tu nombre.",
      "signature_and_tourist": "La firma y el nombre del turista deben ser idénticos.",
      "couldn't_save": "No se pudo guardar, inténtalo de nuevo más tarde.",
      "invalid_language": "Idioma inválido",
      "confirm_to": "Debes confirmar que no eres un robot.",
      "error": "La contraseña debe tener mínimo 8 caracteres, una letra y número"
    },
    "notice": {
      "your_account_has": "Tu cuenta no tiene agencias, contáctenos",
      "session_expired": "La sesión expiró, por favor inicia sesión.",
      "changes_submitted": "¡Cambios enviados!",
      "new_product_created": "Nuevo producto creado, esperando aprobación",
      "invalid_request": "Solicitud no válida. Por favor intentalo de nuevo o contáctanos para ayudarte.",
      "have_excursions": "La agencia tiene excursiones, asignelas a otra antes de eliminarla",
      "updated_information": "Información actualizada",
      "date_no_longer": "La fecha ya no está disponible",
      "availability_updated": "Disponibilidad actualizada",
      "review_sent": "¡Revisión enviada!",
      "bookings_made_for": "Tu reserva fue realizada con exito!",
      "profile_picture_updated": "Foto de perfil actualizada!",
      "tourist_information_saved": "Tu información a sido guardada",
      "enabled": "habilitado",
      "diabled": "deshabilitado",
      "was": "fue",
      "settings_updated": "Ajustes actualizados!",
      "language_updated": "Language updated!",
      "account_updated": "Cuenta actualizada!",
      "reserves_added_for": " reservas añadidas para ",
      "product_was_enabled": "Producto habilitado",
      "product_was_disabled": "Producto deshabilitado"
    },
    "more": {
      "the_best_products": "Las mejores experiencias en Outdoor Index",
      "all_recommendations_in_puerto_natales": "Todas las experiencias en Puerto Natales",
      "all_recommendations_in_punta_arenas": "Todas las experiencias en Punta Arenas",
      "all_recommendations_in_zone": "Todas las sugerencias en %{zone_name}",
      "all_adventure_products": "Todas las experiencias activas",
      "all_standard_products": "Todas las experiencias transformadoras",
      "all_scientific_products": "Todas las experiencias de descubrimiento",
      "all_family_products": "Todas las experiencias familiares y de grupos",
      "all_luxury_products": "Todas las experiencias sofisticadas",
      "all_promotions_products": "Todas las experiencias en promoción",
      "all_ota_products": "Todas las experiencias OTA",
      "a_selection_of_the_best": "Una selección hecha por Outdoor Index",
      "other_activities_that": "Otras actividades que complementan tu experiencia",
      "all_north_patagonia_products": "Todas las experiencias en Patagonia Norte",
      "all_south_patagonia_products": "Todas las experiencias en Patagonia Sur",
      "all_lagos_region_products": "Todas las experiencias en la Región de los Lagos y Ríos"
    },
    "searches": {
      "no_result_to": "Perdona, no hay resultados para \"%{category_name}\" en \"%{zone_name}\"",
      "recommended_for_you": "Experiencias para hacer en \"%{zone_name}\"",
      "category_products_in_zone": "\"%{category_name}\" en \"%{zone_name}\"",
      "category_products_in_zone_no_result": "Perdona, por ahora no hay \"%{category_name}\" en \"%{zone_name}\"",
      "all_products_in_zone": "Todos las experiencias en \"%{zone_name}\"",
      "all_products_in_zone_no_result": "Perdona, no hay experiencias en \"%{zone_name}\"",
      "all_category_products": "Todas las experiencias de \"%{category_name}\"",
      "all_category_products_no_result": "Perdona, por ahora no hay experiencias de \"%{category_name}\"",
      "please_select_category_or_zone": "Por favor selecciona una categoría o zona"
    },
    "guidebook": {
      "download_our_guide_book": "Descarga nuestro libro guía y comienza tu viaje con Outdoor Index",
      "find_out_everything": "Entérate de todo sobre la Patagonia Chilena Sur."
    },
    "banner": {
      "do_you_need_travel_insurance": "¿Necesitas seguro de viaje?",
      "in_partnership_with_world": "Outdoor Index en asociación con World Nomads te brinda el mejor seguro disponible para la Patagonia chilena.",
      "get_a_quote": "Obten cotización"
    },
    "blog": {
      "meta_title": "Blog de Viajes, Naturaleza y Aventura en Chile | Outdoor Index",
      "meta_description": "Explora guías, consejos e inspiración para viajar por Chile, descubrir excursiones outdoor, conectar con la naturaleza y vivir experiencias de aventura.",
      "travel_nature_growth": "Viajes, naturaleza & crecimiento",
      "we_connect_you_with": "Contenido global sobre naturaleza, viajes y crecimiento. ¡Síguenos en redes!",
      "breadcrumb_aria": "Ruta de navegación",
      "breadcrumb_home": "Inicio",
      "breadcrumb_blog": "Blog",
      "guided_tours": "Tours Guiados",
      "book_now": "Reservar ahora",
      "view_more_activities": "Ver más actividades",
      "showing_count": "Mostrando %{loaded} de %{total} artículos",
      "pagination_aria": "Paginación del blog",
      "page_n": "Página %{n}"
    },
    "mail": {
      "welcome_user_name": "Bienvenido(a) a Outdoor Index! %{user_name}",
      "leave_your_review": "%{user_name}, deja una reseña de tu experiencia",
      "voucher": {
        "your_order_is_ready": "Gracias por tu compra %{reference_code}",
        "your_sold_product": "Hola %{user_provider}, hemos vendido una de tus experiencias",
        "new_sold": "Nueva venta %{reference_code}"
      }
    },
    "paypal": {
      "description": "Outdoor Index: Pagando la orden %{reference_code}"
    },
    "payu": {
      "description": "Outdoor Index: Pagando la orden %{reference_code}"
    },
    "pdf": {
      "emergency_contacts": "Contacto de emergencia",
      "congratulations_user_name": "Felicidades %{user_name}",
      "congratulations_agency_name": "Felicidades %{agency_name}",
      "here_we_attach": "Aquí te adjuntamos toda la información de tu viaje. En este voucher podrás ver el detalle de tus experiencias, el contacto de los proveedores, el waiver firmado, como también el comprobante de tu producto pagado (Paypal o PayU). Sientete libre de contactarnos ante cualquier duda.",
      "reservation_number": "Número reserva:",
      "product_detail": "Detalle del producto",
      "departure": "Partida",
      "your_suppliers": "Tus proveedores",
      "in_this_section_appear": "En esta seccion aparece el detalle del pago recibido por Outdoor Index. Recuerda imprimir este voucher y llevarlo siempre contigo. Muchas gracias por preferir Outdoor Index",
      "payments_detail": "Detalles de pagos",
      "initial_payment": "Pago inicial",
      "payment_method": "Medio de pago",
      "total_paid": "Total pagado",
      "total_order": "Total orden:",
      "order_date": "Fecha de orden",
      "payment_date": "Fecha de pago",
      "payment_type": "Tipo de pago",
      "payment_complete": "Pago completo",
      "print_this_voucher": "Imprime este voucher y llevalo contigo",
      "at_all_times": "en todo momento del viaje. Preséntalo al hacer",
      "you_check": "tu check in.",
      "we_have_received": "Hemos recibido una nueva solicitud de reserva de tus productos. A continuación se especifica el detalle de esta y la información de tus pasajeros. Desde este momento puedes contactar a tus pasajeros directamente o si prefieres, instruir a Outdoor Index para que lo haga. Siempre es recomendable enviar un mail informando que la reserva fue realizada con éxito. Te destacarás como un buen proveedor. Recuerda actualizar los cupos de reserva en tus propios sistemas para que no hayan problemas de sobrecupos. Buen trabajo!",
      "guests": "Viajeros",
      "your_guests": "Tus viajeros",
      "date_of_birth": "Fecha de nacimiento:",
      "origin": "Origen:",
      "document_number": "Número de documento:",
      "phone": "Teléfono",
      "email": "Email",
      "emergency_number": "Número de emergencia:",
      "allergies": "Alergias:",
      "medical_conditions": "Condición medica:",
      "food_restrictions": "Restricciones alimenticias:",
      "dear_user_name": "Estimado %{user_name}",
      "service_confirmation": "Confirmación de Servicio",
      "according_to_the_reservation": "De acuerdo con tu solicitud de reserva, confirmamos la siguiente información:",
      "reference_code": "Nro reserva",
      "activity": "Actividad",
      "starting_point": "Lugar",
      "starting_date": "Fecha servicio",
      "starting_time": "Hora servicio",
      "client": "Cliente",
      "payment_details": "DETALLES DE PAGO",
      "applied": "APLICADO",
      "next_payment": "SIGUIENTE PAGO (70%)",
      "excursion": "ACTIVIDAD %{number}",
      "purchase_date": "Fecha compra",
      "description": "Descripción",
      "unit_price": "Precio unitario",
      "unit_price_child": "Precio unitario niño",
      "childen_pax": "Niños",
      "pax": "Pax",
      "tax": "Tax",
      "about_your_host": "SOBRE TU ANFITRIÓN",
      "name": "Persona a cargo:",
      "address": "Dirección:",
      "from": "Fecha de inicio del servicio",
      "to": "Fecha de término del servicio",
      "tourists": "Información de turistas",
      "guest": "Pasajeros",
      "guest_s": "Pasajero",
      "child_guest": "Niños",
      "child_guests": "Niños",
      "child_guest_s": "Niño",
      "guest_price": "Precio Adulto",
      "child_guest_price": "Precio Niño",
      "resident": "Residente",
      "no_resident": "No Residente",
      "problem_with_order": "¿Problemas con su orden?",
      "complete_remaining_payment_web": "Para pagar el saldo pendiente, inicia sesión en tu cuenta en outdoorindex.cl y abre esta orden desde tus vouchers.",
      "contact_us": "Contáctanos"
    },
    "currency": {
      "displaying_prices_in": "Cambio de moneda hecho!"
    },
    "tourists": {
      "first_create_group": "Ooops! No olvides llenar la información de los pasajeros."
    },
    "date": {
      "abbr_day_names": [
        "Dom",
        "Lun",
        "Mar",
        "Mié",
        "Jue",
        "Vie",
        "Sáb"
      ],
      "abbr_month_names": [
        null,
        "ene",
        "feb",
        "mar",
        "abr",
        "may",
        "jun",
        "jul",
        "ago",
        "sep",
        "oct",
        "nov",
        "dic"
      ],
      "day_names": [
        "domingo",
        "lunes",
        "martes",
        "miércoles",
        "jueves",
        "viernes",
        "sábado"
      ],
      "month_names": [
        null,
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre"
      ],
      "formats": {
        "default": "%d/%m/%Y",
        "short": "%a %e %b",
        "long": "%d %B %Y",
        "fixed_departure": "DD/M/YYYY",
        "calendar_picker": "DD/MM/YYYY",
        "moment": "%Y-%m-%d"
      }
    },
    "time": {
      "formats": {
        "default": "%d/%m/%Y",
        "short": "%a %e %b",
        "long": "%d %B %Y",
        "full": "%a, %d %B / %Y",
        "calendar_picker": "DD/MM/YYYY"
      }
    },
    "activities": {
      "trekking": "Caminatas",
      "horseback": "Cabalgatas",
      "birdwatching": "Avistamiento Aves",
      "mountaineering": "Montañismo",
      "icehike": "Caminata en Hielo",
      "kayak": "Kayak",
      "flyfishing": "Pesca con Mosca",
      "navigations": "Navegaciones",
      "cruises": "Cruseros",
      "helicopter": "Helicoptero",
      "multiactivity": "Multi Actividades",
      "photosafari": "Safari Fotográfico",
      "bikes": "Bicicletas",
      "snowshoes": "Raquetas de nieve",
      "ski": "Ski",
      "rafting": "Rafting"
    },
    "filters": {
      "clear_filters": "Limpiar filtros"
    },
    "lang": {
      "countries": {
        "spain": "España",
        "argentina": "Argentina",
        "bolivia": "Bolivia",
        "chile": "Chile",
        "colombia": "Colombia",
        "costa_rica": "Costa Rica",
        "ecuador": "Ecuador",
        "mexico": "México",
        "peru": "Perú",
        "paraguay": "Paraguay",
        "uruguay": "Uruguay",
        "united_states": "Estados Unidos",
        "england": "Inglaterra",
        "australia": "Australia",
        "canada": "Canadá",
        "new_zealand": "Nueva Zelanda",
        "ireland": "Irlanda",
        "portugal": "Portugal",
        "brazil": "Brasil",
        "france": "Francia",
        "germany": "Alemania",
        "china": "China",
        "hong_kong": "Hong Kong",
        "japan": "Japón",
        "korea": "Korea",
        "singapore": "Singapur",
        "taiwan": "Taiwán"
      }
    }
  },
  "en": {
    "terms": {
      "head": {
        "conditions": "Terms of Service",
        "privacy": "Privacy Policy",
        "cookies": "Cookie Policy.",
        "you_as_a_consumer": "You, as a consumer, have the right to be informed about the documentation that could be needed to carry out your trip according to plan.  Verify ahead of time if a passport, visa, vaccines, permission for minors or other documentation is required, whether it be to enter Chile or any other country you pass through in your travels.  If one of these is required and you do not possess it, complete the necessary steps to obtain it with anticipation."
      }
    },
    "devise": {
      "google_sign_in": "Connect with Google",
      "facebook_sign_in": "Connect with Facebook",
      "apple_sign_in": "Connect with Apple",
      "already_have_an_account?": "You have an account?",
      "didn't_receive_confirmation_instructions?": "Didn't receive confirmation instructions?",
      "didn't_receive_unlock_instructions?": "Didn't receive unlock instructions?",
      "forgot_your_password?": "Forgot your password?",
      "don't_have_an_account?": "Don't have an account?",
      "enter_email_associated": "Enter the email associated with your account and we'll email you a link to reset your password.",
      "passwordless": {
        "not_found_in_database": "Could not find a user for that email address",
        "magic_link_sent": "A login link has been sent to your email address. Please follow the link to log in to your account.",
        "magic_link_sent_paranoid": "If your account exists, you will receive an email with a login link. Please follow the link to log in to your account."
      },
      "confirmations": {
        "confirmed": "Your email address has been successfully confirmed.",
        "send_instructions": "You will receive an email with instructions for how to confirm your email address in a few minutes.",
        "send_paranoid_instructions": "If your email address exists in our database, you will receive an email with instructions for how to confirm your email address in a few minutes."
      },
      "failure": {
        "magic_link_invalid": "Invalid or expired login link.",
        "already_authenticated": "You are already signed in.",
        "inactive": "Your account is not activated yet.",
        "invalid": "Invalid %{authentication_keys} or password.",
        "locked": "Your account is locked.",
        "last_attempt": "You have one more attempt before your account is locked.",
        "not_found_in_database": "Invalid %{authentication_keys} or password.",
        "timeout": "Your session expired. Please sign in again to continue.",
        "unauthenticated": "You need to sign in or sign up before continuing.",
        "unconfirmed": "You have to confirm your email address before continuing."
      },
      "mailer": {
        "magic_link": {
          "subject": "Link to login",
          "greeting": "Hello %{email}!",
          "instructions": "You can login using the link below:",
          "login_button": "Log in to my account",
          "expiration_notice": "Note that the link will expire in %{expiration_time}."
        },
        "confirmation_instructions": {
          "subject": "Confirmation instructions"
        },
        "reset_password_instructions": {
          "subject": "Reset password instructions"
        },
        "unlock_instructions": {
          "subject": "Unlock instructions"
        },
        "email_changed": {
          "subject": "Email Changed"
        },
        "password_change": {
          "subject": "Password Changed"
        }
      },
      "omniauth_callbacks": {
        "failure": "Could not authenticate you from %{kind} because \"%{reason}\".",
        "success": "Successfully authenticated from %{kind} account."
      },
      "passwords": {
        "no_token": "You can't access this page without coming from a password reset email. If you do come from a password reset email, please make sure you used the full URL provided.",
        "send_instructions": "You will receive an email with instructions on how to reset your password in a few minutes.",
        "send_paranoid_instructions": "If your email address exists in our database, you will receive a password recovery link at your email address in a few minutes.",
        "updated": "Your password has been changed successfully. You are now signed in.",
        "updated_not_active": "Your password has been changed successfully."
      },
      "registrations": {
        "destroyed": "Bye! Your account has been successfully cancelled. We hope to see you again soon.",
        "signed_up": "Welcome! You have signed up successfully.",
        "signed_up_but_inactive": "You have signed up successfully. However, we could not sign you in because your account is not yet activated.",
        "signed_up_but_locked": "You have signed up successfully. However, we could not sign you in because your account is locked.",
        "signed_up_but_unconfirmed": "A message with a confirmation link has been sent to your email address. Please follow the link to activate your account.",
        "update_needs_confirmation": "You updated your account successfully, but we need to verify your new email address. Please check your email and follow the confirm link to confirm your new email address.",
        "updated": "Your account has been updated successfully."
      },
      "sessions": {
        "signed_in": "Signed in successfully.",
        "signed_out": "Signed out successfully.",
        "already_signed_out": "Signed out successfully."
      },
      "unlocks": {
        "send_instructions": "You will receive an email with instructions for how to unlock your account in a few minutes.",
        "send_paranoid_instructions": "If your account exists, you will receive an email with instructions for how to unlock it in a few minutes.",
        "unlocked": "Your account has been unlocked successfully. Please sign in to continue."
      }
    },
    "errors": {
      "something_went_wrong": "Something went wrong",
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "must be accepted",
        "blank": "can't be blank",
        "confirmation": "doesn't match %{attribute}",
        "empty": "can't be empty",
        "equal_to": "must be equal to %{count}",
        "even": "must be even",
        "exclusion": "is reserved",
        "greater_than": "must be greater than %{count}",
        "greater_than_or_equal_to": "must be greater than or equal to %{count}",
        "inclusion": "is not included in the list",
        "invalid": "is invalid",
        "less_than": "must be less than %{count}",
        "less_than_or_equal_to": "must be less than or equal to %{count}",
        "model_invalid": "Validation failed: %{errors}",
        "not_a_number": "is not a number",
        "not_an_integer": "must be an integer",
        "odd": "must be odd",
        "other_than": "must be other than %{count}",
        "present": "must be blank",
        "required": "must exist",
        "taken": "has already been taken",
        "must_contain_number": " must contain at least one number",
        "must_contain_special": " must contain special character",
        "must_contain_lower": " must contain at least 1 lowercase ",
        "must_contain_upper": " must contain at least 1 uppercase ",
        "too_long": {
          "one": "is too long (maximum is 1 character)",
          "other": "is too long (maximum is %{count} characters)"
        },
        "too_short": {
          "one": "is too short (minimum is 1 character)",
          "other": "is too short (minimum is %{count} characters)"
        },
        "wrong_length": {
          "one": "is the wrong length (should be 1 character)",
          "other": "is the wrong length (should be %{count} characters)"
        },
        "already_confirmed": "was already confirmed, please try signing in",
        "confirmation_period_expired": "needs to be confirmed within %{period}, please request a new one",
        "expired": "has expired, please request a new one",
        "not_found": "not found",
        "not_locked": "was not locked",
        "not_saved": {
          "one": "1 error prohibited this %{resource} from being saved:",
          "other": "%{count} errors prohibited this %{resource} from being saved:"
        }
      }
    },
    "meta_tags": {
      "default": {
        "description": "Discover Chile with exclusive adventure programs and expert guides. Live a unique experience! Book your unforgettable trip.",
        "keywords": "Patagonia, Chile, adventure tours, Patagonia adventure tours, Chile adventure tours, Torres del Paine tours, Patagonia hiking tours, Patagonia kayaking tours, Patagonia horseback riding tours, Patagonia multisport tours, family adventure tours Patagonia, luxury adventure tours Patagonia, budget adventure tours Patagonia, best adventure tours Patagonia, adventure trips Patagonia, adventure activities Patagonia, adventure excursions Patagonia, adventure programs Patagonia",
        "name": "Outdoor Index"
      },
      "help": {
        "title": "Outdoor Index - Help",
        "description": "Have questions about your trip to Patagonia? Visit Outdoor Index and talk to local guides and area experts.",
        "keywords": null
      }
    },
    "views": {
      "pagination": {
        "truncate": "…"
      }
    },
    "activerecord": {
      "models": {
        "season": "Season",
        "seasons": "Seasons"
      },
      "attributes": {
        "season": {
          "name": "Name",
          "valid_from": "Valid from",
          "valid_until": "Valid until",
          "start_time": "Start time",
          "product": "Excursion",
          "mon_check": "Mon",
          "tue_check": "Tue",
          "wed_check": "Wed",
          "thu_check": "Thu",
          "fri_check": "Fri",
          "sat_check": "Sat",
          "sun_check": "Sun"
        },
        "order": {
          "clp_charge": "CLP charge",
          "usd_charge": "USD charge",
          "username": "Client:",
          "email": "Email:",
          "product": "Product:",
          "product_name": "Product",
          "pax_manual": "Pax No:",
          "manual_total": "Paid:",
          "manual_currency": "Currency:",
          "partial_payment": "Payment:",
          "payment_method": "Method:",
          "channel": "Channel:",
          "confirmed_at": "Purchase:",
          "departure_at": "Departure:",
          "starting_datetime": "Departure time:",
          "customer_phone": "Phone:",
          "extra": "Extra:",
          "instructions": "Instructions:",
          "language": "Language:",
          "weather_link": "Weather link",
          "post_link": "Post link",
          "itinerary_document": "Itinerary document",
          "show_itinerary_document": "Show"
        }
      }
    },
    "promotions": {
      "coupon_code_ok": "Coupon code applied success",
      "coupon_code_error": "Coupon code does not exist",
      "coupon_code_already": "Coupon code has already been applied",
      "coupon_code_max": "Maximum one coupon per order",
      "coupon_code_destroy_ok": "Code removed successfully",
      "coupon_code_destroy_error": "Could not remove code",
      "coupon_code_destroy_confirm": "Are you sure you want to delete it?",
      "coupon_have_a_coupon": "Do you have a discount coupon?",
      "coupon_form_palceholder": "Discount code",
      "coupon_apply": "Apply"
    },
    "home_collections": {
      "home_reviews": "350+ people travel with Outdoor Index every year",
      "find_your_experience": "Find your experience",
      "carousel_region": "Adventures by region",
      "carousel_activities": "Adventures by activities",
      "carousel_time_preference": "Adventures by time preference",
      "sub-landing": "Discover the best tourist options in Chile with Outdoor Index. Compare and explore a wide variety of programs from Atacama to Patagonia. Book today to live unique experiences!",
      "title": "Tours of adventure in Chile and Patagonia",
      "subtitle": "Find adventures with the best local guides"
    },
    "products_search": {
      "activities": "Activities",
      "regions": "Regions",
      "time": "Time",
      "date": "Datex",
      "date_sub_label": "When do you want to go?",
      "activities_sub_label": "Choose your favorite activities",
      "regions_sub_label": "What region you want to visit?",
      "time_sub_label": "Select your time preference!",
      "all_adventures": "All Adventures",
      "search_placeholder": "Search adventures across Chile",
      "most_popular_searches": "Most popular searches",
      "see_all_adventures": "See all adventures",
      "help_me_choose": "Help me to Choose",
      "help_me_choose_url": "https://api.whatsapp.com/send?phone=56981785011&text=Hi%2C%20I%20need%20help%20choosing%20an%20adventure",
      "popular_search_items": {
        "circuito_w": {
          "label": "Circuito W",
          "icon": "search",
          "landing_slug": "circuito-w"
        },
        "circuito_o": {
          "label": "Circuito O",
          "icon": "search",
          "landing_slug": "circuito-o"
        },
        "torres_del_paine": {
          "label": "Torres del Paine",
          "icon": "map-pin",
          "zone_id": 1
        },
        "pucon": {
          "label": "Pucón",
          "icon": "map-pin",
          "zone_id": 16
        },
        "san_pedro_atacama": {
          "label": "San Pedro de Atacama",
          "icon": "map-pin",
          "zone_id": 15
        },
        "puerto_natales": {
          "label": "Puerto Natales",
          "icon": "map-pin",
          "zone_id": 2
        }
      },
      "search": "Search",
      "clear": "Clear Selection",
      "tours": "tours",
      "subtext": "Plan your next adventure.\nExplore, book and enjoy nature.",
      "in": "in",
      "showing_count": "Showing %{loaded} of %{total} adventures",
      "load_more": "Load more"
    },
    "comments": {
      "comments": "Comments",
      "replies": "Replies",
      "post_a_comment": "Post a comment!",
      "submit": "Submit",
      "reply": "Reply",
      "body": "Write your comment here..."
    },
    "order": {
      "confirmed": "Confirmed",
      "mail_thank": "thanks for your purchase in Outdoor Index",
      "mail__hi": "Hi!",
      "mail_subject": "Outdoor Index Order N#",
      "order_t": "Order",
      "see_purchase": "Review your purchases!",
      "already_paid": "Order already paid",
      "confirm_payment": "Confirm",
      "cancel_order": "Cancel",
      "recover_order": "Recover",
      "send_confirm": "Confirm (1)",
      "send_reminder": "Reminder (2)",
      "send_last_reminder": "Re-reminder (3)",
      "send_review": "Review (4)",
      "email_title": "Excursion Reminder",
      "email_footer": "here is a reminder of your excursion. If you have any questions, feel free to contact us at info@outdoorindex.cl or +56981785011.",
      "promo": "Visit www.outdoorindex.cl for more excursions and programs.",
      "edit": "Edit",
      "departure_date": "Departure date",
      "reservation": "Reservation",
      "code": "Code",
      "departure": "Departure",
      "contact_info": "Contact information",
      "customer_phone": "Contact number",
      "travelers": "Travelers",
      "itinerary": "Itinerary",
      "view_itinerary": "Download your itinerary",
      "view_itinerary_file": "here",
      "voucher": "View voucher",
      "confirmation_email_title": "Your reservation for %{excursion} is now confirmed",
      "view_weather_link": "Check the weather",
      "instruction_exerpt": "We know that your excursion is approaching and you should already be preparing",
      "here_some_instructions": "Instructions",
      "view_post_link": "Our blog",
      "review_email_title": "Tell us how your excursion went %{excursion}",
      "review_link": "Complete post-trip survey",
      "review_trustpilot_intro": "If you would like other travelers to read about your experience, you can also leave a public review on Trustpilot.",
      "review_trustpilot_link": "Leave a review on Trustpilot",
      "review_question": "How was your excursion?",
      "review_explain_title": "Why completing the survey matters",
      "rewview_explain_body": "<p>Your feedback helps us improve every excursion. The post-trip survey is confidential and helps us understand your experience: the organization, the guide, the activities and the details that made a difference.</p>\n<p>Reflect on your trip before, during and after the excursion. It only takes a few minutes to answer honestly.</p>\n<p>Your responses help us maintain the quality of our service and keep improving for future travelers.</p>\n",
      "review_terrible": "Terrible",
      "review_bad": "Bad",
      "review_acceptable": "Acceptable",
      "review_good": "Good",
      "review_great": "Great",
      "new_order_excerpt": "Here you can complete all the necessary information to create an order. Write clear and precise instructions indicating the times and meeting points for each reservation. Also, remember to contact operators by priority order."
    },
    "ondemand": {
      "explanation": "Exclusive tour! Contact our field specialist.",
      "label": "Private"
    },
    "request": {
      "greeting": "Hi! This information has been sent to your registered email with a copy to one of our agents. Someone will be contacting you soon.",
      "order_mail": {
        "header": {
          "hi": "Hi! We have news about your excursion application!",
          "title": "Your application has been accepted by the Local operator. Please read the information bellow, and make sure everything is allright.",
          "your_order": "Your order N°",
          "ready": "is available for payment."
        },
        "footer": "Now you can go to the payments section through the button link.",
        "disclaimer": "You'll be redirected to a payment window in Outdoor Index via secure connection.",
        "pay": "Pay now",
        "excursion": {
          "title": "Excursion",
          "agency": "Local Operator"
        },
        "manual_order": {
          "observations": "Read the comments bellow from Outdoor Index agent!",
          "price": "Price",
          "price_clp": "Price CLP",
          "price_usd": "Price USD"
        },
        "request_details": "Your application details"
      },
      "singular": "Request",
      "requester": "Requester",
      "product_required": "To request an order, you must login previously",
      "excursion": "Excursion",
      "applicants": "Applicants",
      "from": "From",
      "to": "To",
      "comments": "Comments",
      "comments_placeholder": "Leave us your questions, doubts or anything you want to tell us before we contact you. We’ll reach you as soon as possible!",
      "submit": "Send application",
      "modal_success_title": "Application sent",
      "modal_success_body": "We received your details. We will contact you soon using the information you provided.",
      "modal_close": "Close",
      "email_title": "Excursion coordination application",
      "email_footer": "This form has been sent to our executives. You will be contacted through the information you provide in the contact form. If there are any errors or observations in the form, please, send an email to info@outdoorindex.cl regarding the issue.",
      "contact_name": "Contact name",
      "contact_email": "Contact email",
      "contact_phone": "Contact phone",
      "must_log_in": "You must log in before you can pay",
      "phone": "Contact phone",
      "name": "Name",
      "last_name": "Lastname"
    },
    "applicants": {
      "applicants_number": "2) How many people will participate in the Excursion?",
      "dates_sub": "3) In which days do you wanna make this Excursion?",
      "additional_info": "4) Additional information",
      "applicants_phone": "1) Leave us your contact information",
      "phone_placeholder": "Phone",
      "email": "Email",
      "name": "Name",
      "lastname": "Lastname"
    },
    "active_admin": {
      "observed_dollar_update": "Update",
      "agency": "Operators",
      "agencies": "Agencies",
      "settings": "Settings",
      "users": "Users",
      "admin_users": "Admin Users",
      "orders": "Orders",
      "pages": "Pages",
      "sales": "Sales",
      "sale_goals": "Sale Goals",
      "reviews": "Reviews",
      "blog": "Blog",
      "suppliers": "Suppliers",
      "covers": "Home",
      "excursions": "Excursions",
      "categories": "Categories",
      "comments_tab": "Comments",
      "excursion_images": "Excursion images",
      "home": "Home",
      "home_collections": "Home Collections",
      "save_home_collections": "Save Collection",
      "images": "Post images",
      "mailer": "Mailer",
      "newsletter_covers": "Newsletter covers",
      "notifications": "Notifications",
      "payment_methods": "Payment methods",
      "private": "Private",
      "products": "Products",
      "profiles": "Profiles",
      "properties": "Properties",
      "promotions": "Promotions",
      "question_subjects": "Question subjects",
      "questions": "Questions",
      "tourists": "Tourists",
      "requests": "Requests",
      "tags": "Tags",
      "visits": "Visits",
      "zones": "Zones",
      "seasons": "Seasons",
      "macro_zones": "Macro Zones",
      "landings": "Landings",
      "post": {
        "title": "Title",
        "subtitle": "Subtitle",
        "label": "Label",
        "author_name": "Author name",
        "author_sm": "Author Social Media",
        "content": "Content",
        "cover": "Cover",
        "published": "Published",
        "unpublished": "Unpublished",
        "tags": "Tag",
        "recommended_posts": "Recommended Posts",
        "products": "Tours & excursions",
        "explore_chile": "Explore Chile and its hidden gems with Outdoor Index"
      },
      "zone": {
        "name": "Name",
        "description": "Description",
        "sort_order": "Sort order",
        "country": "Country",
        "state": "State",
        "masonry_cover": "Masonry photo (home)",
        "masonry_cover_hint": "Optional. Used for masonry-style collection cards on the home page. If empty, a product image from the zone is used."
      },
      "review": {
        "tilte1": "Create Review",
        "title2": "Cover",
        "author": "Name",
        "country": "Country",
        "review_date": "Review date",
        "language": "Language",
        "save_review": "Save review",
        "body": "Review text",
        "cover": "Cover",
        "rating": "Rating",
        "url": "URL",
        "excerpt": "Here you can complete all the necessary information to create a Review. Always make sure that the cover photo you upload have a good resolution and is correct. Remember to read y check the information."
      },
      "landing": {
        "tilte1": "Create Landing",
        "title2": "Meta",
        "title3": "Cover",
        "title4": "Reviews",
        "title5": "FAQ",
        "save_landing": "Save landing",
        "title": "Title",
        "place": "Place",
        "body": "Body",
        "cover": "Cover",
        "review": "Review",
        "meta_title": "Meta title",
        "meta_description": "Meta description",
        "product": "Excursion",
        "excerpt": "Here you can complete all the necessary information to create a Landing. Always make sure that the cover photo you upload have a good resolution and are attractive to the tourist. Remember to give clear and reliable information.",
        "more_info": "More info"
      },
      "season": {
        "name": "Name",
        "valid_from": "From",
        "valid_until": "Until",
        "start_time": "Start time",
        "product": "Excursion",
        "child_usd_price": "Childs in dollars",
        "child_clp_price": "Childs in CLP",
        "single_supplement_usd_price": "Dollars",
        "single_supplement_clp_price": "CLP",
        "guardar_temporada": "Save",
        "daily_quota": "Availability",
        "title_days": "Days",
        "title_ages": "Ages",
        "title_prices_kids": "Kids price",
        "title_prices_adults": "Adults price",
        "title_single_supplement": "Single Supplement"
      },
      "kpis": {
        "observed_dollar": "Observed dollar value",
        "observed_dollar_subtitle": "Dollar value define by the Central Bank",
        "visits_today_title": "Today's visits",
        "visits_today_subtitle": "Flows for today",
        "visitors": "Visitors",
        "last_day": "Previous day",
        "show_more": "See more",
        "countries": "Countries",
        "countries_subtitle": "Those who visit us the most",
        "country_anon": "Anonymous",
        "abandoned_cart_title": "Abandoned Backpacks",
        "abandoned_cart_subtitle": "Orders left in the backpack",
        "products_viewed_title": "Most viewed products",
        "products_viewed_subtitle": "Most popular for now",
        "posts_viewed_title": "Most viewed post",
        "posts_viewed_subtitle": "Most popular for now",
        "products_selled_title": "Best Selling Products",
        "products_selled_subtitle": "In the last year",
        "today_excursions_title": "Excursions today",
        "today_excursions_subtitle": "Tourists leaving today for their tour.",
        "users_month_title": "Monthly statistics",
        "users_month_subtitle": "Statistical balance of monthly users.",
        "users_number": "Number of users",
        "new_users_title": "New Users",
        "new_users_subtitle": "Registered last month",
        "users_total_title": "Total Users",
        "users_total_subtitle": "Registered from the start",
        "new_users_title_box": "Today's users",
        "new_users_subtitle_box": "Visit flows of the day",
        "users": "Users",
        "new_orders_title": "New Orders",
        "new_orders_subtitle": "Registered this month",
        "paid_orders_title": "Paid Orders",
        "paid_orders_subtitle": "Registered this month",
        "sale_goals_title": "Sales target",
        "sale_goals_subtitle": "Total yield for this month",
        "goals": "Goal",
        "to": "to",
        "no_sale_goal": "No sale goal defined",
        "conversion_chart_title": "Conversion Chart",
        "conversion_chart_subtitle": "Conversion rate from the last year",
        "conversion_last_year": "Conversion rate last year",
        "conversion_title": "Conversion rate",
        "conversion_subtitle": "Updated to date"
      }
    },
    "mercado_pago": {
      "error_alert": "An error has occurred with Mercado Pago, please check if your order is paid.",
      "error_title": "Transaction rejected",
      "error_dec": "There was an error in processing the payment, please try again. If the problem persists, contact us.",
      "pending_title": "Transaction pending",
      "pending_dec": "Your payment is pending verification in Mercado Pago. Once verified, contact us to validate your Order."
    },
    "webpay": {
      "error_alert": "An error has occurred with Webpay, please check if your order is paid.",
      "error_title": "Transaction rejected",
      "error_dec": "There was an error in processing the payment, please try again. If the problem persists, contact us."
    },
    "back": "Back",
    "chat_title": "How can we help?",
    "chat_subtitle": "We usually respond in a few hours",
    "chat_name": "Name",
    "chat_email": "Email",
    "chat_phone": "Phone",
    "chat_subject": "Subject",
    "chat_body": "Body",
    "chat_btn": "Send Message",
    "menu_welcome": "Welcome, %{user_name}",
    "meesage_sended": "Meesage Sended",
    "meesage_captcha": "You must check the captcha",
    "view_more": "View more...",
    "view_more_excursions": "View more excursions...",
    "view_more_suggestions": "View more suggestions...",
    "location": "Location",
    "zone": "Zone",
    "category": "Category",
    "select_one": "Select One",
    "select_multiple": "Select multiple",
    "select_two": "2 max",
    "price": "Price",
    "vacancies": "Vacancies",
    "key": "Ex: Elevation",
    "value": "1300 mt",
    "value_included": "Ex: Bilingual guide",
    "profiles": "Profiles",
    "optional": "Optional",
    "email": "Email",
    "phone": "Phone",
    "address": "Address",
    "pending": "Pending",
    "edit": "Edit",
    "soon": "Soon",
    "password": "Password (min 8 characters, letter, number)",
    "password_confirmation": "Password confirm",
    "remember_me": "Remember me",
    "log_in": "Log In",
    "sign_up": "Sign Up",
    "create_an_account": "Create your account",
    "name": "Name",
    "last_name": "Last name",
    "back_to": "Back to",
    "reset_password": "Restore password",
    "send": "Send",
    "guests": "Adults",
    "guest": "Adult",
    "guest_s": "Adult",
    "child_guest": "Child",
    "child_guests": "Childs",
    "child_guest_s": "Child",
    "products": "Products",
    "products_show_photos": "Show (%{n}) photos",
    "delete": "Delete",
    "continue": "Continue",
    "subtotal": "Subtotal:",
    "total_only": "Total",
    "total": "Total to paid:",
    "total_paid": "Total paid",
    "total_final": "Final total",
    "coupon": "Coupon",
    "charges": "Charges:",
    "image_not_found": "Image not found",
    "usd": "USD",
    "clp": "CLP",
    "departure": "Departure",
    "when": "When",
    "what": "What",
    "where": "Where",
    "search": "Search",
    "language": "Language",
    "puerto_natales": "Puerto Natales",
    "punta_arenas": "Punta Arenas",
    "tierra_del_fuego": "Tierra del Fuego",
    "puerto_williams": "Puerto Williams",
    "in": "in",
    "or": "or",
    "help": "Frequently asked questions",
    "go_to_home_page": "Go to homepage",
    "add_row": "+ Add",
    "from": "From ",
    "days": "days",
    "hours": "hours",
    "home": {
      "site_title": "Outdoor Index: Book adventure tours in Patagonia and Chile",
      "things_to_do_in": "Suggestions in",
      "scientific_excursions": "In deep touch with nature",
      "luxury_experience": "Live exclusive, just for you",
      "adventure_excursions": "Put more of yourself",
      "the_best_excursions": "Best excursions for this season",
      "explore_your_interests": "Explore your interests",
      "excursions": "Excursions",
      "products": "products",
      "suggestions": "Suggestions",
      "hard_adventurous": "Active",
      "soft_adventurous": "Transformative",
      "scientific": "Discovery",
      "family": "Groups",
      "luxury": "Sofisticate",
      "promotions": "Discounts & offers",
      "download": "Download",
      "adventures_by_region": "Adventures by region",
      "north_patagonia": "North Patagonia",
      "south_patagonia": "South Patagonia",
      "masonry_zone_count": "%{count} adventures"
    },
    "masonry_zones": {
      "names": {
        "1": "Torres del Paine",
        "2": "Puerto Natales",
        "3": "Punta Arenas",
        "4": "Tierra del Fuego",
        "5": "Puerto Williams",
        "6": "Antarctica"
      }
    },
    "survey_page": {
      "title": "Outdoor Index - After sales survey",
      "description": "We would like to know your opinion about the service you received. Your feedback is very important to us.",
      "main_heading": "Post-Trip Survey Outdoor Index"
    },
    "header": {
      "agency_panel": "Agency panel",
      "supplier_panel": "Supplier panel",
      "ask_us_a_question": "Contact us",
      "help": "FAQ",
      "itinerary": "Itinerary",
      "sign_out": "Log out",
      "sign_up": "Sign up",
      "log_in": "Log in",
      "join_our_newsletter": "Join our newsletter",
      "partner": "Partner",
      "blog": "Exclusive stories:",
      "your_blog": "your blog 🔥",
      "config": "Config",
      "orders": "Vouchers",
      "cart": "Cart"
    },
    "header_cat": {
      "excursions": "Excursions",
      "recommendations": "Suggestions",
      "accommodation": "Accommodation",
      "other": "Other"
    },
    "agencies": {
      "address": "Address",
      "review": "Review",
      "agency_type": "Agency Type",
      "owner": "Owner",
      "holder_name": "Holder Name",
      "holder_id": "Holder ID",
      "holder_email": "Holder Email",
      "phone": "Phone",
      "bank_name": "Bank name",
      "account_type": "Account type",
      "account_number": "Account number",
      "agency": "Agency",
      "country": "Country",
      "state": "State",
      "zone": "Zone",
      "duration": "Duration",
      "created_at": "Created at",
      "agency_info": "Information",
      "supplier_info": "Information",
      "products": "Products",
      "numbers": "Numbers",
      "excursions": "Excursions",
      "list_title": "A list of all your dates",
      "no_dates": "No dates yet, please click on the calendar to create one.",
      "change_availability": "Manage your dates",
      "date_range": "Modify according to date range",
      "set_price": "Set price",
      "rooms_to_add": "Rooms to add",
      "rooms_to_remove": "Rooms to remove",
      "products_to_add": "Add products",
      "products_to_remove": "Remove products",
      "apply_changes": "Apply changes",
      "edit_excerpt": "All the information requested to create the supplier profile is of vital importance to establish the commercial link with Outdoor Index. Please enter up to date information.",
      "agency_information": "Agency information",
      "supplier_information": "Supplier information",
      "max_words": "150 words",
      "for_booking": "for booking",
      "supplier_review": "Supplier review ",
      "website_url": "Website URL",
      "person_in_charge": "person in charge",
      "name": "Name",
      "update_info": "Save profile",
      "commercial_information": {
        "self": "Commercial information",
        "name": "Name",
        "bank_name": "Bank name",
        "bank_account": "Bank account",
        "account_type": "Account type",
        "commercial_name": "Commercial name",
        "id_rut": "ID / Rut"
      },
      "actions": "Actions",
      "manage_dates": "Dates",
      "active": "Approved",
      "pending_changes": "Pending",
      "index_excerpt": "Here is the list of your products. You can create, edit and manage the dates. Each product created will remain in the \"Pending\" state until it is reviewed by the Outdoor Index team.",
      "manage_dates_excerpt": "Here you have a calendar to add all your products. You can create, edit and manage the dates. Each product created will remain in the \"Pending\" state until it is reviewed by the Outdoor Index team.",
      "create_excursion": "Create Excursion",
      "create_product": "Create product",
      "create_activity": "Create activity",
      "create_post": "Create post",
      "new_excursion_excerpt": "Here you can complete all the necessary information to create a product. Always make sure that the photos you upload have a good resolution and are attractive to the tourist. Remember to give clear and reliable information.",
      "english": "Traducir al ingles →",
      "spanish": "Translate to spanish →",
      "create_agency": "Create new agency",
      "agency_bank": "Add bank account"
    },
    "error": {
      "sorry": "Sorry, this page doesn't exist.",
      "opps": "You may have mistyped the address or the page may have moved.",
      "go": "Go to homepage",
      "went_wrong": "We're sorry, but something went wrong.",
      "improvements": "If you see this message, it's because you may have typed the web address incorrectly or because we are updating the site with new features and improvements. Please wait a few minutes and reload the page again. Thank you!"
    },
    "excursions": {
      "itinerary": {
        "body": "Body"
      },
      "faq": {
        "body": "Body"
      },
      "title": "Title",
      "location": "Place",
      "zone": "Zone",
      "category": "Category",
      "profiles": "Trip style",
      "price": "Price (in dollars)",
      "vacancies": "Vacancies",
      "duration": "Duration",
      "half_day": "Half day",
      "full_day": "Full day",
      "multiple_days": "Multiple days",
      "duration_days": "Days",
      "duration_hours": "Hours",
      "days": {
        "zero": "Day",
        "one": "Day",
        "other": "Days"
      },
      "hours": {
        "zero": "Hour",
        "one": "Hour",
        "other": "Hours"
      },
      "add_images_(minimum_3)": "Photos (minimum 3)",
      "disclaimer": "Disclaimer",
      "description": "Overview",
      "body": "Our itinerary",
      "useful_information": "Useful information",
      "what's_included?": "Included",
      "what's_not_included?": "Not included",
      "meeting_instruction": "Starting place",
      "meeting_address": "Address",
      "policies": "Policies",
      "save_excursion": "Save excursion",
      "what_we'll_do": "Overview",
      "our_itinerary": "Itinerary",
      "faqs": "FAQs",
      "images": "Images",
      "edit_excerpt": "All the information requested to create the supplier profile is vital importance to establish the commercial link with Outdoor Index. Please enter the most reliable information possible.",
      "other_excursions_from_this_tour_company": "Other experiences from this supplier",
      "create_excursions": "Create excursions",
      "more": "More",
      "less": "Less",
      "best_excursions_for_the_next_season": "Recommended for this season",
      "add_extras": "Add extras",
      "price_per_reservations": "Price per reservations",
      "extra_description": "Activity",
      "macro_zone": "Macro Zone",
      "meta_title": "Meta title",
      "meta_description": "Meta description",
      "time": "Time",
      "prices": "Prices",
      "included": "Whats included?",
      "locations": "Location",
      "alternative_names": "Excursion also known by the following names",
      "breadcrumb_catalog": "Tours & excursions"
    },
    "hotels": {
      "twin": "Twin",
      "double": "Double",
      "double_twins": "Double twin",
      "room_reserved": "room reserved",
      "edit_your_booking": "Edit your booking"
    },
    "reservations": {
      "add_guest_details": "Add info pax",
      "traveler_data_card_title": "Traveler details",
      "traveler_data_badge_missing": "Missing info",
      "traveler_data_badge_complete": "Complete",
      "traveler_data_badge_ready_details": "Ready info",
      "traveler_data_intro": "We need this information to confirm your reservation.",
      "traveler_data_complete_button": "Traveler info",
      "detach_guest_confirm": "Remove this traveler from this booking?",
      "guest_slots_full": "This reservation already has all travelers assigned.",
      "organize_your_itinerary": "1) Itinerary >",
      "create_your_travel_group": "2) Travel group >",
      "assign_tourists": "3) Assign tourists",
      "new_checkout_excerpt": "Here you can find a listg of your products. Don’t forget to add the information of the guests in the Excursion in wich they participate. Before buying, check the number of reservations and their costs. Remember to read our Cancellation policy",
      "cart_title": "Information of your trip",
      "checkout_page_title": "Confirm your reservation and complete payment",
      "checkout_page_intro": "Review your excursion details, complete the traveler information, and choose your payment method.",
      "checkout_trip_summary_heading": "Your trip summary",
      "pay_with": "Pay with",
      "cart_subtitle": "List of all the product in your backpack",
      "itinerary_excerpt": "Here you can find a list of all your products. Make sure the information is correct before continuing to the next steps. Important: All times and dates are displayed in local time.",
      "assign_excerpt": "In this section you indicate which traveler is going to which excursion. That way we will have all the necessary information to provide you the best possible experience.",
      "list_of_products": "List of products",
      "reservations_made": "#",
      "assing_tourists": "Assign tourists",
      "go_to_checkout": "Continue",
      "a_list_of_all_your_reservations": "All your reservations",
      "my_group": "My group",
      "people_(including_you)": "People (Including you)",
      "(me)": "(me)",
      "team_member": "Team member",
      "actions": "Actions",
      "you_have_no_reservations": "You have no reservations",
      "tourists_group": "In this section you have to add the information of all the people who will accompany you. It is very important that the attached information is as reliable as possible.",
      "edit_your_reservation": "Edit your reservation",
      "cancel_date": "Cancel date",
      "departure_date": "Departure date",
      "reserves": "Reserves",
      "update": "Update",
      "not_enough": "has not enough",
      "too_many": "has too many",
      "product_for": "Product for",
      "tourists_assigned": "tourists assigned",
      "many_few_tourists": "The tourists assigned does not match the number of reservations",
      "select_your_extras": "Select your extras:",
      "product_variants": "Options",
      "select_date_first": "Select a date first",
      "total_price": "Total price",
      "see_details": "See details",
      "price_chilean": "Total value residents in Chile:",
      "price_no_chilean": "Total value not residents in Chile:",
      "single_supplement": "Single supplement:",
      "people": "Pax:",
      "details_of_purchase": "Detail of your purchase",
      "confirmed_excerpt": "Thank You for Traveling with us!",
      "confirmed_excerpt_litle": "Check the voucher to see the details of your purchase.",
      "cart_empty": "Your backpack is empty"
    },
    "checkout": {
      "do_checkout": "Checkout",
      "confirm_checkout_excerpt": "Before proceeding please check everything is correct, once you accept this order you will not be able to change it.",
      "confirm_checkout_excerpt_2": "(You can still create a new order.)",
      "please_confirm_your_details": "Please confirm your details",
      "i_need_to_change_something": "I need to change something",
      "everything_looks_fine": "Everything looks fine",
      "after_this_step": "After this step, Outdoor Index will contact all providers.",
      "providers_confirm_availability": "When all providers confirm your order, you will be contacted.",
      "payment_excerpt": "Before buying, make sure that all the details of your products are correct. Check the number of reservations and their costs. Remember to read our cancellation policy.",
      "your_details_confirmation_and_payment": "Detail of your products and payment",
      "important!": "Important",
      "all_transactions_have_an_extra": "You can pay using your debit or credit card in the installments that you agree with your bank. Outdoor Index will receive the full amount of the sale.",
      "get_a_refund_if": "Get a refund if you cancel within 24 hours of purchase.",
      "pay_now": "Confirm Payment",
      "confirm_and_pay": "Confirm and pay",
      "wetravel_link_not_ready": "Please wait a moment and try again, or reselect WeTravel to load the payment link.",
      "mercado_wallet_not_ready": "The Mercado Pago button is still loading. Wait a few seconds and try again.",
      "payment_summary": "Payment summary",
      "payment_method_title": "Payment method",
      "payment_methods_locked_until_traveler_details": "Complete traveler details before choosing a payment method.",
      "payment_method_recommended": "Recommended",
      "payment_method_blurb": {
        "wetravel": "International payment in USD",
        "mercado_pago": "Local card payment and installments according to your bank",
        "webpay": "Pay with your bank card via Webpay",
        "payu": "Pay with PayU",
        "paypal": "Pay with PayPal",
        "google_pay": "Pay with Google Pay",
        "apple_pay": "Pay with Apple Pay"
      },
      "total_to_pay": "Total to pay",
      "secure_payment_note": "100% secure and encrypted payment",
      "help_widget_title": "Need assistance?",
      "help_widget_body": "Talk to an Outdoor Index guide to get personalized assistance.",
      "help_widget_cta": "Talk to a specialist",
      "help_widget_online": "Online",
      "terms_toggle_line_html": "I accept the %{terms} and %{policy}.",
      "terms_toggle_word_terms": "Terms",
      "terms_toggle_word_policy": "Policy",
      "review": "Review",
      "ready": "Ready",
      "choose_payment": "Choose the payment you desire",
      "only_for_reservation": "Reserve",
      "complete_payment": "Pay in full",
      "30_p": "30%",
      "30_per": "Paid 30%",
      "30_pers": "Paid 30%",
      "100_p": "100%",
      "100_per": "Paid 100%",
      "100_pers": "Paid 100%",
      "i_hereby_accept": "By clicking \"Confirm Payment,\" you agree to our",
      "and_confirm": "and confirm that you have read and understood our",
      "and_our": "and our",
      "your_itinerary": "Your itinerary in detail",
      "continue_shopping": "Continue Shopping",
      "not_available": "Not available",
      "disclaimer": "About your reservation",
      "some_products_deleted": "Some products are no longer available",
      "accept": "Yes, accept",
      "cancel": "Cancel",
      "must_have_tourist": "You must have at least 1 tourist with added email and phone number.",
      "wetravel_partial_error": "Partial payment is not available because the excursion date is too close. Please select full payment."
    },
    "vouchers": {
      "active_excerpt": "Here are the details of your vouchers. Please review and print them. It will be necessary to provide the vouchers, with the order number of the reservations.",
      "all_of_your_vouchers": "All of your vouchers",
      "confirmed_excerpt": "Thank you for your purchase. We hope you have a beautiful trip. Do not forget to print your voucher and always take it with you. If you have any question or unexpected situation, do not hesitate to contact us.",
      "active_vouchers": "Active Vouchers",
      "disclaimer": "In this PDF you have all the information about your product. Please check the document and if you have any questions, contact us. Enjoy your trip.",
      "get_your_voucher": "Get your voucher",
      "voucher": "Voucher",
      "payment_error": "Payment error.",
      "error": "Something went wrong with your payment process, please try again later or contact us for other payment options.",
      "restart_payment": "Restart payment",
      "payment_rejected": "Payment rejected",
      "rejected": "PayU/Paypal has indicated that your payment was rejected, please check your details and try again, or contact us for other payment options.",
      "home": "Home",
      "order_number": "Order No:",
      "view": "View",
      "print": "Print",
      "complete": "Complete",
      "incomplete": "Incomplete",
      "activities": "Activities",
      "was_partial_payment": "(2)"
    },
    "categories": {
      "search": "search",
      "general": "general",
      "general_category_search": "General %{category_name} search",
      "other_excursions_to_do": "Other experiences to do in %{zone_name}",
      "general_zone_search": "Search suggestions in %{zone_name}",
      "recommended_for_you": "Experiences to do in %{zone_name}"
    },
    "tourist": {
      "new_tourist_excerpt": "In this section you can add the information profile of all the people who will accompany you. It is very important that the attached information is as reliable as possible.",
      "personal_info": "Personal info",
      "checkout_minimum_one_pax_notice": "We only need full details for one traveler to continue. You can add the rest later if you like.",
      "add_another_pax": "Add another traveler",
      "info_pax_card_title": "Traveler info",
      "name": "Name",
      "last_name": "Last name",
      "date_of_birth": "Date of birth",
      "nationality": "Nationality",
      "passport": "Passport",
      "hometown": "Hometown",
      "phone": "Phone",
      "email": "Email",
      "emergency_contact": "Emergency contact",
      "allergies": "Allergies",
      "medical_conditions": "Medical conditions",
      "food_restrictions": "Food restrictions",
      "pending": "Pending",
      "ready": "Ready",
      "you_have_no_vouchers": "You have no active vouchers",
      "no_reservations_to_assign": "No reservations to assign"
    },
    "footer": {
      "about_us": "About us",
      "statement": "Read our mission statement",
      "go_to_suscribe": "Go subscribe",
      "suscribe_text": "We send bi-weekly updates on new stories and travel discounts",
      "terms_&_conditions": "Terms",
      "privacy_&_cookies": "Privacy",
      "contact_us": "Contact us",
      "edit_endorsement": "Outdoor Index is based in Puerto Natales (Southern Chilean Patagonia) and has the support of more than 40 providers.",
      "all_rights_reserved": "All rights reserved. No parts of this site may be reproduced without permission.",
      "spanish": "Spanish",
      "english": "English",
      "portuguese": "Portuguese",
      "french": "French",
      "german": "German",
      "english_corto": "EN",
      "spanish_corto": "ES",
      "portuguese_corto": "PT",
      "french_corto": "FR",
      "german_corto": "DE",
      "clp": "$ Chilean pesos (CLP)",
      "usd": "$ USA Dollars (USD)",
      "survey": "Survey",
      "endorsement": {
        "support_local_comunity": "Support local, encourage sustainability",
        "when_you_buy": "When buying at Outdoor Index you encourage 35+ local providers on quality & sustainable management.",
        "instant_booking": "Certified guides 100% available for your assistance",
        "by_entering_your": "Before, during, and after your experience to solve your inquiries and help plan your next adventure.",
        "payment_protection": "Pay only 30% now. The rest later",
        "we_comply_with_all": "Make your planning lighter without excessive payments, pay only the 30% now to confirm your reservation, pay the rest closer to date."
      },
      "covid": "Covid",
      "secure": "All bookings processed through this website are protected by our key partners.",
      "titles": {
        "book": "Book with Confidence",
        "destinations": "Popular Destination",
        "activities": "Popular Activities"
      },
      "lang-currency": "Language & Currency"
    },
    "chat": {
      "hi": "Hello",
      "our_chat_service": "Our chat service is available Monday through Friday from 10 am to 6 pm (UTC / GMT -3). If you write to us within these hours, we will respond you in a few minutes.",
      "new-message": "New message",
      "messages": "Messages",
      "enter_your_name": "Enter your name...",
      "enter_email": "Enter your email...",
      "enter_message": "Enter a message...",
      "create_message": "Send message",
      "begin": "Begin",
      "user": "User",
      "need_help": "Need help?",
      "talk_to_local_guide": "Talk to a local guide"
    },
    "registration": {
      "edit_user": "Edit user",
      "email": "Email",
      "name": "Name",
      "lastname": "Last name",
      "confirm_password": "Confirm password",
      "current_password": "Current password",
      "new_password": "New password",
      "profile_picture": "Profile picture",
      "profiles": "Profiles (Choose one or more)",
      "interests": "Interests (Choose one or more)",
      "notification": "Notification Settings",
      "save_settings": "Save",
      "update_account": "Update account",
      "registration_excerpt": "Manage your profile the way you want. Enable or disable your notifications. This way you will be able to customize the contents you receive from Outdoor Index.",
      "vouchers": "Vouchers",
      "all_vouchers": "All vouchers",
      "change_your_password": "Reset or Change password",
      "change_my_password": "Change password",
      "confirm_new_password": "Confirm password",
      "subtitle_password": "Create a new password with at least 8 characters, including letters and numbers.",
      "password_requirements": "Password is not valid.",
      "passwords_dont_match": "Passwords do not match."
    },
    "responsive": {
      "more": "More..."
    },
    "uploader": {
      "upload_a_file": "Upload a file",
      "drop_files_here": "Drop files here",
      "processing_dropped_files": "Processing dropped files..."
    },
    "sidebar_single": {
      "no_dates_available": "No Dates Available",
      "disclaimer": "Secure your spot now by paying only <strong>30% of the total booking amount</strong>.",
      "select_dates": "Book now",
      "share": "Questions about the excursion?",
      "to_make_a": "To make a reservation please ",
      "log_in": "Log in",
      "or": "or",
      "sign_up": "Sign up",
      "if_you_are": "if you are new.",
      "price_for": "Per person",
      "from": "Price from",
      "contact_viewnia": "Contact Us",
      "rates": "CLP rates include VAT. USD rates do not include VAT; foreign non-residents are exempt if paying in USD."
    },
    "request_form": {
      "title": "Request Excursion",
      "contact_viewnia_subtitle": "Fill the form below to begin the process that will allow us to coordinate your excursion with our field specialist."
    },
    "modal_manage_date": {
      "discount": "Add a discount",
      "manage_date": "Manage date",
      "date": "Date",
      "starting_time": "Starting time",
      "price": "Price",
      "vacancies": "Vacancies",
      "save": "Save",
      "cancel_date": "Cancel date",
      "available_ammount": "Available amount",
      "month_form": {
        "edit_month": "Edit month",
        "delete_month": "Delete month",
        "populate_month": "Populate Month",
        "disclaimer_1": "You are about to edit <strong>an entire month</strong>, this action is <strong>hard to reverse</strong>.",
        "disclaimer_2": "Please double check your current calendar before you proceed, in order to avoid duplicates or other problems.",
        "accept": "Accept",
        "month": "Month",
        "week_days": "Week days",
        "continue": "Continue",
        "final_notice_header": "Please read carefully:",
        "final_notice_1": "Add a departure date for excursion <strong id='fn_title'></strong>, every <strong id='fn_week_days'></strong>  of <strong id='fn_month'></strong>.",
        "final_notice_2": "Each departure will start at <strong><span id='fn_starting_time_4i'></span>:<span id='fn_starting_time_5i'></span></strong>, have <strong id='fn_vacancies'></strong> and discount <strong id='fn_discount'></strong>.",
        "confirm": "Save",
        "back": "Back",
        "delete_month_disclaimer": "You are about to delete all departures for the following month, this action is <strong>irreversible</strong>.",
        "vacancies": "vacantes"
      }
    },
    "checkout_bar": {
      "itinerary": "Itinerary",
      "tourists": "Group",
      "assign_tourists": "Assign",
      "checkout": "Payment",
      "voucher": "Voucher"
    },
    "reviews": {
      "title": "Reviews",
      "more": "More",
      "reviewing_excursion": "Reviewing product",
      "thanks_for_submitting": "Thanks for submitting a review",
      "review": "Review",
      "footer": "See on Trustpilot"
    },
    "newsletter": {
      "sign_up_at": "Patagonia´s marketplace for adventure travel",
      "we_value_your_privacy": "Sustainable, personalized and full of adventures for you to enjoy",
      "sign_up_now": "Sign up",
      "view_preferences": "Preferences",
      "subscribe_to_our": "Subscribe to our Newsletter",
      "email_address": "Email Address",
      "subscribe": "Subscribe",
      "we_are_travel_and_growth": "Discover Chile and its landscapes with the best tours and excursions. Live local experiences in unforgettable environments doing what you like."
    },
    "modal": {
      "first_section": "Select date",
      "product_variants": "Select option",
      "second_section": "Passengers",
      "no_daily_quota": "There are not enough seats for this day",
      "date": "Date",
      "wrong_name": "Wrong name or password",
      "per_person": " p/p",
      "departure_time": "Departure:",
      "spot_left": "Spot left",
      "add_reserves": "Number of guests",
      "select": "Select",
      "select_date": "Select Date",
      "select_date_text": "Select an available date on the calendar and follow the steps to generate your reservation.",
      "check_in": "Check in",
      "check_out": "Check out",
      "guests": "Guests",
      "child_guests": "Childs",
      "guest_text": "Ages 13 and older",
      "child_text": "Up to 12 years old",
      "twins": "Twin",
      "doubles": "Doubles",
      "doubles_twin": "2 twins",
      "add_rooms_for": "Add rooms for your",
      "guest": "guests",
      "add_to_itinerary": "Select",
      "start": "Start",
      "ends": "Ends",
      "leave_your_review": "Leave your review",
      "describe_your_experience": "Describe overall experience",
      "add": "Add",
      "next": "Next",
      "load_earlier_dates": "Load earlier dates ...",
      "load_later_dates": "Load later dates ...",
      "is_resident": "Residents in Chile",
      "is_not_resident": "Not resident in Chile",
      "language_title": "Select country and currency",
      "language_subtitle": "Choose your languages from the list",
      "currency_subtitle": "Select your currency",
      "current_language": "Country and language",
      "other_languages": "Other countries and languages"
    },
    "alert": {
      "invalid_changes": "Invalid changes",
      "invalid_action": "Invalid action: amount can't be lower than 0",
      "not_enough_availability": "Not enough availability for that date range. Check other accommodations or book fewer units.",
      "something_went_wrong": "Something went wrong. Please try again or contact us.",
      "review_already_submitted": "Review already submitted",
      "couldn't_send_review": "Couldn't send review",
      "you_must_agree_to": "You must agree to our terms and conditions",
      "no_products_in_your_order": "No products in your order",
      "please_sign_the_waiver": "Please sign the waiver with your name.",
      "signature_and_tourist": "Signature and tourist name must be identical.",
      "couldn't_save": "Couldn't save, please try again later.",
      "invalid_language": "Invalid language",
      "confirm_to": "You must confirm that you are not a robot.",
      "error": "The password must have at least 8 characters, one letter, and one number."
    },
    "notice": {
      "your_account_has": "Your account has no agencies, please contact us",
      "session_expired": "Session expired, please log in.",
      "changes_submitted": "Changes submitted!",
      "new_product_created": "New product created, waiting for approval",
      "invalid_request": "Invalid request. Please try again or contact us.",
      "have_excursions": "The agency has excursions, assign them to another before deleting it",
      "updated_information": "Updated information",
      "date_no_longer": "Date no longer available",
      "availability_updated": "Availability updated",
      "review_sent": "Review Sent!",
      "bookings_made_for": "Your reservation was made successfully!",
      "profile_picture_updated": "Profile picture updated!",
      "tourist_information_saved": "Your information has been saved",
      "enabled": "enabled",
      "diabled": "disabled",
      "was": "was",
      "settings_updated": "Settings updated!",
      "language_updated": "Idioma actualizado!",
      "account_updated": "Account updated!",
      "reserves_added_for": " reserves added for ",
      "product_was_enabled": "Product was enabled",
      "product_was_disabled": "Product was disabled"
    },
    "more": {
      "the_best_products": "The best experiences in Outdoor Index",
      "all_recommendations_in_puerto_natales": "All experiences in Puerto Natales",
      "all_recommendations_in_punta_arenas": "All experiences in Punta Arenas",
      "all_recommendations_in_zone": "All suggestions in %{zone_name}",
      "all_adventure_products": "All active experiences",
      "all_standard_products": "All transformative experiences",
      "all_scientific_products": "All discovery experiences",
      "all_family_products": "All familiars - groups experiences",
      "all_luxury_products": "All sofisticate experiences",
      "all_promotions_products": "All discounts & offers experiences",
      "all_ota_products": "All OTA experiences",
      "a_selection_of_the_best": "A selection made by Outdoor Index",
      "other_activities_that": "Other activities that complement your experience",
      "all_north_patagonia_products": "All North Patagonia products",
      "all_south_patagonia_products": "All South Patagonia products",
      "all_lagos_region_products": "All Lakes & Rivers District products"
    },
    "searches": {
      "no_result_to": "Sorry, no result to \"%{category_name}\" in \"%{zone_name}\"",
      "recommended_for_you": "Experiences to do in \"%{zone_name}\"",
      "category_products_in_zone": "\"%{category_name}\" experiences in \"%{zone_name}\"",
      "category_products_in_zone_no_result": "Sorry, no \"%{category_name}\" experiences in \"%{zone_name}\"",
      "all_products_in_zone": "All experiences in \"%{zone_name}\"",
      "all_products_in_zone_no_result": "Sorry, no experiences in \"%{zone_name}\"",
      "all_category_products": "All \"%{category_name}\" experiences",
      "all_category_products_no_result": "Sorry, no \"%{category_name}\" experiences for now",
      "please_select_category_or_zone": "Please select category or zone"
    },
    "guidebook": {
      "download_our_guide_book": "Download our guide book and start your trip with Outdoor Index",
      "find_out_everything": "Find out everything about the Southern Chilean Patagonia."
    },
    "banner": {
      "do_you_need_travel_insurance": "Do you need travel insurance?",
      "in_partnership_with_world": "Outdoor Index in partnership with World Nomads give you the best insurance available for Chilean Patagonia.",
      "get_a_quote": "Get a Quote"
    },
    "blog": {
      "meta_title": "Travel, Nature & Adventure Blog in Chile | Outdoor Index",
      "meta_description": "Explore guides, tips and inspiration to travel in Chile, discover outdoor excursions, connect with nature and live adventure experiences.",
      "travel_nature_growth": "Travel, nature & growth",
      "we_connect_you_with": "Global content about nature, travel and growth. Follow us on social media!",
      "breadcrumb_aria": "Breadcrumb",
      "breadcrumb_home": "Home",
      "breadcrumb_blog": "Blog",
      "guided_tours": "Guided Tours",
      "book_now": "Book now",
      "view_more_activities": "View more activities",
      "showing_count": "Showing %{loaded} of %{total} articles",
      "pagination_aria": "Blog pagination",
      "page_n": "Page %{n}"
    },
    "mail": {
      "welcome_user_name": "%{user_name}, Welcome to Outdoor Index",
      "leave_your_review": "%{user_name}, leave a review of your experience",
      "voucher": {
        "your_order_is_ready": "Thank you for your purchase, your order number is %{reference_code}",
        "your_sold_product": "Hi %{user_provider}, we have sold one of your experience",
        "new_sold": "New sale %{reference_code}"
      }
    },
    "paypal": {
      "description": "Outdoor Index: Paying order %{reference_code}"
    },
    "payu": {
      "description": "Outdoor Index: Paying order %{reference_code}"
    },
    "pdf": {
      "emergency_contacts": "Emergency contacts",
      "congratulations_user_name": "Congratulations %{user_name}",
      "congratulations_agency_name": "Congratulations %{agency_name}",
      "here_we_attach": "Here we attach all the information of your trip. In this voucher you will see the detail of your products, the contact of the suppliers, the signed waiver, as well as the receipt of your paid product (Paypal or PayU). Feel free to contact us if you have any questions.",
      "reservation_number": "Reservation number:",
      "product_detail": "Product detail",
      "departure": "Departure",
      "your_suppliers": "Your suppliers",
      "in_this_section_appear": "In this section you have the detail of the payment received by Outdoor Index. Remember to print this voucher and take it with you always. Thank you very much for choosing Outdoor Index",
      "payments_detail": "Payments detail",
      "initial_payment": "Initial payment",
      "payment_method": "Payment method",
      "total_paid": "Total paid",
      "total_order": "Order total:",
      "order_date": "Order date",
      "payment_date": "Payment date",
      "payment_type": "Payment type",
      "payment_complete": "Payment complete",
      "print_this_voucher": "Print this voucher and take it with you",
      "at_all_times": "at all times of the trip. Present it when",
      "you_check": "you check in.",
      "we_have_received": "We have received a new reservation request for your products. Below is the detail of this and the information of your passengers. From this moment you can contact your passengers directly or if you prefer, instruct Outdoor Index to do so. It is always advisable to send an email informing that the reservation was made successfully. You will stand out as a good provider. Remember to update the reserve quotas in your own systems so there are no problems of overcrowding. Good job!",
      "guests": "Guests",
      "your_guests": "Your guests",
      "date_of_birth": "Date of birth:",
      "origin": "Origin:",
      "document_number": "Document number:",
      "phone": "Phone",
      "email": "Email",
      "emergency_number": "Emergency number:",
      "allergies": "Allergies:",
      "medical_conditions": "Medical conditions:",
      "food_restrictions": "Food restrictions:",
      "dear_user_name": "Dear %{user_name}",
      "service_confirmation": "Service Confirmation",
      "according_to_the_reservation": "According to the reservation request by you, we confirm the following information:",
      "reference_code": "Reference code",
      "activity": "Activity",
      "starting_point": "Place",
      "starting_date": "Starting date",
      "starting_time": "Starting time",
      "client": "Client",
      "excursion": "ACTIVITY %{number}",
      "payment_details": "PAYMENT DETAILS",
      "applied": "APPLIED",
      "next_payment": "NEXT PAYMENT (70%)",
      "purchase_date": "Purchase date",
      "description": "Description",
      "unit_price": "Unit price",
      "unit_price_child": "Child unit price",
      "childen_pax": "Childs",
      "pax": "Pax",
      "tax": "Tax",
      "about_your_host": "ABOUT YOUR HOST",
      "name": "Person in charge:",
      "address": "Address:",
      "from": "Service start date",
      "to": "Service end date",
      "tourists": "Tourist info",
      "guest": "Guests",
      "child_guest": "Childs",
      "guest_price": "Guest price",
      "child_guest_price": "Child price",
      "resident": "Resident",
      "no_resident": "No resident",
      "problem_with_order": "Problems with your order?",
      "complete_remaining_payment_web": "To pay the remaining balance, sign in to your account on outdoorindex.cl and open this order from your vouchers.",
      "contact_us": "Contact us",
      "guest_s": "Guest",
      "child_guests": "Childs",
      "child_guest_s": "Child"
    },
    "currency": {
      "displaying_prices_in": "Currency exchange done!"
    },
    "tourists": {
      "first_create_group": "Ooops! Don`t forget to fill in the information of the passengers."
    },
    "date": {
      "formats": {
        "default": "%m/%d/%Y",
        "short": "%a, %b %e",
        "long": "%B %d, %Y",
        "calendar_picker": "YYYY/MM/DD",
        "fixed_departure": "YYYY/M/DD",
        "moment": "%Y-%m-%d"
      }
    },
    "time": {
      "formats": {
        "default": "%m/%d/%Y",
        "short": "%a, %b %e",
        "long": "%B %d, %Y",
        "full": "%a, %B %d / %Y",
        "calendar_picker": "YYYY/MM/DD"
      }
    },
    "activities": {
      "trekking": "Trekking",
      "horseback": "Horseback",
      "birdwatching": "Birdwatching",
      "mountaineering": "Mountaineering",
      "icehike": "Ice Hike",
      "kayak": "Kayak",
      "flyfishing": "Fly flyfishing",
      "navigations": "Navigations",
      "cruises": "Cruises",
      "helicopter": "Helicopter",
      "multiactivity": "Multi Activity",
      "photosafari": "Photo Safari",
      "bikes": "Bikes",
      "snowshoes": "Snowshoes",
      "ski": "Ski",
      "rafting": "Rafting"
    },
    "filters": {
      "clear_filters": "Clear filters"
    },
    "lang": {
      "countries": {
        "spain": "Spain",
        "argentina": "Argentina",
        "bolivia": "Bolivia",
        "chile": "Chile",
        "colombia": "Colombia",
        "costa_rica": "Costa Rica",
        "ecuador": "Ecuador",
        "mexico": "Mexico",
        "peru": "Peru",
        "paraguay": "Paraguay",
        "uruguay": "Uruguay",
        "united_states": "United States",
        "england": "England",
        "australia": "Australia",
        "canada": "Canada",
        "new_zealand": "New Zealand",
        "ireland": "Ireland",
        "portugal": "Portugal",
        "brazil": "Brazil",
        "france": "France",
        "germany": "Germany",
        "china": "China",
        "hong_kong": "Hong Kong",
        "japan": "Japan",
        "korea": "Korea",
        "singapore": "Singapore",
        "taiwan": "Taiwan"
      }
    }
  },
  "pt": {
    "terms": {
      "head": {
        "conditions": "Termos de Serviço",
        "privacy": "Políticas de Privacidade",
        "cookies": "Políticas sobre Cookies.",
        "you_as_a_consumer": "Você como consumidor tem o dever de se informar sobre a documentação que pode precisar para poder realizar sua viagem conforme o planejado. Verifique com tempo se requer passaporte, visto, vacinas, permissão para menores ou outras exigências de documentos tanto para a entrada no Chile, como os países em trânsito. Se a requer e não dispõe dela, faça os trâmites necessários para obtê-la com antecipação."
      }
    },
    "devise": {
      "google_sign_in": "Conectar-se com Google",
      "facebook_sign_in": "Conectar-se com Facebook",
      "apple_sign_in": "Conectar-se com Apple",
      "already_have_an_account?": "Já tem uma conta?",
      "didn't_receive_confirmation_instructions?": "Não recebeu as instruções de confirmação?",
      "didn't_receive_unlock_instructions?": "Não recebeu as instruções de desbloqueio?",
      "forgot_your_password?": "Esqueceu sua senha?",
      "don't_have_an_account?": "Não tem uma conta?",
      "enter_email_associated": "Insira o e-mail associado à sua conta e enviaremos um e-mail com um link para redefinir sua senha.",
      "passwordless": {
        "not_found_in_database": "Nenhum usuário encontrado para este endereço de e-mail",
        "magic_link_sent": "Um link de login foi enviado para o seu endereço de e-mail. Por favor, siga o link para fazer login na sua conta.",
        "magic_link_sent_paranoid": "Se a sua conta existir, você receberá um e-mail com um link de login. Por favor, siga o link para fazer login na sua conta."
      },
      "confirmations": {
        "confirmed": "Sua conta foi confirmada com sucesso. Você foi conectado.",
        "send_instructions": "Você receberá um e-mail em poucos minutos com instruções sobre como redefinir sua senha.",
        "send_paranoid_instructions": "Se o seu e-mail existir em nossa base de dados, você receberá um e-mail em poucos minutos com instruções sobre como redefinir sua senha."
      },
      "failure": {
        "magic_link_invalid": "Link de login inválido ou expirado",
        "already_authenticated": "Você já está conectado.",
        "inactive": "Sua conta ainda não foi ativada.",
        "invalid": "E-mail ou senha inválidos.",
        "invalid_token": "Token de autenticação inválido.",
        "locked": "Sua conta está bloqueada.",
        "not_found_in_database": "E-mail ou senha inválidos.",
        "timeout": "Sua sessão expirou. Por favor, faça login novamente para continuar.",
        "unauthenticated": "Você precisa fazer login ou se registrar para continuar.",
        "unconfirmed": "Você deve confirmar sua conta para continuar."
      },
      "mailer": {
        "magic_link": {
          "subject": "Link de login",
          "greeting": "Olá %{email}!",
          "instructions": "Você pode fazer login usando o link abaixo:",
          "login_button": "Acessar minha conta",
          "expiration_notice": "Observe que o link irá expirar em %{expiration_time}."
        },
        "confirmation_instructions": {
          "subject": "Instruções de confirmação"
        },
        "reset_password_instructions": {
          "subject": "Instruções para redefinir sua senha"
        },
        "unlock_instructions": {
          "subject": "Instruções de desbloqueio"
        }
      },
      "omniauth_callbacks": {
        "failure": "Não foi possível autenticá-lo de %{kind} devido a \"%{reason}\".",
        "success": "Autenticado com sucesso com a conta %{kind}."
      },
      "passwords": {
        "no_token": "Você não pode acessar esta página sem vir de um e-mail de redefinição de senha. Se você veio de um e-mail de redefinição de senha, certifique-se de usar a URL completa.",
        "send_instructions": "Você receberá um e-mail com instruções sobre como redefinir sua senha em poucos minutos.",
        "send_paranoid_instructions": "Se o seu e-mail existir em nossa base de dados, você receberá um link de recuperação de senha no seu e-mail em poucos minutos.",
        "updated": "Sua senha foi alterada com sucesso. Você foi conectado.",
        "updated_not_active": "Sua senha foi alterada com sucesso."
      },
      "registrations": {
        "destroyed": "Adeus! Sua conta foi cancelada com sucesso. Esperamos vê-lo novamente em breve.",
        "signed_up": "Bem-vindo(a)! Você foi identificado(a).",
        "signed_up_but_inactive": "Você se registrou com sucesso. No entanto, não pudemos conectá-lo porque sua conta ainda não foi ativada.",
        "signed_up_but_locked": "Você se registrou com sucesso. No entanto, não pudemos conectá-lo porque sua conta está bloqueada.",
        "signed_up_but_unconfirmed": "Uma mensagem com um link de confirmação foi enviada para o seu e-mail. Por favor, siga o link para ativar sua conta.",
        "update_needs_confirmation": "Você atualizou sua conta com sucesso, mas precisamos verificar seu novo endereço de e-mail. Por favor, verifique seu e-mail e siga o link de confirmação para confirmar seu novo endereço de e-mail.",
        "updated": "Sua conta foi atualizada com sucesso."
      },
      "sessions": {
        "signed_in": "Login efetuado com sucesso.",
        "signed_out": "Logout efetuado com sucesso."
      },
      "unlocks": {
        "send_instructions": "Você receberá um e-mail com instruções sobre como desbloquear sua conta em poucos minutos.",
        "send_paranoid_instructions": "Se sua conta existir, você receberá um e-mail com instruções sobre como desbloqueá-la em poucos minutos.",
        "unlocked": "Sua conta foi desbloqueada com sucesso. Por favor, faça login para continuar."
      }
    },
    "errors": {
      "something_went_wrong": "Algo deu errado",
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "deve ser aceito",
        "blank": "não pode ficar em branco",
        "confirmation": "não confere com %{attribute}",
        "empty": "não pode ficar vazio",
        "equal_to": "deve ser igual a %{count}",
        "even": "deve ser par",
        "exclusion": "não está disponível",
        "greater_than": "deve ser maior que %{count}",
        "greater_than_or_equal_to": "deve ser maior ou igual a %{count}",
        "inclusion": "não está incluído na lista",
        "invalid": "não é válido",
        "less_than": "deve ser menor que %{count}",
        "less_than_or_equal_to": "deve ser menor ou igual a %{count}",
        "model_invalid": "A validação falhou: %{errors}",
        "not_a_number": "não é um número",
        "not_an_integer": "deve ser um número inteiro",
        "odd": "deve ser ímpar",
        "other_than": "deve ser diferente de %{count}",
        "present": "deve ficar em branco",
        "required": "é obrigatório(a)",
        "taken": "já está em uso",
        "must_contain_number": " deve conter pelo menos um número e uma letra",
        "must_contain_special": "deve conter um caractere especial",
        "must_contain_lower": "deve conter pelo menos 1 minúscula",
        "must_contain_upper": "deve conter pelo menos 1 maiúscula",
        "too_long": {
          "one": "é muito longo (máximo: 1 caractere)",
          "other": "é muito longo (máximo: %{count} caracteres)"
        },
        "too_short": {
          "one": "é muito curto (mínimo: 1 caractere)",
          "other": "é muito curto (mínimo: %{count} caracteres)"
        },
        "wrong_length": {
          "one": "não possui o tamanho esperado (1 caractere)",
          "other": "não possui o tamanho esperado (%{count} caracteres)"
        },
        "already_confirmed": "já foi confirmado, por favor, tente fazer login",
        "confirmation_period_expired": "precisa ser confirmado em %{period}, por favor, solicite um novo",
        "expired": "expirou, por favor, solicite um novo",
        "not_found": "não encontrado",
        "not_locked": "não estava bloqueado",
        "not_saved": {
          "one": "1 erro impediu que este %{resource} fosse salvo:",
          "other": "%{count} erros impediram que este %{resource} fosse salvo:"
        }
      },
      "template": {
        "body": "Verifique os seguintes campos:",
        "header": {
          "one": "Não foi possível salvar %{model}: 1 erro encontrado",
          "other": "Não foi possível salvar %{model}: %{count} erros encontrados"
        }
      }
    },
    "meta_tags": {
      "default": {
        "description": "Descubra o Chile com programas de aventura exclusivos e guias especializados. Viva uma experiência única! Reserve sua viagem inesquecível.",
        "keywords": "Patagônia, Chile, tours de aventura, tours de aventura Patagônia, tours de aventura Chile, tours Torres del Paine, tours de trekking Patagônia, tours de caiaque Patagônia, tours a cavalo Patagônia, tours multiesporte Patagônia, tours de aventura em família Patagônia, tours de aventura de luxo Patagônia, tours de aventura econômicos Patagônia, melhores tours de aventura Patagônia, viagens de aventura Patagônia, atividades de aventura Patagônia, excursões de aventura Patagônia, programas de aventura Patagônia",
        "name": "Outdoor Index"
      },
      "help": {
        "title": "Outdoor Index - Ajuda",
        "description": "Tem dúvidas sobre sua viagem à Patagônia? Acesse o Outdoor Index e fale com guias locais e especialistas na região.",
        "keywords": null
      }
    },
    "views": {
      "pagination": {
        "truncate": "…"
      }
    },
    "activerecord": {
      "models": {
        "season": "Temporada",
        "seasons": "Temporadas"
      },
      "attributes": {
        "season": {
          "name": "Nome",
          "valid_from": "Válido desde",
          "valid_until": "Válido até",
          "start_time": "Hora de início",
          "product": "Excursão",
          "mon_check": "Segunda-feira",
          "tue_check": "Terça-feira",
          "wed_check": "Quarta-feira",
          "thu_check": "Quinta-feira",
          "fri_check": "Sexta-feira",
          "sat_check": "Sábado",
          "sun_check": "Domingo"
        },
        "order": {
          "clp_charge": "Taxa CLP",
          "usd_charge": "Taxa USD",
          "username": "Cliente:",
          "email": "Email:",
          "product": "Produto:",
          "product_name": "Produto",
          "manual_pax": "Nº Pax:",
          "manual_total": "Pago:",
          "manual_currency": "Moeda:",
          "partial_payment": "Pagamento:",
          "payment_method": "Método:",
          "channel": "Canal:",
          "confirmed_at": "Compra:",
          "departure_at": "Partida:",
          "starting_datetime": "Hora partida:",
          "customer_phone": "Telefone:",
          "extra": "Extra:",
          "instructions": "Instruções:",
          "language": "Idioma:",
          "weather_link": "Link do clima",
          "post_link": "Link para o post",
          "itinerary_document": "Documento de itinerário",
          "show_itinerary_document": "Mostrar"
        }
      }
    },
    "promotions": {
      "coupon_code_ok": "Cupom aplicado com sucesso",
      "coupon_code_error": "O cupom não existe",
      "coupon_code_already": "O cupom já foi aplicado",
      "coupon_code_max": "Máximo um cupom por pedido",
      "coupon_code_destroy_ok": "Código removido com sucesso",
      "coupon_code_destroy_error": "Não foi possível remover o código",
      "coupon_code_destroy_confirm": "Tem certeza que deseja removê-lo?",
      "coupon_have_a_coupon": "Tem um cupom de desconto?",
      "coupon_form_palceholder": "Código de desconto",
      "coupon_apply": "Aplicar"
    },
    "home_collections": {
      "home_reviews": "350+ pessoas por ano viajam com a Outdoor Index",
      "find_your_experience": "Procure sua excursão",
      "carousel_region": "Aventuras por região",
      "carousel_activities": "Aventuras por atividades",
      "carousel_time_preference": "Aventuras por preferência de tempo",
      "sub-landing": "Descubra as melhores opções turísticas no Chile com a Outdoor Index. Compare e explore uma ampla variedade de programas do Atacama à Patagônia. Reserve hoje para viver experiências únicas!",
      "title": "Tours de aventura no Chile e Patagônia",
      "subtitle": "Encontre aventuras com os melhores guias locais"
    },
    "products_search": {
      "activities": "Atividades",
      "regions": "Regiões",
      "time": "Tempo",
      "date_sub_label": "Quando você quer ir?",
      "activities_sub_label": "Escolha sua atividade",
      "regions_sub_label": "Qual região você quer visitar?",
      "time_sub_label": "Selecione sua preferência de horário!",
      "date": "Data",
      "all_adventures": "Todas as aventuras",
      "search_placeholder": "Procure aventuras em todo o Chile",
      "most_popular_searches": "Buscas mais populares",
      "see_all_adventures": "Ver todas as aventuras",
      "help_me_choose": "Ajude-me a escolher",
      "help_me_choose_url": "https://api.whatsapp.com/send?phone=56981785011&text=Ol%C3%A1%2C%20preciso%20de%20ajuda%20para%20escolher%20uma%20aventura",
      "popular_search_items": {
        "circuito_w": {
          "label": "Circuito W",
          "icon": "search",
          "landing_slug": "circuito-w"
        },
        "circuito_o": {
          "label": "Circuito O",
          "icon": "search",
          "landing_slug": "circuito-o"
        },
        "torres_del_paine": {
          "label": "Torres del Paine",
          "icon": "map-pin",
          "zone_id": 1
        },
        "pucon": {
          "label": "Pucón",
          "icon": "map-pin",
          "zone_id": 16
        },
        "san_pedro_atacama": {
          "label": "San Pedro de Atacama",
          "icon": "map-pin",
          "zone_id": 15
        },
        "puerto_natales": {
          "label": "Puerto Natales",
          "icon": "map-pin",
          "zone_id": 2
        }
      },
      "choose_filters": "Escolha atividade, região e duração",
      "explore_all": "Explorar todas",
      "view_excursions_count": "Ver %{count} excursões",
      "search": "Procurar",
      "clear": "Limpar seleção",
      "tours": "tours",
      "subtext": "Planeje sua próxima aventura.\nExplore, reserve e aproveite a natureza.",
      "in": "em",
      "showing_count": "Mostrando %{loaded} de %{total} aventuras",
      "load_more": "Carregar mais"
    },
    "comments": {
      "comments": "Comentários",
      "replies": "Respostas",
      "post_a_comment": "Publique um comentário!",
      "submit": "Enviar",
      "reply": "Responder",
      "body": "Escreva seu comentário aqui..."
    },
    "order": {
      "confirmed": "Confirmado",
      "mail_thanks": "obrigado pela sua compra na Outdoor Index",
      "mail__hi": "Olá!",
      "mail_subject": "Outdoor Index Pedido Nº",
      "order_t": "Pedido",
      "see_purchase": "Revise suas compras",
      "already_paid": "Este pedido já foi pago",
      "confirm_payment": "Confirmar",
      "cancel_order": "Cancelar",
      "recover_order": "Recuperar",
      "send_confirm": "Confirmar (1)",
      "send_reminder": "Lembrar (2)",
      "send_last_reminder": "Re-lembrar (3)",
      "send_review": "Review (4)",
      "email_title": "Lembrete de excursão",
      "email_footer": "a seguir enviamos um lembrete da sua excursão. Se tiver alguma dúvida, não hesite em nos contatar em info@outdoorindex.cl ou pelo +56981785011.",
      "promo": "Visite www.outdoorindex.cl para mais excursões e programas.",
      "edit": "Editar",
      "departure_date": "Data de partida",
      "reservation": "Reserva",
      "code": "Código",
      "departure": "Partida",
      "contact_info": "Informações de contato",
      "customer_phone": "Número de contato",
      "travelers": "Viajantes",
      "itinerary": "Itinerário",
      "view_itinerary": "Baixe seu itinerário",
      "view_itinerary_file": "aqui",
      "voucher": "Ver o voucher",
      "confirmation_email_title": "Sua reserva para %{excursion} já está confirmada",
      "view_weather_link": "Verifique o clima",
      "instruction_exerpt": "Sabemos que sua excursão está se aproximando e você já deve estar se preparando",
      "here_some_instructions": "Instruções",
      "view_post_link": "Nosso blog",
      "review_email_title": "Conte-nos como foi a sua excursão %{excursion}",
      "review_link": "Responder inquérito pós-viagem",
      "review_trustpilot_intro": "Se quiser que outros viajantes conheçam a sua experiência, também pode deixar uma avaliação pública no Trustpilot.",
      "review_trustpilot_link": "Deixar uma avaliação no Trustpilot",
      "review_question": "Como foi sua excursão?",
      "review_explain_title": "Por que é importante completar o inquérito",
      "rewview_explain_body": "<p>A sua opinião ajuda-nos a melhorar cada excursão. O inquérito pós-viagem é confidencial e permite-nos conhecer a sua experiência: a organização, o guia, as atividades e os detalhes que fizeram a diferença.</p>\n<p>Reflita sobre a sua viagem antes, durante e depois da excursão. Responder com sinceridade leva apenas alguns minutos.</p>\n<p>As suas respostas ajudam-nos a cuidar da qualidade do nosso serviço e a continuar a melhorar para futuros viajantes.</p>\n",
      "review_terrible": "Péssima",
      "review_bad": "Ruim",
      "review_acceptable": "Aceitável",
      "review_good": "Boa",
      "review_great": "Ótima",
      "new_order_excerpt": "Aqui você pode completar todas as informações necessárias para criar um pedido. Escreva instruções claras e precisas indicando os horários e os pontos de encontro para cada reserva. Além disso, lembre-se de contatar os operadores por ordem de prioridade."
    },
    "ondemand": {
      "explanation": "Excursão exclusiva! Entre em contato com nosso especialista local.",
      "label": "Privado"
    },
    "request": {
      "greeting": "Olá! Esta informação foi enviada para sua caixa de entrada registrada com cópia para um de nossos agentes. Entraremos em contato com você o mais breve possível através das informações que você nos enviou.",
      "order_mail": {
        "header": {
          "hi": "Olá! Temos notícias sobre sua solicitação de excursão!",
          "title": "Sua solicitação foi aceita pelo operador local. Por favor, leia as informações abaixo e certifique-se de que tudo está correto.",
          "your_order": "Seu pedido Nº",
          "ready": "está disponível para ser pago."
        },
        "footer": "Agora você pode ir para a seção de pagamentos com o botão de pagamento.",
        "disclaimer": "Você será redirecionado para a janela de pagamentos da Outdoor Index através de uma conexão segura.",
        "pay": "Pagar",
        "excursion": {
          "title": "Excursão",
          "agency": "Operador local"
        },
        "manual_order": {
          "observations": "Leia os comentários que o agente Outdoor Index deixou para você!",
          "price": "Preço",
          "price_clp": "Preço CLP",
          "price_usd": "Preço USD"
        },
        "request_details": "Os detalhes da sua solicitação"
      },
      "singular": "Solicitação",
      "requester": "Solicitante",
      "product_required": "Para solicitar o pedido, você deve fazer login previamente",
      "excursion": "Excursão",
      "applicants": "Participantes",
      "from": "De",
      "to": "Até",
      "comments": "Comentários",
      "comments_placeholder": "Deixe suas perguntas, dúvidas ou o que quer que queira nos dizer. Entraremos em contato o mais breve possível!",
      "submit": "Enviar Solicitação",
      "email_title": "Solicitação de Excursão Privada",
      "email_footer": "Este formulário foi enviado aos nossos executivos. Você será contatado através dos dados que inseriu no formulário de contato. Se houver algum erro ou observação no formulário, por favor, envie-nos um e-mail para info@outdoorindex.cl e responderemos o mais breve possível.",
      "contact_name": "Nome de contato",
      "contact_email": "Email de contato",
      "contact_phone": "Telefone de contato",
      "must_log_in": "Você deve iniciar sessão antes de poder pagar",
      "phone": "Telefone de contato",
      "name": "Nome",
      "last_name": "Sobrenome"
    },
    "applicants": {
      "applicants_number": "2) Quantas pessoas participarão da Excursão?",
      "dates_sub": "3) Em que datas você quer realizar a Excursão?",
      "additional_info": "4) Informação adicional",
      "applicants_phone": "1) Deixe seus dados para entrarmos em contato",
      "phone_placeholder": "Telefone",
      "email": "Email",
      "name": "Nome",
      "lastname": "Sobrenome"
    },
    "active_admin": {
      "observed_dollar_update": "Atualizar",
      "agency": "Operadoras",
      "agencies": "Agências",
      "settings": "Configurações",
      "users": "Usuários",
      "admin_users": "Administradores",
      "orders": "Pedidos",
      "pages": "Páginas",
      "sales": "Vendas",
      "sale_goals": "Metas de venda",
      "reviews": "Avaliações",
      "blog": "Blog",
      "suppliers": "Fornecedores",
      "covers": "Coleções",
      "excursions": "Excursões",
      "categories": "Categorias",
      "comments_tab": "Comentários",
      "excursion_images": "Imagens Excursões",
      "home": "Início",
      "home_collections": "Coleções",
      "save_home_collections": "Salvar Coleção",
      "images": "Imagens do Post",
      "mailer": "Criador de e-mails",
      "newsletter_covers": "Capas News",
      "notifications": "Notificações",
      "payment_methods": "Métodos de pagamento",
      "private": "Privado",
      "products": "Produtos",
      "profiles": "Perfis",
      "properties": "Propriedades",
      "promotions": "Promoções",
      "question_subjects": "Perguntas Ajuda",
      "questions": "Perguntas",
      "tourists": "Turistas",
      "requests": "Solicitações",
      "tags": "Etiquetas",
      "visits": "Visitas",
      "zones": "Zonas",
      "seasons": "Temporadas",
      "macro_zones": "Macro Zonas",
      "landings": "Landings",
      "post": {
        "title": "Título",
        "subtitle": "Subtítulo",
        "label": "Etiqueta",
        "author_name": "Autor",
        "author_sm": "Autor rede social",
        "content": "Conteúdo",
        "cover": "Capa",
        "published": "Publicada",
        "unpublished": "Não publicada",
        "tags": "Etiquetas",
        "recommended_posts": "Publicações recomendadas",
        "products": "Tours e excursões",
        "explore_chile": "Explore o Chile e seus cantos com a Outdoor Index"
      },
      "zone": {
        "name": "Nome",
        "description": "Descrição",
        "sort_order": "Ordem",
        "country": "País",
        "state": "Região"
      },
      "review": {
        "tilte1": "Criar Avaliação",
        "title2": "Capa",
        "author": "Nome",
        "country": "País",
        "review_date": "Data da avaliação",
        "language": "Idioma",
        "save_review": "Salvar avaliação",
        "body": "Texto da avaliação",
        "cover": "Capa",
        "rating": "Classificação",
        "url": "Url",
        "excerpt": "Aqui você pode completar todas as informações necessárias para criar uma Avaliação. Certifique-se sempre de que a foto de capa que você carrega tenha uma boa resolução e seja correta. Lembre-se de ler e verificar as informações."
      },
      "landing": {
        "tilte1": "Criar Landing",
        "title2": "Meta",
        "title3": "Capa",
        "title4": "Avaliações",
        "title5": "FAQ",
        "save_landing": "Salvar landing",
        "title": "Título",
        "place": "Lugar",
        "body": "Conteúdo",
        "cover": "Capa",
        "review": "Avaliação",
        "meta_title": "Meta Título",
        "meta_description": "Meta Descrição",
        "product": "Excursão",
        "excerpt": "Aqui você pode completar todas as informações necessárias para criar uma Landing. Certifique-se sempre de que a foto de capa que você carrega tenha uma boa resolução e seja atraente para o turista. Lembre-se de fornecer informações claras e confiáveis.",
        "more_info": "Mais info"
      },
      "season": {
        "name": "Nome",
        "valid_from": "Desde",
        "valid_until": "Até",
        "start_time": "Hora de início",
        "product": "Excursão",
        "child_usd_price": "Crianças em dólares",
        "child_clp_price": "Crianças em CLP",
        "single_supplement_usd_price": "Dólares",
        "single_supplement_clp_price": "CLP",
        "guardar_temporada": "Salvar",
        "daily_quota": "Disponibilidade",
        "title_days": "Dias",
        "title_ages": "Idades",
        "title_prices_kids": "Preços crianças",
        "title_prices_adults": "Preços adultos",
        "title_single_supplement": "Suplemento individual"
      },
      "kpis": {
        "observed_dollar": "Valor dólar observado",
        "observed_dollar_subtitle": "Valor dólar definido pelo Banco Central",
        "visits_today_title": "Visitas de hoje",
        "visits_today_subtitle": "Fluxos para o dia de hoje",
        "visitors": "Visitantes",
        "last_day": "Dia anterior",
        "show_more": "Ver mais",
        "countries": "Países",
        "countries_subtitle": "Os que mais nos visitam",
        "country_anon": "Anônimo",
        "abandoned_cart_title": "Mochila de viagens abandonada",
        "abandoned_cart_subtitle": "Pedidos em sua mochila de viagens",
        "products_viewed_title": "Produtos mais vistos",
        "products_viewed_subtitle": "Os mais populares por agora",
        "posts_viewed_title": "Posts mais vistos",
        "posts_viewed_subtitle": "Os mais populares por agora",
        "products_selled_title": "Produtos mais vendidos",
        "products_selled_subtitle": "No último ano",
        "today_excursions_title": "Excursões hoje",
        "today_excursions_subtitle": "Turistas que hoje iniciam seu tour.",
        "users_month_title": "Estatística mensal",
        "users_month_subtitle": "Balanço estatístico de usuários mensais.",
        "users_number": "Número de usuários",
        "new_users_title": "Novos Usuários",
        "new_users_subtitle": "Registrados no último mês",
        "users_total_title": "Total Usuários",
        "users_total_subtitle": "Registrados desde o início",
        "new_users_title_box": "Usuários de hoje",
        "new_users_subtitle_box": "Fluxos para o dia de hoje",
        "users": "Usuários",
        "new_orders_title": "Novos Pedidos",
        "new_orders_subtitle": "Registrados este mês",
        "paid_orders_title": "Pedidos Pagos",
        "paid_orders_subtitle": "Registrados este mês",
        "sale_goals_title": "Meta de vendas",
        "sale_goals_subtitle": "Rendimento total deste mês",
        "goals": "Meta",
        "to": "até",
        "no_sale_goal": "Não foi definida uma meta de venda",
        "conversion_chart_title": "Gráfico de conversão",
        "conversion_chart_subtitle": "Índice de conversão no último ano",
        "conversion_last_year": "Índice de conversão no último ano",
        "conversion_title": "Taxa de conversão",
        "conversion_subtitle": "Atualizada até a data"
      }
    },
    "mercado_pago": {
      "error_alert": "Ocorreu um erro com o Mercado Pago, por favor verifique se seu pedido está pago.",
      "error_title": "Transação rechazada",
      "error_dec": "Houve um erro no processamento do pagamento, por favor tente novamente. Se o problema persistir, entre em contato conosco.",
      "pending_title": "Transação pendente",
      "pending_dec": "Seu pagamento se encontra pendente de verificação no Mercado Pago. Uma vez verificado, entre em contato conosco para validar sua Ordem."
    },
    "webpay": {
      "error_alert": "Ocorreu um erro com o Webpay, por favor verifique se seu pedido está pago.",
      "error_title": "Transação rejeitada",
      "error_dec": "Houve um erro no processamento do pagamento, por favor tente novamente. Se o problema persistir, entre em contato conosco."
    },
    "back": "Voltar",
    "chat_title": "Como podemos ajudar?",
    "chat_subtitle": "Geralmente respondemos em algumas horas",
    "chat_name": "Nome",
    "chat_email": "Email",
    "chat_phone": "Telefone",
    "chat_subject": "Assunto",
    "chat_body": "Mensagem",
    "chat_btn": "Enviar",
    "menu_welcome": "Bem-vindo(a), %{user_name}",
    "meesage_sended": "Mensagem Enviada",
    "meesage_captcha": "Deve verificar o captcha",
    "view_more": "Ver mais...",
    "view_more_excursions": "Ver mais excursões...",
    "view_more_suggestions": "Ver mais sugestões...",
    "location": "Localização",
    "zone": "Zona",
    "category": "Categoria",
    "select_one": "Selecione um",
    "select_multiple": "Selecione vários",
    "select_two": "2 máx",
    "price": "Preço",
    "vacancies": "Vagas",
    "key": "Ex: Elevação",
    "value": "1300 mt",
    "value_included": "Ex: Guia bilíngue",
    "profiles": "Perfis",
    "optional": "Opcional",
    "email": "Email",
    "phone": "Telefone",
    "address": "Endereço",
    "pending": "Pendente",
    "edit": "Editar",
    "soon": "Em breve",
    "password": "Senha (mín 8 caracteres, letra, número)",
    "password_confirmation": "Confirmação da senha",
    "remember_me": "Lembrar-me",
    "log_in": "Iniciar sessão",
    "sign_up": "Registre-se",
    "create_an_account": "Crie sua conta",
    "name": "Nome",
    "last_name": "Sobrenome",
    "back_to": "Voltar para",
    "reset_password": "Redefinir senha",
    "send": "Enviar",
    "guests": "Adultos",
    "guest": "Adulto",
    "child_guest": "Criança",
    "child_guests": "Crianças",
    "products": "Produtos",
    "products_show_photos": "Ver (%{n}) fotos",
    "delete": "Excluir",
    "continue": "Continuar",
    "total_only": "Total",
    "total": "Total a pagar:",
    "total_paid": "Total pago",
    "charges": "Taxas:",
    "subtotal": "Subtotal:",
    "total_final": "Total final",
    "coupon": "Cupom",
    "image_not_found": "Imagem não encontrada",
    "usd": "USD",
    "clp": "CLP",
    "departure": "Partida",
    "when": "Quando?",
    "what": "O quê?",
    "where": "Onde?",
    "search": "Buscar",
    "language": "Idioma",
    "puerto_natales": "Puerto Natales",
    "punta_arenas": "Punta Arenas",
    "tierra_del_fuego": "Terra do Fogo",
    "puerto_williams": "Puerto Williams",
    "in": "em",
    "or": "ou",
    "help": "Perguntas frequentes",
    "go_to_home_page": "Voltar ao início",
    "add_row": "+ Adicionar",
    "from": "Desde ",
    "days": "dias",
    "hours": "horas",
    "home": {
      "site_title": "Outdoor Index: Reserve tours de aventura na Patagônia e Chile",
      "things_to_do_in": "Sugestões em",
      "scientific_excursions": "Em profundo contato com a natureza",
      "luxury_experience": "Viva exclusivo, só para você",
      "adventure_excursions": "Dê mais de si mesmo",
      "the_best_excursions": "As melhores excursões para esta temporada",
      "explore_your_interests": "Explore seus interesses",
      "excursions": "Excursões",
      "products": "produtos",
      "suggestions": "Sugestões",
      "hard_adventurous": "Ativos",
      "soft_adventurous": "Transformador",
      "scientific": "Descoberta",
      "family": "Grupos",
      "luxury": "Sofisticados",
      "promotions": "Promocionais",
      "download": "Download",
      "adventures_by_region": "Aventuras por região",
      "north_patagonia": "Patagônia Norte",
      "south_patagonia": "Patagônia Sul",
      "masonry_zone_count": "%{count} aventuras"
    },
    "masonry_zones": {
      "names": {
        "1": "Torres del Paine",
        "2": "Puerto Natales",
        "3": "Punta Arenas",
        "4": "Terra do Fogo",
        "5": "Puerto Williams",
        "6": "Antártida"
      }
    },
    "survey_page": {
      "title": "Outdoor Index - Pesquisa pós-venda",
      "description": "Gostaríamos de saber sua opinião sobre o serviço que recebeu. Seu feedback é muito importante para nós.",
      "main_heading": "Pesquisa pós-viagem Outdoor Index"
    },
    "header": {
      "agency_panel": "Painel agência",
      "supplier_panel": "Painel fornecedor",
      "ask_us_a_question": "Contate-nos",
      "help": "Ajuda",
      "itinerary": "Itinerário",
      "sign_out": "Sair",
      "sign_up": "Registrar-se",
      "log_in": "Entrar",
      "join_our_newsletter": "Inscreva-se na newsletter",
      "partner": "Parceiro",
      "blog": "Histórias exclusivas:",
      "your_blog": "seu blog 🔥",
      "config": "Configurações",
      "orders": "Vouchers",
      "cart": "Carrinho"
    },
    "header_cat": {
      "excursions": "Excursões",
      "recommendations": "Sugestões",
      "accommodation": "Acomodações",
      "other": "Outros"
    },
    "agencies": {
      "address": "Endereço",
      "review": "Revisão",
      "agency_type": "Tipo de agência",
      "owner": "Proprietário",
      "holder_name": "Nome do titular",
      "holder_id": "ID do titular",
      "holder_email": "Email do titular",
      "phone": "Phone",
      "bank_name": "Nome do banco",
      "account_type": "Tipo de conta",
      "account_number": "Número da conta",
      "agency": "Agência",
      "country": "País",
      "state": "Região",
      "zone": "Zona",
      "duration": "Duração",
      "created_at": "Data de criação",
      "agency_info": "Informação",
      "supplier_info": "Informação",
      "products": "Produtos",
      "numbers": "Números",
      "excursions": "Excursões",
      "list_title": "Lista de todas as suas datas",
      "no_dates": "Ainda não há datas, por favor clique no calendário para criar uma.",
      "change_availability": "Gerencie suas datas",
      "date_range": "Modifique por intervalo de datas",
      "set_price": "Definir preço",
      "rooms_to_add": "Adicionar quartos",
      "rooms_to_remove": "Remover quartos",
      "products_to_add": "Adicionar produtos",
      "products_to_remove": "Remover produtos",
      "apply_changes": "Aplicar alterações",
      "edit_excerpt": "Toda a informação solicitada para criar o perfil do fornecedor é de vital importância para estabelecer o vínculo comercial com a Outdoor Index. Por favor, insira a informação o mais precisa possível.",
      "agency_information": "Informação agência",
      "supplier_information": "Informação fornecedor",
      "max_words": "150 palavras",
      "for_booking": "para reservar",
      "supplier_review": "Avaliação fornecedor ",
      "website_url": "Endereço web",
      "person_in_charge": "Pessoa responsável",
      "name": "Nome",
      "update_info": "Salvar perfil",
      "commercial_information": {
        "self": "Informação comercial",
        "name": "Nome",
        "bank_name": "Nome banco",
        "bank_account": "Conta",
        "account_type": "Tipo de conta",
        "commercial_name": "Nome Comercial",
        "id_rut": "ID / CNPJ/CPF"
      },
      "actions": "Ações",
      "manage_dates": "Datas",
      "active": "Aprovada",
      "pending_changes": "Pendente",
      "index_excerpt": "Aqui está uma lista de todos os seus produtos. Você pode criar, editar e gerenciar as datas destes. Cada produto criado permanecerá no estado \"Pendente\" até ser revisado pela equipe da Outdoor Index.",
      "manage_dates_excerpt": "Aqui está um calendário para adicionar todos os seus produtos. Você pode criar, editar e gerenciar as datas destes. Cada produto criado permanecerá no estado \"Pendente\" até ser revisado pela equipe da Outdoor Index.",
      "create_excursion": "Criar excursão",
      "create_product": "Criar produto",
      "create_activity": "Criar atividade",
      "create_post": "Criar post",
      "new_excursion_excerpt": "Aqui você pode completar todas as informações necessárias para criar um produto. Sempre certifique-se de que as fotos que você carrega tenham boa resolução e sejam atraentes para o turista. Lembre-se de dar informações claras e confiáveis.",
      "english": "Traduzir para inglês →",
      "spanish": "Traducir para espanhol →",
      "create_agency": "Criar nova agência",
      "agency_bank": "Dados de transferência"
    },
    "error": {
      "sorry": "Desculpe, esta página não existe.",
      "opps": "Pode ser que você tenha digitado o endereço errado ou que a página tenha sido movida.",
      "go": "ir para o início",
      "went_wrong": "Desculpe, mas algo deu errado.",
      "improvements": "Se você vê esta mensagem é porque talvez digitou o endereço web errado ou porque estamos atualizando o site com novas funcionalidades e melhorias. Espere alguns minutos e recarregue a página novamente. Obrigado!"
    },
    "excursions": {
      "title": "Título",
      "location": "Lugar",
      "zone": "Zona",
      "category": "Categoria",
      "profiles": "Tipo de viagem",
      "price": "Preço (em dólares)",
      "vacancies": "Vagas",
      "duration": "Duração",
      "half_day": "Meio dia",
      "full_day": "Dia inteiro",
      "multiple_days": "Vários dias",
      "duration_days": "Dias",
      "duration_hours": "Horas",
      "itinerary": {
        "body": "Corpo"
      },
      "faq": {
        "body": "Corpo"
      },
      "days": {
        "zero": "Dia",
        "one": "Dia",
        "other": "Dias"
      },
      "hours": {
        "zero": "Hora",
        "one": "Hora",
        "other": "Horas"
      },
      "add_images_(minimum_3)": "Fotos (mínimo 3)",
      "disclaimer": "Aviso Legal",
      "description": "Visão geral",
      "body": "Nosso Itinerário",
      "useful_information": "Informações úteis",
      "what's_included?": "Incluído",
      "what's_not_included?": "Não incluído",
      "meeting_instruction": "Local de partida",
      "meeting_address": "Endereço",
      "policies": "Políticas de cancelamento",
      "save_excursion": "Salvar excursão",
      "what_we'll_do": "Visão geral",
      "our_itinerary": "Itinerário",
      "faqs": "FAQs",
      "images": "Imagens",
      "edit_excerpt": "Toda a informação solicitada para criar o perfil do fornecedor é de vital importância para estabelecer o vínculo comercial com a Outdoor Index. Por favor, insira a informação o mais precisa possível.",
      "other_excursions_from_this_tour_company": "Outras experiências deste fornecedor",
      "create_excursions": "Criar excursão",
      "more": "Mais",
      "less": "Menos",
      "best_excursions_for_the_next_season": "Recomendados para esta temporada",
      "add_extras": "Adicionar extras",
      "price_per_reservations": "Preço por reserva",
      "extra_description": "Atividade",
      "macro_zone": "Macro Zona",
      "meta_title": "Meta título",
      "meta_description": "Meta descrição",
      "time": "Tempo",
      "prices": "Preços",
      "included": "O que está incluído?",
      "locations": "Localização",
      "alternative_names": "Excursão também conhecida pelos seguintes nomes",
      "breadcrumb_catalog": "Tours e excursões"
    },
    "hotels": {
      "twin": "Individual",
      "double": "Casal",
      "double_twins": "Dois individuais",
      "room_reserved": "quarto reservado",
      "edit_your_booking": "Edite sua reserva"
    },
    "reservations": {
      "add_guest_details": "Adicionar info turista",
      "traveler_data_card_title": "Dados do viajante",
      "traveler_data_badge_missing": "Falta info",
      "traveler_data_badge_complete": "Completo",
      "traveler_data_badge_ready_details": "Info pronta",
      "traveler_data_intro": "Precisamos destas informações para confirmar sua reserva.",
      "traveler_data_complete_button": "Info do viajante",
      "detach_guest_confirm": "Remover este viajante desta reserva?",
      "guest_slots_full": "Esta reserva já tem todos os viajantes atribuídos.",
      "organize_your_itinerary": "1) Itinerário >",
      "create_your_travel_group": "2) Grupo de viagem >",
      "assign_tourists": "3) Atribua turistas",
      "new_checkout_excerpt": "Aqui está a lista de produtos em sua mochila de viagens. Não se esqueça de adicionar os passageiros nas Excursões em que participarão. Antes de comprar, revise bem a quantidade de reservas e seus custos. Lembre-se de ler nossa Política de cancelamento.",
      "cart_title": "Informação da sua viagem",
      "checkout_page_title": "Confirme a sua reserva e efetue o pagamento",
      "checkout_page_intro": "Revise os dados da sua excursão, complete as informações do viajante e escolha o método de pagamento.",
      "checkout_trip_summary_heading": "Resumo da sua viagem",
      "pay_with": "Pagar com",
      "cart_subtitle": "Lista de produtos em sua mochila de viagens",
      "itinerary_excerpt": "Aqui você pode encontrar uma lista de todos os seus produtos. Certifique-se de que toda a informação esteja correta para continuar com os próximos passos. Importante: todas as horas e datas são mostradas no horário chileno.",
      "assign_excerpt": "Nesta seção, você deve indicar qual viajante vai para qual excursão. Desta forma, teremos todas as informações necessárias para lhe proporcionar a melhor experiência possível.",
      "list_of_products": "Lista de produtos",
      "reservations_made": "#",
      "assing_tourists": "Atribua turistas",
      "go_to_checkout": "Continuar",
      "a_list_of_all_your_reservations": "Todas as suas reservas",
      "my_group": "Meu grupo",
      "people_(including_you)": "Participantes (Incluindo você)",
      "(me)": "(Eu)",
      "team_member": "Membros do grupo",
      "actions": "Ações",
      "you_have_no_reservations": "Você não tem nenhuma reserva",
      "tourists_group": "Nesta seção, você deve adicionar as informações de todas as pessoas que o acompanharão. É muito importante que as informações anexadas sejam as mais confiáveis possíveis.",
      "edit_your_reservation": "Edite sua reserva",
      "cancel_date": "Cancelar reserva",
      "departure_date": "Dia de partida",
      "reserves": "Reservas",
      "update": "Atualizar",
      "not_enough": "não tem suficientes",
      "too_many": "tem demasiados",
      "product_for": "O produto",
      "tourists_assigned": "turistas atribuídos",
      "many_few_tourists": "Os turistas atribuídos não coincidem com o número de reservas",
      "select_your_extras": "Selecione seus extras:",
      "product_variants": "Opções",
      "select_date_first": "Selecione primeiro uma data",
      "total_price": "Preço total",
      "see_details": "Ver detalhes",
      "price_chilean": "Valor total residentes no Chile:",
      "price_no_chilean": "Valor total não residentes no Chile:",
      "single_supplement": "Suplemento individual:",
      "people": "Passageiros:",
      "details_of_purchase": "Detalhe da sua compra",
      "confirmed_excerpt": "Obrigado por viajar conosco!",
      "confirmed_excerpt_litle": "Consulte o voucher para ver os detalhes da sua compra.",
      "cart_empty": "Sua mochila de viagens está vazia"
    },
    "checkout": {
      "do_checkout": "Realizar pedido",
      "confirm_checkout_excerpt": "Antes de continuar, verifique se tudo está correto. Uma vez que você aceite este pedido, não poderá alterá-lo.",
      "confirm_checkout_excerpt_2": "(Você ainda pode criar um novo pedido.)",
      "please_confirm_your_details": "Por favor, confirme suas informações",
      "i_need_to_change_something": "Preciso mudar algo",
      "everything_looks_fine": "Tudo parece bem",
      "after_this_step": "Após este passo, a Outdoor Index entrará em contato com todos os fornecedores.",
      "providers_confirm_availability": "Quando todos os fornecedores confirmarem sua disponibilidade, você será contatado.",
      "payment_excerpt": "Antes de comprar, certifique-se de que todos os detalhes dos seus produtos estão corretos. Verifique o número de reservas e os valores destes. Lembre-se de ler nossas políticas de cancelamento.",
      "your_details_confirmation_and_payment": "Detalhe dos seus produtos e pagamento",
      "important!": "Importante",
      "all_transactions_have_an_extra": "Você poderá pagar usando seu cartão de débito ou crédito nas parcelas que combinar com seu banco. A Outdoor Index receberá o valor total da venda.",
      "get_a_refund_if": "Obtenha o reembolso do seu dinheiro se cancelar dentro de 24 horas após a compra.",
      "pay_now": "Confirmar pagamento",
      "confirm_and_pay": "Confirmar e pagar",
      "wetravel_link_not_ready": "Aguarde um instante e tente novamente ou selecione WeTravel de novo.",
      "mercado_wallet_not_ready": "O botão do Mercado Pago ainda está a carregar. Aguarde alguns segundos.",
      "payment_summary": "Resumo do pagamento",
      "payment_method_title": "Método de pagamento",
      "payment_methods_locked_until_traveler_details": "Conclua os dados dos viajantes antes de escolher um método de pagamento.",
      "payment_method_recommended": "Recomendado",
      "payment_method_blurb": {
        "wetravel": "Pagamento internacional em USD",
        "mercado_pago": "Pagamento local com cartão e parcelas conforme o seu banco",
        "webpay": "Pagamento com cartão bancário via Webpay",
        "payu": "Pagamento com PayU",
        "paypal": "Pagamento com PayPal",
        "google_pay": "Pagamento com Google Pay",
        "apple_pay": "Pagamento com Apple Pay"
      },
      "total_to_pay": "Total a pagar",
      "secure_payment_note": "Pagamento 100% seguro e encriptado",
      "help_widget_title": "Precisa de assistência?",
      "help_widget_body": "Fale com um guia da Outdoor Index para obter uma assistência personalizada.",
      "help_widget_cta": "Falar com um especialista",
      "help_widget_online": "Online",
      "terms_toggle_line_html": "Aceito os %{terms} e a %{policy}.",
      "terms_toggle_word_terms": "Termos",
      "terms_toggle_word_policy": "Política",
      "review": "Avaliação",
      "ready": "Pronto",
      "choose_payment": "Escolha o pagamento que deseja",
      "only_for_reservation": "Reserva",
      "complete_payment": "Pagamento completo",
      "30_p": "30%",
      "30_per": "Pago 30%",
      "30_pers": "Pago 30%",
      "100_p": "100%",
      "100_per": "Pago 100%",
      "100_pers": "Pago 100%",
      "i_hereby_accept": "Ao clicar em \"Confirmar pagamento\", você aceita nossos",
      "and_confirm": "e confirma ter lido e entendido nossa",
      "and_our": "e nossa",
      "your_itinerary": "Seu itinerário em detalhe",
      "continue_shopping": "Continuar comprando",
      "not_available": "Não disponível",
      "some_products_deleted": "Alguns produtos deixaram de estar disponíveis",
      "disclaimer": "Sobre sua reserva",
      "accept": "Aceito",
      "cancel": "Cancelar",
      "must_have_tourist": "Deve ter pelo menos 1 turista com email e telefone adicionados.",
      "wetravel_partial_error": "O pagamento parcial não está disponível porque a data da excursão está muito próxima. Por favor, selecione o pagamento integral."
    },
    "vouchers": {
      "active_excerpt": "Aqui é mostrado um detalhe dos seus vouchers. Você pode vê-los e imprimi-los. Lembre-se de se apresentar no dia da reserva com seu voucher impresso, indicando o número de registro deste.",
      "all_of_your_vouchers": "Todos os seus comprovantes",
      "confirmed_excerpt": "Muito obrigado pela sua compra. Esperamos que tenha uma ótima viagem. Não se esqueça de imprimir seu comprovante e sempre levá-lo consigo. Diante de qualquer consulta ou situação inesperada, não hesite em nos contatar.",
      "active_vouchers": "Vouchers ativos",
      "disclaimer": "Neste PDF você tem todas as informações dos seus produtos. Por favor, revise o documento e se tiver alguma pergunta, contate-nos. Aproveite sua viagem.",
      "get_your_voucher": "Obtenha seu voucher",
      "voucher": "Comprovante",
      "payment_error": "Erro de pagamento",
      "error": "Algo deu errado com o processo de pagamento. Tente novamente mais tarde ou contate-nos para ver outras opções de pagamento.",
      "restart_payment": "Realizar pagamento novamente",
      "payment_rejected": "Pagamento rejeitado",
      "rejected": "PayU / Paypal indicou que seu pagamento foi rejeitado, verifique seus dados e tente novamente, ou contate-nos para outras opções de pagamento.",
      "home": "Início",
      "order_number": "Nº Pedido:",
      "view": "Ver",
      "print": "Imprimir",
      "complete": "Completo",
      "incomplete": "Incompleto",
      "activities": "Atividades",
      "was_partial_payment": "(2)"
    },
    "categories": {
      "search": "busca",
      "general": "geral",
      "general_category_search": "Busca geral de %{category_name}",
      "other_excursions_to_do": "Outras experiências para fazer em %{zone_name}",
      "general_zone_search": "Busca sugestões em %{zone_name}",
      "recommended_for_you": "Experiências para fazer em %{zone_name}"
    },
    "tourist": {
      "new_tourist_excerpt": "Nesta seção você pode adicionar as informações de todas as pessoas que o acompanharão. É muito importante que as informações anexadas sejam as mais confiáveis possíveis.",
      "personal_info": "Informação pessoal",
      "checkout_minimum_one_pax_notice": "Só precisamos dos dados completos de um viajante para continuar. Pode completar os restantes mais tarde, se quiser.",
      "add_another_pax": "Adicionar outro viajante",
      "info_pax_card_title": "Dados do viajante",
      "name": "Nome",
      "last_name": "Sobrenome",
      "date_of_birth": "Data de nascimento",
      "nationality": "Nacionalidade",
      "passport": "Número do passaporte",
      "hometown": "Cidade onde mora",
      "phone": "Telefone",
      "email": "Email",
      "emergency_contact": "Contato de emergência",
      "allergies": "Alergias",
      "medical_conditions": "Condição médica",
      "food_restrictions": "Restrições alimentares",
      "pending": "Pendente",
      "ready": "Pronto",
      "you_have_no_vouchers": "Você não tem vouchers ativos",
      "no_reservations_to_assign": "Não há reservas para atribuir"
    },
    "footer": {
      "about_us": "Sobre nós",
      "statement": "Leia sobre nossos pilares",
      "go_to_suscribe": "Ir para inscrever-me",
      "suscribe_text": "Enviamos atualizações quinzenais sobre novas histórias e descontos em viagens",
      "terms_&_conditions": "Termos",
      "privacy_&_cookies": "Privacidade",
      "contact_us": "Contate-nos",
      "edit_endorsement": "A Outdoor Index tem sede em Puerto Natales (Patagônia Chilena Sul) e conta com o apoio de mais de 40 fornecedores.",
      "all_rights_reserved": "Todos os direitos reservados. Nenhuma parte deste site pode ser reproduzida sem a permissão correspondente.",
      "spanish": "Espanhol",
      "english": "Inglês",
      "portuguese": "Português",
      "french": "Francês",
      "german": "Alemão",
      "english_corto": "EN",
      "spanish_corto": "ES",
      "portuguese_corto": "PT",
      "french_corto": "FR",
      "german_corto": "DE",
      "clp": "$ Pesos chilenos (CLP)",
      "usd": "$Dólares americanos (USD)",
      "survey": "Pesquisa",
      "endorsement": {
        "support_local_comunity": "Apoie a economia local, fomente abordagens sustentáveis",
        "when_you_buy": "Ao comprar conosco, você fomenta mais de 35 fornecedores em sua gestão sustentável e de qualidade.",
        "instant_booking": "Guias certificados 100% disponíveis para sua assistência",
        "by_entering_your": "Antes, durante e depois para todas as suas dúvidas e para ajudar no planejamento de sua próxima aventura.",
        "payment_protection": "Confirme sua reserva pagando apenas 30%",
        "we_comply_with_all": "Planeje sua aventura sem estresse, de forma mais leve pagando apenas uma parte agora e o resto mais perto da data."
      },
      "covid": "Covid",
      "secure": "As reservas processadas através deste site estão protegidas por nossos parceiros.",
      "titles": {
        "book": "Reserve com Confiança",
        "destinations": "Destinos populares",
        "activities": "Atividades populares"
      },
      "lang-currency": "Idioma & Moeda"
    },
    "chat": {
      "hi": "Olá",
      "our_chat_service": "Nosso serviço de chat está disponível de segunda a sexta das 10h às 18h (UTC/GMT -3). Se nos escrever nestes horários, responderemos em alguns minutos.",
      "new-message": "Nova mensagem",
      "messages": "Mensagens",
      "enter_your_name": "Insira seu nome",
      "enter_email": "Insira seu email",
      "enter_message": "Insira uma mensagem...",
      "create_message": "Enviar mensagem",
      "begin": "Iniciar",
      "user": "Usuário",
      "need_help": "Precisa de ajuda?",
      "talk_to_local_guide": "Fale com um guia local"
    },
    "registration": {
      "edit_user": "Editar usuário",
      "email": "Email",
      "name": "Nome",
      "lastname": "Sobrenome",
      "confirm_password": "Confirmar senha",
      "current_password": "Senha atual",
      "new_password": "Nova senha (mín 8 caracteres, letra, número)",
      "profile_picture": "Foto do perfil",
      "profiles": "Perfis (Você pode escolher mais de um)",
      "interests": "Interesses (Você pode escolher mais de um)",
      "notification": "Configuração de notificações",
      "save_settings": "Salvar",
      "update_account": "Atualizar conta",
      "registration_excerpt": "Gerencie seu perfil da maneira que quiser. Habilite ou desabilite suas notificações e defina seus interesses. Desta forma, você poderá personalizar os conteúdos que vê na Outdoor Index.",
      "vouchers": "Vouchers",
      "all_vouchers": "Meus vouchers",
      "change_your_password": "Mudança de senha",
      "change_my_password": "Mudar minha senha",
      "confirm_new_password": "Confirmar nova senha"
    },
    "responsive": {
      "more": "Mais..."
    },
    "uploader": {
      "upload_a_file": "Carregue um arquivo",
      "drop_files_here": "Arraste seu arquivo aqui",
      "processing_dropped_files": "Processando arquivos..."
    },
    "sidebar_single": {
      "no_dates_available": "Não há datas disponíveis",
      "disclaimer": "Garanta seu lugar agora pagando apenas <strong>30% do valor total da reserva.</strong>",
      "select_dates": "Reserve agora",
      "share": "Dúvidas sobre a excursão?",
      "to_make_a": "Para fazer uma reserva, por favor ",
      "log_in": "Inicie sessão",
      "or": "ou",
      "sign_up": "Registre-se",
      "if_you_are": "se você é novo.",
      "price_for": "Por pessoa",
      "from": "Preço desde",
      "contact_viewnia": "Contate-nos",
      "rates": "Tarifas CLP incluem IVA. Tarifas USD não incluem IVA; estrangeiros não residentes ficam isentos se pagarem em USD."
    },
    "request_form": {
      "title": "Solicitar Excursão",
      "contact_viewnia_subtitle": "Complete este formulário para iniciar o processo que nos permitirá coordenar sua excursão com nosso especialista local."
    },
    "modal_manage_date": {
      "discount": "Adicione um desconto",
      "manage_date": "Gerenciar data",
      "date": "Data",
      "starting_time": "Hora de partida",
      "price": "Preço",
      "vacancies": "Vagas",
      "save": "Salvar",
      "cancel_date": "Cancelar data",
      "available_ammount": "Quantidade disponível",
      "month_form": {
        "edit_month": "Editar mês",
        "delete_month": "Apagar mês",
        "populate_month": "Preencher mês",
        "disclaimer_1": "Você está prestes a editar <strong>um mês completo</strong>, esta ação é <strong>difícil de reverter</strong>.",
        "disclaimer_2": "Por favor, revise seu calendário atual antes de continuar para evitar duplicados ou outros problemas.",
        "accept": "Aceitar",
        "month": "Mês",
        "week_days": "Dias da semana",
        "continue": "Continuar",
        "final_notice_header": "Por favor, leia com atenção:",
        "final_notice_1": "Adicionar uma data de saída para a excursão <strong id='fn_title'></strong>, a cada <strong id='fn_week_days'></strong> de <strong id='fn_month'></strong>.",
        "final_notice_2": "Cada saída começará às <strong><span id='fn_starting_time_4i'></span>:<span id='fn_starting_time_5i'></span></strong>, tem <strong id='fn_vacancies'></strong> vagas e um desconto de <strong id='fn_discount'></strong>.",
        "confirm": "Salvar",
        "back": "Voltar",
        "delete_month_disclaimer": "Você está prestes a eliminar todas as saídas do mês, esta ação é <strong>irreversível</strong>.",
        "vacancies": "vagas"
      }
    },
    "checkout_bar": {
      "itinerary": "Itinerário",
      "tourists": "Grupo",
      "assign_tourists": "Atribuir",
      "checkout": "Pagamento",
      "voucher": "Comprovante"
    },
    "reviews": {
      "title": "Avaliações",
      "more": "Mais",
      "reviewing_excursion": "Deixe sua avaliação",
      "thanks_for_submitting": "Obrigado pela sua avaliação",
      "review": "Avaliação",
      "footer": "Ver no TrustPilot"
    },
    "newsletter": {
      "sign_up_at": "A solução local para viagens de aventura na Patagônia",
      "we_value_your_privacy": "Sustentável, personalizado e cheio de aventuras para que você desfrute",
      "sign_up_now": "Registre-se",
      "view_preferences": "Preferências",
      "subscribe_to_our": "Inscreva-se em nosso Newsletter",
      "email_address": "Endereço Email",
      "subscribe": "Inscrever-se",
      "we_are_travel_and_growth": "Conheça o Chile e seus paisagens com os melhores tours e excursões. Viva experiências locais em ambientes inesquecíveis fazendo o que você gosta."
    },
    "modal": {
      "first_section": "Selecciona data",
      "product_variants": "Selecciona opção",
      "second_section": "Passageiros",
      "no_daily_quota": "Não há vagas suficientes para este dia",
      "date": "Data",
      "wrong_name": "Nome ou senha incorreta",
      "per_person": " cada",
      "departure_time": "Saída:",
      "spot_left": "Vagas disponíveis",
      "add_reserves": "Número de reservas",
      "select": "Escolher",
      "select_date": "Selecione Data",
      "select_date_text": "Selecione uma data disponível no calendário e siga os passos para gerar sua reserva.",
      "check_in": "Chegada",
      "check_out": "Saída",
      "guests": "Adultos",
      "child_guests": "Crianças",
      "guest_text": "Idade 13 anos ou mais",
      "child_text": "De 0 a 12 anos",
      "twins": "Simples",
      "doubles": "Duplos",
      "doubles_twin": "2 simples'",
      "add_rooms_for": "Adicione seus quartos para",
      "guest": "hóspedes",
      "add_to_itinerary": "Escolher",
      "start": "Começo",
      "ends": "Término",
      "leave_your_review": "Deixe sua avaliação",
      "describe_your_experience": "Descreva sua experiência em geral",
      "add": "Adicionar",
      "next": "Próximo",
      "load_earlier_dates": "Carregar datas anteriores ...",
      "load_later_dates": "Carregar datas posteriores ...",
      "is_resident": "Residentes no Chile",
      "is_not_resident": "Não residentes no Chile",
      "language_title": "Selecione país e moeda",
      "language_subtitle": "Escolha seu idioma na lista",
      "currency_subtitle": "Selecione sua moeda",
      "current_language": "País e idioma",
      "other_languages": "Outros países e idiomas"
    },
    "alert": {
      "invalid_changes": "Alterações inválidas",
      "invalid_action": "Ação inválida: a quantidade não pode ser menor que 0",
      "not_enough_availability": "Não há disponibilidade suficiente para esse intervalo de datas. Verifique outras acomodações ou reserve menos unidades.",
      "something_went_wrong": "Algo deu errado. Por favor, tente novamente ou contate-nos para ajudar.",
      "review_already_submitted": "Avaliação já enviada",
      "couldn't_send_review": "Não foi possível enviar a avaliação",
      "you_must_agree_to": "Você deve aceitar nossos termos e condições",
      "no_products_in_your_order": "Não há produtos em seu pedido",
      "please_sign_the_waiver": "Por favor, assine o termo de responsabilidade com seu nome.",
      "signature_and_tourist": "A assinatura e o nome do turista devem ser idênticos.",
      "couldn't_save": "Não foi possível salvar, tente novamente mais tarde.",
      "invalid_language": "Idioma inválido",
      "confirm_to": "Você deve confirmar que não é um robô.",
      "error": "A senha deve ter no mínimo 8 caracteres, uma letra e um número"
    },
    "notice": {
      "your_account_has": "Sua conta não tem agências, contate-nos",
      "session_expired": "A sessão expirou, por favor inicie sessão.",
      "changes_submitted": "Alterações enviadas!",
      "new_product_created": "Novo produto criado, esperando aprovação",
      "invalid_request": "Solicitação inválida. Por favor, tente novamente ou contate-nos para ajudar.",
      "have_excursions": "A agência tem excursões, atribua-as a outra antes de eliminá-la",
      "updated_information": "Informação atualizada",
      "date_no_longer": "A data já não está disponível",
      "availability_updated": "Disponibilidade atualizada",
      "review_sent": "Avaliação enviada!",
      "bookings_made_for": "Sua reserva foi realizada com sucesso!",
      "profile_picture_updated": "Foto do perfil atualizada!",
      "tourist_information_saved": "Sua informação foi guardada",
      "enabled": "habilitado",
      "diabled": "desabilitado",
      "was": "foi",
      "settings_updated": "Configurações atualizadas!",
      "language_updated": "Idioma atualizado!",
      "account_updated": "Conta atualizada!",
      "reserves_added_for": " reservas adicionadas para ",
      "product_was_enabled": "Produto habilitado",
      "product_was_disabled": "Produto desabilitado"
    },
    "more": {
      "the_best_products": "As melhores experiências na Outdoor Index",
      "all_recommendations_in_puerto_natales": "Todas as experiências em Puerto Natales",
      "all_recommendations_in_punta_arenas": "Todas as experiências em Punta Arenas",
      "all_recommendations_in_zone": "Todas as sugestões em %{zone_name}",
      "all_adventure_products": "Todas as experiências ativas",
      "all_standard_products": "Todas as experiências transformadoras",
      "all_scientific_products": "Todas as experiências de descoberta",
      "all_family_products": "Todas as experiências familiares e de grupos",
      "all_luxury_products": "Todas as experiências sofisticadas",
      "all_promotions_products": "Todas as experiências em promoção",
      "all_ota_products": "Todas as experiências OTA",
      "a_selection_of_the_best": "Uma seleção feita pela Outdoor Index",
      "other_activities_that": "Outras atividades que complementam sua experiência",
      "all_north_patagonia_products": "Todas as experiências na Patagônia Norte",
      "all_south_patagonia_products": "Todas as experiências na Patagônia Sul",
      "all_lagos_region_products": "Todas as experiências na Região dos Lagos e Rios"
    },
    "searches": {
      "no_result_to": "Desculpe, não há resultados para \"%{category_name}\" em \"%{zone_name}\"",
      "recommended_for_you": "Experiências para fazer em \"%{zone_name}\"",
      "category_products_in_zone": "\"%{category_name}\" em \"%{zone_name}\"",
      "category_products_in_zone_no_result": "Desculpe, por agora não há \"%{category_name}\" em \"%{zone_name}\"",
      "all_products_in_zone": "Todas as experiências em \"%{zone_name}\"",
      "all_products_in_zone_no_result": "Desculpe, não há experiências em \"%{zone_name}\"",
      "all_category_products": "Todas as experiências de \"%{category_name}\"",
      "all_category_products_no_result": "Desculpe, por agora não há experiências de \"%{category_name}\"",
      "please_select_category_or_zone": "Por favor selecione uma categoria ou zona"
    },
    "guidebook": {
      "download_our_guide_book": "Baixe nosso livro guia e comece sua viagem com a Outdoor Index",
      "find_out_everything": "Descubra tudo sobre a Patagônia Chilena Sul."
    },
    "banner": {
      "do_you_need_travel_insurance": "Precisa de seguro de viagem?",
      "in_partnership_with_world": "A Outdoor Index em parceria com a World Nomads te oferece o melhor seguro disponível para a Patagônia chilena.",
      "get_a_quote": "Obtenha cotação"
    },
    "blog": {
      "meta_title": "Blog de Viagens, Natureza e Aventura no Chile | Outdoor Index",
      "meta_description": "Explore guias, dicas e inspiração para viajar pelo Chile, descobrir excursões outdoor, conectar-se com a natureza e viver experiências de aventura.",
      "travel_nature_growth": "Viagens, natureza & crescimento",
      "we_connect_you_with": "Conteúdo global sobre natureza, viagens e crescimento. Siga-nos nas redes sociais!",
      "breadcrumb_aria": "Navegação estrutural",
      "breadcrumb_home": "Início",
      "breadcrumb_blog": "Blog",
      "guided_tours": "Passeios guiados",
      "book_now": "Reservar agora",
      "view_more_activities": "Ver mais atividades",
      "showing_count": "Mostrando %{loaded} de %{total} artigos",
      "pagination_aria": "Paginação do blog",
      "page_n": "Página %{n}"
    },
    "mail": {
      "welcome_user_name": "Bem-vindo(a) à Outdoor Index! %{user_name}",
      "leave_your_review": "%{user_name}, deixe uma avaliação de sua experiência",
      "voucher": {
        "your_order_is_ready": "Obrigado por sua compra %{reference_code}",
        "your_sold_product": "Olá %{user_provider}, vendemos uma de suas experiências",
        "new_sold": "Nova venda %{reference_code}"
      }
    },
    "paypal": {
      "description": "Outdoor Index: Pagando o pedido %{reference_code}"
    },
    "payu": {
      "description": "Outdoor Index: Pagando o pedido %{reference_code}"
    },
    "pdf": {
      "emergency_contacts": "Contato de emergência",
      "congratulations_user_name": "Parabéns %{user_name}",
      "congratulations_agency_name": "Parabéns %{agency_name}",
      "here_we_attach": "Aqui anexamos toda a informação de sua viagem. Neste voucher você poderá ver o detalhe de suas experiências, o contato dos fornecedores, o termo de responsabilidade assinado, como também o comprovante de seu produto pago (Paypal ou PayU). Sinta-se à vontade para nos contatar diante de qualquer dúvida.",
      "reservation_number": "Número reserva:",
      "product_detail": "Detalhe do produto",
      "departure": "Partida",
      "your_suppliers": "Seus fornecedores",
      "in_this_section_appear": "Nesta seção aparece o detalhe do pagamento recebido pela Outdoor Index. Lembre-se de imprimir este voucher e levá-lo sempre consigo. Muito obrigado por preferir a Outdoor Index",
      "payments_detail": "Detalhes de pagamentos",
      "initial_payment": "Pagamento inicial",
      "payment_method": "Meio de pagamento",
      "total_paid": "Total pago",
      "total_order": "Total pedido:",
      "order_date": "Data do pedido",
      "payment_date": "Data de pagamento",
      "payment_type": "Tipo de pagamento",
      "payment_complete": "Pagamento completo",
      "print_this_voucher": "Imprima este voucher e leve-o consigo",
      "at_all_times": "em todo momento da viagem. Apresente-o ao fazer",
      "you_check": "seu check-in.",
      "we_have_received": "Recebemos uma nova solicitação de reserva de seus produtos. A seguir se especifica o detalhe desta e a informação de seus passageiros. A partir deste momento pode contatar seus passageiros diretamente ou, se preferir, instruir a Outdoor Index para que o faça. Sempre é recomendável enviar um e-mail informando que a reserva foi realizada com sucesso. Você se destacará como um bom fornecedor. Lembre-se de atualizar as vagas de reserva em seus próprios sistemas para que não haja problemas de sobrevenda. Bom trabalho!",
      "guests": "Viajantes",
      "your_guests": "Seus viajantes",
      "date_of_birth": "Data de nascimento:",
      "origin": "Origem:",
      "document_number": "Número do documento:",
      "phone": "Telefone",
      "email": "Email",
      "emergency_number": "Número de emergência:",
      "allergies": "Alergias:",
      "medical_conditions": "Condição médica:",
      "food_restrictions": "Restrições alimentares:",
      "dear_user_name": "Prezado(a) %{user_name}",
      "service_confirmation": "Confirmação de Serviço",
      "according_to_the_reservation": "De acordo com sua solicitação de reserva, confirmamos a seguinte informação:",
      "reference_code": "Nº reserva",
      "activity": "Atividade",
      "starting_point": "Lugar",
      "starting_date": "Data serviço",
      "starting_time": "Hora serviço",
      "client": "Cliente",
      "payment_details": "DETALHES DE PAGAMENTO",
      "applied": "APLICADO",
      "next_payment": "PRÓXIMO PAGAMENTO (70%)",
      "excursion": "ATIVIDADE %{number}",
      "purchase_date": "Data compra",
      "description": "Descrição",
      "unit_price": "Preço unitário",
      "unit_price_child": "Preço unitário criança",
      "childen_pax": "Crianças",
      "pax": "Pax",
      "tax": "Taxa",
      "about_your_host": "SOBRE SEU ANFITRIÃO",
      "name": "Pessoa responsável:",
      "address": "Endereço:",
      "from": "Data de início do serviço",
      "to": "Data de término do serviço",
      "tourists": "Informações dos turistas",
      "guest": "Passageiros",
      "guest_s": "Passageiro",
      "child_guest": "Crianças",
      "child_guests": "Crianças",
      "child_guest_s": "Criança",
      "guest_price": "Preço Adulto",
      "child_guest_price": "Preço Criança",
      "resident": "Residente",
      "no_resident": "Não Residente",
      "problem_with_order": "Problemas com seu pedido?",
      "complete_remaining_payment_web": "Para pagar o saldo restante, entre na sua conta em outdoorindex.cl e abra este pedido nos seus vouchers.",
      "contact_us": "Contate-nos"
    },
    "currency": {
      "displaying_prices_in": "Mudança de moeda feita!"
    },
    "tourists": {
      "first_create_group": "Ooops! Não se esqueça de preencher a informação dos passageiros."
    },
    "date": {
      "abbr_day_names": [
        "Dom",
        "Seg",
        "Ter",
        "Qua",
        "Qui",
        "Sex",
        "Sáb"
      ],
      "abbr_month_names": [
        null,
        "jan",
        "fev",
        "mar",
        "abr",
        "mai",
        "jun",
        "jul",
        "ago",
        "set",
        "out",
        "nov",
        "dez"
      ],
      "day_names": [
        "domingo",
        "segunda-feira",
        "terça-feira",
        "quarta-feira",
        "quinta-feira",
        "sexta-feira",
        "sábado"
      ],
      "month_names": [
        null,
        "Janeiro",
        "Fevereiro",
        "Março",
        "Abril",
        "Maio",
        "Junho",
        "Julho",
        "Agosto",
        "Setembro",
        "Outubro",
        "Novembro",
        "Dezembro"
      ],
      "formats": {
        "default": "%d/%m/%Y",
        "short": "%a, %d de %b",
        "long": "%d de %B de %Y",
        "fixed_departure": "DD/M/YYYY",
        "calendar_picker": "DD/MM/YYYY",
        "moment": "%Y-%m-%d"
      }
    },
    "time": {
      "formats": {
        "default": "%d/%m/%Y %H:%M",
        "short": "%d de %b, %H:%M",
        "long": "%d de %B de %Y, %H:%M",
        "full": "%A, %d de %B de %Y / %H:%M",
        "calendar_picker": "DD/MM/YYYY"
      }
    },
    "activities": {
      "trekking": "Caminhadas",
      "horseback": "Cavalgadas",
      "birdwatching": "Observação de Aves",
      "mountaineering": "Montanhismo",
      "icehike": "Caminhada no Gelo",
      "kayak": "Caiaque",
      "flyfishing": "Pesca com Mosca",
      "navigations": "Navegações",
      "cruises": "Cruzeiros",
      "helicopter": "Helicóptero",
      "multiactivity": "Multi Atividades",
      "photosafari": "Safari Fotográfico",
      "bikes": "Bicicletas",
      "snowshoes": "Raquetes de neve",
      "ski": "Ski",
      "rafting": "Rafting"
    },
    "filters": {
      "clear_filters": "Limpar filtros"
    },
    "lang": {
      "countries": {
        "spain": "Espanha",
        "argentina": "Argentina",
        "bolivia": "Bolívia",
        "chile": "Chile",
        "colombia": "Colômbia",
        "costa_rica": "Costa Rica",
        "ecuador": "Equador",
        "mexico": "México",
        "peru": "Peru",
        "paraguay": "Paraguai",
        "uruguay": "Uruguai",
        "united_states": "Estados Unidos",
        "england": "Inglaterra",
        "australia": "Austrália",
        "canada": "Canadá",
        "new_zealand": "Nova Zelândia",
        "ireland": "Irlanda",
        "portugal": "Portugal",
        "brazil": "Brasil",
        "france": "França",
        "germany": "Alemanha",
        "china": "China",
        "hong_kong": "Hong Kong",
        "japan": "Japão",
        "korea": "Coreia do Sul",
        "singapore": "Singapura",
        "taiwan": "Taiwan"
      }
    }
  },
  "fr": {
    "terms": {
      "head": {
        "conditions": "Conditions d'Utilisation",
        "privacy": "Politiques de Confidentialité",
        "cookies": "Politiques sur les Cookies.",
        "you_as_a_consumer": "En tant que consommateur, vous avez le devoir de vous informer sur la documentation dont vous pourriez avoir besoin pour pouvoir réaliser votre voyage comme prévu. Vérifiez à temps si vous avez besoin d'un passeport, d'un visa, de vaccins, d'une autorisation pour mineurs ou d'autres exigences documentaires tant pour l'entrée au Chili que pour les pays de transit. Si vous en avez besoin et que vous n'en disposez pas, effectuez les démarches nécessaires pour l'obtenir à l'avance."
      }
    },
    "devise": {
      "google_sign_in": "Se connecter avec Google",
      "facebook_sign_in": "Se connecter avec Facebook",
      "apple_sign_in": "Se connecter avec Apple",
      "already_have_an_account?": "Vous avez déjà un compte ?",
      "didn't_receive_confirmation_instructions?": "Vous n'avez pas reçu les instructions de confirmation ?",
      "didn't_receive_unlock_instructions?": "Vous n'avez pas reçu les instructions de déverrouillage ?",
      "forgot_your_password?": "Mot de passe oublié ?",
      "don't_have_an_account?": "Vous n'avez pas de compte ?",
      "enter_email_associated": "Entrez l'adresse e-mail associée à votre compte et nous vous enverrons un e-mail avec un lien pour réinitialiser votre mot de passe.",
      "passwordless": {
        "not_found_in_database": "Aucun utilisateur trouvé pour cette adresse e-mail",
        "magic_link_sent": "Un lien de connexion a été envoyé à votre adresse e-mail. Veuillez suivre ce lien pour vous connecter à votre compte.",
        "magic_link_sent_paranoid": "Si votre compte existe, vous recevrez un e-mail avec un lien de connexion. Veuillez suivre ce lien pour vous connecter à votre compte."
      },
      "confirmations": {
        "confirmed": "Votre compte a été confirmé avec succès. Vous êtes maintenant connecté.",
        "send_instructions": "Vous allez recevoir un e-mail contenant les instructions pour réinitialiser votre mot de passe dans quelques minutes.",
        "send_paranoid_instructions": "Si votre adresse e-mail existe dans notre base de données, vous allez recevoir un e-mail contenant les instructions pour réinitialiser votre mot de passe dans quelques minutes."
      },
      "failure": {
        "magic_link_invalid": "Lien de connexion invalide ou expiré",
        "already_authenticated": "Vous êtes déjà connecté.",
        "inactive": "Votre compte n'est pas encore activé.",
        "invalid": "Adresse e-mail ou mot de passe incorrect.",
        "invalid_token": "Jeton d'authentification incorrect.",
        "locked": "Votre compte est verrouillé.",
        "not_found_in_database": "Adresse e-mail ou mot de passe incorrect.",
        "timeout": "Votre session a expiré. Veuillez vous reconnecter pour continuer.",
        "unauthenticated": "Vous devez vous connecter ou vous inscrire pour continuer.",
        "unconfirmed": "Vous devez confirmer votre compte pour continuer."
      },
      "mailer": {
        "magic_link": {
          "subject": "Lien de connexion",
          "greeting": "Bonjour %{email} !",
          "instructions": "Vous pouvez vous connecter en utilisant le lien ci-dessous :",
          "login_button": "Me connecter à mon compte",
          "expiration_notice": "Veuillez noter que le lien expirera dans %{expiration_time}."
        },
        "confirmation_instructions": {
          "subject": "Instructions de confirmation"
        },
        "reset_password_instructions": {
          "subject": "Instructions pour réinitialiser le mot de passe"
        },
        "unlock_instructions": {
          "subject": "Instructions de déverrouillage"
        }
      },
      "omniauth_callbacks": {
        "failure": "Impossible de vous authentifier via %{kind} pour la raison suivante : \"%{reason}\".",
        "success": "Authentifié avec succès via le compte %{kind}."
      },
      "passwords": {
        "no_token": "Vous ne pouvez pas accéder à cette page sans passer par un e-mail de réinitialisation de mot de passe. Si vous venez d'un e-mail de réinitialisation de mot de passe, assurez-vous d'utiliser l'URL complète.",
        "send_instructions": "Vous allez recevoir un e-mail avec les instructions pour réinitialiser votre mot de passe dans quelques minutes.",
        "send_paranoid_instructions": "Si votre adresse e-mail existe dans notre base de données, vous allez recevoir un lien de récupération de mot de passe par e-mail dans quelques minutes.",
        "updated": "Votre mot de passe a été changé avec succès. Vous êtes maintenant connecté.",
        "updated_not_active": "Votre mot de passe a été changé avec succès."
      },
      "registrations": {
        "destroyed": "Au revoir ! Votre compte a été annulé avec succès. Nous espérons vous revoir bientôt.",
        "signed_up": "Bienvenue ! Vous avez été identifié(e).",
        "signed_up_but_inactive": "Vous vous êtes inscrit avec succès. Cependant, nous n'avons pas pu vous connecter car votre compte n'est pas encore activé.",
        "signed_up_but_locked": "Vous vous êtes inscrit avec succès. Cependant, nous n'avons pas pu vous connecter car votre compte est verrouillé.",
        "signed_up_but_unconfirmed": "Un message contenant un lien de confirmation a été envoyé à votre adresse e-mail. Veuillez suivre ce lien pour activer votre compte.",
        "update_needs_confirmation": "Vous avez mis à jour votre compte avec succès, mais nous devons vérifier votre nouvelle adresse e-mail. Veuillez vérifier vos e-mails et suivre le lien de confirmation pour confirmer votre nouvelle adresse e-mail.",
        "updated": "Votre compte a été mis à jour avec succès."
      },
      "sessions": {
        "signed_in": "Connecté avec succès.",
        "signed_out": "Déconnecté avec succès."
      },
      "unlocks": {
        "send_instructions": "Vous allez recevoir un e-mail avec les instructions pour déverrouiller votre compte dans quelques minutes.",
        "send_paranoid_instructions": "Si votre compte existe, vous allez recevoir un e-mail avec les instructions pour le déverrouiller dans quelques minutes.",
        "unlocked": "Votre compte a été déverrouillé avec succès. Veuillez vous connecter pour continuer."
      }
    },
    "errors": {
      "something_went_wrong": "Quelque chose s'est mal passé",
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "doit être accepté(e)",
        "blank": "ne peut pas être vide",
        "confirmation": "ne correspond pas à %{attribute}",
        "empty": "ne peut pas être vide",
        "equal_to": "doit être égal(e) à %{count}",
        "even": "doit être pair",
        "exclusion": "est réservé(e)",
        "greater_than": "doit être supérieur(e) à %{count}",
        "greater_than_or_equal_to": "doit être supérieur(e) ou égal(e) à %{count}",
        "inclusion": "n'est pas inclus(e) dans la liste",
        "invalid": "n'est pas valide",
        "less_than": "doit être inférieur(e) à %{count}",
        "less_than_or_equal_to": "doit être inférieur(e) ou égal(e) à %{count}",
        "model_invalid": "La validation a échoué : %{errors}",
        "not_a_number": "n'est pas un nombre",
        "not_an_integer": "doit être un entier",
        "odd": "doit être impair",
        "other_than": "doit être différent(e) de %{count}",
        "present": "doit être vide",
        "required": "doit exister",
        "taken": "est déjà utilisé(e)",
        "must_contain_number": " doit contenir au moins un chiffre et une lettre",
        "must_contain_special": "doit contenir un caractère spécial",
        "must_contain_lower": "doit contenir au moins 1 minuscule",
        "must_contain_upper": "doit contenir au moins 1 majuscule",
        "too_long": {
          "one": "est trop long (1 caractère maximum)",
          "other": "est trop long (%{count} caractères maximum)"
        },
        "too_short": {
          "one": "est trop court (1 caractère minimum)",
          "other": "est trop court (%{count} caractères minimum)"
        },
        "wrong_length": {
          "one": "n'a pas la bonne longueur (1 caractère exact)",
          "other": "n'a pas la bonne longueur (%{count} caractères exacts)"
        },
        "already_confirmed": "a déjà été confirmé, veuillez essayer de vous connecter",
        "confirmation_period_expired": "doit être confirmé dans les %{period}, veuillez en faire une nouvelle demande",
        "expired": "a expiré, veuillez en faire une nouvelle demande",
        "not_found": "n'a pas été trouvé(e)",
        "not_locked": "n'était pas verrouillé(e)",
        "not_saved": {
          "one": "1 erreur a empêché ce %{resource} d'être enregistré :",
          "other": "%{count} erreurs ont empêché ce %{resource} d'être enregistré :"
        }
      },
      "template": {
        "body": "Des problèmes ont été trouvés avec les champs suivants :",
        "header": {
          "one": "Impossible d'enregistrer ce/cette %{model} car 1 erreur a été trouvée",
          "other": "Impossible d'enregistrer ce/cette %{model} car %{count} erreurs ont été trouvées"
        }
      }
    },
    "meta_tags": {
      "default": {
        "description": "Découvrez le Chili avec des programmes d'aventure exclusifs et des guides experts. Vivez une expérience unique ! Réservez votre voyage inoubliable.",
        "keywords": "Patagonie, Chili, circuits aventure, circuits aventure Patagonie, circuits aventure Chili, circuits Torres del Paine, randonnées Patagonie, kayak Patagonie, balades à cheval Patagonie, circuits multisports Patagonie, circuits famille Patagonie, circuits aventure luxe Patagonie, circuits aventure économiques Patagonie, meilleurs circuits aventure Patagonie, voyages aventure Patagonie, activités aventure Patagonie, excursions aventure Patagonie, programmes aventure Patagonie",
        "name": "Outdoor Index"
      },
      "help": {
        "title": "Outdoor Index - Aide",
        "description": "Vous avez des questions sur votre voyage en Patagonie ? Rendez-vous sur Outdoor Index et discutez avec des guides locaux et des experts de la région.",
        "keywords": null
      }
    },
    "views": {
      "pagination": {
        "truncate": "…"
      }
    },
    "activerecord": {
      "models": {
        "season": "Saison",
        "seasons": "Saisons"
      },
      "attributes": {
        "season": {
          "name": "Nom",
          "valid_from": "Valide du",
          "valid_until": "Valide jusqu'au",
          "start_time": "Heure de début",
          "product": "Excursion",
          "mon_check": "Lundi",
          "tue_check": "Mardi",
          "wed_check": "Mercredi",
          "thu_check": "Jeudi",
          "fri_check": "Vendredi",
          "sat_check": "Samedi",
          "sun_check": "Dimanche"
        },
        "order": {
          "clp_charge": "Frais CLP",
          "usd_charge": "Frais USD",
          "username": "Client :",
          "email": "Email :",
          "product": "Produit :",
          "product_name": "Produit",
          "manual_pax": "Nbr Pax :",
          "manual_total": "Payé :",
          "manual_currency": "Devise :",
          "partial_payment": "Paiement :",
          "payment_method": "Méthode :",
          "channel": "Canal :",
          "confirmed_at": "Achat :",
          "departure_at": "Départ :",
          "starting_datetime": "Heure départ :",
          "customer_phone": "Téléphone :",
          "extra": "Extra :",
          "instructions": "Instructions :",
          "language": "Langue :",
          "weather_link": "Lien météo",
          "post_link": "Lien vers le post",
          "itinerary_document": "Document d'itinéraire",
          "show_itinerary_document": "Afficher"
        }
      }
    },
    "promotions": {
      "coupon_code_ok": "Coupon appliqué avec succès",
      "coupon_code_error": "Le coupon n'existe pas",
      "coupon_code_already": "Le coupon a déjà été appliqué",
      "coupon_code_max": "Maximum un coupon par commande",
      "coupon_code_destroy_ok": "Code supprimé avec succès",
      "coupon_code_destroy_error": "Impossible de supprimer le code",
      "coupon_code_destroy_confirm": "Êtes-vous sûr de vouloir le supprimer ?",
      "coupon_have_a_coupon": "Avez-vous un coupon de réduction ?",
      "coupon_form_palceholder": "Code de réduction",
      "coupon_apply": "Appliquer"
    },
    "home_collections": {
      "home_reviews": "350+ personnes par an voyagent avec Outdoor Index",
      "find_your_experience": "Cherchez votre excursion",
      "carousel_region": "Aventures par région",
      "carousel_activities": "Aventures par activités",
      "carousel_time_preference": "Aventures par préférence horaire",
      "sub-landing": "Découvrez les meilleures options touristiques au Chili avec Outdoor Index. Comparez et explorez une grande variété de programmes d'Atacama à la Patagonie. Réservez dès aujourd'hui pour vivre des expériences uniques !",
      "title": "Tours d'aventure au Chili et en Patagonie",
      "subtitle": "Trouvez des aventures avec les meilleurs guides locaux"
    },
    "products_search": {
      "activities": "Activités",
      "regions": "Régions",
      "time": "Temps",
      "date_sub_label": "Quand voulez-vous y aller ?",
      "activities_sub_label": "Choisissez votre activité",
      "regions_sub_label": "Quelle région voulez-vous visiter ?",
      "time_sub_label": "Sélectionnez votre préférence horaire !",
      "date": "Date",
      "all_adventures": "Toutes les aventures",
      "search_placeholder": "Recherchez des aventures dans tout le Chili",
      "most_popular_searches": "Recherches les plus populaires",
      "see_all_adventures": "Voir toutes les aventures",
      "help_me_choose": "Aidez-moi à choisir",
      "help_me_choose_url": "https://api.whatsapp.com/send?phone=56981785011&text=Bonjour%2C%20j%27ai%20besoin%20d%27aide%20pour%20choisir%20une%20aventure",
      "popular_search_items": {
        "circuito_w": {
          "label": "Circuito W",
          "icon": "search",
          "landing_slug": "circuito-w"
        },
        "circuito_o": {
          "label": "Circuito O",
          "icon": "search",
          "landing_slug": "circuito-o"
        },
        "torres_del_paine": {
          "label": "Torres del Paine",
          "icon": "map-pin",
          "zone_id": 1
        },
        "pucon": {
          "label": "Pucón",
          "icon": "map-pin",
          "zone_id": 16
        },
        "san_pedro_atacama": {
          "label": "San Pedro de Atacama",
          "icon": "map-pin",
          "zone_id": 15
        },
        "puerto_natales": {
          "label": "Puerto Natales",
          "icon": "map-pin",
          "zone_id": 2
        }
      },
      "search": "Rechercher",
      "clear": "Effacer la sélection",
      "tours": "tours",
      "subtext": "Planifiez votre prochaine aventure.\nExplorez, réservez et profitez de la nature.",
      "in": "en",
      "showing_count": "Affichage de %{loaded} sur %{total} aventures",
      "load_more": "Charger plus"
    },
    "comments": {
      "comments": "Commentaires",
      "replies": "Réponses",
      "post_a_comment": "Publiez un commentaire !",
      "submit": "Envoyer",
      "reply": "Répondre",
      "body": "Écrivez votre commentaire ici..."
    },
    "order": {
      "confirmed": "Confirmé",
      "mail_thanks": "merci pour votre achat chez Outdoor Index",
      "mail__hi": "Bonjour !",
      "mail_subject": "Outdoor Index Commande N°",
      "order_t": "Commande",
      "see_purchase": "Consultez vos achats",
      "already_paid": "Cette commande a déjà été payée",
      "confirm_payment": "Confirmer",
      "cancel_order": "Annuler",
      "recover_order": "Récupérer",
      "send_confirm": "Confirmer (1)",
      "send_reminder": "Rappeler (2)",
      "send_last_reminder": "Re-rappeler (3)",
      "send_review": "Avis (4)",
      "email_title": "Rappel d'excursion",
      "email_footer": "ci-joint nous vous envoyons un rappel de votre excursion. Si vous avez des questions, n'hésitez pas à nous contacter à info@outdoorindex.cl ou au +56981785011.",
      "promo": "Visitez www.outdoorindex.cl pour plus d'excursions et de programmes.",
      "edit": "Modifier",
      "departure_date": "Date de départ",
      "reservation": "Réservation",
      "code": "Code",
      "departure": "Départ",
      "contact_info": "Informations de contact",
      "customer_phone": "Numéro de contact",
      "travelers": "Voyageurs",
      "itinerary": "Itinéraire",
      "view_itinerary": "Téléchargez votre itinéraire",
      "view_itinerary_file": "ici",
      "voucher": "Voir le voucher",
      "confirmation_email_title": "Votre réservation pour %{excursion} est confirmée",
      "view_weather_link": "Consultez la météo",
      "instruction_exerpt": "Nous savons que votre excursion approche et que vous devez déjà vous préparer",
      "here_some_instructions": "Instructions",
      "view_post_link": "Notre blog",
      "review_email_title": "Racontez-nous comment s'est passée votre excursion %{excursion}",
      "review_link": "Répondre à l'enquête post-voyage",
      "review_trustpilot_intro": "Si vous souhaitez que d'autres voyageurs découvrent votre expérience, vous pouvez aussi laisser un avis public sur Trustpilot.",
      "review_trustpilot_link": "Laisser un avis sur Trustpilot",
      "review_question": "Comment s'est passée votre excursion ?",
      "review_explain_title": "Pourquoi il est important de répondre à l'enquête",
      "rewview_explain_body": "<p>Votre avis nous aide à améliorer chaque excursion. L'enquête post-voyage est confidentielle et nous permet de comprendre votre expérience : l'organisation, le guide, les activités et les détails qui ont fait la différence.</p>\n<p>Réfléchissez à votre voyage avant, pendant et après l'excursion. Répondre honnêtement ne prend que quelques minutes.</p>\n<p>Vos réponses nous aident à maintenir la qualité de notre service et à continuer à nous améliorer pour les futurs voyageurs.</p>\n",
      "review_terrible": "Très mauvaise",
      "review_bad": "Mauvaise",
      "review_acceptable": "Acceptable",
      "review_good": "Bonne",
      "review_great": "Géniale",
      "new_order_excerpt": "Ici, vous pouvez compléter toutes les informations nécessaires pour créer une commande. Rédigez des instructions claires et précises indiquant les horaires et les points de rencontre pour chaque réservation. N'oubliez pas non plus de contacter les opérateurs par ordre de priorité."
    },
    "ondemand": {
      "explanation": "Excursion exclusive ! Contactez notre spécialiste sur le terrain.",
      "label": "Privé"
    },
    "request": {
      "greeting": "Bonjour ! Ces informations ont été envoyées à votre boîte de réception enregistrée avec copie à l'un de nos agents. Nous vous contacterons dès que possible via les informations que vous nous avez envoyées.",
      "order_mail": {
        "header": {
          "hi": "Bonjour ! Nous avons des nouvelles concernant votre demande d'excursion !",
          "title": "Votre demande a été acceptée par l'opérateur local. Veuillez lire les informations ci-dessous et vous assurer que tout est correct.",
          "your_order": "Votre commande N°",
          "ready": "est disponible pour paiement."
        },
        "footer": "Vous pouvez maintenant accéder à la section des paiements avec le bouton de paiement.",
        "disclaimer": "Vous serez redirigé vers la fenêtre de paiement d'Outdoor Index via une connexion sécurisée.",
        "pay": "Payer",
        "excursion": {
          "title": "Excursion",
          "agency": "Opérateur local"
        },
        "manual_order": {
          "observations": "Lisez les commentaires laissés par l'agent Outdoor Index !",
          "price": "Prix",
          "price_clp": "Prix CLP",
          "price_usd": "Prix USD"
        },
        "request_details": "Les détails de votre demande"
      },
      "singular": "Demande",
      "requester": "Demandeur",
      "product_required": "Pour demander la commande, vous devez vous connecter au préalable",
      "excursion": "Excursion",
      "applicants": "Participants",
      "from": "Du",
      "to": "Au",
      "comments": "Commentaires",
      "comments_placeholder": "Laissez vos questions, doutes ou tout ce que vous voulez nous dire. Nous vous contacterons dès que possible !",
      "submit": "Envoyer la demande",
      "email_title": "Demande d'Excursion Privée",
      "email_footer": "Ce formulaire a été envoyé à nos responsables. Vous serez contacté via les données que vous avez saisies dans le formulaire de contact. S'il y a une erreur ou une observation dans le formulaire, veuillez nous envoyer un e-mail à info@outdoorindex.cl et nous vous répondrons dans les plus brefs délais.",
      "contact_name": "Nom du contact",
      "contact_email": "Email du contact",
      "contact_phone": "Téléphone du contact",
      "must_log_in": "Vous devez vous connecter avant de pouvoir payer",
      "phone": "Téléphone de contact",
      "name": "Nom",
      "last_name": "Nom de famille"
    },
    "applicants": {
      "applicants_number": "2) Combien de personnes participeront à l'Excursion ?",
      "dates_sub": "3) Pendant quelles dates souhaitez-vous réaliser l'Excursion ?",
      "additional_info": "4) Informations supplémentaires",
      "applicants_phone": "1) Laissez-nous vos coordonnées pour vous contacter",
      "phone_placeholder": "Téléphone",
      "email": "Email",
      "name": "Nom",
      "lastname": "Nom de famille"
    },
    "active_admin": {
      "observed_dollar_update": "Mettre à jour",
      "agency": "Opérateurs",
      "agencies": "Agences",
      "settings": "Paramètres",
      "users": "Utilisateurs",
      "admin_users": "Administrateurs",
      "orders": "Commandes",
      "pages": "Pages",
      "sales": "Ventes",
      "sale_goals": "Objectifs de vente",
      "reviews": "Avis",
      "blog": "Blog",
      "suppliers": "Fournisseurs",
      "covers": "Collections",
      "excursions": "Excursions",
      "categories": "Catégories",
      "comments_tab": "Commentaires",
      "excursion_images": "Images Excursions",
      "home": "Accueil",
      "home_collections": "Collections",
      "save_home_collections": "Enregistrer Collection",
      "images": "Images du Post",
      "mailer": "Créateur d'e-mails",
      "newsletter_covers": "Couvertures News",
      "notifications": "Notifications",
      "payment_methods": "Méthodes de paiement",
      "private": "Privé",
      "products": "Produits",
      "profiles": "Profils",
      "properties": "Propriétés",
      "promotions": "Promotions",
      "question_subjects": "Questions Aide",
      "questions": "Questions",
      "tourists": "Touristes",
      "requests": "Demandes",
      "tags": "Étiquettes",
      "visits": "Visites",
      "zones": "Zones",
      "seasons": "Saisons",
      "macro_zones": "Macro Zones",
      "landings": "Landings",
      "post": {
        "title": "Titre",
        "subtitle": "Sous-titre",
        "label": "Étiquette",
        "author_name": "Auteur",
        "author_sm": "Auteur réseau social",
        "content": "Contenu",
        "cover": "Couverture",
        "published": "Publiée",
        "unpublished": "Non publiée",
        "tags": "Étiquettes",
        "recommended_posts": "Publications recommandées",
        "products": "Circuits et excursions",
        "explore_chile": "Explorez le Chili et ses recoins avec Outdoor Index"
      },
      "zone": {
        "name": "Nom",
        "description": "Description",
        "sort_order": "Ordre",
        "country": "Pays",
        "state": "Région"
      },
      "review": {
        "tilte1": "Créer un Avis",
        "title2": "Couverture",
        "author": "Nom",
        "country": "Pays",
        "review_date": "Date de l'avis",
        "language": "Langue",
        "save_review": "Enregistrer l'avis",
        "body": "Texte de l'avis",
        "cover": "Couverture",
        "rating": "Évaluation",
        "url": "Url",
        "excerpt": "Ici, vous pouvez compléter toutes les informations nécessaires pour créer un Avis. Assurez-vous toujours que la photo de couverture que vous téléchargez a une bonne résolution et est correcte. N'oubliez pas de lire et de vérifier les informations."
      },
      "landing": {
        "tilte1": "Créer une Landing",
        "title2": "Méta",
        "title3": "Couverture",
        "title4": "Avis",
        "title5": "FAQ",
        "save_landing": "Enregistrer la landing",
        "title": "Titre",
        "place": "Lieu",
        "body": "Contenu",
        "cover": "Couverture",
        "review": "Avis",
        "meta_title": "Méta Titre",
        "meta_description": "Méta Description",
        "product": "Excursion",
        "excerpt": "Ici, vous pouvez compléter toutes les informations nécessaires pour créer une Landing. Assurez-vous toujours que la photo de couverture que vous téléchargez a une bonne résolution et est attrayante pour le touriste. N'oubliez pas de fournir des informations claires et fiables.",
        "more_info": "Plus d'infos"
      },
      "season": {
        "name": "Nom",
        "valid_from": "Du",
        "valid_until": "Jusqu'au",
        "start_time": "Heure de début",
        "product": "Excursion",
        "child_usd_price": "Enfants en dollars",
        "child_clp_price": "Enfants en CLP",
        "single_supplement_usd_price": "Dollars",
        "single_supplement_clp_price": "CLP",
        "guardar_temporada": "Enregistrer",
        "daily_quota": "Disponibilité",
        "title_days": "Jours",
        "title_ages": "Âges",
        "title_prices_kids": "Prix enfants",
        "title_prices_adults": "Prix adultes",
        "title_single_supplement": "Supplément individuel"
      },
      "kpis": {
        "observed_dollar": "Valeur dollar observée",
        "observed_dollar_subtitle": "Valeur dollar définie par la Banque Centrale",
        "visits_today_title": "Visites d'aujourd'hui",
        "visits_today_subtitle": "Flux pour aujourd'hui",
        "visitors": "Visiteurs",
        "last_day": "Jour précédent",
        "show_more": "Voir plus",
        "countries": "Pays",
        "countries_subtitle": "Ceux qui nous visitent le plus",
        "country_anon": "Anonyme",
        "abandoned_cart_title": "Sac à dos de voyage abandonné",
        "abandoned_cart_subtitle": "Commandes dans votre sac à dos de voyage",
        "products_viewed_title": "Produits les plus vus",
        "products_viewed_subtitle": "Les plus populaires pour le moment",
        "posts_viewed_title": "Posts les plus vus",
        "posts_viewed_subtitle": "Les plus populaires pour le moment",
        "products_selled_title": "Produits les plus vendus",
        "products_selled_subtitle": "Au cours de la dernière année",
        "today_excursions_title": "Excursions aujourd'hui",
        "today_excursions_subtitle": "Touristes qui commencent leur tour aujourd'hui.",
        "users_month_title": "Statistique mensuelle",
        "users_month_subtitle": "Bilan statistique des utilisateurs mensuels.",
        "users_number": "Nombre d'utilisateurs",
        "new_users_title": "Nouveaux Utilisateurs",
        "new_users_subtitle": "Enregistrés le dernier mois",
        "users_total_title": "Total Utilisateurs",
        "users_total_subtitle": "Enregistrés depuis le début",
        "new_users_title_box": "Utilisateurs d'aujourd'hui",
        "new_users_subtitle_box": "Flux pour aujourd'hui",
        "users": "Utilisateurs",
        "new_orders_title": "Nouvelles Commandes",
        "new_orders_subtitle": "Enregistrées ce mois-ci",
        "paid_orders_title": "Commandes Payées",
        "paid_orders_subtitle": "Enregistrées ce mois-ci",
        "sale_goals_title": "Objectif de ventes",
        "sale_goals_subtitle": "Performance totale de ce mois",
        "goals": "Objectif",
        "to": "jusqu'à",
        "no_sale_goal": "Aucun objectif de vente n'a été défini",
        "conversion_chart_title": "Graphique de conversion",
        "conversion_chart_subtitle": "Taux de conversion de la dernière année",
        "conversion_last_year": "Taux de conversion de la dernière année",
        "conversion_title": "Taux de conversion",
        "conversion_subtitle": "Mis à jour à ce jour"
      }
    },
    "mercado_pago": {
      "error_alert": "Une erreur s'est produite avec Mercado Pago, veuillez vérifier si votre commande est payée.",
      "error_title": "Transaction rechazada",
      "error_dec": "Une erreur s'est produite lors du traitement du paiement, veuillez réessayer. Si le problème persiste, contactez-nous.",
      "pending_title": "Transaction pendiente",
      "pending_dec": "Votre paiement se trouve en attente de vérification sur Mercado Pago. Une fois vérifié, contactez-nous pour valider votre commande."
    },
    "webpay": {
      "error_alert": "Une erreur s'est produite avec Webpay, veuillez vérifier si votre commande est payée.",
      "error_title": "Transaction refusée",
      "error_dec": "Une erreur s'est produite lors du traitement du paiement, veuillez réessayer. Si le problème persiste, contactez-nous."
    },
    "back": "Retour",
    "chat_title": "Comment pouvons-nous vous aider ?",
    "chat_subtitle": "Nous répondons généralement en quelques heures",
    "chat_name": "Nom",
    "chat_email": "Email",
    "chat_phone": "Téléphone",
    "chat_subject": "Sujet",
    "chat_body": "Message",
    "chat_btn": "Envoyer",
    "menu_welcome": "Bienvenue, %{user_name}",
    "meesage_sended": "Message Envoyé",
    "meesage_captcha": "Vous devez vérifier le captcha",
    "view_more": "Voir plus...",
    "view_more_excursions": "Voir plus d'excursions...",
    "view_more_suggestions": "Voir plus de suggestions...",
    "location": "Emplacement",
    "zone": "Zone",
    "category": "Catégorie",
    "select_one": "Sélectionnez un",
    "select_multiple": "Sélectionnez plusieurs",
    "select_two": "2 max",
    "price": "Prix",
    "vacancies": "Places",
    "key": "Ex: Élévation",
    "value": "1300 mt",
    "value_included": "Ex: Guide bilingue",
    "profiles": "Profils",
    "optional": "Optionnel",
    "email": "Email",
    "phone": "Téléphone",
    "address": "Adresse",
    "pending": "En attente",
    "edit": "Modifier",
    "soon": "Prochainement",
    "password": "Mot de passe (min 8 caractères, lettre, chiffre)",
    "password_confirmation": "Confirmation du mot de passe",
    "remember_me": "Se souvenir de moi",
    "log_in": "Se connecter",
    "sign_up": "S'inscrire",
    "create_an_account": "Créez votre compte",
    "name": "Nom",
    "last_name": "Nom de famille",
    "back_to": "Retour à",
    "reset_password": "Réinitialiser le mot de passe",
    "send": "Envoyer",
    "guests": "Adultes",
    "guest": "Adulte",
    "child_guest": "Enfant",
    "child_guests": "Enfants",
    "products": "Produits",
    "products_show_photos": "Voir (%{n}) photos",
    "delete": "Supprimer",
    "continue": "Continuer",
    "total_only": "Total",
    "total": "Total à payer :",
    "total_paid": "Total payé",
    "charges": "Frais :",
    "subtotal": "Sous-total :",
    "total_final": "Total final",
    "coupon": "Coupon",
    "image_not_found": "Image non trouvée",
    "usd": "USD",
    "clp": "CLP",
    "departure": "Départ",
    "when": "Quand ?",
    "what": "Quoi ?",
    "where": "Où ?",
    "search": "Rechercher",
    "language": "Langue",
    "puerto_natales": "Puerto Natales",
    "punta_arenas": "Punta Arenas",
    "tierra_del_fuego": "Terre de Feu",
    "puerto_williams": "Puerto Williams",
    "in": "à",
    "or": "ou",
    "help": "Questions fréquentes",
    "go_to_home_page": "Retour à l'accueil",
    "add_row": "+ Ajouter",
    "from": "À partir de ",
    "days": "jours",
    "hours": "heures",
    "home": {
      "site_title": "Outdoor Index : Réservez des tours d'aventure en Patagonie et au Chili",
      "things_to_do_in": "Suggestions à",
      "scientific_excursions": "En contact profond avec la nature",
      "luxury_experience": "Vivez exclusif, rien que pour vous",
      "adventure_excursions": "Dépassez-vous",
      "the_best_excursions": "Les meilleures excursions pour cette saison",
      "explore_your_interests": "Explorez vos centres d'intérêt",
      "excursions": "Excursions",
      "products": "produits",
      "suggestions": "Suggestions",
      "hard_adventurous": "Actifs",
      "soft_adventurous": "Transformateur",
      "scientific": "Découverte",
      "family": "Groupes",
      "luxury": "Sophistiqués",
      "promotions": "Promotionnels",
      "download": "Télécharger",
      "adventures_by_region": "Aventures par région",
      "north_patagonia": "Patagonie Nord",
      "south_patagonia": "Patagonie Sud",
      "masonry_zone_count": "%{count} aventures"
    },
    "masonry_zones": {
      "names": {
        "1": "Torres del Paine",
        "2": "Puerto Natales",
        "3": "Punta Arenas",
        "4": "Terre de Feu",
        "5": "Puerto Williams",
        "6": "Antarctique"
      }
    },
    "survey_page": {
      "title": "Outdoor Index - Enquête après-vente",
      "description": "Nous aimerions connaître votre avis sur le service que vous avez reçu. Votre retour est très important pour nous.",
      "main_heading": "Enquête post-voyage Outdoor Index"
    },
    "header": {
      "agency_panel": "Panneau agence",
      "supplier_panel": "Panneau fournisseur",
      "ask_us_a_question": "Contactez-nous",
      "help": "Aide",
      "itinerary": "Itinéraire",
      "sign_out": "Se déconnecter",
      "sign_up": "S'inscrire",
      "log_in": "Se connecter",
      "join_our_newsletter": "Rejoindre la newsletter",
      "partner": "Partenaire",
      "blog": "Historiques exclusifs:",
      "your_blog": "votre blog 🔥",
      "config": "Paramètres",
      "orders": "Vouchers",
      "cart": "Panier"
    },
    "header_cat": {
      "excursions": "Excursions",
      "recommendations": "Suggestions",
      "accommodation": "Hébergements",
      "other": "Autres"
    },
    "agencies": {
      "address": "Adresse",
      "review": "Révision",
      "agency_type": "Type d'agence",
      "owner": "Propriétaire",
      "holder_name": "Nom du titulaire",
      "holder_id": "ID du titulaire",
      "holder_email": "Email du titulaire",
      "phone": "Phone",
      "bank_name": "Nom de la banque",
      "account_type": "Type de compte",
      "account_number": "Numéro de compte",
      "agency": "Agence",
      "country": "Pays",
      "state": "Région",
      "zone": "Zone",
      "duration": "Durée",
      "created_at": "Date de création",
      "agency_info": "Information",
      "supplier_info": "Information",
      "products": "Produits",
      "numbers": "Chiffres",
      "excursions": "Excursions",
      "list_title": "Liste de toutes vos dates",
      "no_dates": "Il n'y a pas encore de dates, veuillez cliquer sur le calendrier pour en créer une.",
      "change_availability": "Gérez vos dates",
      "date_range": "Modifier par plage de dates",
      "set_price": "Définir le prix",
      "rooms_to_add": "Ajouter des chambres",
      "rooms_to_remove": "Supprimer des chambres",
      "products_to_add": "Ajouter des produits",
      "products_to_remove": "Supprimer des produits",
      "apply_changes": "Appliquer les changements",
      "edit_excerpt": "Toutes les informations demandées pour créer le profil du fournisseur sont d'une importance vitale pour établir le lien commercial avec Outdoor Index. Veuillez saisir les informations aussi précisément que possible.",
      "agency_information": "Information agence",
      "supplier_information": "Information fournisseur",
      "max_words": "150 mots",
      "for_booking": "pour réserver",
      "supplier_review": "Avis fournisseur ",
      "website_url": "Adresse web",
      "person_in_charge": "Personne responsable",
      "name": "Nom",
      "update_info": "Enregistrer le profil",
      "commercial_information": {
        "self": "Information commerciale",
        "name": "Nom",
        "bank_name": "Nom banque",
        "bank_account": "Compte",
        "account_type": "Type de compte",
        "commercial_name": "Nom Commercial",
        "id_rut": "ID / Siret"
      },
      "actions": "Actions",
      "manage_dates": "Dates",
      "active": "Approuvée",
      "pending_changes": "En attente",
      "index_excerpt": "Voici une liste de tous vos produits. Vous pouvez créer, modifier et gérer leurs dates. Chaque produit créé restera à l'état \"En attente\" jusqu'à ce qu'il soit examiné par l'équipe d'Outdoor Index.",
      "manage_dates_excerpt": "Voici un calendrier pour ajouter tous vos produits. Vous pouvez créer, modifier et gérer leurs dates. Chaque produit créé restera à l'état \"En attente\" jusqu'à ce qu'il soit examiné par l'équipe d'Outdoor Index.",
      "create_excursion": "Créer une excursion",
      "create_product": "Créer un produit",
      "create_activity": "Créer une activité",
      "create_post": "Créer un post",
      "new_excursion_excerpt": "Ici, vous pouvez compléter toutes les informations nécessaires pour créer un produit. Assurez-vous toujours que les photos que vous téléchargez ont une bonne résolution et sont attrayantes pour le touriste. N'oubliez pas de fournir des informations claires et fiables.",
      "english": "Traduire en anglais →",
      "spanish": "Traduire en espagnol →",
      "create_agency": "Créer une nouvelle agence",
      "agency_bank": "Données de virement"
    },
    "error": {
      "sorry": "Désolé, cette page n'existe pas.",
      "opps": "Vous avez peut-être mal tapé l'adresse ou la page a été déplacée.",
      "go": "aller à l'accueil",
      "went_wrong": "Désolé, mais quelque chose s'est mal passé.",
      "improvements": "Si vous voyez ce message, c'est peut-être parce que vous avez mal tapé l'adresse web ou parce que nous mettons à jour le site avec de nouvelles fonctionnalités et améliorations. Attendez quelques minutes et rechargez la page. Merci !"
    },
    "excursions": {
      "title": "Titre",
      "location": "Lieu",
      "zone": "Zone",
      "category": "Catégorie",
      "profiles": "Type de voyage",
      "price": "Prix (en dollars)",
      "vacancies": "Places",
      "duration": "Durée",
      "half_day": "Demi-journée",
      "full_day": "Journée complète",
      "multiple_days": "Plusieurs jours",
      "duration_days": "Jours",
      "duration_hours": "Heures",
      "itinerary": {
        "body": "Corps"
      },
      "faq": {
        "body": "Corps"
      },
      "days": {
        "zero": "Jour",
        "one": "Jour",
        "other": "Jours"
      },
      "hours": {
        "zero": "Heure",
        "one": "Heure",
        "other": "Heures"
      },
      "add_images_(minimum_3)": "Photos (minimum 3)",
      "disclaimer": "Clause de non-responsabilité",
      "description": "Aperçu général",
      "body": "Notre Itinéraire",
      "useful_information": "Infos utiles",
      "what's_included?": "Inclus",
      "what's_not_included?": "Non inclus",
      "meeting_instruction": "Lieu de départ",
      "meeting_address": "Adresse",
      "policies": "Politiques d'annulation",
      "save_excursion": "Sauvegarder l'excursion",
      "what_we'll_do": "Aperçu général",
      "our_itinerary": "Itinéraire",
      "faqs": "FAQs",
      "images": "Images",
      "edit_excerpt": "Toutes les informations demandées pour créer le profil du fournisseur sont d'une importance vitale pour établir le lien commercial avec Outdoor Index. Veuillez saisir les informations aussi précisément que possible.",
      "other_excursions_from_this_tour_company": "Autres expériences de ce fournisseur",
      "create_excursions": "Créer une excursion",
      "more": "Plus",
      "less": "Moins",
      "best_excursions_for_the_next_season": "Recommandés pour cette saison",
      "add_extras": "Ajouter des extras",
      "price_per_reservations": "Prix par réservation",
      "extra_description": "Activité",
      "macro_zone": "Macro Zone",
      "meta_title": "Méta titre",
      "meta_description": "Méta description",
      "time": "Temps",
      "prices": "Prix",
      "included": "Qu'est-ce qui est inclus ?",
      "locations": "Emplacement",
      "alternative_names": "Excursion également connue sous les noms suivants",
      "breadcrumb_catalog": "Circuits et excursions"
    },
    "hotels": {
      "twin": "Individuel",
      "double": "Matrimonial",
      "double_twins": "Deux lits simples",
      "room_reserved": "chambre réservée",
      "edit_your_booking": "Modifiez votre réservation"
    },
    "reservations": {
      "add_guest_details": "Ajouter info touriste",
      "traveler_data_card_title": "Données du voyageur",
      "traveler_data_badge_missing": "Infos manquantes",
      "traveler_data_badge_complete": "Complet",
      "traveler_data_badge_ready_details": "Infos prêtes",
      "traveler_data_intro": "Nous avons besoin de ces informations pour confirmer votre réservation.",
      "traveler_data_complete_button": "Infos voyageur",
      "detach_guest_confirm": "Retirer ce voyageur de cette réservation ?",
      "guest_slots_full": "Tous les voyageurs sont déjà assignés pour cette réservation.",
      "organize_your_itinerary": "1) Itinéraire >",
      "create_your_travel_group": "2) Groupe de voyage >",
      "assign_tourists": "3) Attribuer les touristes",
      "new_checkout_excerpt": "Voici la liste des produits dans votre sac à dos de voyage. N'oubliez pas d'ajouter les passagers aux Excursions auxquelles ils participeront. Avant d'acheter, vérifiez bien la quantité de réservations et leurs coûts. N'oubliez pas de lire notre Politique d'annulation.",
      "cart_title": "Informations sur votre voyage",
      "checkout_page_title": "Confirmez votre réservation et procédez au paiement",
      "checkout_page_intro": "Vérifiez les détails de votre excursion, complétez les informations du voyageur et choisissez votre mode de paiement.",
      "checkout_trip_summary_heading": "Résumé de votre voyage",
      "pay_with": "Payer avec",
      "cart_subtitle": "Liste des produits dans votre sac à dos de voyage",
      "itinerary_excerpt": "Ici, vous pouvez trouver une liste de tous vos produits. Assurez-vous que toutes les informations sont correctes pour continuer avec les prochaines étapes. Important : toutes les heures et dates sont affichées à l'heure chilienne.",
      "assign_excerpt": "Dans cette section, vous devez indiquer quel voyageur va à quelle excursion. De cette façon, nous aurons toutes les informations nécessaires pour vous offrir la meilleure expérience possible.",
      "list_of_products": "Liste des produits",
      "reservations_made": "#",
      "assing_tourists": "Attribuer les touristes",
      "go_to_checkout": "Continuer",
      "a_list_of_all_your_reservations": "Toutes vos réservations",
      "my_group": "Mon groupe",
      "people_(including_you)": "Participants (Y compris vous)",
      "(me)": "(Moi)",
      "team_member": "Membres du groupe",
      "actions": "Actions",
      "you_have_no_reservations": "Vous n'avez aucune réservation",
      "tourists_group": "Dans cette section, vous devez ajouter les informations de toutes les personnes qui vous accompagneront. Il est très important que les informations jointes soient aussi fiables que possible.",
      "edit_your_reservation": "Modifiez votre réservation",
      "cancel_date": "Annuler la réservation",
      "departure_date": "Jour de départ",
      "reserves": "Réserves",
      "update": "Mettre à jour",
      "not_enough": "n'a pas assez de",
      "too_many": "a trop de",
      "product_for": "Le produit",
      "tourists_assigned": "touristes attribués",
      "many_few_tourists": "Le nombre de touristes attribués ne correspond pas au nombre de réservations",
      "select_your_extras": "Sélectionnez vos extras :",
      "product_variants": "Options",
      "select_date_first": "Sélectionnez d'abord une date",
      "total_price": "Prix total",
      "see_details": "Voir les détails",
      "price_chilean": "Valeur totale résidents au Chili :",
      "price_no_chilean": "Valeur totale non-résidents au Chili :",
      "single_supplement": "Supplément individuel :",
      "people": "Passagers :",
      "details_of_purchase": "Détail de votre achat",
      "confirmed_excerpt": "Merci de voyager avec nous !",
      "confirmed_excerpt_litle": "Consultez le voucher pour voir les détails de votre achat.",
      "cart_empty": "Votre sac à dos de voyage est vide"
    },
    "checkout": {
      "do_checkout": "Passer la commande",
      "confirm_checkout_excerpt": "Avant de continuer, vérifiez que tout est correct. Une fois que vous aurez accepté cette commande, vous ne pourrez plus la modifier.",
      "confirm_checkout_excerpt_2": "(Vous pouvez toujours créer une nouvelle commande.)",
      "please_confirm_your_details": "Veuillez confirmer vos informations",
      "i_need_to_change_something": "J'ai besoin de changer quelque chose",
      "everything_looks_fine": "Tout semble correct",
      "after_this_step": "Après cette étape, Outdoor Index contactera tous les fournisseurs.",
      "providers_confirm_availability": "Lorsque tous les fournisseurs confirmeront votre disponibilité, vous serez contacté.",
      "payment_excerpt": "Avant d'acheter, assurez-vous que tous les détails de vos produits sont corrects. Vérifiez le nombre de réservations et leurs valeurs. N'oubliez pas de lire nos politiques d'annulation.",
      "your_details_confirmation_and_payment": "Détail de vos produits et paiement",
      "important!": "Important",
      "all_transactions_have_an_extra": "Vous pourrez payer avec votre carte de débit ou de crédit selon les modalités convenues avec votre banque. Outdoor Index recevra le montant total de la vente.",
      "get_a_refund_if": "Obtenez le remboursement de votre argent si vous annulez dans les 24 heures suivant l'achat.",
      "pay_now": "Confirmer le paiement",
      "confirm_and_pay": "Confirmer et payer",
      "wetravel_link_not_ready": "Veuillez patienter puis réessayer, ou sélectionnez à nouveau WeTravel.",
      "mercado_wallet_not_ready": "Le bouton Mercado Pago est encore en cours de chargement. Patientez quelques secondes.",
      "payment_summary": "Récapitulatif du paiement",
      "payment_method_title": "Mode de paiement",
      "payment_methods_locked_until_traveler_details": "Veuillez compléter les informations des voyageurs avant de choisir un mode de paiement.",
      "payment_method_recommended": "Recommandé",
      "payment_method_blurb": {
        "wetravel": "Paiement international en USD",
        "mercado_pago": "Paiement local par carte et en plusieurs fois selon votre banque",
        "webpay": "Paiement par carte bancaire via Webpay",
        "payu": "Paiement avec PayU",
        "paypal": "Paiement avec PayPal",
        "google_pay": "Paiement avec Google Pay",
        "apple_pay": "Paiement avec Apple Pay"
      },
      "total_to_pay": "Total à payer",
      "secure_payment_note": "Paiement 100 % sécurisé et crypté",
      "help_widget_title": "Besoin d'assistance ?",
      "help_widget_body": "Parlez avec un guide Outdoor Index pour obtenir une assistance personnalisée.",
      "help_widget_cta": "Parler à un spécialiste",
      "help_widget_online": "En ligne",
      "terms_toggle_line_html": "J'accepte les %{terms} et la %{policy}.",
      "terms_toggle_word_terms": "conditions",
      "terms_toggle_word_policy": "politique",
      "review": "Avis",
      "ready": "Prêt",
      "choose_payment": "Choisissez le paiement souhaité",
      "only_for_reservation": "Réservation",
      "complete_payment": "Paiement complet",
      "30_p": "30%",
      "30_per": "Payé 30%",
      "30_pers": "Payé 30%",
      "100_p": "100%",
      "100_per": "Payé 100%",
      "100_pers": "Payé 100%",
      "i_hereby_accept": "En cliquant sur \"Confirmer le paiement\", vous acceptez nos",
      "and_confirm": "et confirmez avoir lu et compris notre",
      "and_our": "et notre",
      "your_itinerary": "Votre itinéraire en détail",
      "continue_shopping": "Continuer les achats",
      "not_available": "Non disponible",
      "some_products_deleted": "Certains produits ne sont plus disponibles",
      "disclaimer": "À propos de votre réservation",
      "accept": "J'accepte",
      "cancel": "Annuler",
      "must_have_tourist": "Doit avoir au moins 1 touriste avec email et téléphone ajoutés.",
      "wetravel_partial_error": "Le paiement partiel n'est pas disponible car la date de l'excursion est trop proche. Veuillez sélectionner le paiement complet."
    },
    "vouchers": {
      "active_excerpt": "Ici est affiché un détail de vos vouchers. Vous pouvez les voir et les imprimer. N'oubliez pas de vous présenter le jour de la réservation avec votre voucher imprimé, en indiquant son numéro d'enregistrement.",
      "all_of_your_vouchers": "Tous vos justificatifs",
      "confirmed_excerpt": "Merci beaucoup pour votre achat. Nous espérons que vous passerez un merveilleux voyage. N'oubliez pas d'imprimer votre justificatif et de toujours l'emporter avec vous. Pour toute question ou situation imprévue, n'hésitez pas à nous contacter.",
      "active_vouchers": "Vouchers actifs",
      "disclaimer": "Dans ce PDF, vous trouverez toutes les informations sur vos produits. Veuillez vérifier le document et si vous avez des questions, contactez-nous. Profitez de votre voyage.",
      "get_your_voucher": "Obtenez votre voucher",
      "voucher": "Justificatif",
      "payment_error": "Erreur de paiement",
      "error": "Un problème est survenu lors du processus de paiement. Veuillez réessayer plus tard ou contactez-nous pour voir d'autres options de paiement.",
      "restart_payment": "Réessayer le paiement",
      "payment_rejected": "Paiement refusé",
      "rejected": "PayU / Paypal a indiqué que votre paiement a été refusé, vérifiez vos données et réessayez, ou contactez-nous pour d'autres options de paiement.",
      "home": "Accueil",
      "order_number": "N° Commande :",
      "view": "Voir",
      "print": "Imprimer",
      "complete": "Complet",
      "incomplete": "Incomplet",
      "activities": "Activités",
      "was_partial_payment": "(2)"
    },
    "categories": {
      "search": "recherche",
      "general": "général",
      "general_category_search": "Recherche générale de %{category_name}",
      "other_excursions_to_do": "Autres expériences à faire à %{zone_name}",
      "general_zone_search": "Recherche de suggestions à %{zone_name}",
      "recommended_for_you": "Expériences à faire à %{zone_name}"
    },
    "tourist": {
      "new_tourist_excerpt": "Dans cette section, vous pouvez ajouter les informations de toutes les personnes qui vous accompagneront. Il est très important que les informations jointes soient aussi fiables que possible.",
      "personal_info": "Informations personnelles",
      "checkout_minimum_one_pax_notice": "Nous avons seulement besoin des informations complètes d’un voyageur pour continuer. Vous pourrez compléter les autres plus tard si vous le souhaitez.",
      "add_another_pax": "Ajouter un autre voyageur",
      "info_pax_card_title": "Infos voyageur",
      "name": "Nom",
      "last_name": "Nom de famille",
      "date_of_birth": "Date de naissance",
      "nationality": "Nationalité",
      "passport": "Numéro de passeport",
      "hometown": "Ville de résidence",
      "phone": "Téléphone",
      "email": "Email",
      "emergency_contact": "Contact d'urgence",
      "allergies": "Allergies",
      "medical_conditions": "Condition médicale",
      "food_restrictions": "Restrictions alimentaires",
      "pending": "En attente",
      "ready": "Prêt",
      "you_have_no_vouchers": "Vous n'avez pas de vouchers actifs",
      "no_reservations_to_assign": "Aucune réservation à attribuer"
    },
    "footer": {
      "about_us": "À propos de nous",
      "statement": "Découvrez nos piliers",
      "go_to_suscribe": "S'abonner",
      "suscribe_text": "Nous envoyons des mises à jour bimensuelles sur les nouvelles histoires et les réductions de voyage",
      "terms_&_conditions": "Termes",
      "privacy_&_cookies": "Confidentialité",
      "contact_us": "Contactez-nous",
      "edit_endorsement": "Outdoor Index est basé à Puerto Natales (Patagonie Chilienne Sud) et bénéficie du soutien de plus de 40 fournisseurs.",
      "all_rights_reserved": "Tous droits réservés. Aucune partie de ce site ne peut être reproduite sans l'autorisation correspondante.",
      "spanish": "Espagnol",
      "english": "Anglais",
      "portuguese": "Portugais",
      "french": "Français",
      "german": "Allemand",
      "english_corto": "EN",
      "spanish_corto": "ES",
      "portuguese_corto": "PT",
      "french_corto": "FR",
      "german_corto": "DE",
      "clp": "$ Pesos chilien (CLP)",
      "usd": "$ Dollars américains (USD)",
      "survey": "Enquête",
      "endorsement": {
        "support_local_comunity": "Soutenez l'économie locale, encouragez les approches durables",
        "when_you_buy": "En achetant chez nous, vous encouragez plus de 35 fournisseurs dans leur gestion durable et de qualité.",
        "instant_booking": "Guides certifiés 100% disponibles pour votre assistance",
        "by_entering_your": "Avant, pendant et après pour toutes vos questions et pour vous aider à planifier votre prochaine aventure.",
        "payment_protection": "Confirmez votre réservation en payant seulement 30%",
        "we_comply_with_all": "Planifiez votre aventure sans stress, plus légèrement en payant seulement une partie maintenant et le reste plus près de la date."
      },
      "covid": "Covid",
      "secure": "Les réservations traitées via ce site web sont protégées par nos partenaires.",
      "titles": {
        "book": "Réservez en toute confiance",
        "destinations": "Destinations populaires",
        "activities": "Activités populaires"
      },
      "lang-currency": "Langue & Devise"
    },
    "chat": {
      "hi": "Bonjour",
      "our_chat_service": "Notre service de chat est disponible du lundi au vendredi de 10h à 18h (UTC/GMT -3). Si vous nous écrivez pendant ces heures, nous vous répondrons en quelques minutes.",
      "new-message": "Nouveau message",
      "messages": "Messages",
      "enter_your_name": "Entrez votre nom",
      "enter_email": "Entrez votre email",
      "enter_message": "Entrez un message...",
      "create_message": "Envoyer message",
      "begin": "Commencer",
      "user": "Utilisateur",
      "need_help": "Besoin d'aide?",
      "talk_to_local_guide": "Parlez à un guide local"
    },
    "registration": {
      "edit_user": "Modifier l'utilisateur",
      "email": "Email",
      "name": "Nom",
      "lastname": "Nom de famille",
      "confirm_password": "Confirmer le mot de passe",
      "current_password": "Mot de passe actuel",
      "new_password": "Nouveau mot de passe (min 8 caractères, lettre, chiffre)",
      "profile_picture": "Photo de profil",
      "profiles": "Profils (Vous pouvez en choisir plusieurs)",
      "interests": "Intérêts (Vous pouvez en choisir plusieurs)",
      "notification": "Configuration des notifications",
      "save_settings": "Enregistrer",
      "update_account": "Mettre à jour le compte",
      "registration_excerpt": "Gérez votre profil comme vous le souhaitez. Activez ou désactivez vos notifications et définissez vos centres d'intérêt. Ainsi, vous pourrez personnaliser les contenus que vous voyez sur Outdoor Index.",
      "vouchers": "Vouchers",
      "all_vouchers": "Mes vouchers",
      "change_your_password": "Changement de mot de passe",
      "change_my_password": "Changer mon mot de passe",
      "confirm_new_password": "Confirmer le nouveau mot de passe"
    },
    "responsive": {
      "more": "Plus..."
    },
    "uploader": {
      "upload_a_file": "Télécharger un fichier",
      "drop_files_here": "Déposez votre fichier ici",
      "processing_dropped_files": "Traitement des fichiers..."
    },
    "sidebar_single": {
      "no_dates_available": "Aucune date disponible",
      "disclaimer": "Assurez votre place maintenant en payant seulement <strong>30% de la valeur totale de la réservation.</strong>",
      "select_dates": "Réserver maintenant",
      "share": "Des questions sur l’excursion?",
      "to_make_a": "Pour faire une réservation, veuillez ",
      "log_in": "vous connecter",
      "or": "ou",
      "sign_up": "vous inscrire",
      "if_you_are": "si vous êtes nouveau.",
      "price_for": "Par personne",
      "from": "Prix à partir de",
      "contact_viewnia": "Contactez-nous",
      "rates": "Tarifs CLP incluent la TVA. Tarifs USD n'incluent pas la TVA ; étrangers non résidents exonérés s'ils paient en USD."
    },
    "request_form": {
      "title": "Demander une Excursion",
      "contact_viewnia_subtitle": "Complétez ce formulaire pour commencer le processus qui nous permettra de coordonner votre excursion avec notre spécialiste sur le terrain."
    },
    "modal_manage_date": {
      "discount": "Ajouter une réduction",
      "manage_date": "Gérer la date",
      "date": "Date",
      "starting_time": "Heure de départ",
      "price": "Prix",
      "vacancies": "Places",
      "save": "Enregistrer",
      "cancel_date": "Annuler la date",
      "available_ammount": "Quantité disponible",
      "month_form": {
        "edit_month": "Modifier le mois",
        "delete_month": "Supprimer le mois",
        "populate_month": "Remplir le mois",
        "disclaimer_1": "Vous êtes sur le point de modifier <strong>un mois complet</strong>, cette action est <strong>difficile à annuler</strong>.",
        "disclaimer_2": "Veuillez vérifier votre calendrier actuel avant de continuer pour éviter les doublons ou autres problèmes.",
        "accept": "Accepter",
        "month": "Mois",
        "week_days": "Jours de la semaine",
        "continue": "Continuer",
        "final_notice_header": "Veuillez lire attentivement :",
        "final_notice_1": "Ajouter une date de départ pour l'excursion <strong id='fn_title'></strong>, chaque <strong id='fn_week_days'></strong> de <strong id='fn_month'></strong>.",
        "final_notice_2": "Chaque départ commencera à <strong><span id='fn_starting_time_4i'></span>:<span id='fn_starting_time_5i'></span></strong>, a <strong id='fn_vacancies'></strong> places et une réduction de <strong id='fn_discount'></strong>.",
        "confirm": "Enregistrer",
        "back": "Retour",
        "delete_month_disclaimer": "Vous êtes sur le point de supprimer toutes les sorties du mois, cette action est <strong>irréversible</strong>.",
        "vacancies": "places"
      }
    },
    "checkout_bar": {
      "itinerary": "Itinéraire",
      "tourists": "Groupe",
      "assign_tourists": "Attribuer",
      "checkout": "Paiement",
      "voucher": "Justificatif"
    },
    "reviews": {
      "title": "Avis",
      "more": "Plus",
      "reviewing_excursion": "Laissez votre avis",
      "thanks_for_submitting": "Merci pour votre avis",
      "review": "Avis",
      "footer": "Voir sur TrustPilot"
    },
    "newsletter": {
      "sign_up_at": "La solution locale pour les voyages d'aventure en Patagonie",
      "we_value_your_privacy": "Durable, personnalisé et plein d'aventures pour votre plaisir",
      "sign_up_now": "S'inscrire",
      "view_preferences": "Préférences",
      "subscribe_to_our": "Abonnez-vous à notre Newsletter",
      "email_address": "Adresse Email",
      "subscribe": "S'abonner",
      "we_are_travel_and_growth": "Découvrez le Chili et ses paysages avec les meilleurs tours et excursions. Vivre des expériences locales dans des environnements inoubliables en faisant ce que vous aimez."
    },
    "modal": {
      "first_section": "Sélectionner la date",
      "product_variants": "Sélectionner l'option",
      "second_section": "Passagers",
      "no_daily_quota": "Il n'y a pas assez de places pour ce jour",
      "date": "Date",
      "wrong_name": "Nom ou mot de passe incorrect",
      "per_person": " chacun",
      "departure_time": "Départ :",
      "spot_left": "Places disponibles",
      "add_reserves": "Nombre de réservations",
      "select": "Choisir",
      "select_date": "Sélectionnez une Date",
      "select_date_text": "Sélectionnez une date disponible dans le calendrier et suivez les étapes pour générer votre réservation.",
      "check_in": "Arrivée",
      "check_out": "Départ",
      "guests": "Adultes",
      "child_guests": "Enfants",
      "guest_text": "Âge 13 ans ou plus",
      "child_text": "De 0 à 12 ans",
      "twins": "Simple",
      "doubles": "Doubles",
      "doubles_twin": "2 simples",
      "add_rooms_for": "Ajoutez vos chambres pour",
      "guest": "hôtes",
      "add_to_itinerary": "Choisir",
      "start": "Début",
      "ends": "Fin",
      "leave_your_review": "Laissez votre avis",
      "describe_your_experience": "Décrivez votre expérience en général",
      "add": "Ajouter",
      "next": "Suivant",
      "load_earlier_dates": "Charger les dates antérieures ...",
      "load_later_dates": "Charger les dates ultérieures ...",
      "is_resident": "Résidents au Chili",
      "is_not_resident": "Non-résidents au Chili",
      "language_title": "Sélectionnez pays et devise",
      "language_subtitle": "Choisissez votre langue parmi la liste",
      "currency_subtitle": "Sélectionnez votre devise",
      "current_language": "Pays et langue",
      "other_languages": "Autres pays et langues"
    },
    "alert": {
      "invalid_changes": "Changements invalides",
      "invalid_action": "Action invalide : la quantité ne peut pas être inférieure à 0",
      "not_enough_availability": "Il n'y a pas assez de disponibilité pour cette plage de dates. Vérifiez d'autres hébergements ou réservez moins d'unités.",
      "something_went_wrong": "Quelque chose s'est mal passé. Veuillez réessayer ou contactez-nous pour vous aider.",
      "review_already_submitted": "Avis déjà envoyé",
      "couldn't_send_review": "Impossible d'envoyer l'avis",
      "you_must_agree_to": "Vous devez accepter nos termes et conditions",
      "no_products_in_your_order": "Aucun produit dans votre commande",
      "please_sign_the_waiver": "Veuillez signer la décharge avec votre nom.",
      "signature_and_tourist": "La signature et le nom du touriste doivent être identiques.",
      "couldn't_save": "Impossible d'enregistrer, réessayez plus tard.",
      "invalid_language": "Langue invalide",
      "confirm_to": "Vous devez confirmer que vous n'êtes pas un robot.",
      "error": "Le mot de passe doit comporter au moins 8 caractères, une lettre et un chiffre"
    },
    "notice": {
      "your_account_has": "Votre compte n'a pas d'agences, contactez-nous",
      "session_expired": "La session a expiré, veuillez vous reconnecter.",
      "changes_submitted": "Modifications envoyées !",
      "new_product_created": "Nouveau produit créé, en attente d'approbation",
      "invalid_request": "Demande invalide. Veuillez réessayer ou contactez-nous pour vous aider.",
      "have_excursions": "L'agence a des excursions, assignez-les à une autre avant de la supprimer",
      "updated_information": "Informations mises à jour",
      "date_no_longer": "La date n'est plus disponible",
      "availability_updated": "Disponibilité mise à jour",
      "review_sent": "Avis envoyé !",
      "bookings_made_for": "Votre réservation a été effectuée avec succès !",
      "profile_picture_updated": "Photo de profil mise à jour !",
      "tourist_information_saved": "Vos informations ont été enregistrées",
      "enabled": "activé",
      "diabled": "désactivé",
      "was": "a été",
      "settings_updated": "Paramètres mis à jour !",
      "language_updated": "Langue mise à jour !",
      "account_updated": "Compte mis à jour !",
      "reserves_added_for": " réservations ajoutées pour ",
      "product_was_enabled": "Produit activé",
      "product_was_disabled": "Produit désactivé"
    },
    "more": {
      "the_best_products": "Les meilleures expériences sur Outdoor Index",
      "all_recommendations_in_puerto_natales": "Toutes les expériences à Puerto Natales",
      "all_recommendations_in_punta_arenas": "Toutes les expériences à Punta Arenas",
      "all_recommendations_in_zone": "Toutes les suggestions à %{zone_name}",
      "all_adventure_products": "Toutes les expériences actives",
      "all_standard_products": "Toutes les expériences transformatrices",
      "all_scientific_products": "Toutes les expériences de découverte",
      "all_family_products": "Toutes les expériences familiales et de groupes",
      "all_luxury_products": "Toutes les expériences sophistiquées",
      "all_promotions_products": "Toutes les expériences en promotion",
      "all_ota_products": "Toutes les expériences OTA",
      "a_selection_of_the_best": "Une sélection faite par Outdoor Index",
      "other_activities_that": "Autres activités qui complètent votre expérience",
      "all_north_patagonia_products": "Toutes les expériences en Patagonie Nord",
      "all_south_patagonia_products": "Toutes les expériences en Patagonie Sud",
      "all_lagos_region_products": "Toutes les expériences dans la Région des Lacs et Rivières"
    },
    "searches": {
      "no_result_to": "Désolé, aucun résultat pour \"%{category_name}\" à \"%{zone_name}\"",
      "recommended_for_you": "Expériences à faire à \"%{zone_name}\"",
      "category_products_in_zone": "\"%{category_name}\" à \"%{zone_name}\"",
      "category_products_in_zone_no_result": "Désolé, pour l'instant il n'y a pas de \"%{category_name}\" à \"%{zone_name}\"",
      "all_products_in_zone": "Toutes les expériences à \"%{zone_name}\"",
      "all_products_in_zone_no_result": "Désolé, il n'y a pas d'expériences à \"%{zone_name}\"",
      "all_category_products": "Toutes les expériences de \"%{category_name}\"",
      "all_category_products_no_result": "Désolé, pour l'instant il n'y a pas d'expériences de \"%{category_name}\"",
      "please_select_category_or_zone": "Veuillez sélectionner une catégorie ou une zone"
    },
    "guidebook": {
      "download_our_guide_book": "Téléchargez notre guide et commencez votre voyage avec Outdoor Index",
      "find_out_everything": "Découvrez tout sur la Patagonie Chilienne Sud."
    },
    "banner": {
      "do_you_need_travel_insurance": "Besoin d'une assurance voyage ?",
      "in_partnership_with_world": "Outdoor Index en partenariat avec World Nomads vous offre la meilleure assurance disponible pour la Patagonie chilienne.",
      "get_a_quote": "Obtenir un devis"
    },
    "blog": {
      "meta_title": "Blog Voyage, Nature et Aventure au Chili | Outdoor Index",
      "meta_description": "Découvrez guides, conseils et inspiration pour voyager au Chili, des excursions outdoor, la nature et des expériences d'aventure.",
      "travel_nature_growth": "Voyages, nature & croissance",
      "we_connect_you_with": "Contenu global sur la nature, les voyages et le développement. Suivez-nous sur les réseaux sociaux!",
      "breadcrumb_aria": "Fil d’Ariane",
      "breadcrumb_home": "Accueil",
      "breadcrumb_blog": "Blog",
      "guided_tours": "Circuits guidés",
      "book_now": "Réserver maintenant",
      "view_more_activities": "Voir plus d'activités",
      "showing_count": "Affichage de %{loaded} sur %{total} articles",
      "pagination_aria": "Pagination du blog",
      "page_n": "Page %{n}"
    },
    "mail": {
      "welcome_user_name": "Bienvenue chez Outdoor Index ! %{user_name}",
      "leave_your_review": "%{user_name}, laissez un avis sur votre expérience",
      "voucher": {
        "your_order_is_ready": "Merci pour votre achat %{reference_code}",
        "your_sold_product": "Bonjour %{user_provider}, nous avons vendu une de vos expériences",
        "new_sold": "Nouvelle vente %{reference_code}"
      }
    },
    "paypal": {
      "description": "Outdoor Index : Paiement de la commande %{reference_code}"
    },
    "payu": {
      "description": "Outdoor Index : Paiement de la commande %{reference_code}"
    },
    "pdf": {
      "emergency_contacts": "Contact d'urgence",
      "congratulations_user_name": "Félicitations %{user_name}",
      "congratulations_agency_name": "Félicitations %{agency_name}",
      "here_we_attach": "Ci-joint toutes les informations de votre voyage. Dans ce voucher, vous pourrez voir le détail de vos expériences, le contact des fournisseurs, la décharge signée, ainsi que le justificatif de votre produit payé (Paypal ou PayU). N'hésitez pas à nous contacter pour toute question.",
      "reservation_number": "Numéro de réservation :",
      "product_detail": "Détail du produit",
      "departure": "Départ",
      "your_suppliers": "Vos fournisseurs",
      "in_this_section_appear": "Dans cette section apparaît le détail du paiement reçu par Outdoor Index. N'oubliez pas d'imprimer ce voucher et de l'emporter toujours avec vous. Merci beaucoup de préférer Outdoor Index",
      "payments_detail": "Détails des paiements",
      "initial_payment": "Paiement initial",
      "payment_method": "Moyen de paiement",
      "total_paid": "Total payé",
      "total_order": "Total commande :",
      "order_date": "Date de commande",
      "payment_date": "Date de paiement",
      "payment_type": "Type de paiement",
      "payment_complete": "Paiement complet",
      "print_this_voucher": "Imprimez ce voucher et emportez-le avec vous",
      "at_all_times": "à tout moment du voyage. Présentez-le lors de",
      "you_check": "votre check-in.",
      "we_have_received": "Nous avons reçu une nouvelle demande de réservation pour vos produits. Ci-dessous le détail de celle-ci et les informations de vos passagers. À partir de ce moment, vous pouvez contacter vos passagers directement ou, si vous préférez, instruire Outdoor Index de le faire. Il est toujours recommandé d'envoyer un e-mail informant que la réservation a été effectuée avec succès. Vous vous distinguerez comme un bon fournisseur. N'oubliez pas de mettre à jour les quotas de réservation dans vos propres systèmes pour éviter les problèmes de surréservation. Bon travail !",
      "guests": "Voyageurs",
      "your_guests": "Vos voyageurs",
      "date_of_birth": "Date de naissance :",
      "origin": "Origine :",
      "document_number": "Numéro de document :",
      "phone": "Téléphone",
      "email": "Email",
      "emergency_number": "Numéro d'urgence :",
      "allergies": "Allergies :",
      "medical_conditions": "Condition médicale :",
      "food_restrictions": "Restrictions alimentaires :",
      "dear_user_name": "Cher(ère) %{user_name}",
      "service_confirmation": "Confirmation de Service",
      "according_to_the_reservation": "Conformément à votre demande de réservation, nous confirmons les informations suivantes :",
      "reference_code": "N° réservation",
      "activity": "Activité",
      "starting_point": "Lieu",
      "starting_date": "Date service",
      "starting_time": "Heure service",
      "client": "Client",
      "payment_details": "DÉTAILS DE PAIEMENT",
      "applied": "APPLIQUÉ",
      "next_payment": "PROCHAIN PAIEMENT (70%)",
      "excursion": "ACTIVITÉ %{number}",
      "purchase_date": "Date d'achat",
      "description": "Description",
      "unit_price": "Prix unitaire",
      "unit_price_child": "Prix unitaire enfant",
      "childen_pax": "Enfants",
      "pax": "Pax",
      "tax": "Taxe",
      "about_your_host": "À PROPOS DE VOTRE HÔTE",
      "name": "Personne responsable :",
      "address": "Adresse :",
      "from": "Date de début du service",
      "to": "Date de fin du service",
      "tourists": "Informations sur les voyageurs",
      "guest": "Passagers",
      "guest_s": "Passager",
      "child_guest": "Enfants",
      "child_guests": "Enfants",
      "child_guest_s": "Enfant",
      "guest_price": "Prix Adulte",
      "child_guest_price": "Prix Enfant",
      "resident": "Résident",
      "no_resident": "Non Résident",
      "problem_with_order": "Problèmes avec votre commande ?",
      "complete_remaining_payment_web": "Pour payer le solde restant, connectez-vous à votre compte sur outdoorindex.cl et ouvrez cette commande depuis vos bons.",
      "contact_us": "Contactez-nous"
    },
    "currency": {
      "displaying_prices_in": "Changement de devise effectué !"
    },
    "tourists": {
      "first_create_group": "Oups ! N'oubliez pas de remplir les informations des passagers."
    },
    "date": {
      "abbr_day_names": [
        "Dim",
        "Lun",
        "Mar",
        "Mer",
        "Jeu",
        "Ven",
        "Sam"
      ],
      "abbr_month_names": [
        null,
        "Jan",
        "Fév",
        "Mar",
        "Avr",
        "Mai",
        "Juin",
        "Juil",
        "Août",
        "Sep",
        "Oct",
        "Nov",
        "Déc"
      ],
      "day_names": [
        "Dimanche",
        "Lundi",
        "Mardi",
        "Mercredi",
        "Jeudi",
        "Vendredi",
        "Samedi"
      ],
      "month_names": [
        null,
        "Janvier",
        "Février",
        "Mars",
        "Avril",
        "Mai",
        "Juin",
        "Juillet",
        "Août",
        "Septembre",
        "Octobre",
        "Novembre",
        "Décembre"
      ],
      "formats": {
        "default": "%d/%m/%Y",
        "short": "%e %b",
        "long": "%e %B %Y",
        "calendar_picker": "DD/MM/YYYY",
        "fixed_departure": "DD/M/YYYY",
        "moment": "%Y-%m-%d"
      }
    },
    "time": {
      "formats": {
        "default": "%d/%m/%Y %H:%M",
        "short": "%e %b %H:%M",
        "long": "%e %B %Y %H:%M",
        "full": "%A %e %B %Y / %Hh%M",
        "calendar_picker": "DD/MM/YYYY"
      }
    },
    "activities": {
      "trekking": "Randonnées",
      "horseback": "Randonnées équestres",
      "birdwatching": "Observation d'oiseaux",
      "mountaineering": "Alpinisme",
      "icehike": "Marche sur glacier",
      "kayak": "Kayak",
      "flyfishing": "Pêche à la mouche",
      "navigations": "Navigations",
      "cruises": "Croisières",
      "helicopter": "Hélicoptère",
      "multiactivity": "Multi-activités",
      "photosafari": "Safari photo",
      "bikes": "Vélos",
      "snowshoes": "Raquettes à neige",
      "ski": "Ski",
      "rafting": "Rafting"
    },
    "filters": {
      "clear_filters": "Effacer les filtres"
    },
    "lang": {
      "countries": {
        "spain": "Espagne",
        "argentina": "Argentine",
        "bolivia": "Bolivie",
        "chile": "Chili",
        "colombia": "Colombie",
        "costa_rica": "Costa Rica",
        "ecuador": "Équateur",
        "mexico": "Mexique",
        "peru": "Pérou",
        "paraguay": "Paraguay",
        "uruguay": "Uruguay",
        "united_states": "États-Unis",
        "england": "Angleterre",
        "australia": "Australie",
        "canada": "Canada",
        "new_zealand": "Nouvelle-Zélande",
        "ireland": "Irlande",
        "portugal": "Portugal",
        "brazil": "Brésil",
        "france": "France",
        "germany": "Allemagne",
        "china": "Chine",
        "hong_kong": "Hong Kong",
        "japan": "Japon",
        "korea": "Corée",
        "singapore": "Singapour",
        "taiwan": "Taïwan"
      }
    }
  },
  "de": {
    "terms": {
      "head": {
        "conditions": "Nutzungsbedingungen",
        "privacy": "Datenschutzrichtlinien",
        "cookies": "Cookie-Richtlinien.",
        "you_as_a_consumer": "Als Verbraucher haben Sie die Pflicht, sich über die Dokumentation zu informieren, die Sie benötigen könnten, um Ihre Reise wie geplant durchführen zu können. Überprüfen Sie rechtzeitig, ob Sie einen Reisepass, ein Visum, Impfungen, eine Genehmigung für Minderjährige oder andere Dokumentenanforderungen sowohl für die Einreise nach Chile als auch für die Transitländer benötigen. Wenn Sie diese benötigen und nicht darüber verfügen, erledigen Sie die notwendigen Formalitäten, um sie rechtzeitig zu erhalten."
      }
    },
    "devise": {
      "google_sign_in": "Mit Google anmelden",
      "facebook_sign_in": "Mit Facebook anmelden",
      "apple_sign_in": "Mit Apple anmelden",
      "already_have_an_account?": "Sie haben bereits ein Konto?",
      "didn't_receive_confirmation_instructions?": "Hat die Bestätigungsanweisung nicht erreicht?",
      "didn't_receive_unlock_instructions?": "Hat die Entsperranweisung nicht erreicht?",
      "forgot_your_password?": "Passwort vergessen?",
      "don't_have_an_account?": "Sie haben kein Konto?",
      "enter_email_associated": "Geben Sie die E-Mail-Adresse ein, die mit Ihrem Konto verknüpft ist und wir senden Ihnen eine E-Mail mit einem Link, um Ihr Passwort zurückzusetzen.",
      "passwordless": {
        "not_found_in_database": "Es wurde kein Benutzer für diese E-Mail-Adresse gefunden",
        "magic_link_sent": "Ein Anmeldelink wurde an Ihre E-Mail-Adresse gesendet. Bitte folgen Sie dem Link, um sich in Ihrem Konto anzumelden.",
        "magic_link_sent_paranoid": "Falls Ihr Konto existiert, erhalten Sie eine E-Mail mit einem Anmeldelink. Bitte folgen Sie dem Link, um sich in Ihrem Konto anzumelden."
      },
      "confirmations": {
        "confirmed": "Ihr Konto wurde erfolgreich bestätigt. Sie wurden angemeldet.",
        "send_instructions": "Sie erhalten in wenigen Minuten eine E-Mail mit Anweisungen, wie Sie Ihr Passwort zurücksetzen können.",
        "send_paranoid_instructions": "Wenn Ihre E-Mail-Adresse in unserer Datenbank vorhanden ist, erhalten Sie in wenigen Minuten eine E-Mail mit Anweisungen, wie Sie Ihr Passwort zurücksetzen können."
      },
      "failure": {
        "magic_link_invalid": "Ungültiger oder abgelaufener Anmeldelink.",
        "already_authenticated": "Sie sind bereits angemeldet.",
        "inactive": "Ihr Konto wurde noch nicht aktiviert.",
        "invalid": "Ungültige E-Mail-Adresse oder ungültiges Passwort.",
        "invalid_token": "Ungültiger Authentifizierungstoken.",
        "locked": "Ihr Konto ist gesperrt.",
        "not_found_in_database": "Ungültige E-Mail-Adresse oder ungültiges Passwort.",
        "timeout": "Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an, um fortzufahren.",
        "unauthenticated": "Sie müssen sich anmelden oder registrieren, um fortzufahren.",
        "unconfirmed": "Sie müssen Ihr Konto bestätigen, um fortzufahren."
      },
      "mailer": {
        "magic_link": {
          "subject": "Anmeldelink",
          "greeting": "Hallo %{email}!",
          "instructions": "Sie können sich über den folgenden Link anmelden:",
          "login_button": "Bei meinem Konto anmelden",
          "expiration_notice": "Bitte beachten Sie, dass der Link in %{expiration_time} abläuft."
        },
        "confirmation_instructions": {
          "subject": "Bestätigungsanweisungen"
        },
        "reset_password_instructions": {
          "subject": "Anweisungen zum Zurücksetzen des Passworts"
        },
        "unlock_instructions": {
          "subject": "Entsperranweisungen"
        }
      },
      "omniauth_callbacks": {
        "failure": "Authentifizierung über %{kind} fehlgeschlagen: \"%{reason}\".",
        "success": "Erfolgreich authentifiziert über %{kind}-Konto."
      },
      "passwords": {
        "no_token": "Sie können auf diese Seite nicht zugreifen, außer über einen Link zum Zurücksetzen des Passworts aus einer E-Mail. Wenn Sie über einen Link zum Zurücksetzen des Passworts gekommen sind, stellen Sie sicher, dass Sie die vollständige URL verwendet haben.",
        "send_instructions": "Sie erhalten in wenigen Minuten eine E-Mail mit Anweisungen, wie Sie Ihr Passwort zurücksetzen können.",
        "send_paranoid_instructions": "Wenn Ihre E-Mail-Adresse in unserer Datenbank vorhanden ist, erhalten Sie in wenigen Minuten einen Link zum Zurücksetzen des Passworts per E-Mail.",
        "updated": "Ihr Passwort wurde erfolgreich geändert. Sie wurden angemeldet.",
        "updated_not_active": "Ihr Passwort wurde erfolgreich geändert."
      },
      "registrations": {
        "destroyed": "Auf Wiedersehen! Ihr Konto wurde erfolgreich gelöscht. Wir hoffen, Sie bald wiederzusehen.",
        "signed_up": "Willkommen! Du wurdest identifiziert.",
        "signed_up_but_inactive": "Sie haben sich erfolgreich registriert. Sie konnten jedoch nicht angemeldet werden, da Ihr Konto noch nicht aktiviert ist.",
        "signed_up_but_locked": "Sie haben sich erfolgreich registriert. Sie konnten jedoch nicht angemeldet werden, da Ihr Konto gesperrt ist.",
        "signed_up_but_unconfirmed": "Eine Nachricht mit einem Bestätigungslink wurde an Ihre E-Mail-Adresse gesendet. Bitte folgen Sie dem Link, um Ihr Konto zu aktivieren.",
        "update_needs_confirmation": "Sie haben Ihr Konto erfolgreich aktualisiert, aber wir müssen Ihre neue E-Mail-Adresse überprüfen. Bitte überprüfen Sie Ihre E-Mail und folgen Sie dem Bestätigungslink, um die Bestätigung Ihrer neuen E-Mail-Adresse abzuschließen.",
        "updated": "Ihr Konto wurde erfolgreich aktualisiert."
      },
      "sessions": {
        "signed_in": "Erfolgreich angemeldet.",
        "signed_out": "Erfolgreich abgemeldet."
      },
      "unlocks": {
        "send_instructions": "Sie erhalten in wenigen Minuten eine E-Mail mit Anweisungen, wie Sie Ihr Konto entsperren können.",
        "send_paranoid_instructions": "Wenn Ihr Konto existiert, erhalten Sie in wenigen Minuten eine E-Mail mit Anweisungen, wie Sie es entsperren können.",
        "unlocked": "Ihr Konto wurde erfolgreich entsperrt. Bitte melden Sie sich an, um fortzufahren."
      }
    },
    "errors": {
      "something_went_wrong": "Etwas ist schiefgelaufen",
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "muss akzeptiert werden",
        "blank": "darf nicht leer sein",
        "confirmation": "stimmt nicht mit %{attribute} überein",
        "empty": "darf nicht leer sein",
        "equal_to": "muss gleich %{count} sein",
        "even": "muss gerade sein",
        "exclusion": "ist reserviert",
        "greater_than": "muss größer als %{count} sein",
        "greater_than_or_equal_to": "muss größer oder gleich %{count} sein",
        "inclusion": "ist nicht in der Liste enthalten",
        "invalid": "ist ungültig",
        "less_than": "muss kleiner als %{count} sein",
        "less_than_or_equal_to": "muss kleiner oder gleich %{count} sein",
        "model_invalid": "Validierung fehlgeschlagen: %{errors}",
        "not_a_number": "ist keine Zahl",
        "not_an_integer": "muss eine ganze Zahl sein",
        "odd": "muss ungerade sein",
        "other_than": "muss anders als %{count} sein",
        "present": "muss leer sein",
        "required": "muss vorhanden sein",
        "taken": "ist bereits vergeben",
        "must_contain_number": " muss mindestens eine Zahl und einen Buchstaben enthalten",
        "must_contain_special": "muss ein Sonderzeichen enthalten",
        "must_contain_lower": "muss mindestens 1 Kleinbuchstaben enthalten",
        "must_contain_upper": "muss mindestens 1 Großbuchstaben enthalten",
        "too_long": {
          "one": "ist zu lang (maximal 1 Zeichen)",
          "other": "ist zu lang (maximal %{count} Zeichen)"
        },
        "too_short": {
          "one": "ist zu kurz (mindestens 1 Zeichen)",
          "other": "ist zu kurz (mindestens %{count} Zeichen)"
        },
        "wrong_length": {
          "one": "hat die falsche Länge (genau 1 Zeichen)",
          "other": "hat die falsche Länge (genau %{count} Zeichen)"
        },
        "already_confirmed": "wurde bereits bestätigt, bitte versuchen Sie sich anzumelden",
        "confirmation_period_expired": "muss innerhalb von %{period} bestätigt werden, bitte neu anfordern",
        "expired": "ist abgelaufen, bitte neu anfordern",
        "not_found": "nicht gefunden",
        "not_locked": "war nicht gesperrt",
        "not_saved": {
          "one": "1 Fehler hinderte %{resource} daran, gespeichert zu werden:",
          "other": "%{count} Fehler hinderten %{resource} daran, gespeichert zu werden:"
        }
      },
      "template": {
        "body": "Folgende Felder weisen Probleme auf:",
        "header": {
          "one": "Konnte %{model} nicht speichern: 1 Fehler gefunden",
          "other": "Konnte %{model} nicht speichern: %{count} Fehler gefunden"
        }
      }
    },
    "meta_tags": {
      "default": {
        "description": "Entdecken Sie Chile mit exklusiven Abenteuerprogrammen und erfahrenen Guides. Erleben Sie ein einzigartiges Abenteuer! Buchen Sie Ihre unvergessliche Reise.",
        "keywords": "Patagonien, Chile, Abenteuertouren, Abenteuertouren Patagonien, Abenteuertouren Chile, Torres del Paine Touren, Wandertouren Patagonien, Kajaktouren Patagonien, Reittouren Patagonien, Multisporttouren Patagonien, Familientouren Patagonien, Luxus-Abenteuertouren Patagonien, günstige Abenteuertouren Patagonien, beste Abenteuertouren Patagonien, Abenteuerreisen Patagonien, Abenteueraktivitäten Patagonien, Abenteuerausflüge Patagonien, Abenteuerprogramme Patagonien",
        "name": "Outdoor Index"
      },
      "help": {
        "title": "Outdoor Index - Hilfe",
        "description": "Hast du Fragen zu deiner Reise nach Patagonien? Besuche Outdoor Index und sprich mit lokalen Guides und Experten aus der Region.",
        "keywords": null
      }
    },
    "views": {
      "pagination": {
        "truncate": "…"
      }
    },
    "activerecord": {
      "models": {
        "season": "Saison",
        "seasons": "Saisons"
      },
      "attributes": {
        "season": {
          "name": "Name",
          "valid_from": "Gültig ab",
          "valid_until": "Gültig bis",
          "start_time": "Startzeit",
          "product": "Exkursion",
          "mon_check": "Montag",
          "tue_check": "Dienstag",
          "wed_check": "Mittwoch",
          "thu_check": "Donnerstag",
          "fri_check": "Freitag",
          "sat_check": "Samstag",
          "sun_check": "Sonntag"
        },
        "order": {
          "clp_charge": "CLP-Gebühr",
          "usd_charge": "USD-Gebühr",
          "username": "Kunde:",
          "email": "E-Mail:",
          "product": "Produkt:",
          "product_name": "Produkt",
          "manual_pax": "Anz. Pax:",
          "manual_total": "Bezahlt:",
          "manual_currency": "Währung:",
          "partial_payment": "Zahlung:",
          "payment_method": "Methode:",
          "channel": "Kanal:",
          "confirmed_at": "Kauf:",
          "departure_at": "Abfahrt:",
          "starting_datetime": "Abfahrtszeit:",
          "customer_phone": "Telefon:",
          "extra": "Extra:",
          "instructions": "Anweisungen:",
          "language": "Sprache:",
          "weather_link": "Wetterlink",
          "post_link": "Link zum Beitrag",
          "itinerary_document": "Reiseplan-Dokument",
          "show_itinerary_document": "Anzeigen"
        }
      }
    },
    "promotions": {
      "coupon_code_ok": "Gutschein erfolgreich angewendet",
      "coupon_code_error": "Der Gutschein existiert nicht",
      "coupon_code_already": "Der Gutschein wurde bereits angewendet",
      "coupon_code_max": "Maximal ein Gutschein pro Bestellung",
      "coupon_code_destroy_ok": "Code erfolgreich entfernt",
      "coupon_code_destroy_error": "Der Code konnte nicht entfernt werden",
      "coupon_code_destroy_confirm": "Sind Sie sicher, dass Sie ihn entfernen möchten?",
      "coupon_have_a_coupon": "Haben Sie einen Rabattgutschein?",
      "coupon_form_palceholder": "Rabattcode",
      "coupon_apply": "Anwenden"
    },
    "home_collections": {
      "home_reviews": "350+ Personen pro Jahr reisen mit Outdoor Index",
      "find_your_experience": "Finde deine Exkursion",
      "carousel_region": "Abenteuer nach Region",
      "carousel_activities": "Abenteuer nach Aktivitäten",
      "carousel_time_preference": "Abenteuer nach Zeitpräferenz",
      "sub-landing": "Entdecken Sie die besten touristischen Optionen in Chile mit Outdoor Index. Vergleichen und erkunden Sie eine breite Palette von Programmen von Atacama bis Patagonien. Buchen Sie noch heute, um einzigartige Erlebnisse zu erleben!",
      "title": "Abenteuertouren in Chile und Patagonien",
      "subtitle": "Finden Sie Abenteuer mit den besten lokalen Guides"
    },
    "products_search": {
      "activities": "Aktivitäten",
      "regions": "Regionen",
      "time": "Zeit",
      "date_sub_label": "Wann möchten Sie gehen?",
      "activities_sub_label": "Wählen Sie Ihre Aktivität",
      "regions_sub_label": "Welche Region möchten Sie besuchen?",
      "time_sub_label": "Wählen Sie Ihre Zeitpräferenz!",
      "date": "Datum",
      "all_adventures": "Alle Abenteuer",
      "search_placeholder": "Abenteuer in ganz Chile suchen",
      "most_popular_searches": "Beliebteste Suchen",
      "see_all_adventures": "Alle Abenteuer ansehen",
      "help_me_choose": "Hilf mir bei der Auswahl",
      "help_me_choose_url": "https://api.whatsapp.com/send?phone=56981785011&text=Hallo%2C%20ich%20brauche%20Hilfe%20bei%20der%20Auswahl%20eines%20Abenteuers",
      "popular_search_items": {
        "circuito_w": {
          "label": "Circuito W",
          "icon": "search",
          "landing_slug": "circuito-w"
        },
        "circuito_o": {
          "label": "Circuito O",
          "icon": "search",
          "landing_slug": "circuito-o"
        },
        "torres_del_paine": {
          "label": "Torres del Paine",
          "icon": "map-pin",
          "zone_id": 1
        },
        "pucon": {
          "label": "Pucón",
          "icon": "map-pin",
          "zone_id": 16
        },
        "san_pedro_atacama": {
          "label": "San Pedro de Atacama",
          "icon": "map-pin",
          "zone_id": 15
        },
        "puerto_natales": {
          "label": "Puerto Natales",
          "icon": "map-pin",
          "zone_id": 2
        }
      },
      "search": "Suchen",
      "clear": "Auswahl löschen",
      "tours": "Touren",
      "subtext": "Planen Sie Ihr nächstes Abenteuer.\nErkunden, buchen und die Natur genießen.",
      "in": "in",
      "showing_count": "%{loaded} von %{total} Abenteuern angezeigt",
      "load_more": "Mehr laden"
    },
    "comments": {
      "comments": "Kommentare",
      "replies": "Antworten",
      "post_a_comment": "Veröffentlichen Sie einen Kommentar!",
      "submit": "Senden",
      "reply": "Antworten",
      "body": "Schreiben Sie Ihren Kommentar hier..."
    },
    "order": {
      "confirmed": "Bestätigt",
      "mail_thanks": "Danke für Ihren Einkauf bei Outdoor Index",
      "mail__hi": "Hallo!",
      "mail_subject": "Outdoor Index Bestellung Nr.",
      "order_t": "Bestellung",
      "see_purchase": "Überprüfen Sie Ihre Einkäufe",
      "already_paid": "Diese Bestellung wurde bereits bezahlt",
      "confirm_payment": "Bestätigen",
      "cancel_order": "Stornieren",
      "recover_order": "Wiederherstellen",
      "send_confirm": "Bestätigen (1)",
      "send_reminder": "Erinnern (2)",
      "send_last_reminder": "Erneut erinnern (3)",
      "send_review": "Bewertung (4)",
      "email_title": "Erinnerung an die Exkursion",
      "email_footer": "Anbei senden wir Ihnen eine Erinnerung an Ihre Exkursion. Bei Fragen zögern Sie bitte nicht, uns unter info@outdoorindex.cl oder +56981785011 zu kontaktieren.",
      "promo": "Besuchen Sie www.outdoorindex.cl für weitere Exkursionen und Programme.",
      "edit": "Bearbeiten",
      "departure_date": "Abfahrtsdatum",
      "reservation": "Reservierung",
      "code": "Code",
      "departure": "Abfahrt",
      "contact_info": "Kontaktinformationen",
      "customer_phone": "Kontaktnummer",
      "travelers": "Reisende",
      "itinerary": "Reiseplan",
      "view_itinerary": "Laden Sie Ihren Reiseplan herunter",
      "view_itinerary_file": "hier",
      "voucher": "Gutschein ansehen",
      "confirmation_email_title": "Ihre Reservierung für %{excursion} ist bestätigt",
      "view_weather_link": "Überprüfen Sie das Wetter",
      "instruction_exerpt": "Wir wissen, dass Ihre Exkursion näher rückt und Sie sich wahrscheinlich schon vorbereiten",
      "here_some_instructions": "Anweisungen",
      "view_post_link": "Unser Blog",
      "review_email_title": "Erzählen Sie uns, wie Ihre Exkursion war %{excursion}",
      "review_link": "Post-Reise-Umfrage ausfüllen",
      "review_trustpilot_intro": "Wenn andere Reisende von Ihrer Erfahrung erfahren sollen, können Sie auch eine öffentliche Bewertung auf Trustpilot hinterlassen.",
      "review_trustpilot_link": "Bewertung auf Trustpilot hinterlassen",
      "review_question": "Wie war Ihre Exkursion?",
      "review_explain_title": "Warum die Umfrage wichtig ist",
      "rewview_explain_body": "<p>Ihr Feedback hilft uns, jede Exkursion zu verbessern. Die Post-Reise-Umfrage ist vertraulich und hilft uns zu verstehen, wie Ihre Erfahrung war: Organisation, Guide, Aktivitäten und die Details, die den Unterschied gemacht haben.</p>\n<p>Denken Sie über Ihre Reise vor, während und nach der Exkursion nach. Eine ehrliche Antwort dauert nur wenige Minuten.</p>\n<p>Ihre Antworten helfen uns, die Qualität unseres Service zu sichern und uns für zukünftige Reisende weiter zu verbessern.</p>\n",
      "review_terrible": "Sehr schlecht",
      "review_bad": "Schlecht",
      "review_acceptable": "Akzeptabel",
      "review_good": "Gut",
      "review_great": "Ausgezeichnet",
      "new_order_excerpt": "Hier können Sie alle notwendigen Informationen zur Erstellung einer Bestellung eingeben. Schreiben Sie klare und präzise Anweisungen mit Angabe der Zeiten und Treffpunkte für jede Reservierung. Denken Sie auch daran, die Betreiber in der Reihenfolge ihrer Priorität zu kontaktieren."
    },
    "ondemand": {
      "explanation": "Exklusive Exkursion! Kontaktieren Sie unseren Spezialisten vor Ort.",
      "label": "Privat"
    },
    "request": {
      "greeting": "Hallo! Diese Informationen wurden an Ihre registrierte E-Mail-Adresse gesendet, mit Kopie an einen unserer Agenten. Wir werden uns so schnell wie möglich über die von Ihnen gesendeten Informationen mit Ihnen in Verbindung setzen.",
      "order_mail": {
        "header": {
          "hi": "Hallo! Wir haben Neuigkeiten zu Ihrer Exkursionsanfrage!",
          "title": "Ihre Anfrage wurde vom lokalen Betreiber akzeptiert. Bitte lesen Sie die nachstehenden Informationen und stellen Sie sicher, dass alles korrekt ist.",
          "your_order": "Ihre Bestellung Nr.",
          "ready": "ist zur Zahlung bereit."
        },
        "footer": "Sie können jetzt über den Zahlungsbutton zum Zahlungsbereich gehen.",
        "disclaimer": "Sie werden über eine sichere Verbindung zum Zahlungsfenster von Outdoor Index weitergeleitet.",
        "pay": "Bezahlen",
        "excursion": {
          "title": "Exkursion",
          "agency": "Lokaler Betreiber"
        },
        "manual_order": {
          "observations": "Lesen Sie die Kommentare, die Ihnen der Outdoor Index Agent hinterlassen hat!",
          "price": "Preis",
          "price_clp": "Preis CLP",
          "price_usd": "Preis USD"
        },
        "request_details": "Die Details Ihrer Anfrage"
      },
      "singular": "Anfrage",
      "requester": "Antragsteller",
      "product_required": "Um eine Bestellung anzufordern, müssen Sie sich zuerst anmelden",
      "excursion": "Exkursion",
      "applicants": "Teilnehmer",
      "from": "Von",
      "to": "Bis",
      "comments": "Kommentare",
      "comments_placeholder": "Hinterlassen Sie Ihre Fragen, Zweifel oder was auch immer Sie uns mitteilen möchten. Wir werden uns so schnell wie möglich bei Ihnen melden!",
      "submit": "Anfrage senden",
      "email_title": "Anfrage für private Exkursion",
      "email_footer": "Dieses Formular wurde an unsere Führungskräfte gesendet. Sie werden über die im Kontaktformular eingegebenen Daten kontaktiert. Sollte es einen Fehler oder eine Anmerkung im Formular geben, senden Sie uns bitte eine E-Mail an info@outdoorindex.cl und wir werden Ihnen so schnell wie möglich antworten.",
      "contact_name": "Kontaktname",
      "contact_email": "Kontakt-E-Mail",
      "contact_phone": "Kontakttelefon",
      "must_log_in": "Sie müssen sich anmelden, bevor Sie bezahlen können",
      "phone": "Kontakttelefon",
      "name": "Name",
      "last_name": "Nachname"
    },
    "applicants": {
      "applicants_number": "2) Wie viele Personen werden an der Exkursion teilnehmen?",
      "dates_sub": "3) An welchen Daten möchten Sie die Exkursion durchführen?",
      "additional_info": "4) Zusätzliche Informationen",
      "applicants_phone": "1) Hinterlassen Sie Ihre Daten, damit wir Sie kontaktieren können",
      "phone_placeholder": "Telefon",
      "email": "E-Mail",
      "name": "Name",
      "lastname": "Nachname"
    },
    "active_admin": {
      "observed_dollar_update": "Aktualisieren",
      "agency": "Betreiber",
      "agencies": "Agenturen",
      "settings": "Einstellungen",
      "users": "Benutzer",
      "admin_users": "Administratoren",
      "orders": "Bestellungen",
      "pages": "Seiten",
      "sales": "Verkäufe",
      "sale_goals": "Verkaufsziele",
      "reviews": "Bewertungen",
      "blog": "Blog",
      "suppliers": "Lieferanten",
      "covers": "Sammlungen",
      "excursions": "Exkursionen",
      "categories": "Kategorien",
      "comments_tab": "Kommentare",
      "excursion_images": "Exkursionsbilder",
      "home": "Startseite",
      "home_collections": "Sammlungen",
      "save_home_collections": "Sammlung speichern",
      "images": "Beitragsbilder",
      "mailer": "E-Mail-Ersteller",
      "newsletter_covers": "Newsletter-Cover",
      "notifications": "Benachrichtigungen",
      "payment_methods": "Zahlungsmethoden",
      "private": "Privat",
      "products": "Produkte",
      "profiles": "Profile",
      "properties": "Eigenschaften",
      "promotions": "Promotionen",
      "question_subjects": "Hilfe-Fragen",
      "questions": "Fragen",
      "tourists": "Touristen",
      "requests": "Anfragen",
      "tags": "Tags",
      "visits": "Besuche",
      "zones": "Zonen",
      "seasons": "Saisons",
      "macro_zones": "Makrozonen",
      "landings": "Landings",
      "post": {
        "title": "Titel",
        "subtitle": "Untertitel",
        "label": "Etikett",
        "author_name": "Autor",
        "author_sm": "Autor Soziales Netzwerk",
        "content": "Inhalt",
        "cover": "Cover",
        "published": "Veröffentlicht",
        "unpublished": "Unveröffentlicht",
        "tags": "Tags",
        "recommended_posts": "Empfohlene Beiträge",
        "products": "Touren & Exkursionen",
        "explore_chile": "Erkunden Sie Chile und seine Ecken mit Outdoor Index"
      },
      "zone": {
        "name": "Name",
        "description": "Beschreibung",
        "sort_order": "Reihenfolge",
        "country": "Land",
        "state": "Region"
      },
      "review": {
        "tilte1": "Bewertung erstellen",
        "title2": "Cover",
        "author": "Name",
        "country": "Land",
        "review_date": "Datum der Bewertung",
        "language": "Sprache",
        "save_review": "Bewertung speichern",
        "body": "Bewertungstext",
        "cover": "Cover",
        "rating": "Bewertung",
        "url": "Url",
        "excerpt": "Hier können Sie alle notwendigen Informationen zur Erstellung einer Bewertung eingeben. Stellen Sie immer sicher, dass das hochgeladene Coverfoto eine gute Auflösung hat und korrekt ist. Denken Sie daran, die Informationen zu lesen und zu überprüfen."
      },
      "landing": {
        "tilte1": "Landing erstellen",
        "title2": "Meta",
        "title3": "Cover",
        "title4": "Bewertungen",
        "title5": "FAQ",
        "save_landing": "Landing speichern",
        "title": "Titel",
        "place": "Ort",
        "body": "Inhalt",
        "cover": "Cover",
        "review": "Bewertung",
        "meta_title": "Meta-Titel",
        "meta_description": "Meta-Beschreibung",
        "product": "Exkursion",
        "excerpt": "Hier können Sie alle notwendigen Informationen zur Erstellung einer Landing Page eingeben. Stellen Sie immer sicher, dass das hochgeladene Coverfoto eine gute Auflösung hat und für den Touristen attraktiv ist. Denken Sie daran, klare und zuverlässige Informationen bereitzustellen.",
        "more_info": "Mehr Infos"
      },
      "season": {
        "name": "Name",
        "valid_from": "Von",
        "valid_until": "Bis",
        "start_time": "Startzeit",
        "product": "Exkursion",
        "child_usd_price": "Kinder in Dollar",
        "child_clp_price": "Kinder in CLP",
        "single_supplement_usd_price": "Dollar",
        "single_supplement_clp_price": "CLP",
        "guardar_temporada": "Speichern",
        "daily_quota": "Verfügbarkeit",
        "title_days": "Tage",
        "title_ages": "Alter",
        "title_prices_kids": "Preise Kinder",
        "title_prices_adults": "Preise Erwachsene",
        "title_single_supplement": "Einzelzimmerzuschlag"
      },
      "kpis": {
        "observed_dollar": "Beobachteter Dollarwert",
        "observed_dollar_subtitle": "Von der Zentralbank festgelegter Dollarwert",
        "visits_today_title": "Besuche heute",
        "visits_today_subtitle": "Flüsse für heute",
        "visitors": "Besucher",
        "last_day": "Vortag",
        "show_more": "Mehr anzeigen",
        "countries": "Länder",
        "countries_subtitle": "Die uns am häufigsten besuchen",
        "country_anon": "Anonym",
        "abandoned_cart_title": "Verlassener Reise-Rucksack",
        "abandoned_cart_subtitle": "Bestellungen in Ihrem Reise-Rucksack",
        "products_viewed_title": "Meistgesehene Produkte",
        "products_viewed_subtitle": "Die im Moment beliebtesten",
        "posts_viewed_title": "Meistgesehene Beiträge",
        "posts_viewed_subtitle": "Die im Moment beliebtesten",
        "products_selled_title": "Meistverkaufte Produkte",
        "products_selled_subtitle": "Im letzten Jahr",
        "today_excursions_title": "Heutige Exkursionen",
        "today_excursions_subtitle": "Touristen, die heute ihre Tour beginnen.",
        "users_month_title": "Monatliche Statistik",
        "users_month_subtitle": "Statistische Bilanz der monatlichen Benutzer.",
        "users_number": "Anzahl der Benutzer",
        "new_users_title": "Neue Benutzer",
        "new_users_subtitle": "Im letzten Monat registriert",
        "users_total_title": "Gesamt Benutzer",
        "users_total_subtitle": "Seit Beginn registriert",
        "new_users_title_box": "Heutige Benutzer",
        "new_users_subtitle_box": "Flüsse für heute",
        "users": "Benutzer",
        "new_orders_title": "Neue Bestellungen",
        "new_orders_subtitle": "Diesen Monat registriert",
        "paid_orders_title": "Bezahlte Bestellungen",
        "paid_orders_subtitle": "Diesen Monat registriert",
        "sale_goals_title": "Verkaufsziel",
        "sale_goals_subtitle": "Gesamtleistung dieses Monats",
        "goals": "Ziel",
        "to": "bis",
        "no_sale_goal": "Es wurde kein Verkaufsziel definiert",
        "conversion_chart_title": "Konversionsdiagramm",
        "conversion_chart_subtitle": "Konversionsrate im letzten Jahr",
        "conversion_last_year": "Konversionsrate im letzten Jahr",
        "conversion_title": "Konversionsrate",
        "conversion_subtitle": "Bis heute aktualisiert"
      }
    },
    "mercado_pago": {
      "error_alert": "Ein Fehler ist bei Mercado Pago aufgetreten. Bitte überprüfen Sie, ob Ihre Bestellung bezahlt ist.",
      "error_title": "Transaktion abgelehnt",
      "error_dec": "Bei der Zahlungsabwicklung ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut. Wenn das Problem weiterhin besteht, kontaktieren Sie uns.",
      "pending_title": "Transaktion pendend",
      "pending_dec": "Ihre Zahlung ist noch nicht verifiziert. Bitte kontaktieren Sie uns, wenn Sie Ihre Bestellung bestätigen möchten."
    },
    "webpay": {
      "error_alert": "Ein Fehler ist bei Webpay aufgetreten. Bitte überprüfen Sie, ob Ihre Bestellung bezahlt ist.",
      "error_title": "Transaktion abgelehnt",
      "error_dec": "Bei der Zahlungsabwicklung ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut. Wenn das Problem weiterhin besteht, kontaktieren Sie uns."
    },
    "back": "Zurück",
    "chat_title": "Wie können wir Ihnen helfen?",
    "chat_subtitle": "Normalerweise antworten wir innerhalb weniger Stunden",
    "chat_name": "Name",
    "chat_email": "E-Mail",
    "chat_phone": "Telefon",
    "chat_subject": "Betreff",
    "chat_body": "Nachricht",
    "chat_btn": "Senden",
    "menu_welcome": "Willkommen, %{user_name}",
    "meesage_sended": "Nachricht gesendet",
    "meesage_captcha": "Sie müssen das Captcha überprüfen",
    "view_more": "Mehr anzeigen...",
    "view_more_excursions": "Mehr Exkursionen anzeigen...",
    "view_more_suggestions": "Mehr Vorschläge anzeigen...",
    "location": "Ort",
    "zone": "Zone",
    "category": "Kategorie",
    "select_one": "Eins auswählen",
    "select_multiple": "Mehrere auswählen",
    "select_two": "2 max",
    "price": "Preis",
    "vacancies": "Plätze",
    "key": "Bsp: Höhe",
    "value": "1300 m",
    "value_included": "Bsp: Zweisprachiger Guide",
    "profiles": "Profile",
    "optional": "Optional",
    "email": "E-Mail",
    "phone": "Telefon",
    "address": "Adresse",
    "pending": "Ausstehend",
    "edit": "Bearbeiten",
    "soon": "Demnächst",
    "password": "Passwort (min. 8 Zeichen, Buchstabe, Zahl)",
    "password_confirmation": "Passwortbestätigung",
    "remember_me": "Angemeldet bleiben",
    "log_in": "Anmelden",
    "sign_up": "Registrieren",
    "create_an_account": "Konto erstellen",
    "name": "Name",
    "last_name": "Nachname",
    "back_to": "Zurück zu",
    "reset_password": "Passwort zurücksetzen",
    "send": "Senden",
    "guests": "Erwachsene",
    "guest": "Erwachsener",
    "child_guest": "Kind",
    "child_guests": "Kinder",
    "products": "Produkte",
    "products_show_photos": "(%{n}) Fotos anzeigen",
    "delete": "Löschen",
    "continue": "Weiter",
    "total_only": "Gesamt",
    "total": "Gesamtbetrag:",
    "total_paid": "Gesamt bezahlt",
    "charges": "Gebühren:",
    "subtotal": "Zwischensumme:",
    "total_final": "Endsumme",
    "coupon": "Gutschein",
    "image_not_found": "Bild nicht gefunden",
    "usd": "USD",
    "clp": "CLP",
    "departure": "Abfahrt",
    "when": "Wann?",
    "what": "Was?",
    "where": "Wo?",
    "search": "Suchen",
    "language": "Sprache",
    "puerto_natales": "Puerto Natales",
    "punta_arenas": "Punta Arenas",
    "tierra_del_fuego": "Feuerland",
    "puerto_williams": "Puerto Williams",
    "in": "in",
    "or": "oder",
    "help": "Häufig gestellte Fragen",
    "go_to_home_page": "Zur Startseite zurückkehren",
    "add_row": "+ Hinzufügen",
    "from": "Ab ",
    "days": "Tage",
    "hours": "Stunden",
    "home": {
      "site_title": "Outdoor Index: Buche Abenteuertouren in Patagonien und Chile",
      "things_to_do_in": "Vorschläge in",
      "scientific_excursions": "In tiefem Kontakt mit der Natur",
      "luxury_experience": "Erlebe Exklusivität, nur für dich",
      "adventure_excursions": "Gib mehr von dir",
      "the_best_excursions": "Die besten Exkursionen für diese Saison",
      "explore_your_interests": "Erkunde deine Interessen",
      "excursions": "Exkursionen",
      "products": "Produkte",
      "suggestions": "Vorschläge",
      "hard_adventurous": "Aktiv",
      "soft_adventurous": "Transformierend",
      "scientific": "Entdeckung",
      "family": "Gruppen",
      "luxury": "Anspruchsvoll",
      "promotions": "Werbeaktionen",
      "download": "Herunterladen",
      "adventures_by_region": "Abenteuer nach Region",
      "north_patagonia": "Nord-Patagonien",
      "south_patagonia": "Süd-Patagonien",
      "masonry_zone_count": "%{count} Abenteuer"
    },
    "masonry_zones": {
      "names": {
        "1": "Torres del Paine",
        "2": "Puerto Natales",
        "3": "Punta Arenas",
        "4": "Feuerland",
        "5": "Puerto Williams",
        "6": "Antarktis"
      }
    },
    "survey_page": {
      "title": "Outdoor Index - Umfrage nach dem Verkauf",
      "description": "Wir würden gerne Ihre Meinung über den erhaltenen Service erfahren. Ihr Feedback ist uns sehr wichtig.",
      "main_heading": "Umfrage nach der Reise mit Outdoor Index"
    },
    "header": {
      "agency_panel": "Agentur-Panel",
      "supplier_panel": "Anbieter-Panel",
      "ask_us_a_question": "Kontaktieren Sie uns",
      "help": "Hilfe",
      "itinerary": "Reiseplan",
      "sign_out": "Abmelden",
      "sign_up": "Registrieren",
      "log_in": "Anmelden",
      "join_our_newsletter": "Newsletter abonnieren",
      "partner": "Partner",
      "blog": "Ausgewählte Geschichten:",
      "your_blog": "Ihr Blog 🔥",
      "config": "Einstellungen",
      "orders": "Gutscheine",
      "cart": "Warenkorb"
    },
    "header_cat": {
      "excursions": "Exkursionen",
      "recommendations": "Empfehlungen",
      "accommodation": "Unterkünfte",
      "other": "Andere"
    },
    "agencies": {
      "address": "Adresse",
      "review": "Überprüfung",
      "agency_type": "Agenturtyp",
      "owner": "Eigentümer",
      "holder_name": "Name des Inhabers",
      "holder_id": "ID des Inhabers",
      "holder_email": "E-Mail des Inhabers",
      "phone": "Phone",
      "bank_name": "Name der Bank",
      "account_type": "Kontotyp",
      "account_number": "Kontonummer",
      "agency": "Agentur",
      "country": "Land",
      "state": "Region",
      "zone": "Zone",
      "duration": "Dauer",
      "created_at": "Erstellungsdatum",
      "agency_info": "Information",
      "supplier_info": "Information",
      "products": "Produkte",
      "numbers": "Zahlen",
      "excursions": "Exkursionen",
      "list_title": "Liste aller Ihrer Termine",
      "no_dates": "Es gibt noch keine Termine. Bitte klicken Sie auf den Kalender, um einen zu erstellen.",
      "change_availability": "Verwalten Sie Ihre Termine",
      "date_range": "Nach Datumsbereich ändern",
      "set_price": "Preis festlegen",
      "rooms_to_add": "Zimmer hinzufügen",
      "rooms_to_remove": "Zimmer entfernen",
      "products_to_add": "Produkte hinzufügen",
      "products_to_remove": "Produkte entfernen",
      "apply_changes": "Änderungen anwenden",
      "edit_excerpt": "Alle zur Erstellung des Anbieterprofils angeforderten Informationen sind von entscheidender Bedeutung für die Herstellung der Geschäftsbeziehung mit Outdoor Index. Bitte geben Sie die Informationen so genau wie möglich ein.",
      "agency_information": "Agenturinformationen",
      "supplier_information": "Anbieterinformationen",
      "max_words": "150 Wörter",
      "for_booking": "zur Buchung",
      "supplier_review": "Anbieterbewertung ",
      "website_url": "Webadresse",
      "person_in_charge": "Verantwortliche Person",
      "name": "Name",
      "update_info": "Profil speichern",
      "commercial_information": {
        "self": "Kommerzielle Informationen",
        "name": "Name",
        "bank_name": "Bankname",
        "bank_account": "Konto",
        "account_type": "Kontotyp",
        "commercial_name": "Handelsname",
        "id_rut": "ID / Steuernummer"
      },
      "actions": "Aktionen",
      "manage_dates": "Termine",
      "active": "Genehmigt",
      "pending_changes": "Ausstehend",
      "index_excerpt": "Hier finden Sie eine Liste aller Ihrer Produkte. Sie können deren Termine erstellen, bearbeiten und verwalten. Jedes erstellte Produkt bleibt im Status \"Ausstehend\", bis es vom Outdoor Index Team überprüft wird.",
      "manage_dates_excerpt": "Hier finden Sie einen Kalender zum Hinzufügen all Ihrer Produkte. Sie können deren Termine erstellen, bearbeiten und verwalten. Jedes erstellte Produkt bleibt im Status \"Ausstehend\", bis es vom Outdoor Index Team überprüft wird.",
      "create_excursion": "Exkursion erstellen",
      "create_product": "Produkt erstellen",
      "create_activity": "Aktivität erstellen",
      "create_post": "Beitrag erstellen",
      "new_excursion_excerpt": "Hier können Sie alle notwendigen Informationen zur Erstellung eines Produkts eingeben. Stellen Sie immer sicher, dass die hochgeladenen Fotos eine gute Auflösung haben und für den Touristen attraktiv sind. Denken Sie daran, klare und zuverlässige Informationen zu geben.",
      "english": "Auf Englisch übersetzen →",
      "spanish": "Auf Spanisch übersetzen →",
      "create_agency": "Neue Agentur erstellen",
      "agency_bank": "Überweisungsdaten"
    },
    "error": {
      "sorry": "Entschuldigung, diese Seite existiert nicht.",
      "opps": "Möglicherweise haben Sie die Adresse falsch eingegeben oder die Seite wurde verschoben.",
      "go": "Zur Startseite gehen",
      "went_wrong": "Entschuldigung, aber etwas ist schiefgelaufen.",
      "improvements": "Wenn Sie diese Nachricht sehen, liegt das möglicherweise daran, dass Sie die Webadresse falsch eingegeben haben oder dass wir die Website mit neuen Funktionen und Verbesserungen aktualisieren. Warten Sie ein paar Minuten und laden Sie die Seite erneut. Danke!"
    },
    "excursions": {
      "title": "Titel",
      "location": "Ort",
      "zone": "Zone",
      "category": "Kategorie",
      "profiles": "Reisetyp",
      "price": "Preis (in Dollar)",
      "vacancies": "Plätze",
      "duration": "Dauer",
      "half_day": "Halbtags",
      "full_day": "Ganztags",
      "multiple_days": "Mehrtägig",
      "duration_days": "Tage",
      "duration_hours": "Stunden",
      "itinerary": {
        "body": "Körper"
      },
      "faq": {
        "body": "Körper"
      },
      "days": {
        "zero": "Tag",
        "one": "Tag",
        "other": "Tage"
      },
      "hours": {
        "zero": "Stunde",
        "one": "Stunde",
        "other": "Stunden"
      },
      "add_images_(minimum_3)": "Fotos (mindestens 3)",
      "disclaimer": "Haftungsausschluss",
      "description": "Überblick",
      "body": "Unser Reiseplan",
      "useful_information": "Nützliche Infos",
      "what's_included?": "Inklusive",
      "what's_not_included?": "Nicht inklusive",
      "meeting_instruction": "Abfahrtsort",
      "meeting_address": "Adresse",
      "policies": "Stornierungsbedingungen",
      "save_excursion": "Exkursion speichern",
      "what_we'll_do": "Überblick",
      "our_itinerary": "Reiseplan",
      "faqs": "FAQs",
      "images": "Bilder",
      "edit_excerpt": "Alle zur Erstellung des Anbieterprofils angeforderten Informationen sind von entscheidender Bedeutung für die Herstellung der Geschäftsbeziehung mit Outdoor Index. Bitte geben Sie die Informationen so genau wie möglich ein.",
      "other_excursions_from_this_tour_company": "Andere Erlebnisse dieses Anbieters",
      "create_excursions": "Exkursion erstellen",
      "more": "Mehr",
      "less": "Weniger",
      "best_excursions_for_the_next_season": "Empfohlen für diese Saison",
      "add_extras": "Extras hinzufügen",
      "price_per_reservations": "Preis pro Reservierung",
      "extra_description": "Aktivität",
      "macro_zone": "Makrozone",
      "meta_title": "Meta-Titel",
      "meta_description": "Meta-Beschreibung",
      "time": "Zeit",
      "prices": "Preise",
      "included": "Was ist inklusive?",
      "locations": "Ort",
      "alternative_names": "Exkursion auch unter folgenden Namen bekannt",
      "breadcrumb_catalog": "Touren & Exkursionen"
    },
    "hotels": {
      "twin": "Einzelzimmer",
      "double": "Doppelzimmer",
      "double_twins": "Zwei Einzelbetten",
      "room_reserved": "Zimmer reserviert",
      "edit_your_booking": "Bearbeiten Sie Ihre Buchung"
    },
    "reservations": {
      "add_guest_details": "Touristeninfo hinzufügen",
      "traveler_data_card_title": "Reisendendaten",
      "traveler_data_badge_missing": "Infos fehlen",
      "traveler_data_badge_complete": "Vollständig",
      "traveler_data_badge_ready_details": "Infos vollständig",
      "traveler_data_intro": "Wir benötigen diese Angaben, um Ihre Reservierung zu bestätigen.",
      "traveler_data_complete_button": "Reisendeninfo",
      "detach_guest_confirm": "Diesen Reisenden von dieser Buchung entfernen?",
      "guest_slots_full": "Für diese Reservierung sind bereits alle Reisenden zugewiesen.",
      "organize_your_itinerary": "1) Reiseplan >",
      "create_your_travel_group": "2) Reisegruppe >",
      "assign_tourists": "3) Touristen zuweisen",
      "new_checkout_excerpt": "Hier ist die Liste der Produkte in Ihrem Reise-Rucksack. Vergessen Sie nicht, die Passagiere zu den Exkursionen hinzuzufügen, an denen sie teilnehmen werden. Überprüfen Sie vor dem Kauf sorgfältig die Anzahl der Reservierungen und deren Kosten. Denken Sie daran, unsere Stornierungsbedingungen zu lesen.",
      "cart_title": "Informationen zu Ihrer Reise",
      "checkout_page_title": "Bestätigen Sie Ihre Reservierung und schließen Sie die Zahlung ab",
      "checkout_page_intro": "Überprüfen Sie die Angaben zu Ihrer Exkursion, ergänzen Sie die Reisendeninformationen und wählen Sie Ihre Zahlungsmethode.",
      "checkout_trip_summary_heading": "Zusammenfassung Ihrer Reise",
      "pay_with": "Bezahlen mit",
      "cart_subtitle": "Liste der Produkte in Ihrem Reise-Rucksack",
      "itinerary_excerpt": "Hier finden Sie eine Liste aller Ihrer Produkte. Stellen Sie sicher, dass alle Informationen korrekt sind, um mit den nächsten Schritten fortzufahren. Wichtig: Alle Zeiten und Daten werden in chilenischer Zeit angezeigt.",
      "assign_excerpt": "In diesem Abschnitt müssen Sie angeben, welcher Reisende an welcher Exkursion teilnimmt. Auf diese Weise haben wir alle notwendigen Informationen, um Ihnen das bestmögliche Erlebnis zu bieten.",
      "list_of_products": "Produktliste",
      "reservations_made": "#",
      "assing_tourists": "Touristen zuweisen",
      "go_to_checkout": "Weiter",
      "a_list_of_all_your_reservations": "Alle Ihre Reservierungen",
      "my_group": "Meine Gruppe",
      "people_(including_you)": "Teilnehmer (einschließlich Ihnen)",
      "(me)": "(Ich)",
      "team_member": "Gruppenmitglieder",
      "actions": "Aktionen",
      "you_have_no_reservations": "Sie haben keine Reservierungen",
      "tourists_group": "In diesem Abschnitt müssen Sie die Informationen aller Personen hinzufügen, die Sie begleiten werden. Es ist sehr wichtig, dass die beigefügten Informationen so zuverlässig wie möglich sind.",
      "edit_your_reservation": "Bearbeiten Sie Ihre Reservierung",
      "cancel_date": "Reservierung stornieren",
      "departure_date": "Abreisetag",
      "reserves": "Reservierungen",
      "update": "Aktualisieren",
      "not_enough": "hat nicht genug",
      "too_many": "hat zu viele",
      "product_for": "Das Produkt",
      "tourists_assigned": "zugewiesene Touristen",
      "many_few_tourists": "Die zugewiesenen Touristen stimmen nicht mit der Anzahl der Reservierungen überein",
      "select_your_extras": "Wählen Sie Ihre Extras:",
      "product_variants": "Optionen",
      "select_date_first": "Wählen Sie zuerst eine Datum",
      "total_price": "Gesamtpreis",
      "see_details": "Details anzeigen",
      "price_chilean": "Gesamtwert für Einwohner Chiles:",
      "price_no_chilean": "Gesamtwert für Nicht-Einwohner Chiles:",
      "single_supplement": "Einzelzimmerzuschlag:",
      "people": "Passagiere:",
      "details_of_purchase": "Details Ihres Kaufs",
      "confirmed_excerpt": "Danke, dass Sie mit uns reisen!",
      "confirmed_excerpt_litle": "Konsultieren Sie den Gutschein, um die Details Ihres Kaufs zu sehen.",
      "cart_empty": "Ihr Reise-Rucksack ist leer"
    },
    "checkout": {
      "do_checkout": "Bestellung aufgeben",
      "confirm_checkout_excerpt": "Bevor Sie fortfahren, überprüfen Sie, ob alles korrekt ist. Sobald Sie diese Bestellung akzeptieren, können Sie sie nicht mehr ändern.",
      "confirm_checkout_excerpt_2": "(Sie können immer noch eine neue Bestellung erstellen.)",
      "please_confirm_your_details": "Bitte bestätigen Sie Ihre Informationen",
      "i_need_to_change_something": "Ich muss etwas ändern",
      "everything_looks_fine": "Alles sieht gut aus",
      "after_this_step": "Nach diesem Schritt wird Outdoor Index alle Anbieter kontaktieren.",
      "providers_confirm_availability": "Wenn alle Anbieter Ihre Verfügbarkeit bestätigen, werden Sie kontaktiert.",
      "payment_excerpt": "Stellen Sie vor dem Kauf sicher, dass alle Details Ihrer Produkte korrekt sind. Überprüfen Sie die Anzahl der Reservierungen und deren Werte. Denken Sie daran, unsere Stornierungsbedingungen zu lesen.",
      "your_details_confirmation_and_payment": "Details Ihrer Produkte und Zahlung",
      "important!": "Wichtig",
      "all_transactions_have_an_extra": "Sie können mit Ihrer Debit- oder Kreditkarte in den mit Ihrer Bank vereinbarten Raten bezahlen. Outdoor Index erhält den vollen Verkaufsbetrag.",
      "get_a_refund_if": "Erhalten Sie Ihr Geld zurück, wenn Sie innerhalb von 24 Stunden nach dem Kauf stornieren.",
      "pay_now": "Zahlung bestätigen",
      "confirm_and_pay": "Bestätigen und bezahlen",
      "wetravel_link_not_ready": "Bitte warten Sie kurz und versuchen Sie es erneut, oder wählen Sie WeTravel erneut.",
      "mercado_wallet_not_ready": "Der Mercado-Pago-Button wird noch geladen. Bitte kurz warten und erneut versuchen.",
      "payment_summary": "Zahlungsübersicht",
      "payment_method_title": "Zahlungsmethode",
      "payment_methods_locked_until_traveler_details": "Bitte vervollständigen Sie zuerst die Reisendenangaben, bevor Sie eine Zahlungsmethode wählen.",
      "payment_method_recommended": "Empfohlen",
      "payment_method_blurb": {
        "wetravel": "Internationale Zahlung in USD",
        "mercado_pago": "Lokale Kartenzahlung und Raten je nach Bank",
        "webpay": "Zahlung per Bankkarte über Webpay",
        "payu": "Zahlung mit PayU",
        "paypal": "Zahlung mit PayPal",
        "google_pay": "Zahlung mit Google Pay",
        "apple_pay": "Zahlung mit Apple Pay"
      },
      "total_to_pay": "Zu zahlender Betrag",
      "secure_payment_note": "100 % sichere und verschlüsselte Zahlung",
      "help_widget_title": "Brauchen Sie Unterstützung?",
      "help_widget_body": "Sprechen Sie mit einem Outdoor-Index-Guide, um eine persönliche Unterstützung zu erhalten.",
      "help_widget_cta": "Mit einem Spezialisten sprechen",
      "help_widget_online": "Online",
      "terms_toggle_line_html": "Ich akzeptiere die %{terms} und die %{policy}.",
      "terms_toggle_word_terms": "Bedingungen",
      "terms_toggle_word_policy": "Richtlinie",
      "review": "Bewertung",
      "ready": "Fertig",
      "choose_payment": "Wählen Sie die gewünschte Zahlung",
      "only_for_reservation": "Reservierung",
      "complete_payment": "Vollständige Zahlung",
      "30_p": "30%",
      "30_per": "30% bezahlt",
      "30_pers": "30% bezahlt",
      "100_p": "100%",
      "100_per": "100% bezahlt",
      "100_pers": "100% bezahlt",
      "i_hereby_accept": "Durch Klicken auf \"Zahlung bestätigen\" akzeptieren Sie unsere",
      "and_confirm": "und bestätigen, dass Sie unsere",
      "and_our": "und unsere",
      "your_itinerary": "Ihr Reiseplan im Detail",
      "continue_shopping": "Weiter einkaufen",
      "not_available": "Nicht verfügbar",
      "some_products_deleted": "Einige Produkte sind nicht mehr verfügbar",
      "disclaimer": "Über Ihre Reservierung",
      "accept": "Ich akzeptiere",
      "cancel": "Abbrechen",
      "must_have_tourist": "Muss mindestens 1 Tourist mit hinzugefügter E-Mail und Telefonnummer haben.",
      "wetravel_partial_error": "Teilzahlung ist nicht verfügbar, da das Ausflugdatum zu nahe liegt. Bitte wählen Sie die vollständige Zahlung."
    },
    "vouchers": {
      "active_excerpt": "Hier wird ein Detail Ihrer Gutscheine angezeigt. Sie können sie ansehen und ausdrucken. Denken Sie daran, sich am Tag der Reservierung mit Ihrem ausgedruckten Gutschein unter Angabe der Registrierungsnummer zu präsentieren.",
      "all_of_your_vouchers": "Alle Ihre Belege",
      "confirmed_excerpt": "Vielen Dank für Ihren Kauf. Wir hoffen, Sie haben eine wunderschöne Reise. Vergessen Sie nicht, Ihren Beleg auszudrucken und immer bei sich zu tragen. Bei Fragen oder unerwarteten Situationen zögern Sie nicht, uns zu kontaktieren.",
      "active_vouchers": "Aktive Gutscheine",
      "disclaimer": "In diesem PDF finden Sie alle Informationen zu Ihren Produkten. Bitte überprüfen Sie das Dokument und kontaktieren Sie uns bei Fragen. Genießen Sie Ihre Reise.",
      "get_your_voucher": "Holen Sie sich Ihren Gutschein",
      "voucher": "Beleg",
      "payment_error": "Zahlungsfehler",
      "error": "Bei der Zahlungsabwicklung ist etwas schiefgelaufen. Bitte versuchen Sie es später erneut oder kontaktieren Sie uns, um andere Zahlungsoptionen zu prüfen.",
      "restart_payment": "Zahlung erneut durchführen",
      "payment_rejected": "Zahlung abgelehnt",
      "rejected": "PayU / Paypal hat angegeben, dass Ihre Zahlung abgelehnt wurde. Überprüfen Sie Ihre Daten und versuchen Sie es erneut oder kontaktieren Sie uns für andere Zahlungsoptionen.",
      "home": "Startseite",
      "order_number": "Bestellnr.:",
      "view": "Ansehen",
      "print": "Drucken",
      "complete": "Vollständig",
      "incomplete": "Unvollständig",
      "activities": "Aktivitäten",
      "was_partial_payment": "(2)"
    },
    "categories": {
      "search": "Suche",
      "general": "allgemein",
      "general_category_search": "Allgemeine Suche nach %{category_name}",
      "other_excursions_to_do": "Andere Erlebnisse zu tun in %{zone_name}",
      "general_zone_search": "Suche nach Vorschlägen in %{zone_name}",
      "recommended_for_you": "Erlebnisse zu tun in %{zone_name}"
    },
    "tourist": {
      "new_tourist_excerpt": "In diesem Abschnitt können Sie die Informationen aller Personen hinzufügen, die Sie begleiten werden. Es ist sehr wichtig, dass die beigefügten Informationen so zuverlässig wie möglich sind.",
      "personal_info": "Persönliche Informationen",
      "checkout_minimum_one_pax_notice": "Um fortzufahren, benötigen wir nur die vollständigen Angaben für eine Person. Die übrigen können Sie bei Bedarf später ergänzen.",
      "add_another_pax": "Weitere Person hinzufügen",
      "info_pax_card_title": "Reisende/r",
      "name": "Vorname",
      "last_name": "Nachname",
      "date_of_birth": "Geburtsdatum",
      "nationality": "Nationalität",
      "passport": "Passnummer",
      "hometown": "Wohnort",
      "phone": "Telefon",
      "email": "E-Mail",
      "emergency_contact": "Notfallkontakt",
      "allergies": "Allergien",
      "medical_conditions": "Medizinischer Zustand",
      "food_restrictions": "Ernährungseinschränkungen",
      "pending": "Ausstehend",
      "ready": "Fertig",
      "you_have_no_vouchers": "Sie haben keine aktiven Gutscheine",
      "no_reservations_to_assign": "Keine Reservierungen zum Zuweisen vorhanden"
    },
    "footer": {
      "about_us": "Über uns",
      "statement": "Lesen Sie über unsere Säulen",
      "go_to_suscribe": "Abonnieren",
      "suscribe_text": "Wir senden zweiwöchentliche Updates über neue Geschichten und Reiserabatte",
      "terms_&_conditions": "Bedingungen",
      "privacy_&_cookies": "Datenschutz",
      "contact_us": "Kontaktieren Sie uns",
      "edit_endorsement": "Outdoor Index hat seinen Sitz in Puerto Natales (Süd-Chilenisches Patagonien) und wird von mehr als 40 Anbietern unterstützt.",
      "all_rights_reserved": "Alle Rechte vorbehalten. Kein Teil dieser Website darf ohne entsprechende Genehmigung reproduziert werden.",
      "spanish": "Spanisch",
      "english": "Englisch",
      "portuguese": "Portugiesisch",
      "french": "Französisch",
      "german": "Deutsch",
      "english_corto": "EN",
      "spanish_corto": "ES",
      "portuguese_corto": "PT",
      "french_corto": "FR",
      "german_corto": "DE",
      "clp": "$ Chilenische Pesos (CLP)",
      "usd": "$ US-Dollar (USD)",
      "survey": "Umfrage",
      "endorsement": {
        "support_local_comunity": "Unterstützen Sie die lokale Wirtschaft, fördern Sie nachhaltige Ansätze",
        "when_you_buy": "Mit Ihrem Kauf bei uns fördern Sie mehr als 35 Anbieter in ihrer nachhaltigen und qualitativen Betriebsführung.",
        "instant_booking": "Zertifizierte Guides 100% verfügbar für Ihre Unterstützung",
        "by_entering_your": "Vor, während und nach der Reise für all Ihre Fragen und zur Unterstützung bei der Planung Ihres nächsten Abenteuers.",
        "payment_protection": "Bestätigen Sie Ihre Reservierung durch Zahlung von nur 30%",
        "we_comply_with_all": "Planen Sie Ihr Abenteuer stressfrei und leichter, indem Sie nur einen Teil jetzt und den Rest näher am Datum bezahlen."
      },
      "covid": "Covid",
      "secure": "Über diese Website abgewickelte Reservierungen sind durch unsere Partner geschützt.",
      "titles": {
        "book": "Buchen Sie mit Vertrauen",
        "destinations": "Beliebte Reiseziele",
        "activities": "Beliebte Aktivitäten"
      },
      "lang-currency": "Sprache & Währung"
    },
    "chat": {
      "hi": "Hallo",
      "our_chat_service": "Unser Chat-Service ist von Montag bis Freitag von 10 bis 18 Uhr (UTC/GMT -3) verfügbar. Wenn Sie uns während dieser Zeiten schreiben, antworten wir innerhalb weniger Minuten.",
      "new-message": "Neue Nachricht",
      "messages": "Nachrichten",
      "enter_your_name": "Geben Sie Ihren Namen ein",
      "enter_email": "Geben Sie Ihre E-Mail ein",
      "enter_message": "Geben Sie eine Nachricht ein...",
      "create_message": "Nachricht senden",
      "begin": "Starten",
      "user": "Benutzer",
      "need_help": "Benötigen Sie Hilfe?",
      "talk_to_local_guide": "Sprich mit einem lokalen guide"
    },
    "registration": {
      "edit_user": "Benutzer bearbeiten",
      "email": "E-Mail",
      "name": "Vorname",
      "lastname": "Nachname",
      "confirm_password": "Passwort bestätigen",
      "current_password": "Aktuelles Passwort",
      "new_password": "Neues Passwort (min. 8 Zeichen, Buchstabe, Zahl)",
      "profile_picture": "Profilbild",
      "profiles": "Profile (Sie können mehrere auswählen)",
      "interests": "Interessen (Sie können mehrere auswählen)",
      "notification": "Benachrichtigungseinstellungen",
      "save_settings": "Speichern",
      "update_account": "Konto aktualisieren",
      "registration_excerpt": "Verwalten Sie Ihr Profil nach Belieben. Aktivieren oder deaktivieren Sie Ihre Benachrichtigungen und definieren Sie Ihre Interessen. Auf diese Weise können Sie die Inhalte personalisieren, die Sie auf Outdoor Index sehen.",
      "vouchers": "Gutscheine",
      "all_vouchers": "Meine Gutscheine",
      "change_your_password": "Passwort ändern",
      "change_my_password": "Mein Passwort ändern",
      "confirm_new_password": "Neues Passwort bestätigen"
    },
    "responsive": {
      "more": "Mehr..."
    },
    "uploader": {
      "upload_a_file": "Datei hochladen",
      "drop_files_here": "Datei hierher ziehen",
      "processing_dropped_files": "Dateien werden verarbeitet..."
    },
    "sidebar_single": {
      "no_dates_available": "Keine Termine verfügbar",
      "disclaimer": "Sichern Sie sich Ihren Platz jetzt, indem Sie nur <strong>30% des Gesamtreservierungswertes bezahlen.</strong>",
      "select_dates": "Jetzt buchen",
      "share": "Fragen zur Exkursion?",
      "to_make_a": "Um eine Reservierung vorzunehmen, bitte ",
      "log_in": "anmelden",
      "or": "oder",
      "sign_up": "registrieren",
      "if_you_are": "wenn Sie neu sind.",
      "price_for": "Pro Person",
      "from": "Preis ab",
      "contact_viewnia": "Kontaktieren Sie uns",
      "rates": "CLP-Tarife enthalten MwSt. USD-Tarife enthalten keine MwSt.; ausländische Nicht-Residenten sind befreit, wenn sie in USD zahlen."
    },
    "request_form": {
      "title": "Exkursion anfragen",
      "contact_viewnia_subtitle": "Füllen Sie dieses Formular aus, um den Prozess zu starten, der es uns ermöglicht, Ihre Exkursion mit unserem Spezialisten vor Ort zu koordinieren."
    },
    "modal_manage_date": {
      "discount": "Rabatt hinzufügen",
      "manage_date": "Datum verwalten",
      "date": "Datum",
      "starting_time": "Startzeit",
      "price": "Preis",
      "vacancies": "Plätze",
      "save": "Speichern",
      "cancel_date": "Datum stornieren",
      "available_ammount": "Verfügbare Menge",
      "month_form": {
        "edit_month": "Monat bearbeiten",
        "delete_month": "Monat löschen",
        "populate_month": "Monat füllen",
        "disclaimer_1": "Sie sind dabei, <strong>einen ganzen Monat</strong> zu bearbeiten, diese Aktion ist <strong>schwer rückgängig zu machen</strong>.",
        "disclaimer_2": "Bitte überprüfen Sie Ihren aktuellen Kalender, bevor Sie fortfahren, um Duplikate oder andere Probleme zu vermeiden.",
        "accept": "Akzeptieren",
        "month": "Monat",
        "week_days": "Wochentage",
        "continue": "Weiter",
        "final_notice_header": "Bitte aufmerksam lesen:",
        "final_notice_1": "Ein Abreisedatum für die Exkursion <strong id='fn_title'></strong> hinzufügen, jeden <strong id='fn_week_days'></strong> im <strong id='fn_month'></strong>.",
        "final_notice_2": "Jede Abreise beginnt um <strong><span id='fn_starting_time_4i'></span>:<span id='fn_starting_time_5i'></span> Uhr</strong>, hat <strong id='fn_vacancies'></strong> Plätze und einen Rabatt von <strong id='fn_discount'></strong>.",
        "confirm": "Speichern",
        "back": "Zurück",
        "delete_month_disclaimer": "Sie sind dabei, alle Abreisen des Monats zu löschen, diese Aktion ist <strong>unumkehrbar</strong>.",
        "vacancies": "Plätze"
      }
    },
    "checkout_bar": {
      "itinerary": "Reiseplan",
      "tourists": "Gruppe",
      "assign_tourists": "Zuweisen",
      "checkout": "Zahlung",
      "voucher": "Beleg"
    },
    "reviews": {
      "title": "Bewertungen",
      "more": "Mehr",
      "reviewing_excursion": "Hinterlassen Sie Ihre Bewertung",
      "thanks_for_submitting": "Danke für Ihre Bewertung",
      "review": "Bewertung",
      "footer": "Auf TrustPilot ansehen"
    },
    "newsletter": {
      "sign_up_at": "Die lokale Lösung für Abenteuerreisen in Patagonien",
      "we_value_your_privacy": "Nachhaltig, personalisiert und voller Abenteuer für Ihren Genuss",
      "sign_up_now": "Registrieren",
      "view_preferences": "Einstellungen",
      "subscribe_to_our": "Abonnieren Sie unseren Newsletter",
      "email_address": "E-Mail-Adresse",
      "subscribe": "Abonnieren",
      "we_are_travel_and_growth": "Entdecken Sie Chile und seine Landschaften mit den besten Touren und Exkursionen. Erleben Sie lokale Erlebnisse in unvergesslichen Umgebungen und tun, was Sie möchten."
    },
    "modal": {
      "first_section": "Datum auswählen",
      "product_variants": "Option auswählen",
      "second_section": "Passagiere",
      "no_daily_quota": "An diesem Tag gibt es nicht genügend Plätze",
      "date": "Datum",
      "wrong_name": "Falscher Name oder Passwort",
      "per_person": " pro Person",
      "departure_time": "Abfahrt:",
      "spot_left": "Verfügbare Plätze",
      "add_reserves": "Anzahl der Reservierungen",
      "select": "Auswählen",
      "select_date": "Datum auswählen",
      "select_date_text": "Wählen Sie ein verfügbares Datum im Kalender aus und folgen Sie den Schritten, um Ihre Reservierung zu generieren.",
      "check_in": "Ankunft",
      "check_out": "Abreise",
      "guests": "Erwachsene",
      "child_guests": "Kinder",
      "guest_text": "Alter 13 Jahre oder älter",
      "child_text": "Von 0 bis 12 Jahre",
      "twins": "Einzel",
      "doubles": "Doppel",
      "doubles_twin": "2 Einzelbetten",
      "add_rooms_for": "Fügen Sie Ihre Zimmer hinzu für",
      "guest": "Gäste",
      "add_to_itinerary": "Auswählen",
      "start": "Beginn",
      "ends": "Ende",
      "leave_your_review": "Hinterlassen Sie Ihre Bewertung",
      "describe_your_experience": "Beschreiben Sie Ihre allgemeine Erfahrung",
      "add": "Hinzufügen",
      "next": "Weiter",
      "load_earlier_dates": "Frühere Daten laden ...",
      "load_later_dates": "Spätere Daten laden ...",
      "is_resident": "Einwohner Chiles",
      "is_not_resident": "Nicht-Einwohner Chiles",
      "language_title": "Land und Währung auswählen",
      "language_subtitle": "Wählen Sie Ihre Sprache aus der Liste",
      "currency_subtitle": "Wählen Sie Ihre Währung aus der Liste",
      "current_language": "Land und Sprache",
      "other_languages": "Andere Länder und Sprachen"
    },
    "alert": {
      "invalid_changes": "Ungültige Änderungen",
      "invalid_action": "Ungültige Aktion: Die Menge darf nicht kleiner als 0 sein",
      "not_enough_availability": "Für diesen Datumsbereich ist nicht genügend Verfügbarkeit vorhanden. Überprüfen Sie andere Unterkünfte oder buchen Sie weniger Einheiten.",
      "something_went_wrong": "Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut oder kontaktieren Sie uns, um Ihnen zu helfen.",
      "review_already_submitted": "Bewertung bereits gesendet",
      "couldn't_send_review": "Bewertung konnte nicht gesendet werden",
      "you_must_agree_to": "Sie müssen unseren Allgemeinen Geschäftsbedingungen zustimmen",
      "no_products_in_your_order": "Keine Produkte in Ihrer Bestellung",
      "please_sign_the_waiver": "Bitte unterzeichnen Sie die Verzichtserklärung mit Ihrem Namen.",
      "signature_and_tourist": "Die Unterschrift und der Name des Touristen müssen identisch sein.",
      "couldn't_save": "Speichern fehlgeschlagen, versuchen Sie es später erneut.",
      "invalid_language": "Ungültige Sprache",
      "confirm_to": "Sie müssen bestätigen, dass Sie kein Roboter sind.",
      "error": "Das Passwort muss mindestens 8 Zeichen, einen Buchstaben und eine Zahl enthalten"
    },
    "notice": {
      "your_account_has": "Ihr Konto hat keine Agenturen, kontaktieren Sie uns",
      "session_expired": "Sitzung abgelaufen, bitte melden Sie sich an.",
      "changes_submitted": "Änderungen gesendet!",
      "new_product_created": "Neues Produkt erstellt, wartet auf Genehmigung",
      "invalid_request": "Ungültige Anfrage. Bitte versuchen Sie es erneut oder kontaktieren Sie uns, um Ihnen zu helfen.",
      "have_excursions": "Die Agentur hat Exkursionen, weisen Sie sie einer anderen zu, bevor Sie sie löschen",
      "updated_information": "Informationen aktualisiert",
      "date_no_longer": "Das Datum ist nicht mehr verfügbar",
      "availability_updated": "Verfügbarkeit aktualisiert",
      "review_sent": "Bewertung gesendet!",
      "bookings_made_for": "Ihre Reservierung wurde erfolgreich durchgeführt!",
      "profile_picture_updated": "Profilbild aktualisiert!",
      "tourist_information_saved": "Ihre Informationen wurden gespeichert",
      "enabled": "aktiviert",
      "diabled": "deaktiviert",
      "was": "wurde",
      "settings_updated": "Einstellungen aktualisiert!",
      "language_updated": "Sprache aktualisiert!",
      "account_updated": "Konto aktualisiert!",
      "reserves_added_for": " Reservierungen hinzugefügt für ",
      "product_was_enabled": "Produkt aktiviert",
      "product_was_disabled": "Produkt deaktiviert"
    },
    "more": {
      "the_best_products": "Die besten Erlebnisse bei Outdoor Index",
      "all_recommendations_in_puerto_natales": "Alle Erlebnisse in Puerto Natales",
      "all_recommendations_in_punta_arenas": "Alle Erlebnisse in Punta Arenas",
      "all_recommendations_in_zone": "Alle Vorschläge in %{zone_name}",
      "all_adventure_products": "Alle aktiven Erlebnisse",
      "all_standard_products": "Alle transformierenden Erlebnisse",
      "all_scientific_products": "Alle Entdeckungserlebnisse",
      "all_family_products": "Alle Familien- und Gruppenerlebnisse",
      "all_luxury_products": "Alle anspruchsvollen Erlebnisse",
      "all_promotions_products": "Alle Aktionserlebnisse",
      "all_ota_products": "Alle OTA-Erlebnisse",
      "a_selection_of_the_best": "Eine Auswahl von Outdoor Index",
      "other_activities_that": "Andere Aktivitäten, die Ihr Erlebnis ergänzen",
      "all_north_patagonia_products": "Alle Erlebnisse in Nord-Patagonien",
      "all_south_patagonia_products": "Alle Erlebnisse in Süd-Patagonien",
      "all_lagos_region_products": "Alle Erlebnisse in der Seen- und Flussregion"
    },
    "searches": {
      "no_result_to": "Entschuldigung, keine Ergebnisse für \"%{category_name}\" in \"%{zone_name}\"",
      "recommended_for_you": "Erlebnisse zu tun in \"%{zone_name}\"",
      "category_products_in_zone": "\"%{category_name}\" in \"%{zone_name}\"",
      "category_products_in_zone_no_result": "Entschuldigung, im Moment gibt es keine \"%{category_name}\" in \"%{zone_name}\"",
      "all_products_in_zone": "Alle Erlebnisse in \"%{zone_name}\"",
      "all_products_in_zone_no_result": "Entschuldigung, es gibt keine Erlebnisse in \"%{zone_name}\"",
      "all_category_products": "Alle Erlebnisse von \"%{category_name}\"",
      "all_category_products_no_result": "Entschuldigung, im Moment gibt es keine Erlebnisse von \"%{category_name}\"",
      "please_select_category_or_zone": "Bitte wählen Sie eine Kategorie oder Zone aus"
    },
    "guidebook": {
      "download_our_guide_book": "Laden Sie unser Handbuch herunter und beginnen Sie Ihre Reise mit Outdoor Index",
      "find_out_everything": "Erfahren Sie alles über Süd-Chilenisches Patagonien."
    },
    "banner": {
      "do_you_need_travel_insurance": "Benötigen Sie eine Reiseversicherung?",
      "in_partnership_with_world": "Outdoor Index in Partnerschaft mit World Nomads bietet Ihnen die beste verfügbare Versicherung für das chilenische Patagonien.",
      "get_a_quote": "Angebot einholen"
    },
    "blog": {
      "meta_title": "Reise-, Natur- und Abenteuerblog in Chile | Outdoor Index",
      "meta_description": "Entdecken Sie Reiseführer, Tipps und Inspiration für Chile, Outdoor-Ausflüge, Natur und unvergessliche Abenteuererlebnisse.",
      "travel_nature_growth": "Reisen, Natur & Wachstum",
      "we_connect_you_with": "Globale Inhalte über Natur, Reisen und Wachstum. Folgt uns auf Social Media!",
      "breadcrumb_aria": "Navigation",
      "breadcrumb_home": "Startseite",
      "breadcrumb_blog": "Blog",
      "guided_tours": "Geführte Touren",
      "book_now": "Jetzt buchen",
      "view_more_activities": "Mehr Aktivitäten anzeigen",
      "showing_count": "%{loaded} von %{total} Artikeln angezeigt",
      "pagination_aria": "Blog-Paginierung",
      "page_n": "Seite %{n}"
    },
    "mail": {
      "welcome_user_name": "Willkommen bei Outdoor Index! %{user_name}",
      "leave_your_review": "%{user_name}, hinterlassen Sie eine Bewertung Ihrer Erfahrung",
      "voucher": {
        "your_order_is_ready": "Danke für Ihren Kauf %{reference_code}",
        "your_sold_product": "Hallo %{user_provider}, wir haben eines Ihrer Erlebnisse verkauft",
        "new_sold": "Neuer Verkauf %{reference_code}"
      }
    },
    "paypal": {
      "description": "Outdoor Index: Bezahlung der Bestellung %{reference_code}"
    },
    "payu": {
      "description": "Outdoor Index: Bezahlung der Bestellung %{reference_code}"
    },
    "pdf": {
      "emergency_contacts": "Notfallkontakt",
      "congratulations_user_name": "Herzlichen Glückwunsch %{user_name}",
      "congratulations_agency_name": "Herzlichen Glückwunsch %{agency_name}",
      "here_we_attach": "Anbei finden Sie alle Informationen zu Ihrer Reise. In diesem Gutschein sehen Sie die Details Ihrer Erlebnisse, den Kontakt der Anbieter, die unterzeichnete Verzichtserklärung sowie den Beleg für Ihr bezahltes Produkt (Paypal oder PayU). Zögern Sie nicht, uns bei Fragen zu kontaktieren.",
      "reservation_number": "Reservierungsnummer:",
      "product_detail": "Produktdetail",
      "departure": "Abfahrt",
      "your_suppliers": "Ihre Anbieter",
      "in_this_section_appear": "In diesem Abschnitt erscheint das Detail der von Outdoor Index erhaltenen Zahlung. Denken Sie daran, diesen Gutschein auszudrucken und immer bei sich zu tragen. Vielen Dank, dass Sie sich für Outdoor Index entschieden haben",
      "payments_detail": "Zahlungsdetails",
      "initial_payment": "Anzahlung",
      "payment_method": "Zahlungsmethode",
      "total_paid": "Gesamt bezahlt",
      "total_order": "Gesamtbestellung:",
      "order_date": "Bestelldatum",
      "payment_date": "Zahlungsdatum",
      "payment_type": "Zahlungsart",
      "payment_complete": "Vollständige Zahlung",
      "print_this_voucher": "Drucken Sie diesen Gutschein aus und tragen Sie ihn bei sich",
      "at_all_times": "während der gesamten Reise. Zeigen Sie ihn beim",
      "you_check": "Check-in vor.",
      "we_have_received": "Wir haben eine neue Reservierungsanfrage für Ihre Produkte erhalten. Nachfolgend finden Sie die Details dazu und die Informationen Ihrer Passagiere. Ab diesem Zeitpunkt können Sie Ihre Passagiere direkt kontaktieren oder, falls Sie es bevorzugen, Outdoor Index damit beauftragen. Es ist immer empfehlenswert, eine E-Mail zu senden, die den erfolgreichen Abschluss der Reservierung bestätigt. Sie werden sich als guter Anbieter hervorheben. Denken Sie daran, die Reservierungskontingente in Ihren eigenen Systemen zu aktualisieren, um Überbuchungsprobleme zu vermeiden. Gute Arbeit!",
      "guests": "Reisende",
      "your_guests": "Ihre Reisenden",
      "date_of_birth": "Geburtsdatum:",
      "origin": "Herkunft:",
      "document_number": "Dokumentennummer:",
      "phone": "Telefon",
      "email": "E-Mail",
      "emergency_number": "Notfallnummer:",
      "allergies": "Allergien:",
      "medical_conditions": "Medizinischer Zustand:",
      "food_restrictions": "Ernährungseinschränkungen:",
      "dear_user_name": "Sehr geehrte(r) %{user_name}",
      "service_confirmation": "Servicebestätigung",
      "according_to_the_reservation": "Gemäß Ihrer Reservierungsanfrage bestätigen wir folgende Informationen:",
      "reference_code": "Reservierungsnr.",
      "activity": "Aktivität",
      "starting_point": "Ort",
      "starting_date": "Servicedatum",
      "starting_time": "Servicezeit",
      "client": "Kunde",
      "payment_details": "ZAHLUNGSDETAILS",
      "applied": "ANGEWENDET",
      "next_payment": "NÄCHSTE ZAHLUNG (70%)",
      "excursion": "AKTIVITÄT %{number}",
      "purchase_date": "Kaufdatum",
      "description": "Beschreibung",
      "unit_price": "Stückpreis",
      "unit_price_child": "Stückpreis Kind",
      "childen_pax": "Kinder",
      "pax": "Pax",
      "tax": "Steuer",
      "about_your_host": "ÜBER IHREN GASTGEBER",
      "name": "Verantwortliche Person:",
      "address": "Adresse:",
      "from": "Servicestartdatum",
      "to": "Serviceenddatum",
      "tourists": "Touristen information",
      "guest": "Passagiere",
      "guest_s": "Passagier",
      "child_guest": "Kinder",
      "child_guests": "Kinder",
      "child_guest_s": "Kind",
      "guest_price": "Preis Erwachsener",
      "child_guest_price": "Preis Kind",
      "resident": "Ansässig",
      "no_resident": "Nicht Ansässig",
      "problem_with_order": "Probleme mit Ihrer Bestellung?",
      "complete_remaining_payment_web": "Um den Restbetrag zu zahlen, melden Sie sich bei outdoorindex.cl an und öffnen Sie diese Bestellung unter Ihren Gutscheinen.",
      "contact_us": "Kontaktieren Sie uns"
    },
    "currency": {
      "displaying_prices_in": "Währungsumstellung erfolgt!"
    },
    "tourists": {
      "first_create_group": "Ups! Vergessen Sie nicht, die Passagierinformationen auszufüllen."
    },
    "date": {
      "abbr_day_names": [
        "So",
        "Mo",
        "Di",
        "Mi",
        "Do",
        "Fr",
        "Sa"
      ],
      "abbr_month_names": [
        null,
        "Jan",
        "Feb",
        "Mär",
        "Apr",
        "Mai",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Okt",
        "Nov",
        "Dez"
      ],
      "day_names": [
        "Sonntag",
        "Montag",
        "Dienstag",
        "Mittwoch",
        "Donnerstag",
        "Freitag",
        "Samstag"
      ],
      "month_names": [
        null,
        "Januar",
        "Februar",
        "März",
        "April",
        "Mai",
        "Juni",
        "Juli",
        "August",
        "September",
        "Oktober",
        "November",
        "Dezember"
      ],
      "formats": {
        "default": "%d.%m.%Y",
        "short": "%e. %b",
        "long": "%e. %B %Y",
        "fixed_departure": "DD.M.YYYY",
        "calendar_picker": "DD.MM.YYYY",
        "moment": "%Y-%m-%d"
      }
    },
    "time": {
      "formats": {
        "default": "%d.%m.%Y, %H:%M Uhr",
        "short": "%e. %b, %H:%M",
        "long": "%e. %B %Y, %H:%M Uhr",
        "full": "%A, %e. %B %Y / %H:%M Uhr",
        "calendar_picker": "DD.MM.YYYY"
      }
    },
    "activities": {
      "trekking": "Wanderungen",
      "horseback": "Reitausflüge",
      "birdwatching": "Vogelbeobachtung",
      "mountaineering": "Bergsteigen",
      "icehike": "Gletscherwanderung",
      "kayak": "Kajak",
      "flyfishing": "Fliegenfischen",
      "navigations": "Schifffahrten",
      "cruises": "Kreuzfahrten",
      "helicopter": "Helikopter",
      "multiactivity": "Multi-Aktivitäten",
      "photosafari": "Fotosafari",
      "bikes": "Fahrräder",
      "snowshoes": "Schneeschuhe",
      "ski": "Ski",
      "rafting": "Rafting"
    },
    "filters": {
      "clear_filters": "Filter löschen"
    },
    "lang": {
      "countries": {
        "spain": "Spanien",
        "argentina": "Argentinien",
        "bolivia": "Bolivien",
        "chile": "Chile",
        "colombia": "Kolumbien",
        "costa_rica": "Costa Rica",
        "ecuador": "Ecuador",
        "mexico": "Mexiko",
        "peru": "Peru",
        "paraguay": "Paraguay",
        "uruguay": "Uruguay",
        "united_states": "Vereinigte Staaten",
        "england": "England",
        "australia": "Australien",
        "canada": "Kanada",
        "new_zealand": "Neuseeland",
        "ireland": "Irland",
        "portugal": "Portugal",
        "brazil": "Brasilien",
        "france": "Frankreich",
        "germany": "Deutschland",
        "china": "China",
        "hong_kong": "Hong Kong",
        "japan": "Japan",
        "korea": "Korea",
        "singapore": "Singapore",
        "taiwan": "Taiwan"
      }
    }
  },
  "zh": {
    "terms": {
      "head": {
        "conditions": "服务条款",
        "privacy": "隐私政策",
        "cookies": "Cookie 政策",
        "you_as_a_consumer": "作为消费者，您有权了解按计划进行旅行可能需要的文件。请提前核实进入智利或旅途中经过的任何其他国家是否需要护照、签证、疫苗、未成年人许可或其他文件。如果需要其中任何一项而您尚未持有，请提前办理相关手续。"
      }
    },
    "devise": {
      "google_sign_in": "使用 Google 登录",
      "facebook_sign_in": "使用 Facebook 登录",
      "apple_sign_in": "使用 Apple 登录",
      "already_have_an_account?": "已有账号？",
      "didn''t_receive_confirmation_instructions?": "没有收到确认邮件？",
      "didn''t_receive_unlock_instructions?": "没有收到解锁邮件？",
      "forgot_your_password?": "忘记密码？",
      "don''t_have_an_account?": "还没有账号？",
      "enter_email_associated": "输入与您的帐户关联的电子邮件，我们将向您发送重置密码的链接。",
      "passwordless": {
        "not_found_in_database": "找不到该电子邮件地址的用户",
        "magic_link_sent": "登录链接已发送到您的电子邮件地址。请点击链接登录您的帐户。",
        "magic_link_sent_paranoid": "如果您的帐户存在，您将收到一封包含登录链接的电子邮件。请跟随链接登录您的帐户。"
      },
      "confirmations": {
        "confirmed": "您的电子邮件地址已成功确认。",
        "send_instructions": "您将在几分钟内收到一封包含确认电子邮件地址说明的电子邮件。",
        "send_paranoid_instructions": "如果您的电子邮件地址在我们的数据库中，您将在几分钟内收到一封包含确认电子邮件地址说明的电子邮件。"
      },
      "failure": {
        "magic_link_invalid": "无效或过期的登录链接。",
        "already_authenticated": "您已登录。",
        "inactive": "您的帐户尚未激活。",
        "invalid": "%{authentication_keys} 或密码无效。",
        "locked": "您的帐户已被锁定。",
        "last_attempt": "您还有最后一次尝试机会，之后您的帐户将被锁定。",
        "not_found_in_database": "%{authentication_keys} 或密码无效。",
        "timeout": "您的会话已过期。请重新登录以继续。",
        "unauthenticated": "在继续之前，您需要登录或注册。",
        "unconfirmed": "在继续之前，您必须确认您的电子邮件地址。"
      },
      "mailer": {
        "magic_link": {
          "subject": "登录链接",
          "greeting": "你好 %{email}!",
          "instructions": "您可以使用以下链接登录：",
          "login_button": "登录我的帐户",
          "expiration_notice": "请注意，该链接将在 %{expiration_time} 后过期。"
        },
        "confirmation_instructions": {
          "subject": "确认说明"
        },
        "reset_password_instructions": {
          "subject": "重置密码说明"
        },
        "unlock_instructions": {
          "subject": "解锁说明"
        },
        "email_changed": {
          "subject": "电子邮件已更改"
        },
        "password_change": {
          "subject": "密码已更改"
        }
      },
      "omniauth_callbacks": {
        "failure": "无法从 %{kind} 验证您的身份，因为 \"%{reason}\"。",
        "success": "已成功从 %{kind} 帐户验证。"
      },
      "passwords": {
        "no_token": "如果您不是来自密码重置电子邮件，则无法访问此页面。如果您确实来自密码重置电子邮件，请确保使用了提供的完整 URL。",
        "send_instructions": "您将在几分钟内收到一封包含重置密码说明的电子邮件。",
        "send_paranoid_instructions": "如果您的电子邮件地址在我们的数据库中，您将在几分钟内收到密码恢复链接。",
        "updated": "您的密码已成功更改。您现在已登录。",
        "updated_not_active": "您的密码已成功更改。"
      },
      "registrations": {
        "destroyed": "再见！您的帐户已成功取消。我们希望很快能再次见到您。",
        "signed_up": "欢迎！您已成功注册。",
        "signed_up_but_inactive": "您已成功注册。但是，我们无法让您登录，因为您的帐户尚未激活。",
        "signed_up_but_locked": "您已成功注册。但是，我们无法让您登录，因为您的帐户已被锁定。",
        "signed_up_but_unconfirmed": "一封带有确认链接的消息已发送到您的电子邮件地址。请跟随链接激活您的帐户。",
        "update_needs_confirmation": "您已成功更新帐户，但我们需要验证您的新电子邮件地址。请检查您的电子邮件并按照确认链接确认您的新电子邮件地址。",
        "updated": "您的帐户已成功更新。"
      },
      "sessions": {
        "signed_in": "登录成功。",
        "signed_out": "退出成功。",
        "already_signed_out": "退出成功。"
      },
      "unlocks": {
        "send_instructions": "您将在几分钟内收到一封包含解锁帐户说明的电子邮件。",
        "send_paranoid_instructions": "如果您的帐户存在，您将在几分钟内收到一封包含解锁帐户说明的电子邮件。",
        "unlocked": "您的帐户已成功解锁。请登录以继续。"
      }
    },
    "errors": {
      "something_went_wrong": "出了点问题",
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "必须被接受",
        "blank": "不能为空",
        "confirmation": "与 %{attribute} 不匹配",
        "empty": "不能为空",
        "equal_to": "必须等于 %{count}",
        "even": "必须是偶数",
        "exclusion": "被保留",
        "greater_than": "必须大于 %{count}",
        "greater_than_or_equal_to": "必须大于或等于 %{count}",
        "inclusion": "不在列表中",
        "invalid": "无效",
        "less_than": "必须小于 %{count}",
        "less_than_or_equal_to": "必须小于或等于 %{count}",
        "model_invalid": "验证失败: %{errors}",
        "not_a_number": "不是一个数字",
        "not_an_integer": "必须是一个整数",
        "odd": "必须是奇数",
        "other_than": "必须不同于 %{count}",
        "present": "必须为空",
        "required": "必须存在",
        "taken": "已经被使用",
        "must_contain_number": " 必须包含至少一个数字",
        "must_contain_special": " 必须包含特殊字符",
        "must_contain_lower": " 必须包含至少 1 个小写字母",
        "must_contain_upper": " 必须包含至少 1 个大写字母",
        "too_long": {
          "one": "太长（最大为 1 个字符）",
          "other": "太长（最大为 %{count} 个字符）"
        },
        "too_short": {
          "one": "太短（最小为 1 个字符）",
          "other": "太短（最小为 %{count} 个字符）"
        },
        "wrong_length": {
          "one": "长度错误（应该是 1 个字符）",
          "other": "长度错误（应该是 %{count} 个字符）"
        },
        "already_confirmed": "已经被确认，请尝试登录",
        "confirmation_period_expired": "需要在 %{period} 内确认，请重新请求",
        "expired": "已过期，请重新请求",
        "not_found": "未找到",
        "not_locked": "未被锁定",
        "not_saved": {
          "one": "1 个错误导致此 %{resource} 无法保存：",
          "other": "%{count} 个错误导致此 %{resource} 无法保存："
        }
      }
    },
    "meta_tags": {
      "default": {
        "description": "与 Outdoor Index 一起探索智利，体验独特的冒险项目和专家向导。开启您的难忘之旅！",
        "keywords": "巴塔哥尼亚, 智利, 探险旅游, 巴塔哥尼亚探险, 智利探险, 百内国家公园旅游, 巴塔哥尼亚徒步, 巴塔哥尼亚皮划艇, 巴塔哥尼亚骑马, 巴塔哥尼亚多项运动, 巴塔哥尼亚家庭探险, 巴塔哥尼亚豪华探险, 巴塔哥尼亚预算探险, 巴塔哥尼亚最佳探险, 巴塔哥尼亚探险之旅, 巴塔哥尼亚探险活动, 巴塔哥尼亚探险短途旅行, 巴塔哥尼亚探险项目",
        "name": "Outdoor Index"
      },
      "help": {
        "title": "Outdoor Index - 帮助",
        "description": "对您的巴塔哥尼亚之旅有疑问？访问 Outdoor Index，与当地向导和领域专家交谈。",
        "keywords": null
      }
    },
    "views": {
      "pagination": {
        "truncate": "…"
      }
    },
    "activerecord": {
      "models": {
        "season": "季节",
        "seasons": "季节"
      },
      "attributes": {
        "season": {
          "name": "名称",
          "valid_from": "有效期自",
          "valid_until": "有效期至",
          "start_time": "开始时间",
          "product": "短途旅行",
          "mon_check": "周一",
          "tue_check": "周二",
          "wed_check": "周三",
          "thu_check": "周四",
          "fri_check": "周五",
          "sat_check": "周六",
          "sun_check": "周日"
        },
        "order": {
          "clp_charge": "智利比索费用",
          "usd_charge": "美元费用",
          "username": "客户:",
          "email": "邮箱:",
          "product": "产品:",
          "product_name": "产品",
          "pax_manual": "人数:",
          "manual_total": "已付:",
          "manual_currency": "货币:",
          "partial_payment": "付款:",
          "payment_method": "方式:",
          "channel": "渠道:",
          "confirmed_at": "购买:",
          "departure_at": "出发:",
          "starting_datetime": "出发时间:",
          "customer_phone": "电话:",
          "extra": "额外:",
          "instructions": "说明:",
          "language": "语言:",
          "weather_link": "天气链接",
          "post_link": "文章链接",
          "itinerary_document": "行程文件",
          "show_itinerary_document": "显示"
        }
      }
    },
    "promotions": {
      "coupon_code_ok": "优惠券代码应用成功",
      "coupon_code_error": "优惠券代码不存在",
      "coupon_code_already": "优惠券代码已应用",
      "coupon_code_max": "每个订单最多使用一张优惠券",
      "coupon_code_destroy_ok": "代码已成功删除",
      "coupon_code_destroy_error": "无法删除代码",
      "coupon_code_destroy_confirm": "您确定要删除它吗？",
      "coupon_have_a_coupon": "您有优惠券吗？",
      "coupon_form_palceholder": "折扣代码",
      "coupon_apply": "应用"
    },
    "home_collections": {
      "home_reviews": "每年有 350+ 人随 Outdoor Index 旅行",
      "find_your_experience": "发现您的体验",
      "carousel_region": "按地区探险",
      "carousel_activities": "按活动探险",
      "carousel_time_preference": "按时间偏好探险",
      "sub-landing": "与 Outdoor Index 一起探索智利最佳旅游选择。比较并探索从阿塔卡马到巴塔哥尼亚的各种项目。立即预订，体验独特经历！",
      "title": "智利和巴塔哥尼亚的探险之旅",
      "subtitle": "与当地最佳向导一起寻找冒险"
    },
    "products_search": {
      "activities": "活动",
      "regions": "地区",
      "time": "时间",
      "date": "日期",
      "date_sub_label": "您想什么时候去？",
      "activities_sub_label": "选择您喜欢的活动",
      "regions_sub_label": "您想去哪个地区？",
      "time_sub_label": "选择您的时间偏好！",
      "all_adventures": "所有探险",
      "search_placeholder": "搜索智利各地的探险",
      "most_popular_searches": "热门搜索",
      "see_all_adventures": "查看所有探险",
      "help_me_choose": "帮我选择",
      "help_me_choose_url": "https://api.whatsapp.com/send?phone=56981785011&text=Hi%2C%20I%20need%20help%20choosing%20an%20adventure",
      "popular_search_items": {
        "circuito_w": {
          "label": "Circuito W",
          "icon": "search",
          "landing_slug": "circuito-w"
        },
        "circuito_o": {
          "label": "Circuito O",
          "icon": "search",
          "landing_slug": "circuito-o"
        },
        "torres_del_paine": {
          "label": "Torres del Paine",
          "icon": "map-pin",
          "zone_id": 1
        },
        "pucon": {
          "label": "Pucón",
          "icon": "map-pin",
          "zone_id": 16
        },
        "san_pedro_atacama": {
          "label": "San Pedro de Atacama",
          "icon": "map-pin",
          "zone_id": 15
        },
        "puerto_natales": {
          "label": "Puerto Natales",
          "icon": "map-pin",
          "zone_id": 2
        }
      },
      "search": "搜索",
      "clear": "清除选择",
      "tours": "旅游",
      "subtext": "规划您的下一次冒险。\n探索、预订，尽享自然之美。",
      "in": "在",
      "showing_count": "显示 %{loaded} / %{total} 个探险",
      "load_more": "加载更多"
    },
    "comments": {
      "comments": "评论",
      "replies": "回复",
      "post_a_comment": "发表评论！",
      "submit": "提交",
      "reply": "回复",
      "body": "在此写下您的评论..."
    },
    "order": {
      "confirmed": "已确认",
      "mail_thank": "感谢您在 Outdoor Index 购买",
      "mail__hi": "您好！",
      "mail_subject": "Outdoor Index 订单号 N#",
      "order_t": "订单",
      "see_purchase": "查看您的购买！",
      "already_paid": "订单已支付",
      "confirm_payment": "确认",
      "cancel_order": "取消",
      "recover_order": "恢复",
      "send_confirm": "确认 (1)",
      "send_reminder": "提醒 (2)",
      "send_last_reminder": "再次提醒 (3)",
      "send_review": "审查 (4)",
      "email_title": "短途旅行提醒",
      "email_footer": "这是您的短途旅行提醒。如果您有任何问题，请随时通过 info@outdoorindex.cl 或 +56981785011 联系我们。",
      "promo": "访问 www.outdoorindex.cl 获取更多短途旅行和项目。",
      "edit": "编辑",
      "departure_date": "出发日期",
      "reservation": "预订",
      "code": "代码",
      "departure": "出发",
      "contact_info": "联系方式",
      "customer_phone": "联系电话",
      "travelers": "旅客",
      "itinerary": "行程",
      "view_itinerary": "下载您的行程",
      "view_itinerary_file": "这里",
      "voucher": "查看凭证",
      "confirmation_email_title": "您的 %{excursion} 预订已确认",
      "view_weather_link": "查看天气",
      "instruction_exerpt": "我们知道您的短途旅行临近，您应该已经准备好了",
      "here_some_instructions": "说明",
      "view_post_link": "我们的博客",
      "review_email_title": "告诉我们您的短途旅行体验 %{excursion}",
      "review_link": "填写行后调查",
      "review_trustpilot_intro": "如果您希望其他旅行者了解您的体验，也可以在 Trustpilot 上留下公开评价。",
      "review_trustpilot_link": "在 Trustpilot 上留下评价",
      "review_question": "您的短途旅行怎么样？",
      "review_explain_title": "为什么填写调查很重要",
      "rewview_explain_body": "<p>您的反馈帮助我们改进每一次短途旅行。行后调查是保密的，让我们了解您的体验：组织、导游、活动以及那些重要的细节。</p>\n<p>请回顾您在短途旅行之前、期间和之后的体验。诚实回答只需几分钟。</p>\n<p>您的回答帮助我们保持服务质量，并持续为未来的旅行者改进。</p>\n",
      "review_terrible": "糟糕",
      "review_bad": "差",
      "review_acceptable": "尚可",
      "review_good": "好",
      "review_great": "棒极了",
      "new_order_excerpt": "在这里您可以完成创建订单所需的所有必要信息。写下清晰精确的说明，指明每个预订的时间和集合地点。此外，记得按优先顺序联系运营商。"
    },
    "ondemand": {
      "explanation": "独家旅游！联系我们的现场专家。",
      "label": "私人"
    },
    "request": {
      "greeting": "您好！此信息已发送至您的注册邮箱，并抄送给我们的一位代理。很快会有人联系您。",
      "order_mail": {
        "header": {
          "hi": "您好！关于您的短途旅行申请有好消息！",
          "title": "您的申请已被当地运营商接受。请阅读以下信息，确保一切无误。",
          "your_order": "您的订单号 N°",
          "ready": "可供付款。"
        },
        "footer": "现在您可以通过按钮链接进入付款部分。",
        "disclaimer": "您将被重定向到 Outdoor Index 的安全连接付款窗口。",
        "pay": "立即付款",
        "excursion": {
          "title": "短途旅行",
          "agency": "当地运营商"
        },
        "manual_order": {
          "observations": "阅读下面来自 Outdoor Index 代理的评论！",
          "price": "价格",
          "price_clp": "价格 CLP",
          "price_usd": "价格 USD"
        },
        "request_details": "您的申请详情"
      },
      "singular": "申请",
      "requester": "申请人",
      "product_required": "要申请订单，您必须先登录",
      "excursion": "短途旅行",
      "applicants": "申请人",
      "from": "从",
      "to": "到",
      "comments": "评论",
      "comments_placeholder": "在我们联系您之前，请留下您的问题、疑问或任何想告诉我们的内容。我们会尽快联系您！",
      "submit": "发送申请",
      "email_title": "短途旅行协调申请",
      "email_footer": "此表格已发送给我们的高管。我们将通过您在联系表格中提供的信息与您联系。如果表格中有任何错误或意见，请发送电子邮件至 info@outdoorindex.cl 说明问题。",
      "contact_name": "联系人姓名",
      "contact_email": "联系人邮箱",
      "contact_phone": "联系电话",
      "must_log_in": "您必须登录才能付款",
      "phone": "联系电话",
      "name": "姓名",
      "last_name": "姓氏"
    },
    "applicants": {
      "applicants_number": "2) 有多少人将参加短途旅行？",
      "dates_sub": "3) 您想在哪几天进行此短途旅行？",
      "additional_info": "4) 其他信息",
      "applicants_phone": "1) 留下您的联系方式",
      "phone_placeholder": "电话",
      "email": "电子邮件",
      "name": "姓名",
      "lastname": "姓氏"
    },
    "active_admin": {
      "observed_dollar_update": "更新",
      "agency": "运营商",
      "agencies": "运营商",
      "settings": "设置",
      "users": "用户",
      "admin_users": "管理员用户",
      "orders": "订单",
      "pages": "页面",
      "sales": "销售",
      "sale_goals": "销售目标",
      "reviews": "评论",
      "blog": "博客",
      "suppliers": "供应商",
      "covers": "封面",
      "excursions": "短途旅行",
      "categories": "类别",
      "comments_tab": "评论",
      "excursion_images": "短途旅行图片",
      "home": "首页",
      "home_collections": "首页合集",
      "save_home_collections": "保存合集",
      "images": "文章图片",
      "mailer": "邮件",
      "newsletter_covers": "通讯封面",
      "notifications": "通知",
      "payment_methods": "付款方式",
      "private": "私人",
      "products": "产品",
      "profiles": "个人资料",
      "properties": "属性",
      "promotions": "促销",
      "question_subjects": "问题主题",
      "questions": "问题",
      "tourists": "游客",
      "requests": "申请",
      "tags": "标签",
      "visits": "访问",
      "zones": "区域",
      "seasons": "季节",
      "macro_zones": "大区",
      "landings": "落地页",
      "post": {
        "title": "标题",
        "subtitle": "副标题",
        "label": "标签",
        "author_name": "作者姓名",
        "author_sm": "作者社交媒体",
        "content": "内容",
        "cover": "封面",
        "published": "已发布",
        "unpublished": "未发布",
        "tags": "标签",
        "recommended_posts": "推荐文章",
        "products": "旅游线路与短途行程",
        "explore_chile": "与 Outdoor Index 一起探索智利及其隐藏的宝石"
      },
      "zone": {
        "name": "名称",
        "description": "描述",
        "sort_order": "以此排序",
        "country": "国家",
        "state": "州/省"
      },
      "review": {
        "tilte1": "创建评论",
        "title2": "封面",
        "author": "姓名",
        "country": "国家",
        "review_date": "评论日期",
        "language": "语言",
        "save_review": "保存评论",
        "body": "评论内容",
        "cover": "封面",
        "rating": "评分",
        "url": "URL",
        "excerpt": "在这里您可以完成创建评论所需的所有必要信息。请确保您上传的封面照片具有良好的分辨率且正确无误。记得阅读并检查信息。"
      },
      "landing": {
        "tilte1": "创建落地页",
        "title2": "Meta",
        "title3": "封面",
        "title4": "评论",
        "title5": "常见问题",
        "save_landing": "保存落地页",
        "title": "标题",
        "place": "地点",
        "body": "正文",
        "cover": "封面",
        "review": "评论",
        "meta_title": "Meta 标题",
        "meta_description": "Meta 描述",
        "product": "短途旅行",
        "excerpt": "在这里您可以完成创建落地页所需的所有必要信息。请确保您上传的封面照片具有良好的分辨率并能吸引游客。记得提供清晰可靠的信息。",
        "more_info": "更多信息"
      },
      "season": {
        "name": "名称",
        "valid_from": "从",
        "valid_until": "至",
        "start_time": "开始时间",
        "product": "短途旅行",
        "child_usd_price": "儿童（美元）",
        "child_clp_price": "儿童（CLP）",
        "single_supplement_usd_price": "美元",
        "single_supplement_clp_price": "CLP",
        "guardar_temporada": "保存",
        "daily_quota": "可用性",
        "title_days": "天数",
        "title_ages": "年龄",
        "title_prices_kids": "儿童价格",
        "title_prices_adults": "成人价格",
        "title_single_supplement": "单人补差"
      },
      "kpis": {
        "observed_dollar": "观测美元值",
        "observed_dollar_subtitle": "中央银行定义的美元值",
        "visits_today_title": "今日访问",
        "visits_today_subtitle": "今日流量",
        "visitors": "访客",
        "last_day": "前一天",
        "show_more": "查看更多",
        "countries": "国家",
        "countries_subtitle": "访问我们最多的人",
        "country_anon": "匿名",
        "abandoned_cart_title": "废弃的背包",
        "abandoned_cart_subtitle": "留在背包中的订单",
        "products_viewed_title": "浏览最多的产品",
        "products_viewed_subtitle": "目前最受欢迎",
        "posts_viewed_title": "浏览最多的文章",
        "posts_viewed_subtitle": "目前最受欢迎",
        "products_selled_title": "畅销产品",
        "products_selled_subtitle": "去年",
        "today_excursions_title": "今日短途旅行",
        "today_excursions_subtitle": "今天出发的游客。",
        "users_month_title": "每月统计",
        "users_month_subtitle": "每月用户统计平衡。",
        "users_number": "用户数量",
        "new_users_title": "新用户",
        "new_users_subtitle": "上月注册",
        "users_total_title": "总用户",
        "users_total_subtitle": "从开始注册",
        "new_users_title_box": "今日用户",
        "new_users_subtitle_box": "当日访问流量",
        "users": "用户",
        "new_orders_title": "新订单",
        "new_orders_subtitle": "本月注册",
        "paid_orders_title": "已付订单",
        "paid_orders_subtitle": "本月注册",
        "sale_goals_title": "销售目标",
        "sale_goals_subtitle": "本月总收益",
        "goals": "目标",
        "to": "至",
        "no_sale_goal": "未定义销售目标",
        "conversion_chart_title": "转化图表",
        "conversion_chart_subtitle": "去年的转化率",
        "conversion_last_year": "去年转化率",
        "conversion_title": "转化率",
        "conversion_subtitle": "更新至今"
      }
    },
    "mercado_pago": {
      "error_alert": "Mercado Pago 发生错误，请检查您的订单是否已支付。",
      "error_title": "交易被拒绝",
      "error_dec": "处理付款时出错，请重试。如果问题仍然存在，请联系我们。",
      "pending_title": "交易待处理",
      "pending_dec": "您的付款在 Mercado Pago 中待验证。验证后，联系我们以验证您的订单。"
    },
    "webpay": {
      "error_alert": "Webpay 发生错误，请检查您的订单是否已支付。",
      "error_title": "交易被拒绝",
      "error_dec": "处理付款时出错，请重试。如果问题仍然存在，请联系我们。"
    },
    "back": "返回",
    "chat_title": "我们能帮您什么？",
    "chat_subtitle": "我们通常在几个小时内回复",
    "chat_name": "姓名",
    "chat_email": "电子邮件",
    "chat_phone": "电话",
    "chat_subject": "主题",
    "chat_body": "正文",
    "chat_btn": "发送消息",
    "menu_welcome": "欢迎，%{user_name}",
    "meesage_sended": "消息已发送",
    "meesage_captcha": "您必须检查验证码",
    "view_more": "查看更多...",
    "view_more_excursions": "查看更多短途旅行...",
    "view_more_suggestions": "查看更多建议...",
    "location": "地点",
    "zone": "区域",
    "category": "类别",
    "select_one": "选择一个",
    "select_multiple": "选择多个",
    "select_two": "最多 2 个",
    "price": "价格",
    "vacancies": "空缺",
    "key": "例如：海拔",
    "value": "1300 米",
    "value_included": "例如：双语导游",
    "profiles": "个人资料",
    "optional": "可选",
    "email": "电子邮件",
    "phone": "电话",
    "address": "地址",
    "pending": "待定",
    "edit": "编辑",
    "soon": "即将推出",
    "password": "密码 (至少 8 个字符，字母，数字)",
    "password_confirmation": "确认密码",
    "remember_me": "记住我",
    "log_in": "登录",
    "sign_up": "注册",
    "create_an_account": "创建您的帐户",
    "name": "名字",
    "last_name": "姓氏",
    "back_to": "返回",
    "reset_password": "恢复密码",
    "send": "发送",
    "guests": "成人",
    "guest": "成人",
    "guest_s": "成人",
    "child_guest": "儿童",
    "child_guests": "儿童",
    "child_guest_s": "儿童",
    "products": "产品",
    "products_show_photos": "显示 (%{n}) 张照片",
    "delete": "删除",
    "continue": "继续",
    "subtotal": "小计：",
    "total_only": "总计",
    "total": "应付总额：",
    "total_paid": "已付总额",
    "total_final": "最终总计",
    "coupon": "优惠券",
    "charges": "费用：",
    "image_not_found": "找不到图片",
    "usd": "美元",
    "clp": "CLP",
    "departure": "出发",
    "when": "时间",
    "what": "什么",
    "where": "地点",
    "search": "搜索",
    "language": "语言",
    "puerto_natales": "纳塔莱斯港",
    "punta_arenas": "蓬塔阿雷纳斯",
    "tierra_del_fuego": "火地岛",
    "puerto_williams": "威廉斯港",
    "in": "在",
    "or": "或",
    "help": "常见问题",
    "go_to_home_page": "转到主页",
    "add_row": "+ 添加",
    "from": "从 ",
    "days": "天",
    "hours": "小时",
    "home": {
      "site_title": "Outdoor Index: 预订巴塔哥尼亚和智利的探险之旅",
      "things_to_do_in": "建议在",
      "scientific_excursions": "与大自然亲密接触",
      "luxury_experience": "专为您打造的独特体验",
      "adventure_excursions": "挑战自我",
      "the_best_excursions": "本季最佳旅游",
      "explore_your_interests": "探索您的兴趣",
      "excursions": "短途旅行",
      "products": "产品",
      "suggestions": "建议",
      "hard_adventurous": "活力",
      "soft_adventurous": "变革",
      "scientific": "发现",
      "family": "团体",
      "luxury": "精致",
      "promotions": "折扣与优惠",
      "download": "下载",
      "adventures_by_region": "按地区探险",
      "north_patagonia": "北巴塔哥尼亚",
      "south_patagonia": "南巴塔哥尼亚",
      "masonry_zone_count": "%{count} 项探险"
    },
    "masonry_zones": {
      "names": {
        "1": "百内国家公园",
        "2": "纳塔莱斯港",
        "3": "蓬塔阿雷纳斯",
        "4": "火地岛",
        "5": "威廉斯港",
        "6": "南极洲"
      }
    },
    "survey_page": {
      "title": "Outdoor Index - 售后调查",
      "description": "我们想知道您对我们服务的看法。您的反馈对我们非常重要。",
      "main_heading": "Outdoor Index 行程后调查"
    },
    "header": {
      "agency_panel": "代理面板",
      "supplier_panel": "供应商面板",
      "ask_us_a_question": "联系我们",
      "help": "常见问题",
      "itinerary": "行程",
      "sign_out": "退出",
      "sign_up": "注册",
      "log_in": "登录",
      "join_our_newsletter": "加入我们的通讯",
      "partner": "合作伙伴",
      "blog": "独家故事:",
      "your_blog": "您的博客 🔥",
      "config": "配置",
      "orders": "凭证",
      "cart": "购物车"
    },
    "header_cat": {
      "excursions": "短途旅行",
      "recommendations": "建议",
      "accommodation": "住宿",
      "other": "其他"
    },
    "agencies": {
      "address": "地址",
      "review": "评论",
      "agency_type": "运营商类型",
      "owner": "所有者",
      "holder_name": "持有人姓名",
      "holder_id": "持有人ID",
      "holder_email": "持有人电子邮件",
      "phone": "电话",
      "bank_name": "银行名称",
      "account_type": "账户类型",
      "account_number": "账号",
      "agency": "运营商",
      "country": "国家",
      "state": "州/省",
      "zone": "区域",
      "duration": "持续时间",
      "created_at": "创建于",
      "agency_info": "信息",
      "supplier_info": "信息",
      "products": "产品",
      "numbers": "数字",
      "excursions": "短途旅行",
      "list_title": "您的所有日期列表",
      "no_dates": "暂无日期，请点击日历创建。",
      "change_availability": "管理您的日期",
      "date_range": "根据日期范围修改",
      "set_price": "设定价格",
      "rooms_to_add": "添加房间",
      "rooms_to_remove": "删除房间",
      "products_to_add": "添加产品",
      "products_to_remove": "删除产品",
      "apply_changes": "应用更改",
      "edit_excerpt": "创建供应商资料所需的所有信息对于与 Outdoor Index 建立商业联系至关重要。请尽可能输入最可靠的信息。",
      "agency_information": "运营商信息",
      "supplier_information": "供应商信息",
      "max_words": "150 字",
      "for_booking": "用于预订",
      "supplier_review": "供应商评论 ",
      "website_url": "网站链接",
      "person_in_charge": "负责人",
      "name": "姓名",
      "update_info": "保存资料",
      "commercial_information": {
        "self": "商业信息",
        "name": "名称",
        "bank_name": "银行名称",
        "bank_account": "银行账户",
        "account_type": "账户类型",
        "commercial_name": "商业名称",
        "id_rut": "ID / Rut"
      },
      "actions": "操作",
      "manage_dates": "日期",
      "active": "已批准",
      "pending_changes": "待定",
      "index_excerpt": "这是您的产品列表。您可以创建、编辑和管理日期。创建的每个产品在 Outdoor Index 团队审核之前都将保持“待定”状态。",
      "manage_dates_excerpt": "这里有一个日历，您可以添加所有产品。您可以创建、编辑和管理日期。创建的每个产品在 Outdoor Index 团队审核之前都将保持“待定”状态。",
      "create_excursion": "创建短途旅行",
      "create_product": "创建产品",
      "create_activity": "创建活动",
      "create_post": "创建文章",
      "new_excursion_excerpt": "在这里您可以完成创建产品所需的所有必要信息。请确保您上传的照片具有良好的分辨率并能吸引游客。记得提供清晰可靠的信息。",
      "english": "翻译成英语 →",
      "spanish": "翻译成西班牙语 →",
      "create_agency": "创建新运营商",
      "agency_bank": "添加银行账户"
    },
    "error": {
      "sorry": "Sorry, this page doesn't exist.",
      "opps": "You may have mistyped the address or the page may have moved.",
      "go": "Go to homepage",
      "went_wrong": "We're sorry, but something went wrong.",
      "improvements": "If you see this message, it's because you may have typed the web address incorrectly or because we are updating the site with new features and improvements. Please wait a few minutes and reload the page again. Thank you!"
    },
    "excursions": {
      "itinerary": {
        "body": "正文"
      },
      "faq": {
        "body": "正文"
      },
      "title": "标题",
      "location": "地点",
      "zone": "区域",
      "category": "类别",
      "profiles": "旅行风格",
      "price": "价格（美元）",
      "vacancies": "空缺",
      "duration": "持续时间",
      "half_day": "半天",
      "full_day": "全天",
      "multiple_days": "多天",
      "duration_days": "天",
      "duration_hours": "小时",
      "days": {
        "zero": "天",
        "one": "天",
        "other": "天"
      },
      "hours": {
        "zero": "小时",
        "one": "小时",
        "other": "小时"
      },
      "add_images_(minimum_3)": "照片（至少 3 张）",
      "disclaimer": "免责声明",
      "description": "概述",
      "body": "我们的行程",
      "useful_information": "有用信息",
      "what's_included?": "包含",
      "what's_not_included?": "不包含",
      "meeting_instruction": "出发地点",
      "meeting_address": "地址",
      "policies": "政策",
      "save_excursion": "保存短途旅行",
      "what_we'll_do": "概述",
      "our_itinerary": "行程",
      "faqs": "常见问题",
      "images": "图片",
      "edit_excerpt": "创建供应商资料所需的所有信息对于与 Outdoor Index 建立商业联系至关重要。请尽可能输入最可靠的信息。",
      "other_excursions_from_this_tour_company": "来自此供应商的其他体验",
      "create_excursions": "创建短途旅行",
      "more": "更多",
      "less": "更少",
      "best_excursions_for_the_next_season": "本季推荐",
      "add_extras": "添加额外服务",
      "price_per_reservations": "每次预订价格",
      "extra_description": "活动",
      "macro_zone": "大区",
      "meta_title": "Meta 标题",
      "meta_description": "Meta 描述",
      "time": "时间",
      "prices": "价格",
      "included": "包含什么？",
      "locations": "位置",
      "alternative_names": "短途旅行也通过以下名称为人所知",
      "breadcrumb_catalog": "旅游线路与短途行程"
    },
    "hotels": {
      "twin": "Twin",
      "double": "Double",
      "double_twins": "Double twin",
      "room_reserved": "room reserved",
      "edit_your_booking": "Edit your booking"
    },
    "reservations": {
      "add_guest_details": "添加旅客信息",
      "traveler_data_card_title": "旅客信息",
      "traveler_data_badge_missing": "信息不全",
      "traveler_data_badge_complete": "已完成",
      "traveler_data_badge_ready_details": "信息就绪",
      "traveler_data_intro": "我们需要这些信息以确认您的预订。",
      "traveler_data_complete_button": "旅客信息",
      "detach_guest_confirm": "要从此预订中移除该旅客吗？",
      "guest_slots_full": "此预订已分配了全部旅客名额。",
      "organize_your_itinerary": "1) 行程 >",
      "create_your_travel_group": "2) 旅游团 >",
      "assign_tourists": "3) 分配游客",
      "new_checkout_excerpt": "就在这里，您可以找到您的产品清单。别忘了添加参与该短途旅行的客人的信息。购买前，请检查预订数量及其费用。记得阅读我们的取消政策。",
      "cart_title": "您的旅行信息",
      "checkout_page_title": "确认预订并完成付款",
      "checkout_page_intro": "请核对行程信息，填写旅客资料并选择付款方式。",
      "checkout_trip_summary_heading": "行程摘要",
      "pay_with": "支付方式",
      "cart_subtitle": "背包中的所有产品列表",
      "itinerary_excerpt": "在这里您可以找到所有产品的列表。继续下一步之前，请确保信息正确无误。重要提示：所有时间和日期均以当地时间显示。",
      "assign_excerpt": "在此部分中，您指明哪位旅客去哪个短途旅行。这样我们就拥有为您提供最佳体验所需的所有必要信息。",
      "list_of_products": "产品列表",
      "reservations_made": "#",
      "assing_tourists": "分配游客",
      "go_to_checkout": "继续",
      "a_list_of_all_your_reservations": "您的所有预订",
      "my_group": "我的团队",
      "people_(including_you)": "人数（包括您）",
      "(me)": "(我)",
      "team_member": "团队成员",
      "actions": "操作",
      "you_have_no_reservations": "您没有预订",
      "tourists_group": "在此部分中，您必须添加所有陪同人员的信息。所附信息尽可能可靠非常重要。",
      "edit_your_reservation": "编辑您的预订",
      "cancel_date": "取消日期",
      "departure_date": "出发日期",
      "reserves": "预订",
      "update": "更新",
      "not_enough": "不足",
      "too_many": "太多",
      "product_for": "产品用于",
      "tourists_assigned": "名游客已分配",
      "many_few_tourists": "分配的游客与预订数量不符",
      "select_your_extras": "选择您的额外服务：",
      "product_variants": "选项",
      "select_date_first": "先选择日期",
      "total_price": "总价",
      "see_details": "查看详情",
      "price_chilean": "智利居民总值：",
      "price_no_chilean": "非智利居民总值：",
      "single_supplement": "单人补差：",
      "people": "人数：",
      "details_of_purchase": "购买详情",
      "confirmed_excerpt": "感谢您与我们一起旅行！",
      "confirmed_excerpt_litle": "检查凭证以查看您的购买详情。",
      "cart_empty": "您的背包是空的"
    },
    "checkout": {
      "do_checkout": "结账",
      "confirm_checkout_excerpt": "在继续之前，请检查一切是否正确，一旦接受此订单，您将无法更改它。",
      "confirm_checkout_excerpt_2": "（您仍然可以创建新订单。）",
      "please_confirm_your_details": "请确认您的详细信息",
      "i_need_to_change_something": "我需要更改一些内容",
      "everything_looks_fine": "一切看起来都很好",
      "after_this_step": "此步骤之后，Outdoor Index 将联系所有提供商。",
      "providers_confirm_availability": "当所有提供商确认您的订单时，我们会与您联系。",
      "payment_excerpt": "购买前，请确保您产品的所有详细信息均正确无误。检查预订数量及其费用。记得阅读我们的取消政策。",
      "your_details_confirmation_and_payment": "您的产品和付款详情",
      "important!": "重要",
      "all_transactions_have_an_extra": "您可以使用借记卡或信用卡分期付款（与银行约定）。Outdoor Index 将收到全额销售款项。",
      "get_a_refund_if": "如果您在购买后 24 小时内取消，将获得退款。",
      "pay_now": "确认付款",
      "confirm_and_pay": "确认并付款",
      "wetravel_link_not_ready": "请稍候再试，或重新选择 WeTravel 以加载付款链接。",
      "mercado_wallet_not_ready": "Mercado Pago 按钮仍在加载，请几秒后再试。",
      "payment_summary": "付款摘要",
      "payment_method_title": "付款方式",
      "payment_methods_locked_until_traveler_details": "请选择付款方式前先完成旅客资料。",
      "payment_method_recommended": "推荐",
      "payment_method_blurb": {
        "wetravel": "以美元进行国际支付",
        "mercado_pago": "本地银行卡支付，分期以银行为准",
        "webpay": "通过 Webpay 使用银行卡支付",
        "payu": "使用 PayU 支付",
        "paypal": "使用 PayPal 支付",
        "google_pay": "使用 Google Pay 支付",
        "apple_pay": "使用 Apple Pay 支付"
      },
      "total_to_pay": "应付总额",
      "secure_payment_note": "100% 安全加密付款",
      "help_widget_title": "需要协助吗？",
      "help_widget_body": "与 Outdoor Index 向导沟通，获得个性化协助。",
      "help_widget_cta": "联系专员",
      "help_widget_online": "在线",
      "terms_toggle_line_html": "我同意%{terms}和%{policy}。",
      "terms_toggle_word_terms": "条款",
      "terms_toggle_word_policy": "政策",
      "review": "审查",
      "ready": "准备就绪",
      "choose_payment": "选择您想要的付款方式",
      "only_for_reservation": "预订",
      "complete_payment": "全额付款",
      "30_p": "30%",
      "30_per": "已付 30%",
      "30_pers": "已付 30%",
      "100_p": "100%",
      "100_per": "已付 100%",
      "100_pers": "已付 100%",
      "i_hereby_accept": "点击“确认付款”，即表示您同意我们的",
      "and_confirm": "并确认您已阅读并理解我们的",
      "and_our": "和我们的",
      "your_itinerary": "您的详细行程",
      "continue_shopping": "继续购物",
      "not_available": "不可用",
      "disclaimer": "关于您的预订",
      "some_products_deleted": "某些产品不再可用",
      "accept": "是的，接受",
      "cancel": "取消",
      "must_have_tourist": "您必须至少有 1 名添加了电子邮件和电话号码的游客。",
      "wetravel_partial_error": "由于出发日期太近，无法使用部分付款。请选择全额付款。"
    },
    "vouchers": {
      "active_excerpt": "这是您的凭证详情。请查看并打印它们。有必要提供凭证以及预订的订单号。",
      "all_of_your_vouchers": "您的所有凭证",
      "confirmed_excerpt": "感谢您的购买。要把有一个美好的旅程。别忘了打印您的凭证并随身携带。如果您有任何问题或意外情况，请随时联系我们。",
      "active_vouchers": "有效凭证",
      "disclaimer": "在此 PDF 中，您拥有有关您产品的所有信息。请检查文件，如果您有任何问题，请联系我们。祝您旅途愉快。",
      "get_your_voucher": "获取您的凭证",
      "voucher": "凭证",
      "payment_error": "付款错误。",
      "error": "您的付款流程出了点问题，请稍后重试或联系我们以获取其他付款方式。",
      "restart_payment": "重新开始付款",
      "payment_rejected": "付款被拒绝",
      "rejected": "PayU/Paypal 提示您的付款被拒绝，请检查您的详细信息并重试，或联系我们以获取其他付款方式。",
      "home": "主页",
      "order_number": "订单号：",
      "view": "查看",
      "print": "打印",
      "complete": "完成",
      "incomplete": "未完成",
      "activities": "活动",
      "was_partial_payment": "(2)"
    },
    "categories": {
      "search": "搜索",
      "general": "通用",
      "general_category_search": "%{category_name} 通用搜索",
      "other_excursions_to_do": "在 %{zone_name} 可以做的其他体验",
      "general_zone_search": "在 %{zone_name} 的搜索建议",
      "recommended_for_you": "在 %{zone_name} 的体验"
    },
    "tourist": {
      "new_tourist_excerpt": "在此部分中，您可以添加所有陪同人员的个人资料信息。所附信息尽可能可靠非常重要。",
      "personal_info": "个人信息",
      "checkout_minimum_one_pax_notice": "继续操作只需填写一位旅客的完整信息，其余可稍后再补。",
      "add_another_pax": "添加另一位旅客",
      "info_pax_card_title": "旅客信息",
      "name": "名字",
      "last_name": "姓氏",
      "date_of_birth": "出生日期",
      "nationality": "国籍",
      "passport": "护照",
      "hometown": "家乡",
      "phone": "电话",
      "email": "电子邮件",
      "emergency_contact": "紧急联系人",
      "allergies": "过敏",
      "medical_conditions": "医疗状况",
      "food_restrictions": "食物限制",
      "pending": "待定",
      "ready": "就绪",
      "you_have_no_vouchers": "您没有有效凭证",
      "no_reservations_to_assign": "没有可分配的预订"
    },
    "footer": {
      "about_us": "关于我们",
      "statement": "阅读我们的使命声明",
      "go_to_suscribe": "去订阅",
      "suscribe_text": "我们每两周发送一次关于新故事和旅游折扣的更新",
      "terms_&_conditions": "条款",
      "privacy_&_cookies": "隐私",
      "contact_us": "联系我们",
      "edit_endorsement": "Outdoor Index 总部位于纳塔莱斯港（智利南巴塔哥尼亚），拥有 40 多家供应商的支持。",
      "all_rights_reserved": "版权所有。未经许可，不得复制本网站的任何部分。",
      "spanish": "西班牙语",
      "english": "英语",
      "portuguese": "葡萄牙语",
      "french": "法语",
      "german": "德语",
      "english_corto": "英",
      "spanish_corto": "西",
      "portuguese_corto": "葡",
      "french_corto": "法",
      "german_corto": "德",
      "clp": "$ 智利比索 (CLP)",
      "usd": "$ 美元 (USD)",
      "survey": "调查",
      "endorsement": {
        "support_local_comunity": "支持本地，鼓励可持续性",
        "when_you_buy": "在 Outdoor Index 购买时，您鼓励 35+ 本地供应商进行优质和可持续的管理。",
        "instant_booking": "认证向导 100% 可为您提供帮助",
        "by_entering_your": "在您的体验之前、期间和之后解决您的疑问并帮助规划您的下一次冒险。",
        "payment_protection": "现在只需支付 30%。其余的稍后",
        "we_comply_with_all": "让您的计划更轻松，无需支付过多费用，现在只需支付 30% 即可确认您的预订，其余费用在临近日期时支付。"
      },
      "covid": "Covid",
      "secure": "通过本网站处理的所有预订均受我们的主要合作伙伴保护。",
      "titles": {
        "book": "放心预订",
        "destinations": "热门目的地",
        "activities": "热门活动"
      },
      "lang-currency": "语言和货币"
    },
    "chat": {
      "hi": "你好",
      "our_chat_service": "我们的聊天服务时间为周一至周五上午 10 点至下午 6 点 (UTC / GMT -3)。如果您在这些时间内给我们写信，我们将会在几分钟内回复您。",
      "new-message": "新消息",
      "messages": "消息",
      "enter_your_name": "输入您的姓名...",
      "enter_email": "输入您的电子邮件...",
      "enter_message": "输入消息...",
      "create_message": "发送消息",
      "begin": "开始",
      "user": "用户",
      "need_help": "需要帮助？",
      "talk_to_local_guide": "与当地导游交谈"
    },
    "registration": {
      "edit_user": "编辑用户",
      "email": "电子邮件",
      "name": "名字",
      "lastname": "姓氏",
      "confirm_password": "确认密码",
      "current_password": "当前密码",
      "new_password": "新密码",
      "profile_picture": "个人资料图片",
      "profiles": "个人资料（选择一个或多个）",
      "interests": "兴趣（选择一个或多个）",
      "notification": "通知设置",
      "save_settings": "保存",
      "update_account": "更新帐户",
      "registration_excerpt": "按您想要的方式管理您的个人资料。启用或禁用您的通知。这样，您将能够自定义从 Outdoor Index 接收的内容。",
      "vouchers": "凭证",
      "all_vouchers": "所有凭证",
      "change_your_password": "重置或更改密码",
      "change_my_password": "更改密码",
      "confirm_new_password": "确认密码",
      "subtitle_password": "创建一个至少包含 8 个字符（包括字母和数字）的新密码。",
      "password_requirements": "密码无效。",
      "passwords_dont_match": "密码不匹配。"
    },
    "responsive": {
      "more": "More..."
    },
    "uploader": {
      "upload_a_file": "Upload a file",
      "drop_files_here": "Drop files here",
      "processing_dropped_files": "Processing dropped files..."
    },
    "sidebar_single": {
      "no_dates_available": "没有可用日期",
      "disclaimer": "现在只需支付 <strong>总预订金额的 30%</strong> 即可锁定您的位置。",
      "select_dates": "立即预订",
      "share": "对短途旅行有疑问？",
      "to_make_a": "要进行预订，请 ",
      "log_in": "登录",
      "or": "或",
      "sign_up": "注册",
      "if_you_are": "如果您是新用户。",
      "price_for": "每人",
      "from": "价格起",
      "contact_viewnia": "联系我们",
      "rates": "CLP 费率含增值税。USD 费率不含增值税；外国非居民以 USD 支付可免税。"
    },
    "request_form": {
      "title": "Request Excursion",
      "contact_viewnia_subtitle": "Fill the form below to begin the process that will allow us to coordinate your excursion with our field specialist."
    },
    "modal_manage_date": {
      "discount": "Add a discount",
      "manage_date": "Manage date",
      "date": "Date",
      "starting_time": "Starting time",
      "price": "Price",
      "vacancies": "Vacancies",
      "save": "Save",
      "cancel_date": "Cancel date",
      "available_ammount": "Available amount",
      "month_form": {
        "edit_month": "Edit month",
        "delete_month": "Delete month",
        "populate_month": "Populate Month",
        "disclaimer_1": "You are about to edit <strong>an entire month</strong>, this action is <strong>hard to reverse</strong>.",
        "disclaimer_2": "Please double check your current calendar before you proceed, in order to avoid duplicates or other problems.",
        "accept": "Accept",
        "month": "Month",
        "week_days": "Week days",
        "continue": "Continue",
        "final_notice_header": "Please read carefully:",
        "final_notice_1": "Add a departure date for excursion <strong id='fn_title'></strong>, every <strong id='fn_week_days'></strong>  of <strong id='fn_month'></strong>.",
        "final_notice_2": "Each departure will start at <strong><span id='fn_starting_time_4i'></span>:<span id='fn_starting_time_5i'></span></strong>, have <strong id='fn_vacancies'></strong> and discount <strong id='fn_discount'></strong>.",
        "confirm": "Save",
        "back": "Back",
        "delete_month_disclaimer": "You are about to delete all departures for the following month, this action is <strong>irreversible</strong>.",
        "vacancies": "vacantes"
      }
    },
    "checkout_bar": {
      "itinerary": "行程",
      "tourists": "团队",
      "assign_tourists": "分配",
      "checkout": "付款",
      "voucher": "凭证"
    },
    "reviews": {
      "title": "评论",
      "more": "更多",
      "reviewing_excursion": "评论产品",
      "thanks_for_submitting": "感谢您提交评论",
      "review": "评论",
      "footer": "在 Trustpilot 上查看"
    },
    "newsletter": {
      "sign_up_at": "巴塔哥尼亚的探险旅游市场",
      "we_value_your_privacy": "可持续、个性化且充满冒险的体验供您享受",
      "sign_up_now": "立即注册",
      "view_preferences": "偏好",
      "subscribe_to_our": "订阅我们的通讯",
      "email_address": "电子邮件地址",
      "subscribe": "订阅",
      "we_are_travel_and_growth": "探索智利及其风景，体验最好的旅游和短途旅行。在令人难忘的环境中体验当地生活，做您喜欢做的事。"
    },
    "modal": {
      "first_section": "选择日期",
      "product_variants": "选择选项",
      "second_section": "乘客",
      "no_daily_quota": "今天没有足够的座位",
      "date": "日期",
      "wrong_name": "错误的名称或密码",
      "per_person": " 每人",
      "departure_time": "出发时间:",
      "spot_left": "剩余名额",
      "add_reserves": "客人数",
      "select": "选择",
      "select_date": "选择日期",
      "select_date_text": "在日历上选择可用日期，然后按照步骤生成您的预订。",
      "check_in": "入住",
      "check_out": "退房",
      "guests": "客人",
      "child_guests": "儿童",
      "guest_text": "13 岁及以上",
      "guest": "客人",
      "child_text": "12 岁及以下",
      "twins": "双床",
      "doubles": "大床",
      "doubles_twin": "2 张双床",
      "add_rooms_for": "为您的添加房间",
      "add_to_itinerary": "选择",
      "start": "开始",
      "ends": "结束",
      "leave_your_review": "留下您的评论",
      "describe_your_experience": "描述整体体验",
      "add": "添加",
      "next": "下一步",
      "load_earlier_dates": "加载更早的日期 ...",
      "load_later_dates": "加载更晚的日期 ...",
      "is_resident": "智利居民",
      "is_not_resident": "非智利居民",
      "language_title": "选择国家和货币",
      "language_subtitle": "从列表中选择您的语言",
      "currency_subtitle": "选择您的货币",
      "current_language": "国家和语言",
      "other_languages": "其他国家和语言"
    },
    "alert": {
      "invalid_changes": "无效更改",
      "invalid_action": "无效操作：金额不能低于 0",
      "not_enough_availability": "该日期范围内没有足够的可用性。请检查其他住宿或预订更少的单位。",
      "something_went_wrong": "出了点问题。请重试或联系我们。",
      "review_already_submitted": "评论已提交",
      "couldn't_send_review": "无法发送评论",
      "you_must_agree_to": "您必须同意我们的条款和条件",
      "no_products_in_your_order": "您的订单中没有产品",
      "please_sign_the_waiver": "请用您的名字签署弃权书。",
      "signature_and_tourist": "签名和游客姓名必须一致。",
      "couldn't_save": "无法保存，请稍后重试。",
      "invalid_language": "无效语言",
      "confirm_to": "您必须确认您不是机器人。",
      "error": "密码必须至少包含 8 个字符，一个字母和一个数字。"
    },
    "notice": {
      "your_account_has": "您的帐户没有代理机构，请联系我们",
      "session_expired": "会话已过期，请登录。",
      "changes_submitted": "更改已提交！",
      "new_product_created": "新产品已创建，等待批准",
      "invalid_request": "无效请求。请重试或联系我们。",
      "have_excursions": "该代理机构有短途旅行，请在删除之前将其分配给另一个代理机构",
      "updated_information": "信息已更新",
      "date_no_longer": "日期不再可用",
      "availability_updated": "可用性已更新",
      "review_sent": "评论已发送！",
      "bookings_made_for": "您的预订已成功！",
      "profile_picture_updated": "头像已更新！",
      "tourist_information_saved": "您的信息已保存",
      "enabled": "已启用",
      "diabled": "已禁用",
      "was": "是",
      "settings_updated": "设置已更新！",
      "language_updated": "语言已更新！",
      "account_updated": "帐户已更新！",
      "reserves_added_for": " 已添加预订 ",
      "product_was_enabled": "产品已启用",
      "product_was_disabled": "产品已禁用"
    },
    "more": {
      "the_best_products": "Outdoor Index 最佳体验",
      "all_recommendations_in_puerto_natales": "纳塔莱斯港的所有体验",
      "all_recommendations_in_punta_arenas": "蓬塔阿雷纳斯的所有体验",
      "all_recommendations_in_zone": "%{zone_name} 的所有建议",
      "all_adventure_products": "所有探险体验",
      "all_standard_products": "所有变革性体验",
      "all_scientific_products": "所有发现体验",
      "all_family_products": "所有家庭/团体体验",
      "all_luxury_products": "所有精致体验",
      "all_promotions_products": "所有折扣和优惠体验",
      "all_ota_products": "所有 OTA 体验",
      "a_selection_of_the_best": "Outdoor Index 精选",
      "other_activities_that": "补充您体验的其他活动",
      "all_north_patagonia_products": "所有北巴塔哥尼亚产品",
      "all_south_patagonia_products": "所有南巴塔哥尼亚产品",
      "all_lagos_region_products": "所有湖泊与河流区产品"
    },
    "searches": {
      "no_result_to": "抱歉，在“%{zone_name}”中找不到“%{category_name}”的结果",
      "recommended_for_you": "在“%{zone_name}”的体验",
      "category_products_in_zone": "在“%{zone_name}”的“%{category_name}”体验",
      "category_products_in_zone_no_result": "抱歉，在“%{zone_name}”暂时没有“%{category_name}”体验",
      "all_products_in_zone": "“%{zone_name}”的所有体验",
      "all_products_in_zone_no_result": "抱歉，“%{zone_name}”暂时没有体验",
      "all_category_products": "所有“%{category_name}”体验",
      "all_category_products_no_result": "抱歉，暂时没有“%{category_name}”体验",
      "please_select_category_or_zone": "请选择类别或区域"
    },
    "guidebook": {
      "download_our_guide_book": "下载我们的指南，开始您的 Outdoor Index 之旅",
      "find_out_everything": "了解有关智利南部巴塔哥尼亚的一切。"
    },
    "banner": {
      "do_you_need_travel_insurance": "需要旅游保险吗？",
      "in_partnership_with_world": "Outdoor Index 与 World Nomads 合作，为您提供智利巴塔哥尼亚最好的保险。",
      "get_a_quote": "获取报价"
    },
    "blog": {
      "meta_title": "智利旅行、自然与探险博客 | Outdoor Index",
      "meta_description": "探索智利旅行指南、贴士与灵感，发现户外短途行程，亲近自然，体验冒险之旅。",
      "travel_nature_growth": "旅行、自然与成长",
      "we_connect_you_with": "关于自然、旅行和成长的全球内容。在社交媒体上关注我们！",
      "breadcrumb_aria": "面包屑导航",
      "breadcrumb_home": "首页",
      "breadcrumb_blog": "博客",
      "guided_tours": "导览游",
      "book_now": "立即预订",
      "view_more_activities": "查看更多活动",
      "showing_count": "显示 %{loaded} / %{total} 篇文章",
      "pagination_aria": "博客分页",
      "page_n": "第 %{n} 页"
    },
    "mail": {
      "welcome_user_name": "%{user_name}，欢迎来到 Outdoor Index",
      "leave_your_review": "%{user_name}，留下您的体验评论",
      "voucher": {
        "your_order_is_ready": "感谢您的购买，您的订单号是 %{reference_code}",
        "your_sold_product": "你好 %{user_provider}，我们已售出您的一个体验",
        "new_sold": "新销售 %{reference_code}"
      }
    },
    "paypal": {
      "description": "Outdoor Index: 支付订单 %{reference_code}"
    },
    "payu": {
      "description": "Outdoor Index: 支付订单 %{reference_code}"
    },
    "pdf": {
      "emergency_contacts": "紧急联系人",
      "congratulations_user_name": "恭喜 %{user_name}",
      "congratulations_agency_name": "恭喜 %{agency_name}",
      "here_we_attach": "我们在此附上您旅行的所有信息。在此凭证中，您将看到产品详情、供应商联系方式、已签署的免责声明，以及您的付款收据（Paypal 或 PayU）。如有任何疑问，请随时联系我们。",
      "reservation_number": "预订编号:",
      "product_detail": "产品详情",
      "departure": "出发",
      "your_suppliers": "您的供应商",
      "in_this_section_appear": "此部分包含 Outdoor Index 收到的付款详情。请记得打印此凭证并随身携带。非常感谢您选择 Outdoor Index",
      "payments_detail": "付款详情",
      "initial_payment": "首付款",
      "payment_method": "付款方式",
      "total_paid": "已付总额",
      "total_order": "订单总额:",
      "order_date": "订单日期",
      "payment_date": "付款日期",
      "payment_type": "付款类型",
      "payment_complete": "付款完成",
      "print_this_voucher": "打印此凭证并随身携带",
      "at_all_times": "在整个旅程中。",
      "you_check": "办理登机手续时请出示。",
      "we_have_received": "我们已收到您的产品预订请求。以下是其详细信息和乘客信息。从现在起，您可以直接联系您的乘客，或者如果您愿意，可以指示 Outdoor Index 联系。建议发送电子邮件通知预订已成功。您将作为优秀供应商脱颖而出。记得在您自己的系统中更新预订配额，以免出现超售问题。干得好！",
      "guests": "客人",
      "your_guests": "您的客人",
      "date_of_birth": "出生日期:",
      "origin": "籍贯:",
      "document_number": "证件号码:",
      "phone": "电话",
      "email": "电子邮件",
      "emergency_number": "紧急电话:",
      "allergies": "过敏:",
      "medical_conditions": "医疗状况:",
      "food_restrictions": "饮食限制:",
      "dear_user_name": "亲爱的 %{user_name}",
      "service_confirmation": "服务确认",
      "according_to_the_reservation": "根据您的预订请求，我们确认以下信息：",
      "reference_code": "参考代码",
      "activity": "活动",
      "starting_point": "地点",
      "starting_date": "开始日期",
      "starting_time": "开始时间",
      "client": "客户",
      "excursion": "活动 %{number}",
      "payment_details": "付款详情",
      "applied": "已应用",
      "next_payment": "下次付款 (70%)",
      "purchase_date": "购买日期",
      "description": "描述",
      "unit_price": "单价",
      "unit_price_child": "儿童单价",
      "childen_pax": "儿童",
      "pax": "人数",
      "tax": "税",
      "about_your_host": "关于您的房东",
      "name": "负责人:",
      "address": "地址:",
      "from": "服务开始日期",
      "to": "服务结束日期",
      "tourists": "游客信息",
      "guest": "客人",
      "child_guest": "儿童",
      "guest_price": "客人价格",
      "child_guest_price": "儿童价格",
      "resident": "居民",
      "no_resident": "非居民",
      "problem_with_order": "订单有问题？",
      "complete_remaining_payment_web": "如需支付余款，请登录 outdoorindex.cl 账户，在凭证中打开此订单。",
      "contact_us": "联系我们",
      "guest_s": "客人",
      "child_guests": "儿童",
      "child_guest_s": "儿童"
    },
    "currency": {
      "displaying_prices_in": "货币兑换完成！"
    },
    "tourists": {
      "first_create_group": "哎呀！别忘了填写乘客信息。"
    },
    "date": {
      "formats": {
        "default": "%Y/%m/%d",
        "short": "%Y年%b%e日",
        "long": "%Y年%B%d日",
        "calendar_picker": "YYYY/MM/DD",
        "fixed_departure": "YYYY/M/DD",
        "moment": "%Y-%m-%d"
      }
    },
    "time": {
      "formats": {
        "default": "%Y/%m/%d",
        "short": "%Y年%b%e日",
        "long": "%Y年%B%d日",
        "full": "%Y年%B%d日 %a",
        "calendar_picker": "YYYY/MM/DD"
      }
    },
    "activities": {
      "trekking": "徒步",
      "horseback": "骑马",
      "birdwatching": "观鸟",
      "mountaineering": "登山",
      "icehike": "冰川徒步",
      "kayak": "皮划艇",
      "flyfishing": "飞蝇钓",
      "navigations": "航海",
      "cruises": "游轮",
      "helicopter": "直升机",
      "multiactivity": "多项活动",
      "photosafari": "摄影游猎",
      "bikes": "自行车",
      "snowshoes": "雪鞋行走",
      "ski": "滑雪",
      "rafting": "漂流"
    },
    "filters": {
      "clear_filters": "清除筛选"
    },
    "lang": {
      "countries": {
        "spain": "西班牙",
        "argentina": "阿根廷",
        "bolivia": "玻利维亚",
        "chile": "智利",
        "colombia": "哥伦比亚",
        "costa_rica": "哥斯达黎加",
        "ecuador": "厄瓜多尔",
        "mexico": "墨西哥",
        "peru": "秘鲁",
        "paraguay": "巴拉圭",
        "uruguay": "乌拉圭",
        "united_states": "美国",
        "england": "英国",
        "australia": "澳大利亚",
        "canada": "加拿大",
        "new_zealand": "新西兰",
        "ireland": "爱尔兰",
        "portugal": "葡萄牙",
        "brazil": "巴西",
        "france": "法国",
        "germany": "德国",
        "china": "中国",
        "hong_kong": "香港",
        "japan": "日本",
        "korea": "韩国",
        "singapore": "新加坡",
        "taiwan": "台湾"
      }
    }
  },
  "ja": {
    "terms": {
      "head": {
        "conditions": "利用規約",
        "privacy": "プライバシーポリシー",
        "cookies": "Cookieポリシー",
        "you_as_a_consumer": "消費者であるあなたには、計画通りに旅行を実行するために必要となる可能性のある書類について知る権利があります。パスポート、ビザ、ワクチン、未成年者の許可、その他の書類が必要かどうか、チリに入国するため、または旅行中に通過する他の国に入国するために必要かどうかを事前に確認してください。これらのいずれかが必要で、それを持っていない場合は、事前にそれらを取得するために必要な手順を完了してください。"
      }
    },
    "devise": {
      "google_sign_in": "Googleでログイン",
      "facebook_sign_in": "Facebookでログイン",
      "apple_sign_in": "Appleでログイン",
      "already_have_an_account?": "アカウントをお持ちですか？",
      "didn''t_receive_confirmation_instructions?": "確認手順を受け取っていませんか？",
      "didn''t_receive_unlock_instructions?": "ロック解除手順を受け取っていませんか？",
      "forgot_your_password?": "パスワードをお忘れですか？",
      "don''t_have_an_account?": "アカウントをお持ちではありませんか？",
      "enter_email_associated": "アカウントに関連付けられているメールアドレスを入力すると、パスワードをリセットするためのリンクがメールで送信されます。",
      "passwordless": {
        "not_found_in_database": "そのメールアドレスのユーザーが見つかりませんでした",
        "magic_link_sent": "ログインリンクがメールアドレスに送信されました。リンクをクリックしてアカウントにログインしてください。",
        "magic_link_sent_paranoid": "アカウントが存在する場合は、ログインリンクが記載されたメールが届きます。リンクをクリックしてアカウントにログインしてください。"
      },
      "confirmations": {
        "confirmed": "メールアドレスが正常に確認されました。",
        "send_instructions": "数分以内にメールアドレスの確認方法を記載したメールが届きます。",
        "send_paranoid_instructions": "メールアドレスがデータベースに存在する場合は、数分以内にメールアドレスの確認方法を記載したメールが届きます。"
      },
      "failure": {
        "magic_link_invalid": "無効または期限切れのログインリンクです。",
        "already_authenticated": "すでにログインしています。",
        "inactive": "アカウントはまだ有効化されていません。",
        "invalid": "%{authentication_keys} またはパスワードが無効です。",
        "locked": "アカウントはロックされています。",
        "last_attempt": "アカウントがロックされるまで、あと1回試行できます。",
        "not_found_in_database": "%{authentication_keys} またはパスワードが無効です。",
        "timeout": "セッションが期限切れになりました。続行するにはもう一度ログインしてください。",
        "unauthenticated": "続行するには、ログインまたは登録する必要があります。",
        "unconfirmed": "続行するには、メールアドレスを確認する必要があります。"
      },
      "mailer": {
        "magic_link": {
          "subject": "ログインリンク",
          "greeting": "こんにちは %{email}さん！",
          "instructions": "以下のリンクからログインできます：",
          "login_button": "アカウントにログイン",
          "expiration_notice": "リンクは %{expiration_time} で期限切れになりますのでご注意ください。"
        },
        "confirmation_instructions": {
          "subject": "確認手順"
        },
        "reset_password_instructions": {
          "subject": "パスワードのリセット手順"
        },
        "unlock_instructions": {
          "subject": "ロック解除手順"
        },
        "email_changed": {
          "subject": "メールアドレスが変更されました"
        },
        "password_change": {
          "subject": "パスワードが変更されました"
        }
      },
      "omniauth_callbacks": {
        "failure": "\"%{reason}\" のため、%{kind} から認証できませんでした。",
        "success": "%{kind} アカウントから正常に認証されました。"
      },
      "passwords": {
        "no_token": "パスワードリセットメールからアクセスしない限り、このページにはアクセスできません。パスワードリセットメールからアクセスしている場合は、提供された完全なURLを使用していることを確認してください。",
        "send_instructions": "数分以内にパスワードのリセット方法を記載したメールが届きます。",
        "send_paranoid_instructions": "メールアドレスがデータベースに存在する場合は、数分以内にパスワード復元リンクがメールアドレスに送信されます。",
        "updated": "パスワードが正常に変更されました。現在ログインしています。",
        "updated_not_active": "パスワードが正常に変更されました。"
      },
      "registrations": {
        "destroyed": "さようなら！アカウントは正常にキャンセルされました。またのご利用をお待ちしております。",
        "signed_up": "ようこそ！登録が完了しました。",
        "signed_up_but_inactive": "登録が完了しました。ただし、アカウントがまだ有効化されていないため、ログインできませんでした。",
        "signed_up_but_locked": "登録が完了しました。ただし、アカウントがロックされているため、ログインできませんでした。",
        "signed_up_but_unconfirmed": "確認リンクを含むメッセージがメールアドレスに送信されました。リンクをクリックしてアカウントを有効にしてください。",
        "update_needs_confirmation": "アカウントは正常に更新されましたが、新しいメールアドレスを確認する必要があります。メールを確認し、確認リンクをクリックして、新しいメールアドレスを確認してください。",
        "updated": "アカウントが正常に更新されました。"
      },
      "sessions": {
        "signed_in": "ログインしました。",
        "signed_out": "ログアウトしました。",
        "already_signed_out": "ログアウトしました。"
      },
      "unlocks": {
        "send_instructions": "数分以内にアカウントのロック解除方法を記載したメールが届きます。",
        "send_paranoid_instructions": "アカウントが存在する場合は、数分以内にアカウントのロック解除方法を記載したメールが届きます。",
        "unlocked": "アカウントのロックが正常に解除されました。続行するにはログインしてください。"
      }
    },
    "errors": {
      "something_went_wrong": "問題が発生しました",
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "受け入れる必要があります",
        "blank": "空白にすることはできません",
        "confirmation": "%{attribute} と一致しません",
        "empty": "空にすることはできません",
        "equal_to": "%{count} と等しくなければなりません",
        "even": "偶数でなければなりません",
        "exclusion": "予約されています",
        "greater_than": "%{count} より大きくなければなりません",
        "greater_than_or_equal_to": "%{count} 以上でなければなりません",
        "inclusion": "リストに含まれていません",
        "invalid": "無効です",
        "less_than": "%{count} より小さくなければなりません",
        "less_than_or_equal_to": "%{count} 以下でなければなりません",
        "model_invalid": "検証に失敗しました: %{errors}",
        "not_a_number": "数字ではありません",
        "not_an_integer": "整数でなければなりません",
        "odd": "奇数でなければなりません",
        "other_than": "%{count} 以外でなければなりません",
        "present": "空白でなければなりません",
        "required": "存在する必要があります",
        "taken": "すでに使用されています",
        "must_contain_number": " 少なくとも1つの数字を含める必要があります",
        "must_contain_special": " 特殊文字を含める必要があります",
        "must_contain_lower": " 少なくとも1つの小文字を含める必要があります",
        "must_contain_upper": " 少なくとも1つの大文字を含める必要があります",
        "too_long": {
          "one": "長すぎます（最大1文字）",
          "other": "長すぎます（最大%{count}文字）"
        },
        "too_short": {
          "one": "短すぎます（最小1文字）",
          "other": "短すぎます（最小%{count}文字）"
        },
        "wrong_length": {
          "one": "長さが間違っています（1文字である必要があります）",
          "other": "長さが間違っています（%{count}文字である必要があります）"
        },
        "already_confirmed": "すでに確認されています。ログインしてみてください",
        "confirmation_period_expired": "%{period} 以内に確認する必要があります。新しくリクエストしてください",
        "expired": "期限切れです。新しくリクエストしてください",
        "not_found": "見つかりません",
        "not_locked": "ロックされていませんでした",
        "not_saved": {
          "one": "1つのエラーにより、この %{resource} を保存できませんでした：",
          "other": "%{count} 個のエラーにより、この %{resource} を保存できませんでした："
        }
      }
    },
    "meta_tags": {
      "default": {
        "description": "アウトドア・インデックスで、特別な冒険プログラムと専門ガイドによるチリ旅行を見つけましょう。ユニークな体験を！忘れられない旅を予約しましょう。",
        "keywords": "パタゴニア, チリ, アドベンチャーツアー, パタゴニアアドベンチャーツアー, チリアドベンチャーツアー, トーレス・デル・パイネツアー, パタゴニアハイキングツアー, パタゴニアカヤックツアー, パタゴニア乗馬ツアー, パタゴニアマルチスポーツツアー, パタゴニア家族向けアドベンチャーツアー, パタゴニア豪華アドベンチャーツアー, パタゴニア格安アドベンチャーツアー, パタゴニア最高のアドベンチャーツアー, パタゴニアアドベンチャー旅行, パタゴニアアドベンチャーアクティビティ, パタゴニアアドベンチャーエクスカーション, パタゴニアアドベンチャープログラム",
        "name": "Outdoor Index"
      },
      "help": {
        "title": "Outdoor Index - ヘルプ",
        "description": "パタゴニア旅行について質問がありますか？Outdoor Indexにアクセスして、現地のガイドや分野の専門家に相談してください。",
        "keywords": null
      }
    },
    "views": {
      "pagination": {
        "truncate": "…"
      }
    },
    "activerecord": {
      "models": {
        "season": "シーズン",
        "seasons": "シーズン"
      },
      "attributes": {
        "season": {
          "name": "名前",
          "valid_from": "有効開始日",
          "valid_until": "有効終了日",
          "start_time": "開始時間",
          "product": "エクスカーション",
          "mon_check": "月",
          "tue_check": "火",
          "wed_check": "水",
          "thu_check": "木",
          "fri_check": "金",
          "sat_check": "土",
          "sun_check": "日"
        },
        "order": {
          "clp_charge": "CLP料金",
          "usd_charge": "USD料金",
          "username": "クライアント:",
          "email": "メール:",
          "product": "商品:",
          "product_name": "商品",
          "pax_manual": "人数:",
          "manual_total": "支払済:",
          "manual_currency": "通貨:",
          "partial_payment": "支払い:",
          "payment_method": "方法:",
          "channel": "チャネル:",
          "confirmed_at": "購入:",
          "departure_at": "出発:",
          "starting_datetime": "出発時間:",
          "customer_phone": "電話:",
          "extra": "追加:",
          "instructions": "指示:",
          "language": "言語:",
          "weather_link": "天気リンク",
          "post_link": "投稿リンク",
          "itinerary_document": "旅程ドキュメント",
          "show_itinerary_document": "表示"
        }
      }
    },
    "promotions": {
      "coupon_code_ok": "クーポンコードが正常に適用されました",
      "coupon_code_error": "クーポンコードが存在しません",
      "coupon_code_already": "クーポンコードはすでに適用されています",
      "coupon_code_max": "注文ごとに最大1つのクーポン（コード）",
      "coupon_code_destroy_ok": "コードが正常に削除されました",
      "coupon_code_destroy_error": "コードを削除できませんでした",
      "coupon_code_destroy_confirm": "本当に削除してもよろしいですか？",
      "coupon_have_a_coupon": "割引クーポンをお持ちですか？",
      "coupon_form_palceholder": "割引コード",
      "coupon_apply": "適用"
    },
    "home_collections": {
      "home_reviews": "毎年350人以上がOutdoor Indexで旅行しています",
      "find_your_experience": "体験を見つける",
      "carousel_region": "地域別アドベンチャー",
      "carousel_activities": "アクティビティ別アドベンチャー",
      "carousel_time_preference": "時間設定別アドベンチャー",
      "sub-landing": "Outdoor Indexでチリの最高の観光オプションを見つけてください。アタカマからパタゴニアまで、さまざまなプログラムを比較して探索してください。今すぐ予約して、ユニークな体験をしましょう！",
      "title": "チリとパタゴニアのアドベンチャーツアー",
      "subtitle": "最高の地元ガイドと一緒に冒険を見つける"
    },
    "products_search": {
      "activities": "アクティビティ",
      "regions": "地域",
      "time": "時間",
      "date": "日付",
      "date_sub_label": "いつ行きたいですか？",
      "activities_sub_label": "お気に入りのアクティビティを選択",
      "regions_sub_label": "どの地域を訪問したいですか？",
      "time_sub_label": "時間設定を選択してください！",
      "all_adventures": "すべてのアドベンチャー",
      "search_placeholder": "チリ全体で冒険を検索",
      "most_popular_searches": "人気の検索",
      "see_all_adventures": "すべての冒険を見る",
      "help_me_choose": "選ぶのを手伝ってください",
      "help_me_choose_url": "https://api.whatsapp.com/send?phone=56981785011&text=Hi%2C%20I%20need%20help%20choosing%20an%20adventure",
      "popular_search_items": {
        "circuito_w": {
          "label": "Circuito W",
          "icon": "search",
          "landing_slug": "circuito-w"
        },
        "circuito_o": {
          "label": "Circuito O",
          "icon": "search",
          "landing_slug": "circuito-o"
        },
        "torres_del_paine": {
          "label": "Torres del Paine",
          "icon": "map-pin",
          "zone_id": 1
        },
        "pucon": {
          "label": "Pucón",
          "icon": "map-pin",
          "zone_id": 16
        },
        "san_pedro_atacama": {
          "label": "San Pedro de Atacama",
          "icon": "map-pin",
          "zone_id": 15
        },
        "puerto_natales": {
          "label": "Puerto Natales",
          "icon": "map-pin",
          "zone_id": 2
        }
      },
      "search": "検索",
      "clear": "選択をクリア",
      "tours": "ツアー",
      "subtext": "次の冒険を計画しましょう。\n探索し、予約し、自然を楽しんでください。",
      "in": "場所：",
      "showing_count": "%{total}件中%{loaded}件を表示",
      "load_more": "さらに読み込む"
    },
    "comments": {
      "comments": "コメント",
      "replies": "返信",
      "post_a_comment": "コメントを投稿！",
      "submit": "送信",
      "reply": "返信",
      "body": "ここにコメントを書いてください..."
    },
    "order": {
      "confirmed": "確認済み",
      "mail_thank": "Outdoor Indexでのご購入ありがとうございます",
      "mail__hi": "こんにちは！",
      "mail_subject": "Outdoor Index 注文 N#",
      "order_t": "注文",
      "see_purchase": "購入を確認！",
      "already_paid": "注文は支払い済みです",
      "confirm_payment": "確認",
      "cancel_order": "キャンセル",
      "recover_order": "復元",
      "send_confirm": "確認 (1)",
      "send_reminder": "リマインダー (2)",
      "send_last_reminder": "再リマインダー (3)",
      "send_review": "レビュー (4)",
      "email_title": "エクスカーション リマインダー",
      "email_footer": "これはエクスカーションのリマインダーです。ご質問がある場合は、info@outdoorindex.cl または +56981785011 までお気軽にお問い合わせください。",
      "promo": "その他のエクスカーションやプログラムについては、www.outdoorindex.cl をご覧ください。",
      "edit": "編集",
      "departure_date": "出発日",
      "reservation": "予約",
      "code": "コード",
      "departure": "出発",
      "contact_info": "連絡先情報",
      "customer_phone": "連絡先電話番号",
      "travelers": "旅行者",
      "itinerary": "旅程",
      "view_itinerary": "旅程をダウンロード",
      "view_itinerary_file": "こちら",
      "voucher": "バウチャーを表示",
      "confirmation_email_title": "%{excursion} の予約が確認されました",
      "view_weather_link": "天気をチェック",
      "instruction_exerpt": "エクスカーションが近づいています。準備は万端ですか？",
      "here_some_instructions": "指示",
      "view_post_link": "ブログ",
      "review_email_title": "エクスカーションの感想をお聞かせください %{excursion}",
      "review_link": "旅行後アンケートに回答する",
      "review_trustpilot_intro": "他の旅行者にも体験を知ってもらいたい場合は、Trustpilot に公開レビューを残すこともできます。",
      "review_trustpilot_link": "Trustpilot にレビューを残す",
      "review_question": "エクスカーションはいかがでしたか？",
      "review_explain_title": "アンケートに回答することが大切な理由",
      "rewview_explain_body": "<p>ご意見は、すべてのエクスカーションを改善するために役立ちます。旅行後アンケートは非公開で、組織、ガイド、アクティビティ、そして印象に残った詳細など、体験を把握するのに役立ちます。</p>\n<p>エクスカーションの前、最中、後の体験を振り返ってください。正直に回答するのに数分で済みます。</p>\n<p>ご回答は、サービスの品質を保ち、今後の旅行者のために改善を続ける助けになります。</p>\n",
      "review_terrible": "ひどい",
      "review_bad": "悪い",
      "review_acceptable": "許容範囲",
      "review_good": "良い",
      "review_great": "素晴らしい",
      "new_order_excerpt": "ここで注文を作成するために必要なすべての情報を完了できます。各予約の時間と集合場所を示す明確で正確な指示を書いてください。また、優先順位でオペレーターに連絡することを忘れないでください。"
    },
    "ondemand": {
      "explanation": "限定ツアー！フィールドスペシャリストにお問い合わせください。",
      "label": "プライベート"
    },
    "request": {
      "greeting": "こんにちは！この情報は登録されたメールに送信され、エージェントの1人にコピーが送信されました。すぐに誰かがあなたに連絡します。",
      "order_mail": {
        "header": {
          "hi": "こんにちは！エクスカーションの申し込みについてニュースがあります！",
          "title": "あなたの申し込みはローカルオペレーターによって受け入れられました。以下の情報を読み、すべてが正しいことを確認してください。",
          "your_order": "あなたの注文 N°",
          "ready": "は支払いが可能です。"
        },
        "footer": "ボタンリンクから支払いセクションに移動できます。",
        "disclaimer": "Outdoor Indexの安全な接続を介して支払いウィンドウにリダイレクトされます。",
        "pay": "今すぐ支払う",
        "excursion": {
          "title": "エクスカーション",
          "agency": "ローカルオペレーター"
        },
        "manual_order": {
          "observations": "Outdoor Indexエージェントからの以下のコメントを読んでください！",
          "price": "価格",
          "price_clp": "価格 CLP",
          "price_usd": "価格 USD"
        },
        "request_details": "アプリケーションの詳細"
      },
      "singular": "リクエスト",
      "requester": "リクエスター",
      "product_required": "注文をリクエストするには、事前にログインする必要があります",
      "excursion": "エクスカーション",
      "applicants": "応募者",
      "from": "から",
      "to": "まで",
      "comments": "コメント",
      "comments_placeholder": "私たちがあなたに連絡する前に、質問、疑問、または私たちに伝えたいことを残してください。できるだけ早く連絡します！",
      "submit": "アプリケーションを送信",
      "email_title": "エクスカーション調整アプリケーション",
      "email_footer": "このフォームは幹部に送信されました。お問い合わせフォームに記載された情報を通じて連絡があります。フォームにエラーや意見がある場合は、問題に関して info@outdoorindex.cl にメールを送信してください。",
      "contact_name": "連絡先名",
      "contact_email": "連絡先メール",
      "contact_phone": "連絡先電話番号",
      "must_log_in": "支払う前にログインする必要があります",
      "phone": "連絡先電話番号",
      "name": "名前",
      "last_name": "姓"
    },
    "applicants": {
      "applicants_number": "2) 何人がエクスカーションに参加しますか？",
      "dates_sub": "3) どの日程でこのエクスカーションを行うことを希望しますか？",
      "additional_info": "4) 追加情報",
      "applicants_phone": "1) 連絡先情報を残してください",
      "phone_placeholder": "電話番号",
      "email": "メール",
      "name": "名前",
      "lastname": "姓"
    },
    "active_admin": {
      "observed_dollar_update": "Update",
      "agency": "Operators",
      "agencies": "Agencies",
      "users": "ユーザー",
      "admin_users": "管理ユーザー",
      "orders": "注文",
      "pages": "ページ",
      "sales": "売上",
      "sale_goals": "売上目標",
      "reviews": "レビュー",
      "blog": "ブログ",
      "suppliers": "サプライヤー",
      "covers": "カバー",
      "excursions": "エクスカーション",
      "categories": "カテゴリー",
      "comments_tab": "コメント",
      "excursion_images": "エクスカーション画像",
      "home": "ホーム",
      "home_collections": "ホームコレクション",
      "save_home_collections": "コレクションを保存",
      "images": "画像",
      "mailer": "メーラー",
      "newsletter_covers": "ニュースレターカバー",
      "notifications": "通知",
      "payment_methods": "支払い方法",
      "private": "プライベート",
      "products": "製品",
      "profiles": "プロフィール",
      "properties": "プロパティ",
      "promotions": "プロモーション",
      "question_subjects": "質問の件名",
      "questions": "質問",
      "tourists": "旅行者",
      "requests": "リクエスト",
      "tags": "タグ",
      "visits": "訪問",
      "zones": "ゾーン",
      "seasons": "シーズン",
      "macro_zones": "マクロゾーン",
      "landings": "ランディング",
      "post": {
        "title": "タイトル",
        "subtitle": "サブタイトル",
        "label": "ラベル",
        "author_name": "著者名",
        "author_sm": "著者ソーシャルメディア",
        "content": "コンテンツ",
        "cover": "カバー",
        "published": "公開済み",
        "unpublished": "未公開",
        "tags": "タグ",
        "recommended_posts": "おすすめの投稿",
        "products": "ツアー・エクスカーション",
        "explore_chile": "Outdoor Indexでチリとその隠れた名所を探索"
      },
      "zone": {
        "name": "名前",
        "description": "説明",
        "sort_order": "並び順",
        "country": "国",
        "state": "州/県"
      },
      "review": {
        "tilte1": "レビューを作成",
        "title2": "カバー",
        "author": "名前",
        "country": "国",
        "review_date": "レビュー日",
        "language": "言語",
        "save_review": "レビューを保存",
        "body": "レビュー内容",
        "cover": "カバー",
        "rating": "評価",
        "url": "URL",
        "excerpt": "ここでレビューを作成するために必要なすべての情報を入力できます。アップロードするカバー写真の解像度が良く、正しいことを確認してください。情報を読んで確認することを忘れないでください。"
      },
      "landing": {
        "tilte1": "ランディングを作成",
        "title2": "メタ",
        "title3": "カバー",
        "title4": "レビュー",
        "title5": "よくある質問",
        "save_landing": "ランディングを保存",
        "title": "タイトル",
        "place": "場所",
        "body": "本文",
        "cover": "カバー",
        "review": "レビュー",
        "meta_title": "メタタイトル",
        "meta_description": "メタディスクリプション",
        "product": "エクスカーション",
        "excerpt": "ここでランディングを作成するために必要なすべての情報を入力できます。アップロードするカバー写真の解像度が良く、旅行者にとって魅力的であることを確認してください。明確で信頼できる情報を提供することを忘れないでください。",
        "more_info": "詳細情報"
      },
      "season": {
        "name": "名前",
        "valid_from": "から",
        "valid_until": "まで",
        "start_time": "開始時間",
        "product": "エクスカーション",
        "child_usd_price": "子供（ドル）",
        "child_clp_price": "子供（CLP）",
        "single_supplement_usd_price": "ドル",
        "single_supplement_clp_price": "CLP",
        "guardar_temporada": "保存",
        "daily_quota": "可用性",
        "title_days": "日数",
        "title_ages": "年龄",
        "title_prices_kids": "子供料金",
        "title_prices_adults": "大人料金",
        "title_single_supplement": "シングルサプリメント"
      },
      "kpis": {
        "observed_dollar": "観測されたドル値",
        "observed_dollar_subtitle": "中央銀行によって定義されたドル値",
        "visits_today_title": "今日の訪問",
        "visits_today_subtitle": "今日のフロー",
        "visitors": "訪問者",
        "last_day": "前日",
        "show_more": "もっと見る",
        "countries": "国",
        "countries_subtitle": "最も訪問者が多い国",
        "country_anon": "匿名",
        "abandoned_cart_title": "放棄されたバックパック",
        "abandoned_cart_subtitle": "バックパックに残された注文",
        "products_viewed_title": "最も閲覧された製品",
        "products_viewed_subtitle": "現在最も人気",
        "posts_viewed_title": "最も閲覧された投稿",
        "posts_viewed_subtitle": "現在最も人気",
        "products_selled_title": "ベストセラー製品",
        "products_selled_subtitle": "昨年",
        "today_excursions_title": "今日のエクスカーション",
        "today_excursions_subtitle": "今日ツアーに出発する旅行者。",
        "users_month_title": "月次統計",
        "users_month_subtitle": "月次ユーザーの統計的バランス。",
        "users_number": "ユーザー数",
        "new_users_title": "新規ユーザー",
        "new_users_subtitle": "先月登録",
        "users_total_title": "総ユーザー数",
        "users_total_subtitle": "開始からの登録数",
        "new_users_title_box": "今日のユーザー",
        "new_users_subtitle_box": "当日の訪問フロー",
        "users": "ユーザー",
        "new_orders_title": "新しい注文",
        "new_orders_subtitle": "今月登録",
        "paid_orders_title": "支払い済みの注文",
        "paid_orders_subtitle": "今月登録",
        "sale_goals_title": "売上目標",
        "sale_goals_subtitle": "今月の総収益",
        "goals": "目標",
        "to": "〜",
        "no_sale_goal": "売上目標が定義されていません",
        "conversion_chart_title": "コンバージョンチャート",
        "conversion_chart_subtitle": "昨年のコンバージョン率",
        "conversion_last_year": "昨年のコンバージョン率",
        "conversion_title": "コンバージョン率",
        "conversion_subtitle": "現在まで更新"
      }
    },
    "mercado_pago": {
      "error_alert": "Mercado Pagoでエラーが発生しました。注文が支払われているか確認してください。",
      "error_title": "取引拒否",
      "error_dec": "支払いの処理中にエラーが発生しました。もう一度お試しください。問題が解決しない場合は、お問い合わせください。",
      "pending_title": "取引保留中",
      "pending_dec": "お支払いはMercado Pagoで確認待ちです。確認後、注文を確認するためにご連絡ください。"
    },
    "webpay": {
      "error_alert": "Webpayでエラーが発生しました。注文が支払われているか確認してください。",
      "error_title": "取引拒否",
      "error_dec": "支払いの処理中にエラーが発生しました。もう一度お試しください。問題が解決しない場合は、お問い合わせください。"
    },
    "back": "戻る",
    "chat_title": "どのようなご用件でしょうか？",
    "chat_subtitle": "通常、数時間以内に返信いたします",
    "chat_name": "名前",
    "chat_email": "メール",
    "chat_phone": "電話番号",
    "chat_subject": "件名",
    "chat_body": "本文",
    "chat_btn": "メッセージを送信",
    "menu_welcome": "ようこそ、%{user_name}",
    "meesage_sended": "メッセージ送信済み",
    "meesage_captcha": "キャプチャを確認してください",
    "view_more": "もっと見る...",
    "view_more_excursions": "もっとエクスカーションを見る...",
    "view_more_suggestions": "もっと提案を見る...",
    "location": "場所",
    "zone": "ゾーン",
    "category": "カテゴリー",
    "select_one": "1つ選択",
    "select_multiple": "複数選択",
    "select_two": "最大2つ",
    "price": "価格",
    "vacancies": "空き状況",
    "key": "例：標高",
    "value": "1300 m",
    "value_included": "例：バイリンガルガイド",
    "profiles": "プロフィール",
    "optional": "オプション",
    "email": "メール",
    "phone": "電話番号",
    "address": "住所",
    "pending": "保留中",
    "edit": "編集",
    "soon": "近日公開",
    "password": "パスワード（8文字以上、文字、数字）",
    "password_confirmation": "パスワード確認",
    "remember_me": "ログイン状態を保持する",
    "log_in": "ログイン",
    "sign_up": "登録",
    "create_an_account": "アカウント作成",
    "name": "名前",
    "last_name": "姓",
    "back_to": "戻る",
    "reset_password": "パスワードをリセット",
    "send": "送信",
    "guests": "大人",
    "guest": "大人",
    "guest_s": "大人",
    "child_guest": "子供",
    "child_guests": "子供",
    "child_guest_s": "子供",
    "products": "製品",
    "products_show_photos": "写真を表示 (%{n})",
    "delete": "削除",
    "continue": "続ける",
    "subtotal": "小計:",
    "total_only": "合計",
    "total": "支払い総額:",
    "total_paid": "支払い総額",
    "total_final": "最終合計",
    "coupon": "クーポン",
    "charges": "料金:",
    "image_not_found": "画像が見つかりません",
    "usd": "USD",
    "clp": "CLP",
    "departure": "出発",
    "when": "いつ",
    "what": "何",
    "where": "どこ",
    "search": "検索",
    "language": "言語",
    "puerto_natales": "プエルト・ナタレス",
    "punta_arenas": "プンタ・アレーナス",
    "tierra_del_fuego": "ティエラ・デル・フエゴ",
    "puerto_williams": "プエルト・ウィリアムズ",
    "in": "場所",
    "or": "または",
    "help": "よくある質問",
    "go_to_home_page": "ホームページへ",
    "add_row": "+ 追加",
    "from": "から",
    "days": "日",
    "hours": "時間",
    "home": {
      "site_title": "Outdoor Index: パタゴニアとチリのアドベンチャーツアーを予約",
      "things_to_do_in": "おすすめの場所：",
      "scientific_excursions": "自然と深く触れ合う",
      "luxury_experience": "あなただけの特別な体験",
      "adventure_excursions": "もっと自分らしく",
      "the_best_excursions": "今シーズン最高のエクスカーション",
      "explore_your_interests": "興味を探求する",
      "excursions": "エクスカーション",
      "products": "商品",
      "suggestions": "おすすめ",
      "hard_adventurous": "アクティブ",
      "soft_adventurous": "変革的",
      "scientific": "発見",
      "family": "グループ",
      "luxury": "洗練された",
      "promotions": "割引とオファー",
      "download": "ダウンロード",
      "adventures_by_region": "地域別アドベンチャー",
      "north_patagonia": "北パタゴニア",
      "south_patagonia": "南パタゴニア",
      "masonry_zone_count": "%{count}件のアドベンチャー"
    },
    "masonry_zones": {
      "names": {
        "1": "トレス・デル・パイネ",
        "2": "プエルト・ナタレス",
        "3": "プンタ・アレーナス",
        "4": "ティエラ・デル・フエゴ",
        "5": "プエルト・ウィリアムズ",
        "6": "南極"
      }
    },
    "survey_page": {
      "title": "Outdoor Index - アフターセールスアンケート",
      "description": "私たちが提供したサービスについてのご意見をお聞かせください。あなたのフィードバックは私たちにとって非常に重要です。",
      "main_heading": "Outdoor Index 旅行後アンケート"
    },
    "header": {
      "agency_panel": "代理店パネル",
      "supplier_panel": "サプライヤーパネル",
      "ask_us_a_question": "お問い合わせ",
      "help": "よくある質問",
      "itinerary": "旅程",
      "sign_out": "ログアウト",
      "sign_up": "登録",
      "log_in": "ログイン",
      "join_our_newsletter": "ニュースレターに参加",
      "partner": "パートナー",
      "blog": "独占ストーリー:",
      "your_blog": "ブログ 🔥",
      "config": "設定",
      "orders": "バウチャー",
      "cart": "カート"
    },
    "header_cat": {
      "excursions": "エクスカーション",
      "recommendations": "おすすめ",
      "accommodation": "宿泊施設",
      "other": "その他"
    },
    "agencies": {
      "address": "住所",
      "review": "レビュー",
      "agency_type": "オペレータータイプ",
      "owner": "所有者",
      "holder_name": "所有者名",
      "holder_id": "所有者ID",
      "holder_email": "所有者メール",
      "phone": "電話番号",
      "bank_name": "銀行名",
      "account_type": "口座の種類",
      "account_number": "口座番号",
      "agency": "オペレーター",
      "country": "国",
      "state": "州/県",
      "zone": "ゾーン",
      "duration": "期間",
      "created_at": "作成日時",
      "agency_info": "情報",
      "supplier_info": "情報",
      "products": "製品",
      "numbers": "数字",
      "excursions": "エクスカーション",
      "list_title": "すべての日付のリスト",
      "no_dates": "日付はまだありません。カレンダーをクリックして作成してください。",
      "change_availability": "日付を管理",
      "date_range": "日付範囲に従って変更",
      "set_price": "価格を設定",
      "rooms_to_add": "部屋を追加",
      "rooms_to_remove": "部屋を削除",
      "products_to_add": "製品を追加",
      "products_to_remove": "製品を削除",
      "apply_changes": "変更を適用",
      "edit_excerpt": "サプライヤーのプロフィールを作成するために要求されるすべての情報は、Outdoor Indexとの商業的なリンクを確立するために不可欠です。可能な限り信頼できる情報を入力してください。",
      "agency_information": "オペレーター情報",
      "supplier_information": "サプライヤー情報",
      "max_words": "150 語",
      "for_booking": "予約用",
      "supplier_review": "サプライヤーレビュー",
      "website_url": "ウェブサイトURL",
      "person_in_charge": "担当者",
      "name": "名前",
      "update_info": "プロフィールを保存",
      "commercial_information": {
        "self": "商業情報",
        "name": "名前",
        "bank_name": "銀行名",
        "bank_account": "銀行口座",
        "account_type": "口座の種類",
        "commercial_name": "商号",
        "id_rut": "ID / Rut"
      },
      "actions": "アクション",
      "manage_dates": "日付",
      "active": "承認済み",
      "pending_changes": "保留中",
      "index_excerpt": "これはあなたの製品のリストです。日付を作成、編集、管理できます。作成された各製品は、Outdoor Indexチームによってレビューされるまで「保留中」の状態のままになります。",
      "manage_dates_excerpt": "ここにすべての製品を追加するカレンダーがあります。日付を作成、編集、管理できます。作成された各製品は、Outdoor Indexチームによってレビューされるまで「保留中」の状態のままになります。",
      "create_excursion": "エクスカーションを作成",
      "create_product": "製品を作成",
      "create_activity": "アクティビティを作成",
      "create_post": "投稿を作成",
      "new_excursion_excerpt": "ここで製品を作成するために必要なすべての情報を完了できます。アップロードする写真の解像度が良く、旅行者にとって魅力的であることを確認してください。明確で信頼できる情報を提供することを忘れないでください。",
      "english": "英語に翻訳 →",
      "spanish": "スペイン語に翻訳 →",
      "create_agency": "新しいオペレーターを作成",
      "agency_bank": "銀行口座を追加"
    },
    "error": {
      "sorry": "Sorry, this page doesn't exist.",
      "opps": "You may have mistyped the address or the page may have moved.",
      "go": "Go to homepage",
      "went_wrong": "We're sorry, but something went wrong.",
      "improvements": "If you see this message, it's because you may have typed the web address incorrectly or because we are updating the site with new features and improvements. Please wait a few minutes and reload the page again. Thank you!"
    },
    "excursions": {
      "itinerary": {
        "body": "本文"
      },
      "faq": {
        "body": "本文"
      },
      "title": "タイトル",
      "location": "場所",
      "zone": "ゾーン",
      "category": "カテゴリー",
      "profiles": "旅行スタイル",
      "price": "価格（ドル）",
      "vacancies": "空き状況",
      "duration": "期間",
      "half_day": "半日",
      "full_day": "終日",
      "multiple_days": "数日",
      "duration_days": "日",
      "duration_hours": "時間",
      "days": {
        "zero": "日",
        "one": "日",
        "other": "日"
      },
      "hours": {
        "zero": "時間",
        "one": "時間",
        "other": "時間"
      },
      "add_images_(minimum_3)": "写真（最低3枚）",
      "disclaimer": "免責事項",
      "description": "概要",
      "body": "私たちの旅程",
      "useful_information": "役立つ情報",
      "what's_included?": "含まれるもの",
      "what's_not_included?": "含まれないもの",
      "meeting_instruction": "出発場所",
      "meeting_address": "住所",
      "policies": "ポリシー",
      "save_excursion": "エクスカーションを保存",
      "what_we'll_do": "概要",
      "our_itinerary": "旅程",
      "faqs": "よくある質問",
      "images": "画像",
      "edit_excerpt": "サプライヤーのプロフィールを作成するために要求されるすべての情報は、Outdoor Indexとの商業的なリンクを確立するために不可欠です。可能な限り信頼できる情報を入力してください。",
      "other_excursions_from_this_tour_company": "このサプライヤーの他の体験",
      "create_excursions": "エクスカーションを作成",
      "more": "もっと",
      "less": "少なく",
      "best_excursions_for_the_next_season": "今シーズンのおすすめ",
      "add_extras": "追加オプションを追加",
      "price_per_reservations": "予約ごとの価格",
      "extra_description": "アクティビティ",
      "macro_zone": "マクロゾーン",
      "meta_title": "メタタイトル",
      "meta_description": "メタディスクリプション",
      "time": "時間",
      "prices": "価格",
      "included": "含まれるものは？",
      "locations": "場所",
      "alternative_names": "エクスカーションは次の名前でも知られています",
      "breadcrumb_catalog": "ツアー・エクスカーション"
    },
    "hotels": {
      "twin": "Twin",
      "double": "Double",
      "double_twins": "Double twin",
      "room_reserved": "room reserved",
      "edit_your_booking": "Edit your booking"
    },
    "reservations": {
      "add_guest_details": "旅行者情報の追加",
      "traveler_data_card_title": "旅行者情報",
      "traveler_data_badge_missing": "情報不足",
      "traveler_data_badge_complete": "完了",
      "traveler_data_badge_ready_details": "情報済み",
      "traveler_data_intro": "ご予約を確定するために、以下の情報が必要です。",
      "traveler_data_complete_button": "旅行者情報",
      "detach_guest_confirm": "この予約からこの旅行者を外しますか？",
      "guest_slots_full": "この予約にはすでに必要人数の旅行者が登録されています。",
      "organize_your_itinerary": "1) 旅程 >",
      "create_your_travel_group": "2) 旅行グループ >",
      "assign_tourists": "3) 旅行者の割り当て",
      "new_checkout_excerpt": "ここに製品のリストがあります。エクスカーションに参加するゲストの情報を忘れずに追加してください。購入する前に、予約数と費用を確認してください。キャンセルポリシーを必ずお読みください。",
      "cart_title": "旅行情報",
      "checkout_page_title": "予約を確認してお支払いください",
      "checkout_page_intro": "ツアー内容を確認し、旅行者情報を入力し、お支払い方法を選んでください。",
      "checkout_trip_summary_heading": "ご旅行の概要",
      "pay_with": "支払い方法",
      "cart_subtitle": "バックパック内のすべての製品のリスト",
      "itinerary_excerpt": "ここにすべての製品のリストがあります。次のステップに進む前に、情報が正しいことを確認してください。重要：すべての時間と日付は現地時間で表示されます。",
      "assign_excerpt": "このセクションでは、どの旅行者がどのエクスカーションに行くかを指定します。そうすることで、可能な限り最高の体験を提供するために必要なすべての情報を得ることができます。",
      "list_of_products": "製品リスト",
      "reservations_made": "#",
      "assing_tourists": "旅行者の割り当て",
      "go_to_checkout": "続ける",
      "a_list_of_all_your_reservations": "すべての予約",
      "my_group": "私のグループ",
      "people_(including_you)": "人数（あなたを含む）",
      "(me)": "(私)",
      "team_member": "チームメンバー",
      "actions": "アクション",
      "you_have_no_reservations": "予約はありません",
      "tourists_group": "このセクションでは、同行するすべての人々の情報を追加する必要があります。添付された情報が可能な限り信頼できるものであることが非常に重要です。",
      "edit_your_reservation": "予約の編集",
      "cancel_date": "キャンセル日",
      "departure_date": "出発日",
      "reserves": "予約",
      "update": "更新",
      "not_enough": "不足しています",
      "too_many": "多すぎます",
      "product_for": "対象製品",
      "tourists_assigned": "割り当てられた旅行者",
      "many_few_tourists": "割り当てられた旅行者が予約数と一致しません",
      "select_your_extras": "追加オプションの選択：",
      "product_variants": "オプション",
      "select_date_first": "最初に日付を選択",
      "total_price": "合計金額",
      "see_details": "詳細を見る",
      "price_chilean": "チリ居住者の合計金額：",
      "price_no_chilean": "チリ非居住者の合計金額：",
      "single_supplement": "シングルサプリメント：",
      "people": "人数：",
      "details_of_purchase": "購入の詳細",
      "confirmed_excerpt": "私たちと一緒に旅行していただきありがとうございます！",
      "confirmed_excerpt_litle": "バウチャーをチェックして購入の詳細を確認してください。",
      "cart_empty": "バックパックは空です"
    },
    "checkout": {
      "do_checkout": "チェックアウト",
      "confirm_checkout_excerpt": "続行する前に、すべてが正しいことを確認してください。この注文を受け入れると、変更することはできません。",
      "confirm_checkout_excerpt_2": "（新しい注文を作成することは可能です。）",
      "please_confirm_your_details": "詳細を確認してください",
      "i_need_to_change_something": "変更が必要なものがあります",
      "everything_looks_fine": "すべて問題なさそうです",
      "after_this_step": "このステップの後、Outdoor Indexはすべてのプロバイダーに連絡します。",
      "providers_confirm_availability": "すべてのプロバイダーが注文を確認すると、連絡があります。",
      "payment_excerpt": "購入する前に、製品のすべての詳細が正しいことを確認してください。予約数と費用を確認してください。キャンセルポリシーを必ずお読みください。",
      "your_details_confirmation_and_payment": "製品と支払いの詳細",
      "important!": "重要",
      "all_transactions_have_an_extra": "銀行と合意した分割払いでデビットカードまたはクレジットカードを使用して支払うことができます。Outdoor Indexは売上の全額を受け取ります。",
      "get_a_refund_if": "購入から24時間以内にキャンセルした場合、払い戻しを受けられます。",
      "pay_now": "支払いの確認",
      "confirm_and_pay": "確認して支払う",
      "wetravel_link_not_ready": "少し待ってから再度お試しください。WeTravelを選び直すとリンクが読み込まれます。",
      "mercado_wallet_not_ready": "Mercado Pagoのボタンを読み込み中です。数秒待ってから再度お試しください。",
      "payment_summary": "お支払い概要",
      "payment_method_title": "お支払い方法",
      "payment_methods_locked_until_traveler_details": "お支払い方法を選ぶ前に、旅行者情報をすべて入力してください。",
      "payment_method_recommended": "おすすめ",
      "payment_method_blurb": {
        "wetravel": "USDでの国際決済",
        "mercado_pago": "国内カード払い・銀行の条件に応じた分割払い",
        "webpay": "Webpayで銀行カード決済",
        "payu": "PayUで決済",
        "paypal": "PayPalで決済",
        "google_pay": "Google Payで決済",
        "apple_pay": "Apple Payで決済"
      },
      "total_to_pay": "お支払い合計",
      "secure_payment_note": "100%安全な暗号化決済",
      "help_widget_title": "サポートをご希望ですか？",
      "help_widget_body": "Outdoor Indexのガイドとお話しして、パーソナライズされたサポートを受けましょう。",
      "help_widget_cta": "スペシャリストに相談する",
      "help_widget_online": "オンライン",
      "terms_toggle_line_html": "%{terms}と%{policy}に同意します。",
      "terms_toggle_word_terms": "利用規約",
      "terms_toggle_word_policy": "プライバシーポリシー",
      "review": "レビュー",
      "ready": "準備完了",
      "choose_payment": "希望する支払い方法を選択",
      "only_for_reservation": "予約する",
      "complete_payment": "全額支払い",
      "30_p": "30%",
      "30_per": "30%支払い済み",
      "30_pers": "30%支払い済み",
      "100_p": "100%",
      "100_per": "100%支払い済み",
      "100_pers": "100%支払い済み",
      "i_hereby_accept": "「支払いの確認」をクリックすることで、あなたは私たちの",
      "and_confirm": "に同意し、私たちの",
      "and_our": "および私たちの",
      "your_itinerary": "旅程の詳細",
      "continue_shopping": "買い物を続ける",
      "not_available": "利用不可",
      "disclaimer": "予約について",
      "some_products_deleted": "一部の製品はもう利用できません",
      "accept": "はい、受け入れます",
      "cancel": "キャンセル",
      "must_have_tourist": "メールと電話番号が追加された少なくとも1人の旅行者が必要です。",
      "wetravel_partial_error": "ツアー日が近すぎるため、分割払いはご利用いただけません。全額払いを選択してください。"
    },
    "vouchers": {
      "active_excerpt": "これがバウチャーの詳細です。確認して印刷してください。予約の注文番号が記載されたバウチャーを提供する必要があります。",
      "all_of_your_vouchers": "すべてのバウチャー",
      "confirmed_excerpt": "ご購入ありがとうございます。素晴らしい旅行になることを願っています。バウチャーを印刷して常に携帯することを忘れないでください。質問や予期しない状況が発生した場合は、遠慮なくお問い合わせください。",
      "active_vouchers": "有効なバウチャー",
      "disclaimer": "このPDFには製品に関するすべての情報が含まれています。ドキュメントを確認し、質問がある場合はお問い合わせください。旅行を楽しんでください。",
      "get_your_voucher": "バウチャーを取得",
      "voucher": "バウチャー",
      "payment_error": "支払いエラー。",
      "error": "支払いプロセスで問題が発生しました。後でもう一度試すか、他の支払いオプションについてお問い合わせください。",
      "restart_payment": "支払いを再開",
      "payment_rejected": "支払いが拒否されました",
      "rejected": "PayU/Paypalが支払いが拒否されたことを示しています。詳細を確認して再試行するか、他の支払いオプションについてお問い合わせください。",
      "home": "ホーム",
      "order_number": "注文番号:",
      "view": "表示",
      "print": "印刷",
      "complete": "完了",
      "incomplete": "未完了",
      "activities": "アクティビティ",
      "was_partial_payment": "(2)"
    },
    "categories": {
      "search": "検索",
      "general": "一般",
      "general_category_search": "%{category_name} 一般検索",
      "other_excursions_to_do": "%{zone_name} で体験できるその他のこと",
      "general_zone_search": "%{zone_name} での検索提案",
      "recommended_for_you": "%{zone_name} での体験"
    },
    "tourist": {
      "new_tourist_excerpt": "このセクションでは、同行するすべての人々のプロフィール情報を追加できます。添付された情報が可能な限り信頼できるものであることが非常に重要です。",
      "personal_info": "個人情報",
      "checkout_minimum_one_pax_notice": "続行には一名様分の情報で構いません。ほかの同行者は後から入力いただけます。",
      "add_another_pax": "同行者を追加",
      "info_pax_card_title": "同行者の情報",
      "name": "名前",
      "last_name": "姓",
      "date_of_birth": "生年月日",
      "nationality": "国籍",
      "passport": "パスポート",
      "hometown": "出身地",
      "phone": "電話番号",
      "email": "メールアドレス",
      "emergency_contact": "緊急連絡先",
      "allergies": "アレルギー",
      "medical_conditions": "病状",
      "food_restrictions": "食事制限",
      "pending": "保留中",
      "ready": "準備完了",
      "you_have_no_vouchers": "有効なバウチャーはありません",
      "no_reservations_to_assign": "割り当てる予約はありません"
    },
    "footer": {
      "about_us": "私たちについて",
      "statement": "ミッションステートメントを読む",
      "go_to_suscribe": "購読する",
      "suscribe_text": "新しいストーリーや旅行割引に関する最新情報を隔週でお送りします",
      "terms_&_conditions": "規約",
      "privacy_&_cookies": "プライバシー",
      "contact_us": "お問い合わせ",
      "edit_endorsement": "Outdoor Indexはプエルト・ナタレス（チリ南パタゴニア）に拠点を置き、40以上のサプライヤーのサポートを受けています。",
      "all_rights_reserved": "All rights reserved. 許可なく本サイトの一部を複製することはできません。",
      "spanish": "スペイン語",
      "english": "英語",
      "portuguese": "ポルトガル語",
      "french": "フランス語",
      "german": "ドイツ語",
      "english_corto": "英",
      "spanish_corto": "西",
      "portuguese_corto": "葡",
      "french_corto": "仏",
      "german_corto": "独",
      "clp": "$ チリペソ (CLP)",
      "usd": "$ 米ドル (USD)",
      "survey": "アンケート",
      "endorsement": {
        "support_local_comunity": "地元を支援し、持続可能性を奨励する",
        "when_you_buy": "Outdoor Indexで購入すると、35以上の地元サプライヤーの品質と持続可能な管理を奨励することになります。",
        "instant_booking": "認定ガイドが100％あなたのサポートに対応",
        "by_entering_your": "体験の前、最中、後に質問を解決し、次の冒険の計画を支援します。",
        "payment_protection": "今は30％支払うだけ。残りは後で",
        "we_comply_with_all": "過度な支払いをせずに計画を軽くしましょう。今は30％支払って予約を確認し、残りは日付が近づいてから支払います。"
      },
      "covid": "Covid",
      "secure": "このウェブサイトを通じて処理されるすべての予約は、主要なパートナーによって保護されています。",
      "titles": {
        "book": "安心して予約",
        "destinations": "人気の目的地",
        "activities": "人気のアクティビティ"
      },
      "lang-currency": "言語と通貨"
    },
    "chat": {
      "hi": "こんにちは",
      "our_chat_service": "チャットサービスは、月曜日から金曜日の午前10時から午後6時（UTC / GMT -3）まで利用可能です。この時間内にご連絡いただければ、数分以内に返信いたします。",
      "new-message": "新しいメッセージ",
      "messages": "メッセージ",
      "enter_your_name": "名前を入力...",
      "enter_email": "メールを入力...",
      "enter_message": "メッセージを入力...",
      "create_message": "メッセージを送信",
      "begin": "開始",
      "user": "ユーザー",
      "need_help": "助けが必要ですか？",
      "talk_to_local_guide": "ローカルガイドと話す"
    },
    "registration": {
      "edit_user": "ユーザーの編集",
      "email": "メールアドレス",
      "name": "名前",
      "lastname": "姓",
      "confirm_password": "パスワードの確認",
      "current_password": "現在のパスワード",
      "new_password": "新しいパスワード",
      "profile_picture": "プロフィール写真",
      "profiles": "プロフィール（1つ以上選択）",
      "interests": "興味（1つ以上選択）",
      "notification": "通知設定",
      "save_settings": "保存",
      "update_account": "アカウントの更新",
      "registration_excerpt": "プロフィールを好きなように管理できます。通知を有効または無効にします。これにより、Outdoor Indexから受け取るコンテンツをカスタマイズできます。",
      "vouchers": "バウチャー",
      "all_vouchers": "すべてのバウチャー",
      "change_your_password": "パスワードのリセットまたは変更",
      "change_my_password": "パスワードの変更",
      "confirm_new_password": "パスワードの確認",
      "subtitle_password": "文字と数字を含む少なくとも8文字の新しいパスワードを作成してください。",
      "password_requirements": "パスワードが無効です。",
      "passwords_dont_match": "パスワードが一致しません。"
    },
    "responsive": {
      "more": "More..."
    },
    "uploader": {
      "upload_a_file": "Upload a file",
      "drop_files_here": "Drop files here",
      "processing_dropped_files": "Processing dropped files..."
    },
    "sidebar_single": {
      "no_dates_available": "利用可能な日付はありません",
      "disclaimer": "<strong>予約総額の30％</strong>を支払うだけで、今すぐ場所を確保できます。",
      "select_dates": "今すぐ予約",
      "share": "エクスカーションについて質問がありますか？",
      "to_make_a": "予約するには ",
      "log_in": "ログイン",
      "or": "または",
      "sign_up": "登録",
      "if_you_are": "新規の場合。",
      "price_for": "1人あたり",
      "from": "価格",
      "contact_viewnia": "お問い合わせ",
      "rates": "CLP料金にはVATが含まれます。USD料金にはVATが含まれません。外国の非居住者はUSDで支払う場合、免除されます。"
    },
    "request_form": {
      "title": "Request Excursion",
      "contact_viewnia_subtitle": "Fill the form below to begin the process that will allow us to coordinate your excursion with our field specialist."
    },
    "modal_manage_date": {
      "discount": "Add a discount",
      "manage_date": "Manage date",
      "date": "Date",
      "starting_time": "Starting time",
      "price": "Price",
      "vacancies": "Vacancies",
      "save": "Save",
      "cancel_date": "Cancel date",
      "available_ammount": "Available amount",
      "month_form": {
        "edit_month": "Edit month",
        "delete_month": "Delete month",
        "populate_month": "Populate Month",
        "disclaimer_1": "You are about to edit <strong>an entire month</strong>, this action is <strong>hard to reverse</strong>.",
        "disclaimer_2": "Please double check your current calendar before you proceed, in order to avoid duplicates or other problems.",
        "accept": "Accept",
        "month": "Month",
        "week_days": "Week days",
        "continue": "Continue",
        "final_notice_header": "Please read carefully:",
        "final_notice_1": "Add a departure date for excursion <strong id='fn_title'></strong>, every <strong id='fn_week_days'></strong>  of <strong id='fn_month'></strong>.",
        "final_notice_2": "Each departure will start at <strong><span id='fn_starting_time_4i'></span>:<span id='fn_starting_time_5i'></span></strong>, have <strong id='fn_vacancies'></strong> and discount <strong id='fn_discount'></strong>.",
        "confirm": "Save",
        "back": "Back",
        "delete_month_disclaimer": "You are about to delete all departures for the following month, this action is <strong>irreversible</strong>.",
        "vacancies": "vacantes"
      }
    },
    "checkout_bar": {
      "itinerary": "旅程",
      "tourists": "グループ",
      "assign_tourists": "割り当て",
      "checkout": "支払い",
      "voucher": "バウチャー"
    },
    "reviews": {
      "title": "レビュー",
      "more": "もっと",
      "reviewing_excursion": "製品のレビュー",
      "thanks_for_submitting": "レビューを送信していただきありがとうございます",
      "review": "レビュー",
      "footer": "Trustpilotで見る"
    },
    "newsletter": {
      "sign_up_at": "パタゴニアのアドベンチャー旅行マーケットプレイス",
      "we_value_your_privacy": "持続可能でパーソナライズされた、冒険に満ちた体験をお楽しみください",
      "sign_up_now": "今すぐ登録",
      "view_preferences": "設定",
      "subscribe_to_our": "ニュースレターを購読する",
      "email_address": "メールアドレス",
      "subscribe": "購読",
      "we_are_travel_and_growth": "最高のツアーとエクスカーションでチリとその風景を発見してください。忘れられない環境で、好きなことをして地元の体験をしてください。"
    },
    "modal": {
      "first_section": "日付を選択",
      "product_variants": "オプションを選択",
      "second_section": "乗客",
      "no_daily_quota": "この日は十分な席がありません",
      "date": "日付",
      "wrong_name": "名前またはパスワードが間違っています",
      "per_person": " 1人あたり",
      "departure_time": "出発:",
      "spot_left": "残り枠",
      "add_reserves": "ゲスト数",
      "select": "選択",
      "select_date": "日付を選択",
      "select_date_text": "カレンダーで利用可能な日付を選択し、手順に従って予約を生成してください。",
      "check_in": "チェックイン",
      "check_out": "チェックアウト",
      "guests": "ゲスト",
      "child_guests": "子供",
      "guest_text": "13歳以上",
      "child_text": "12歳以下",
      "twins": "ツイン",
      "doubles": "ダブル",
      "doubles_twin": "ツイン2部屋",
      "add_rooms_for": "部屋を追加",
      "guest": "ゲスト",
      "add_to_itinerary": "選択",
      "start": "開始",
      "ends": "終了",
      "leave_your_review": "レビューを残す",
      "describe_your_experience": "全体的な体験を説明してください",
      "add": "追加",
      "next": "次へ",
      "load_earlier_dates": "前の日付を読み込む...",
      "load_later_dates": "後の日付を読み込む...",
      "is_resident": "チリ在住",
      "is_not_resident": "チリ国外在住",
      "language_title": "国と通貨を選択",
      "language_subtitle": "リストから言語を選択してください",
      "currency_subtitle": "通貨を選択してください",
      "current_language": "国と言語",
      "other_languages": "その他の国と言語"
    },
    "alert": {
      "invalid_changes": "無効な変更",
      "invalid_action": "無効な操作：金額は0未満にできません",
      "not_enough_availability": "その日付範囲には十分な空きがありません。他の宿泊施設を確認するか、予約数を減らしてください。",
      "something_went_wrong": "問題が発生しました。再試行するか、お問い合わせください。",
      "review_already_submitted": "レビューはすでに送信済みです",
      "couldn't_send_review": "レビューを送信できませんでした",
      "you_must_agree_to": "利用規約に同意する必要があります",
      "no_products_in_your_order": "注文に製品がありません",
      "please_sign_the_waiver": "名前で免責事項に署名してください。",
      "signature_and_tourist": "署名と旅行者名は同一でなければなりません。",
      "couldn't_save": "保存できませんでした。後でもう一度お試しください。",
      "invalid_language": "無効な言語",
      "confirm_to": "ロボットではないことを確認する必要があります。",
      "error": "パスワードは8文字以上で、文字と数字を1つずつ含める必要があります。"
    },
    "notice": {
      "your_account_has": "アカウントに代理店がありません。お問い合わせください",
      "session_expired": "セッションが期限切れになりました。ログインしてください。",
      "changes_submitted": "変更が送信されました！",
      "new_product_created": "新しい製品が作成され、承認待ちです",
      "invalid_request": "無効なリクエストです。再試行するか、お問い合わせください。",
      "have_excursions": "代理店にはエクスカーションがあります。削除する前に別の代理店に割り当ててください",
      "updated_information": "情報が更新されました",
      "date_no_longer": "日付は利用できなくなりました",
      "availability_updated": "空き状況が更新されました",
      "review_sent": "レビュー送信済み！",
      "bookings_made_for": "予約が成功しました！",
      "profile_picture_updated": "プロフィール写真が更新されました！",
      "tourist_information_saved": "情報が保存されました",
      "enabled": "有効",
      "diabled": "無効",
      "was": "でした",
      "settings_updated": "設定が更新されました！",
      "language_updated": "言語が更新されました！",
      "account_updated": "アカウントが更新されました！",
      "reserves_added_for": " 予約が追加されました ",
      "product_was_enabled": "製品が有効になりました",
      "product_was_disabled": "製品が無効になりました"
    },
    "more": {
      "the_best_products": "Outdoor Indexの最高の体験",
      "all_recommendations_in_puerto_natales": "プエルトナタレスのすべての体験",
      "all_recommendations_in_punta_arenas": "プンタアレナスのすべての体験",
      "all_recommendations_in_zone": "%{zone_name}のすべての提案",
      "all_adventure_products": "すべてのアドベンチャー体験",
      "all_standard_products": "すべての変革的体験",
      "all_scientific_products": "すべての発見体験",
      "all_family_products": "すべての家族・グループ体験",
      "all_luxury_products": "すべての洗練された体験",
      "all_promotions_products": "すべての割引・オファー体験",
      "all_ota_products": "すべてのOTA体験",
      "a_selection_of_the_best": "Outdoor Indexによるセレクション",
      "other_activities_that": "体験を補完するその他のアクティビティ",
      "all_north_patagonia_products": "北パタゴニアのすべての製品",
      "all_south_patagonia_products": "南パタゴニアのすべての製品",
      "all_lagos_region_products": "湖と川の地区のすべての製品"
    },
    "searches": {
      "no_result_to": "申し訳ありませんが、\"%{zone_name}\"の\"%{category_name}\"には結果がありません",
      "recommended_for_you": "\"%{zone_name}\"での体験",
      "category_products_in_zone": "\"%{zone_name}\"の\"%{category_name}\"体験",
      "category_products_in_zone_no_result": "申し訳ありませんが、現在\"%{zone_name}\"には\"%{category_name}\"体験はありません",
      "all_products_in_zone": "\"%{zone_name}\"のすべての体験",
      "all_products_in_zone_no_result": "申し訳ありませんが、現在\"%{zone_name}\"には体験はありません",
      "all_category_products": "すべての\"%{category_name}\"体験",
      "all_category_products_no_result": "申し訳ありませんが、現在\"%{category_name}\"体験はありません",
      "please_select_category_or_zone": "カテゴリまたはゾーンを選択してください"
    },
    "guidebook": {
      "download_our_guide_book": "ガイドブックをダウンロードして、Outdoor Indexで旅を始めましょう",
      "find_out_everything": "南チリパタゴニアのすべてをご覧ください。"
    },
    "banner": {
      "do_you_need_travel_insurance": "旅行保険が必要ですか？",
      "in_partnership_with_world": "Outdoor IndexはWorld Nomadsと提携し、チリパタゴニアで最高の保険を提供します。",
      "get_a_quote": "見積もりを取得"
    },
    "blog": {
      "meta_title": "チリの旅行・自然・アドベンチャーブログ | Outdoor Index",
      "meta_description": "チリ旅行のガイド、ヒント、インスピレーション。アウトドア体験、自然とのつながり、冒険体験をお届けします。",
      "travel_nature_growth": "旅行、自然、成長",
      "we_connect_you_with": "自然、旅行、成長に関するグローバルコンテンツ。ソーシャルメディアでフォローしてください！",
      "breadcrumb_aria": "パンくずリスト",
      "breadcrumb_home": "ホーム",
      "breadcrumb_blog": "ブログ",
      "guided_tours": "ガイド付きツアー",
      "book_now": "今すぐ予約",
      "view_more_activities": "その他のアクティビティを見る",
      "showing_count": "%{total}件中%{loaded}件の記事を表示",
      "pagination_aria": "ブログのページネーション",
      "page_n": "%{n}ページ目"
    },
    "mail": {
      "welcome_user_name": "%{user_name}、Outdoor Indexへようこそ",
      "leave_your_review": "%{user_name}、体験のレビューを残してください",
      "voucher": {
        "your_order_is_ready": "ご購入ありがとうございます。注文番号は%{reference_code}です",
        "your_sold_product": "こんにちは%{user_provider}、体験が1つ販売されました",
        "new_sold": "新しい販売 %{reference_code}"
      }
    },
    "paypal": {
      "description": "Outdoor Index: 注文の支払い %{reference_code}"
    },
    "payu": {
      "description": "Outdoor Index: 注文の支払い %{reference_code}"
    },
    "pdf": {
      "emergency_contacts": "緊急連絡先",
      "congratulations_user_name": "おめでとうございます %{user_name}",
      "congratulations_agency_name": "おめでとうございます %{agency_name}",
      "here_we_attach": "ここに旅行のすべての情報を添付します。このバウチャーには、製品の詳細、サプライヤーの連絡先、署名済みの免責事項、および支払い済み製品（PaypalまたはPayU）の領収書が表示されます。ご質問がある場合は、お気軽にお問い合わせください。",
      "reservation_number": "予約番号:",
      "product_detail": "製品詳細",
      "departure": "出発",
      "your_suppliers": "あなたのサプライヤー",
      "in_this_section_appear": "このセクションには、Outdoor Indexが受け取った支払いの詳細が表示されます。このバウチャーを印刷して、常に携帯してください。Outdoor Indexをお選びいただき、誠にありがとうございます",
      "payments_detail": "支払い詳細",
      "initial_payment": "初回支払い",
      "payment_method": "支払い方法",
      "total_paid": "支払い総額",
      "total_order": "注文総額:",
      "order_date": "注文日",
      "payment_date": "支払い日",
      "payment_type": "支払いタイプ",
      "payment_complete": "支払い完了",
      "print_this_voucher": "このバウチャーを印刷して携帯してください",
      "at_all_times": "旅行中常に。",
      "you_check": "チェックイン時に提示してください。",
      "we_have_received": "製品の新しい予約リクエストを受け取りました。以下に、これと乗客情報の詳細を示します。今後は、乗客に直接連絡するか、必要に応じてOutdoor Indexに連絡するよう指示できます。予約が正常に行われたことを通知するメールを送信することを常にお勧めします。あなたは良いプロバイダーとして際立つでしょう。過密の問題が発生しないように、独自のシステムで予約枠を更新することを忘れないでください。お疲れ様でした！",
      "guests": "ゲスト",
      "your_guests": "あなたのゲスト",
      "date_of_birth": "生年月日:",
      "origin": "出身地:",
      "document_number": "書類番号:",
      "phone": "電話",
      "email": "メール",
      "emergency_number": "緊急電話番号:",
      "allergies": "アレルギー:",
      "medical_conditions": "病状:",
      "food_restrictions": "食事制限:",
      "dear_user_name": "親愛なる %{user_name}",
      "service_confirmation": "サービス確認",
      "according_to_the_reservation": "あなたによる予約リクエストに従い、以下の情報を確認します：",
      "reference_code": "参照コード",
      "activity": "アクティビティ",
      "starting_point": "場所",
      "starting_date": "開始日",
      "starting_time": "開始時間",
      "client": "クライアント",
      "excursion": "アクティビティ %{number}",
      "payment_details": "支払い詳細",
      "applied": "適用済み",
      "next_payment": "次の支払い (70%)",
      "purchase_date": "購入日",
      "description": "説明",
      "unit_price": "単価",
      "unit_price_child": "子供単価",
      "childen_pax": "子供",
      "pax": "人数",
      "tax": "税金",
      "about_your_host": "ホストについて",
      "name": "担当者:",
      "address": "住所:",
      "from": "サービス開始日",
      "to": "サービス終了日",
      "tourists": "旅行者情報",
      "guest": "ゲスト",
      "child_guest": "子供",
      "guest_price": "ゲスト価格",
      "child_guest_price": "子供価格",
      "resident": "居住者",
      "no_resident": "非居住者",
      "problem_with_order": "注文に問題がありますか？",
      "complete_remaining_payment_web": "残額をお支払いの場合は、outdoorindex.cl にログインし、バウチャー一覧からこの注文を開いてください。",
      "contact_us": "お問い合わせ",
      "guest_s": "ゲスト",
      "child_guests": "子供",
      "child_guest_s": "子供"
    },
    "currency": {
      "displaying_prices_in": "通貨換算完了！"
    },
    "tourists": {
      "first_create_group": "おっと！乗客情報の入力を忘れないでください。"
    },
    "date": {
      "formats": {
        "default": "%m/%d/%Y",
        "short": "%a, %b %e",
        "long": "%B %d, %Y",
        "calendar_picker": "YYYY/MM/DD",
        "fixed_departure": "YYYY/M/DD",
        "moment": "%Y-%m-%d"
      }
    },
    "time": {
      "formats": {
        "default": "%m/%d/%Y",
        "short": "%a, %b %e",
        "long": "%B %d, %Y",
        "full": "%a, %B %d / %Y",
        "calendar_picker": "YYYY/MM/DD"
      }
    },
    "activities": {
      "trekking": "トレッキング",
      "horseback": "乗馬",
      "birdwatching": "バードウォッチング",
      "mountaineering": "登山",
      "icehike": "アイスハイク",
      "kayak": "カヤック",
      "flyfishing": "フライフィッシング",
      "navigations": "航海",
      "cruises": "クルーズ",
      "helicopter": "ヘリコプター",
      "multiactivity": "マルチアクティビティ",
      "photosafari": "フォトサファリ",
      "bikes": "自転車",
      "snowshoes": "スノーシュー",
      "ski": "スキー",
      "rafting": "ラフティング"
    },
    "filters": {
      "clear_filters": "フィルターをクリア"
    },
    "lang": {
      "countries": {
        "spain": "スペイン",
        "argentina": "アルゼンチン",
        "bolivia": "ボリビア",
        "chile": "チリ",
        "colombia": "コロンビア",
        "costa_rica": "コスタリカ",
        "ecuador": "エクアドル",
        "mexico": "メキシコ",
        "peru": "ペルー",
        "paraguay": "パラグアイ",
        "uruguay": "ウルグアイ",
        "united_states": "アメリカ",
        "england": "イギリス",
        "australia": "オーストラリア",
        "canada": "カナダ",
        "new_zealand": "ニュージーランド",
        "ireland": "アイルランド",
        "portugal": "ポルトガル",
        "brazil": "ブラジル",
        "france": "フランス",
        "germany": "ドイツ",
        "china": "中国",
        "hong_kong": "香港",
        "japan": "日本",
        "korea": "韓国",
        "singapore": "シンガポール",
        "taiwan": "台湾"
      }
    }
  },
  "ko": {
    "terms": {
      "head": {
        "conditions": "이용 약관",
        "privacy": "개인정보 보호정책",
        "cookies": "쿠키 정책",
        "you_as_a_consumer": "소비자인 귀하는 계획대로 여행을 수행하는 데 필요할 수 있는 문서에 대해 알 권리가 있습니다. 여행 중 칠레 또는 다른 국가에 입국하기 위해 여권, 비자, 백신, 미성년자 허가 또는 기타 문서가 필요한지 미리 확인하십시오. 이 중 하나라도 필요하고 가지고 있지 않다면 미리 준비하십시오."
      }
    },
    "devise": {
      "google_sign_in": "Google로 로그인",
      "facebook_sign_in": "Facebook으로 로그인",
      "apple_sign_in": "Apple로 로그인",
      "already_have_an_account?": "계정이 있으신가요?",
      "didn''t_receive_confirmation_instructions?": "확인 메일을 받지 못하셨나요?",
      "didn''t_receive_unlock_instructions?": "잠금 해제 메일을 받지 못하셨나요?",
      "forgot_your_password?": "비밀번호를 잊으셨나요?",
      "don''t_have_an_account?": "계정이 없으신가요?",
      "enter_email_associated": "계정과 연결된 이메일 주소를 입력하면 비밀번호 재설정 링크를 이메일로 보내드립니다.",
      "passwordless": {
        "not_found_in_database": "해당 이메일 주소의 사용자를 찾을 수 없습니다.",
        "magic_link_sent": "로그인 링크가 이메일 주소로 전송되었습니다. 링크를 클릭하여 계정에 로그인하십시오.",
        "magic_link_sent_paranoid": "계정이 존재하는 경우 로그인 링크가 포함된 이메일을 받게 됩니다. 링크를 클릭하여 계정에 로그인하십시오."
      },
      "confirmations": {
        "confirmed": "이메일 주소가 성공적으로 확인되었습니다.",
        "send_instructions": "몇 분 내에 이메일 주소 확인 방법에 대한 지침이 포함된 이메일을 받게 됩니다.",
        "send_paranoid_instructions": "이메일 주소가 데이터베이스에 존재하는 경우, 몇 분 내에 이메일 주소 확인 방법에 대한 지침이 포함된 이메일을 받게 됩니다."
      },
      "failure": {
        "magic_link_invalid": "유효하지 않거나 만료된 로그인 링크입니다.",
        "already_authenticated": "이미 로그인되어 있습니다.",
        "inactive": "계정이 아직 활성화되지 않았습니다.",
        "invalid": "%{authentication_keys} 또는 비밀번호가 잘못되었습니다.",
        "locked": "계정이 잠겼습니다.",
        "last_attempt": "한 번 더 시도하면 계정이 잠깁니다.",
        "not_found_in_database": "%{authentication_keys} 또는 비밀번호가 잘못되었습니다.",
        "timeout": "세션이 만료되었습니다. 계속하려면 다시 로그인하십시오.",
        "unauthenticated": "계속하려면 로그인하거나 가입해야 합니다.",
        "unconfirmed": "계속하려면 이메일 주소를 확인해야 합니다."
      },
      "mailer": {
        "magic_link": {
          "subject": "로그인 링크",
          "greeting": "안녕하세요 %{email}님!",
          "instructions": "아래 링크를 사용하여 로그인할 수 있습니다:",
          "login_button": "내 계정에 로그인",
          "expiration_notice": "링크는 %{expiration_time} 후에 만료됩니다."
        },
        "confirmation_instructions": {
          "subject": "확인 지침"
        },
        "reset_password_instructions": {
          "subject": "비밀번호 재설정 지침"
        },
        "unlock_instructions": {
          "subject": "잠금 해제 지침"
        },
        "email_changed": {
          "subject": "이메일 변경됨"
        },
        "password_change": {
          "subject": "비밀번호 변경됨"
        }
      },
      "omniauth_callbacks": {
        "failure": "\"%{reason}\" 때문에 %{kind}에서 인증할 수 없습니다.",
        "success": "%{kind} 계정에서 성공적으로 인증되었습니다."
      },
      "passwords": {
        "no_token": "비밀번호 재설정 이메일에서 오지 않는 한 이 페이지에 액세스할 수 없습니다. 비밀번호 재설정 이메일에서 온 경우 제공된 전체 URL을 사용했는지 확인하십시오.",
        "send_instructions": "몇 분 내에 비밀번호 재설정 방법에 대한 지침이 포함된 이메일을 받게 됩니다.",
        "send_paranoid_instructions": "이메일 주소가 데이터베이스에 존재하는 경우 몇 분 내에 비밀번호 복구 링크가 이메일로 전송됩니다.",
        "updated": "비밀번호가 성공적으로 변경되었습니다. 이제 로그인되었습니다.",
        "updated_not_active": "비밀번호가 성공적으로 변경되었습니다."
      },
      "registrations": {
        "destroyed": "안녕히 가세요! 계정이 성공적으로 취소되었습니다. 다시 뵙기를 바랍니다.",
        "signed_up": "환영합니다! 성공적으로 가입되었습니다.",
        "signed_up_but_inactive": "성공적으로 가입되었습니다. 그러나 계정이 아직 활성화되지 않아 로그인할 수 없습니다.",
        "signed_up_but_locked": "성공적으로 가입되었습니다. 그러나 계정이 잠겨 있어 로그인할 수 없습니다.",
        "signed_up_but_unconfirmed": "확인 링크가 포함된 메시지가 이메일 주소로 전송되었습니다. 링크를 클릭하여 계정을 활성화하십시오.",
        "update_needs_confirmation": "계정이 성공적으로 업데이트되었지만 새 이메일 주소를 확인해야 합니다. 이메일을 확인하고 확인 링크를 클릭하여 새 이메일 주소를 확인하십시오.",
        "updated": "계정이 성공적으로 업데이트되었습니다."
      },
      "sessions": {
        "signed_in": "성공적으로 로그인되었습니다.",
        "signed_out": "성공적으로 로그아웃되었습니다.",
        "already_signed_out": "성공적으로 로그아웃되었습니다."
      },
      "unlocks": {
        "send_instructions": "몇 분 내에 계정 잠금 해제 방법에 대한 지침이 포함된 이메일을 받게 됩니다.",
        "send_paranoid_instructions": "계정이 존재하는 경우 몇 분 내에 계정 잠금 해제 방법에 대한 지침이 포함된 이메일을 받게 됩니다.",
        "unlocked": "계정이 성공적으로 잠금 해제되었습니다. 계속하려면 로그인하십시오."
      }
    },
    "errors": {
      "something_went_wrong": "문제가 발생했습니다",
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "허용되어야 합니다",
        "blank": "비워둘 수 없습니다",
        "confirmation": "%{attribute}와 일치하지 않습니다",
        "empty": "비워둘 수 없습니다",
        "equal_to": "%{count}와 같아야 합니다",
        "even": "짝수여야 합니다",
        "exclusion": "예약됨",
        "greater_than": "%{count}보다 커야 합니다",
        "greater_than_or_equal_to": "%{count}보다 크거나 같아야 합니다",
        "inclusion": "목록에 포함되어 있지 않습니다",
        "invalid": "유효하지 않습니다",
        "less_than": "%{count}보다 작아야 합니다",
        "less_than_or_equal_to": "%{count}보다 작거나 같아야 합니다",
        "model_invalid": "유효성 검사 실패: %{errors}",
        "not_a_number": "숫자가 아닙니다",
        "not_an_integer": "정수여야 합니다",
        "odd": "홀수여야 합니다",
        "other_than": "%{count} 이외여야 합니다",
        "present": "비워둬야 합니다",
        "required": "존재해야 합니다",
        "taken": "이미 사용 중입니다",
        "must_contain_number": " 하나 이상의 숫자를 포함해야 합니다",
        "must_contain_special": " 특수 문자를 포함해야 합니다",
        "must_contain_lower": " 하나 이상의 소문자를 포함해야 합니다",
        "must_contain_upper": " 하나 이상의 대문자를 포함해야 합니다",
        "too_long": {
          "one": "너무 깁니다(최대 1자)",
          "other": "너무 깁니다(최대 %{count}자)"
        },
        "too_short": {
          "one": "너무 짧습니다(최소 1자)",
          "other": "너무 짧습니다(최소 %{count}자)"
        },
        "wrong_length": {
          "one": "길이가 잘못되었습니다(1자여야 함)",
          "other": "길이가 잘못되었습니다(%{count}자여야 함)"
        },
        "already_confirmed": "이미 확인되었습니다. 로그인해 보십시오",
        "confirmation_period_expired": "%{period} 내에 확인해야 합니다. 새로 요청하십시오",
        "expired": "만료되었습니다. 새로 요청하십시오",
        "not_found": "찾을 수 없음",
        "not_locked": "잠기지 않음",
        "not_saved": {
          "one": "1개의 오류로 인해 이 %{resource}이(가) 저장되지 않았습니다:",
          "other": "%{count}개의 오류로 인해 이 %{resource}이(가) 저장되지 않았습니다:"
        }
      }
    },
    "meta_tags": {
      "default": {
        "description": "Outdoor Index와 함께 독점적인 모험 프로그램과 전문 가이드와 함께 칠레를 발견하십시오. 독특한 경험을 하십시오! 잊을 수 없는 여행을 예약하십시오.",
        "keywords": "파타고니아, 칠레, 모험 투어, 파타고니아 모험 투어, 칠레 모험 투어, 토레스 델 파이네 투어, 파타고니아 하이킹 투어, 파타고니아 카약 투어, 파타고니아 승마 투어, 파타고니아 멀티스포츠 투어, 파타고니아 가족 모험 투어, 파타고니아 럭셔리 모험 투어, 파타고니아 저예산 모험 투어, 파타고니아 최고의 모험 투어, 파타고니아 모험 여행, 파타고니아 모험 활동, 파타고니아 모험 여행, 파타고니아 모험 프로그램",
        "name": "Outdoor Index"
      },
      "help": {
        "title": "Outdoor Index - 도움말",
        "description": "파타고니아 여행에 대해 궁금한 점이 있으십니까? Outdoor Index를 방문하여 현지 가이드 및 분야 전문가와 상담하십시오.",
        "keywords": null
      }
    },
    "views": {
      "pagination": {
        "truncate": "…"
      }
    },
    "activerecord": {
      "models": {
        "season": "시즌",
        "seasons": "시즌"
      },
      "attributes": {
        "season": {
          "name": "이름",
          "valid_from": "유효 시작일",
          "valid_until": "유효 종료일",
          "start_time": "시작 시간",
          "product": "여행",
          "mon_check": "월",
          "tue_check": "화",
          "wed_check": "수",
          "thu_check": "목",
          "fri_check": "금",
          "sat_check": "토",
          "sun_check": "일"
        },
        "order": {
          "clp_charge": "CLP 요금",
          "usd_charge": "USD 요금",
          "username": "클라이언트:",
          "email": "이메일:",
          "product": "상품:",
          "product_name": "상품",
          "pax_manual": "인원:",
          "manual_total": "지불됨:",
          "manual_currency": "통화:",
          "partial_payment": "지불:",
          "payment_method": "방법:",
          "channel": "채널:",
          "confirmed_at": "구매:",
          "departure_at": "출발:",
          "starting_datetime": "출발 시간:",
          "customer_phone": "전화:",
          "extra": "추가:",
          "instructions": "지침:",
          "language": "언어:",
          "weather_link": "날씨 링크",
          "post_link": "게시물 링크",
          "itinerary_document": "여행 일정 문서",
          "show_itinerary_document": "표시"
        }
      }
    },
    "promotions": {
      "coupon_code_ok": "쿠폰 코드가 성공적으로 적용되었습니다",
      "coupon_code_error": "쿠폰 코드가 존재하지 않습니다",
      "coupon_code_already": "쿠폰 코드가 이미 적용되었습니다",
      "coupon_code_max": "주문당 최대 1개의 쿠폰",
      "coupon_code_destroy_ok": "코드가 성공적으로 제거되었습니다",
      "coupon_code_destroy_error": "코드를 제거할 수 없습니다",
      "coupon_code_destroy_confirm": "정말 삭제하시겠습니까?",
      "coupon_have_a_coupon": "할인 쿠폰이 있으십니까?",
      "coupon_form_palceholder": "할인 코드",
      "coupon_apply": "적용"
    },
    "home_collections": {
      "home_reviews": "매년 350명 이상의 사람들이 Outdoor Index와 함께 여행합니다",
      "find_your_experience": "경험 찾기",
      "carousel_region": "지역별 모험",
      "carousel_activities": "활동별 모험",
      "carousel_time_preference": "시간 선호도별 모험",
      "sub-landing": "Outdoor Index와 함께 칠레 최고의 관광 옵션을 발견하십시오. 아타카마에서 파타고니아까지 다양한 프로그램을 비교하고 탐색하십시오. 오늘 예약하여 독특한 경험을 하십시오!",
      "title": "칠레와 파타고니아의 모험 투어",
      "subtitle": "최고의 현지 가이드와 함께 모험 찾기"
    },
    "products_search": {
      "activities": "활동",
      "regions": "지역",
      "time": "시간",
      "date": "날짜",
      "date_sub_label": "언제 가고 싶으십니까?",
      "activities_sub_label": "좋아하는 활동 선택",
      "regions_sub_label": "어느 지역을 방문하고 싶으십니까?",
      "time_sub_label": "시간 선호도를 선택하십시오!",
      "all_adventures": "모든 모험",
      "search_placeholder": "칠레 전역의 모험 검색",
      "most_popular_searches": "인기 검색",
      "see_all_adventures": "모든 모험 보기",
      "help_me_choose": "선택을 도와주세요",
      "help_me_choose_url": "https://api.whatsapp.com/send?phone=56981785011&text=Hi%2C%20I%20need%20help%20choosing%20an%20adventure",
      "popular_search_items": {
        "circuito_w": {
          "label": "Circuito W",
          "icon": "search",
          "landing_slug": "circuito-w"
        },
        "circuito_o": {
          "label": "Circuito O",
          "icon": "search",
          "landing_slug": "circuito-o"
        },
        "torres_del_paine": {
          "label": "Torres del Paine",
          "icon": "map-pin",
          "zone_id": 1
        },
        "pucon": {
          "label": "Pucón",
          "icon": "map-pin",
          "zone_id": 16
        },
        "san_pedro_atacama": {
          "label": "San Pedro de Atacama",
          "icon": "map-pin",
          "zone_id": 15
        },
        "puerto_natales": {
          "label": "Puerto Natales",
          "icon": "map-pin",
          "zone_id": 2
        }
      },
      "search": "검색",
      "clear": "선택 취소",
      "tours": "투어",
      "subtext": "다음 모험을 계획하세요.\n탐험하고, 예약하고, 자연을 즐기세요.",
      "in": "위치:",
      "showing_count": "총 %{total}개 중 %{loaded}개 표시",
      "load_more": "더 보기"
    },
    "comments": {
      "comments": "댓글",
      "replies": "답글",
      "post_a_comment": "댓글을 남겨주세요!",
      "submit": "제출",
      "reply": "답글",
      "body": "여기에 댓글을 작성하세요..."
    },
    "order": {
      "confirmed": "확인됨",
      "mail_thank": "Outdoor Index에서 구매해 주셔서 감사합니다",
      "mail__hi": "안녕하세요!",
      "mail_subject": "Outdoor Index 주문 N#",
      "order_t": "주문",
      "see_purchase": "구매 내역 확인!",
      "already_paid": "주문이 이미 결제되었습니다",
      "confirm_payment": "확인",
      "cancel_order": "취소",
      "recover_order": "복구",
      "send_confirm": "확인 (1)",
      "send_reminder": "알림 (2)",
      "send_last_reminder": "재알림 (3)",
      "send_review": "검토 (4)",
      "email_title": "여행 알림",
      "email_footer": "여행 알림입니다. 궁금한 점이 있으면 언제든지 info@outdoorindex.cl 또는 +56981785011로 문의해 주십시오.",
      "promo": "더 많은 여행 및 프로그램은 www.outdoorindex.cl을 방문하십시오.",
      "edit": "편집",
      "departure_date": "출발 날짜",
      "reservation": "예약",
      "code": "코드",
      "departure": "출발",
      "contact_info": "연락처 정보",
      "customer_phone": "연락처 전화번호",
      "travelers": "여행자",
      "itinerary": "일정",
      "view_itinerary": "일정 다운로드",
      "view_itinerary_file": "여기",
      "voucher": "바우처 보기",
      "confirmation_email_title": "%{excursion} 예약이 확정되었습니다",
      "view_weather_link": "날씨 확인",
      "instruction_exerpt": "여행이 다가오고 있습니다. 이미 준비하고 계시겠지요?",
      "here_some_instructions": "지침",
      "view_post_link": "블로그",
      "review_email_title": "여행은 어떠셨는지 알려주세요 %{excursion}",
      "review_link": "여행 후 설문조사 응답하기",
      "review_trustpilot_intro": "다른 여행자에게도 경험을 알리고 싶다면 Trustpilot에 공개 리뷰를 남길 수도 있습니다.",
      "review_trustpilot_link": "Trustpilot에 리뷰 남기기",
      "review_question": "여행은 어떠셨나요?",
      "review_explain_title": "설문조사에 응답하는 것이 중요한 이유",
      "rewview_explain_body": "<p>귀하의 의견은 모든 여행을 개선하는 데 도움이 됩니다. 여행 후 설문조사는 비공개이며, 조직, 가이드, 활동 및 인상 깊었던 세부 사항 등 경험을 파악하는 데 도움이 됩니다.</p>\n<p>여행 전, 도중, 후의 경험을 되돌아보세요. 솔직하게 응답하는 데 몇 분이면 충분합니다.</p>\n<p>귀하의 답변은 서비스 품질을 유지하고 앞으로의 여행자를 위해 계속 개선하는 데 도움이 됩니다.</p>\n",
      "review_terrible": "끔찍함",
      "review_bad": "나쁨",
      "review_acceptable": "보통",
      "review_good": "좋음",
      "review_great": "훌륭함",
      "new_order_excerpt": "여기에서 주문을 생성하는 데 필요한 모든 정보를 완료할 수 있습니다. 각 예약의 시간과 만남 장소를 나타내는 명확하고 정확한 지침을 작성하십시오. 또한 우선 순위에 따라 운영자에게 연락하는 것을 잊지 마십시오."
    },
    "ondemand": {
      "explanation": "독점 투어! 현장 전문가에게 문의하십시오.",
      "label": "프라이빗"
    },
    "request": {
      "greeting": "안녕하세요! 이 정보는 등록된 이메일로 전송되었으며 대리인 중 한 명에게 사본이 전송되었습니다. 곧 연락드리겠습니다.",
      "order_mail": {
        "header": {
          "hi": "안녕하세요! 여행 신청에 대한 소식이 있습니다!",
          "title": "현지 운영자가 귀하의 신청을 수락했습니다. 아래 정보를 읽고 모든 것이 올바른지 확인하십시오.",
          "your_order": "주문 번호 N°",
          "ready": "결제 가능합니다."
        },
        "footer": "이제 버튼 링크를 통해 결제 섹션으로 이동할 수 있습니다.",
        "disclaimer": "Outdoor Index의 보안 연결을 통해 결제 창으로 리디렉션됩니다.",
        "pay": "지금 결제",
        "excursion": {
          "title": "여행",
          "agency": "현지 운영자"
        },
        "manual_order": {
          "observations": "아래의 Outdoor Index 대리인 의견을 읽어보세요!",
          "price": "가격",
          "price_clp": "가격 CLP",
          "price_usd": "가격 USD"
        },
        "request_details": "신청 세부 정보"
      },
      "singular": "요청",
      "requester": "요청자",
      "product_required": "주문을 요청하려면 먼저 로그인해야 합니다",
      "excursion": "여행",
      "applicants": "신청자",
      "from": "시작",
      "to": "종료",
      "comments": "댓글",
      "comments_placeholder": "연락하기 전에 질문, 의문점 또는 하고 싶은 말을 남겨주세요. 가능한 한 빨리 연락드리겠습니다!",
      "submit": "신청서 보내기",
      "email_title": "여행 조정 신청",
      "email_footer": "이 양식은 임원에게 전송되었습니다. 연락처 양식에 제공한 정보를 통해 연락을 드릴 것입니다. 양식에 오류나 의견이 있는 경우 문제와 관련하여 info@outdoorindex.cl로 이메일을 보내주십시오.",
      "contact_name": "담당자 이름",
      "contact_email": "담당자 이메일",
      "contact_phone": "담당자 전화번호",
      "must_log_in": "결제하려면 로그인해야 합니다",
      "phone": "담당자 전화번호",
      "name": "이름",
      "last_name": "성"
    },
    "applicants": {
      "applicants_number": "2) 여행에 몇 명이 참여합니까?",
      "dates_sub": "3) 이 여행을 며칠 동안 하시겠습니까?",
      "additional_info": "4) 추가 정보",
      "applicants_phone": "1) 연락처 정보를 남겨주세요",
      "phone_placeholder": "전화번호",
      "email": "이메일",
      "name": "이름",
      "lastname": "성"
    },
    "active_admin": {
      "observed_dollar_update": "업데이트",
      "agency": "운영자",
      "agencies": "운영자",
      "settings": "설정",
      "users": "사용자",
      "admin_users": "관리자 사용자",
      "orders": "주문",
      "pages": "페이지",
      "sales": "판매",
      "sale_goals": "판매 목표",
      "reviews": "리뷰",
      "blog": "블로그",
      "suppliers": "공급업체",
      "covers": "표지",
      "excursions": "여행",
      "categories": "카테고리",
      "comments_tab": "댓글",
      "excursion_images": "여행 이미지",
      "home": "홈",
      "home_collections": "홈 컬렉션",
      "save_home_collections": "컬렉션 저장",
      "images": "게시물 이미지",
      "mailer": "메일러",
      "newsletter_covers": "뉴스레터 표지",
      "notifications": "알림",
      "payment_methods": "결제 방법",
      "private": "비공개",
      "products": "상품",
      "profiles": "프로필",
      "properties": "속성",
      "promotions": "프로모션",
      "question_subjects": "질문 주제",
      "questions": "질문",
      "tourists": "관광객",
      "requests": "요청",
      "tags": "태그",
      "visits": "방문",
      "zones": "구역",
      "seasons": "시즌",
      "macro_zones": "매크로 구역",
      "landings": "랜딩 페이지",
      "post": {
        "title": "제목",
        "subtitle": "부제목",
        "label": "라벨",
        "author_name": "저자 이름",
        "author_sm": "저자 소셜 미디어",
        "content": "내용",
        "cover": "표지",
        "published": "게시됨",
        "unpublished": "게시 취소됨",
        "tags": "태그",
        "recommended_posts": "추천 게시물",
        "products": "투어 및 여행",
        "explore_chile": "Outdoor Index와 함께 칠레와 숨겨진 보석 탐험하기"
      },
      "zone": {
        "name": "이름",
        "description": "설명",
        "sort_order": "정렬 순서",
        "country": "국가",
        "state": "주/도"
      },
      "review": {
        "tilte1": "리뷰 작성",
        "title2": "표지",
        "author": "이름",
        "country": "국가",
        "review_date": "리뷰 날짜",
        "language": "언어",
        "save_review": "리뷰 저장",
        "body": "리뷰 내용",
        "cover": "표지",
        "rating": "평점",
        "url": "URL",
        "excerpt": "여기에서 리뷰 작성에 필요한 모든 정보를 입력할 수 있습니다. 업로드하는 표지 사진의 해상도가 양호하고 올바른지 항상 확인하십시오. 정보를 잘 읽고 확인하십시오."
      },
      "landing": {
        "tilte1": "랜딩 페이지 생성",
        "title2": "메타",
        "title3": "표지",
        "title4": "리뷰",
        "title5": "FAQ",
        "save_landing": "랜딩 페이지 저장",
        "title": "제목",
        "place": "장소",
        "body": "본문",
        "cover": "표지",
        "review": "리뷰",
        "meta_title": "메타 제목",
        "meta_description": "메타 설명",
        "product": "여행",
        "excerpt": "여기에서 랜딩 페이지 생성에 필요한 모든 정보를 입력할 수 있습니다. 업로드하는 표지 사진의 해상도가 양호하고 관광객의 매력을 끌 수 있는지 항상 확인하십시오. 명확하고 신뢰할 수 있는 정보를 제공하십시오.",
        "more_info": "더 많은 정보"
      },
      "season": {
        "name": "이름",
        "valid_from": "부터",
        "valid_until": "까지",
        "start_time": "시작 시간",
        "product": "여행",
        "child_usd_price": "어린이 (달러)",
        "child_clp_price": "어린이 (CLP)",
        "single_supplement_usd_price": "달러",
        "single_supplement_clp_price": "CLP",
        "guardar_temporada": "저장",
        "daily_quota": "가용성",
        "title_days": "일수",
        "title_ages": "연령",
        "title_prices_kids": "어린이 가격",
        "title_prices_adults": "성인 가격",
        "title_single_supplement": "싱글 추가 요금"
      },
      "kpis": {
        "observed_dollar": "관측 달러 가치",
        "observed_dollar_subtitle": "중앙 은행이 정의한 달러 가치",
        "visits_today_title": "오늘의 방문",
        "visits_today_subtitle": "오늘의 흐름",
        "visitors": "방문자",
        "last_day": "전날",
        "show_more": "더 보기",
        "countries": "국가",
        "countries_subtitle": "우리를 가장 많이 방문하는 사람들",
        "country_anon": "익명",
        "abandoned_cart_title": "버려진 배낭",
        "abandoned_cart_subtitle": "배낭에 남겨진 주문",
        "products_viewed_title": "가장 많이 본 상품",
        "products_viewed_subtitle": "현재 가장 인기 있는 상품",
        "posts_viewed_title": "가장 많이 본 게시물",
        "posts_viewed_subtitle": "현재 가장 인기 있는 게시물",
        "products_selled_title": "베스트셀러 상품",
        "products_selled_subtitle": "작년",
        "today_excursions_title": "오늘의 여행",
        "today_excursions_subtitle": "오늘 투어를 떠나는 관광객.",
        "users_month_title": "월별 통계",
        "users_month_subtitle": "월별 사용자 통계 잔고.",
        "users_number": "사용자 수",
        "new_users_title": "신규 사용자",
        "new_users_subtitle": "지난달 등록",
        "users_total_title": "총 사용자",
        "users_total_subtitle": "시작부터 등록됨",
        "new_users_title_box": "오늘의 사용자",
        "new_users_subtitle_box": "당일 방문 흐름",
        "users": "사용자",
        "new_orders_title": "신규 주문",
        "new_orders_subtitle": "이번 달 등록",
        "paid_orders_title": "결제된 주문",
        "paid_orders_subtitle": "이번 달 등록",
        "sale_goals_title": "판매 목표",
        "sale_goals_subtitle": "이번 달 총 수익",
        "goals": "목표",
        "to": null,
        "no_sale_goal": "판매 목표가 정의되지 않음",
        "conversion_chart_title": "전환 차트",
        "conversion_chart_subtitle": "작년 전환율",
        "conversion_last_year": "작년 전환율",
        "conversion_title": "전환율",
        "conversion_subtitle": "현재까지 업데이트됨"
      }
    },
    "mercado_pago": {
      "error_alert": "Mercado Pago오류가 발생했습니다. 주문이 지불되었는지 확인하십시오.",
      "error_title": "거래 거부됨",
      "error_dec": "결제 처리 중 오류가 발생했습니다. 다시 시도하십시오. 문제가 지속되면 당사에 문의하십시오.",
      "pending_title": "거래 보류 중",
      "pending_dec": "귀하의 결제는 Mercado Pago에서 확인 대기 중입니다. 확인 후 주문을 확인하려면 당사에 문의하십시오."
    },
    "webpay": {
      "error_alert": "Webpay오류가 발생했습니다. 주문이 지불되었는지 확인하십시오.",
      "error_title": "거래 거부됨",
      "error_dec": "결제 처리 중 오류가 발생했습니다. 다시 시도하십시오. 문제가 지속되면 당사에 문의하십시오."
    },
    "back": "뒤로",
    "chat_title": "무엇을 도와드릴까요?",
    "chat_subtitle": "보통 몇 시간 내에 응답합니다",
    "chat_name": "이름",
    "chat_email": "이메일",
    "chat_phone": "전화번호",
    "chat_subject": "주제",
    "chat_body": "내용",
    "chat_btn": "메시지 보내기",
    "menu_welcome": "환영합니다, %{user_name}님",
    "meesage_sended": "메시지가 전송되었습니다",
    "meesage_captcha": "캡차를 확인해야 합니다",
    "view_more": "더 보기...",
    "view_more_excursions": "더 많은 여행 보기...",
    "view_more_suggestions": "더 많은 추천 보기...",
    "location": "위치",
    "zone": "구역",
    "category": "카테고리",
    "select_one": "하나 선택",
    "select_multiple": "다중 선택",
    "select_two": "최대 2개",
    "price": "가격",
    "vacancies": "공석",
    "key": "예: 고도",
    "value": "1300 mt",
    "value_included": "예: 이중 언어 가이드",
    "profiles": "프로필",
    "optional": "선택 사항",
    "email": "이메일",
    "phone": "전화번호",
    "address": "주소",
    "pending": "보류 중",
    "edit": "편집",
    "soon": "곧",
    "password": "비밀번호 (최소 8자, 문자, 숫자 포함)",
    "password_confirmation": "비밀번호 확인",
    "remember_me": "기억하기",
    "log_in": "로그인",
    "sign_up": "가입하기",
    "create_an_account": "계정 만들기",
    "name": "이름",
    "last_name": "성",
    "back_to": "돌아가기",
    "reset_password": "비밀번호 복구",
    "send": "보내기",
    "guests": "성인",
    "guest": "성인",
    "guest_s": "성인",
    "child_guest": "어린이",
    "child_guests": "어린이",
    "child_guest_s": "어린이",
    "products": "상품",
    "products_show_photos": "(%{n})장의 사진 보기",
    "delete": "삭제",
    "continue": "계속",
    "subtotal": "소계:",
    "total_only": "합계",
    "total": "결제할 총액:",
    "total_paid": "지불된 총액",
    "total_final": "최종 합계",
    "coupon": "쿠폰",
    "charges": "요금:",
    "image_not_found": "이미지를 찾을 수 없음",
    "usd": "USD",
    "clp": "CLP",
    "departure": "출발",
    "when": "언제",
    "what": "무엇을",
    "where": "어디로",
    "search": "검색",
    "language": "언어",
    "puerto_natales": "푸에르토 나탈레스",
    "punta_arenas": "푼타 아레나스",
    "tierra_del_fuego": "티에라 델 푸에고",
    "puerto_williams": "푸에르토 윌리엄스",
    "in": "에서",
    "or": "또는",
    "help": "자주 묻는 질문",
    "go_to_home_page": "홈으로 가기",
    "add_row": "+ 추가",
    "from": "부터",
    "days": "일",
    "hours": "시간",
    "home": {
      "site_title": "Outdoor Index: 파타고니아 및 칠레 모험 투어 예약",
      "things_to_do_in": "추천 장소:",
      "scientific_excursions": "자연과의 깊은 교감",
      "luxury_experience": "당신만을 위한 특별한 경험",
      "adventure_excursions": "더 적극적인 참여",
      "the_best_excursions": "이번 시즌 최고의 여행",
      "explore_your_interests": "관심 분야 탐색",
      "excursions": "여행",
      "products": "상품",
      "suggestions": "추천",
      "hard_adventurous": "활동적",
      "soft_adventurous": "변화",
      "scientific": "발견",
      "family": "그룹",
      "luxury": "세련됨",
      "promotions": "할인 및 혜택",
      "download": "다운로드",
      "adventures_by_region": "지역별 모험",
      "north_patagonia": "북부 파타고니아",
      "south_patagonia": "남부 파타고니아",
      "masonry_zone_count": "%{count}개 모험"
    },
    "masonry_zones": {
      "names": {
        "1": "토레스델파이네",
        "2": "푸에르토 나탈레스",
        "3": "풍타 아레나스",
        "4": "티에라 델 퓨에고",
        "5": "푸에르토 윌리엄스",
        "6": "남극"
      }
    },
    "survey_page": {
      "title": "Outdoor Index - 판매 후 설문 조사",
      "description": "귀하가 받은 서비스에 대한 귀하의 의견을 듣고 싶습니다. 귀하의 피드백은 우리에게 매우 중요합니다.",
      "main_heading": "Outdoor Index 여행 후 설문 조사"
    },
    "header": {
      "agency_panel": "대리점 패널",
      "supplier_panel": "공급업체 패널",
      "ask_us_a_question": "문의하기",
      "help": "자주 묻는 질문",
      "itinerary": "여행 일정",
      "sign_out": "로그아웃",
      "sign_up": "가입",
      "log_in": "로그인",
      "join_our_newsletter": "뉴스레터 가입",
      "partner": "파트너",
      "blog": "독점 스토리:",
      "your_blog": "블로그 🔥",
      "config": "설정",
      "orders": "바우처",
      "cart": "장바구니"
    },
    "header_cat": {
      "excursions": "여행",
      "recommendations": "추천",
      "accommodation": "숙박",
      "other": "기타"
    },
    "agencies": {
      "address": "주소",
      "review": "리뷰",
      "agency_type": "대행사 유형",
      "owner": "소유자",
      "holder_name": "소유자 이름",
      "holder_id": "소유자 ID",
      "holder_email": "소유자 이메일",
      "phone": "전화번호",
      "bank_name": "은행 이름",
      "account_type": "계좌 유형",
      "account_number": "계좌 번호",
      "agency": "운영자",
      "country": "국가",
      "state": "주/도",
      "zone": "구역",
      "duration": "기간",
      "created_at": "생성일",
      "agency_info": "정보",
      "supplier_info": "정보",
      "products": "상품",
      "numbers": "통계",
      "excursions": "여행",
      "list_title": "모든 날짜 목록",
      "no_dates": "아직 날짜가 없습니다. 날짜를 생성하려면 달력을 클릭하십시오.",
      "change_availability": "날짜 관리",
      "date_range": "날짜 범위에 따라 수정",
      "set_price": "가격 설정",
      "rooms_to_add": "추가할 방",
      "rooms_to_remove": "제거할 방",
      "products_to_add": "상품 추가",
      "products_to_remove": "상품 제거",
      "apply_changes": "변경 사항 적용",
      "edit_excerpt": "공급업체 프로필 생성에 필요한 모든 정보는 Outdoor Index와의 상업적 관계를 수립하는 데 매우 중요합니다. 최신 정보를 입력하십시오.",
      "agency_information": "운영자 정보",
      "supplier_information": "공급업체 정보",
      "max_words": "150 단어",
      "for_booking": "예약용",
      "supplier_review": "공급업체 리뷰 ",
      "website_url": "웹사이트 URL",
      "person_in_charge": "담당자",
      "name": "이름",
      "update_info": "프로필 저장",
      "commercial_information": {
        "self": "상업 정보",
        "name": "이름",
        "bank_name": "은행 이름",
        "bank_account": "은행 계좌",
        "account_type": "계좌 유형",
        "commercial_name": "상호",
        "id_rut": "ID / Rut"
      },
      "actions": "작업",
      "manage_dates": "날짜",
      "active": "승인됨",
      "pending_changes": "보류 중",
      "index_excerpt": "상품 목록입니다. 날짜를 생성, 편집 및 관리할 수 있습니다. 생성된 각 상품은 Outdoor Index 팀이 검토할 때까지 \"보류 중\" 상태로 유지됩니다.",
      "manage_dates_excerpt": "여기에 모든 상품을 추가할 수 있는 달력이 있습니다. 날짜를 생성, 편집 및 관리할 수 있습니다. 생성된 각 상품은 Outdoor Index 팀이 검토할 때까지 \"보류 중\" 상태로 유지됩니다.",
      "create_excursion": "여행 생성",
      "create_product": "상품 생성",
      "create_activity": "활동 생성",
      "create_post": "게시물 생성",
      "new_excursion_excerpt": "여기에서 상품 생성에 필요한 모든 정보를 입력할 수 있습니다. 업로드하는 사진의 해상도가 양호하고 관광객의 매력을 끌 수 있는지 항상 확인하십시오. 명확하고 신뢰할 수 있는 정보를 제공하십시오.",
      "english": "영어로 번역 →",
      "spanish": "스페인어로 번역 →",
      "create_agency": "새 운영자 생성",
      "agency_bank": "은행 계좌 추가"
    },
    "error": {
      "sorry": "Sorry, this page doesn't exist.",
      "opps": "You may have mistyped the address or the page may have moved.",
      "go": "Go to homepage",
      "went_wrong": "We're sorry, but something went wrong.",
      "improvements": "If you see this message, it's because you may have typed the web address incorrectly or because we are updating the site with new features and improvements. Please wait a few minutes and reload the page again. Thank you!"
    },
    "excursions": {
      "itinerary": {
        "body": "본문"
      },
      "faq": {
        "body": "본문"
      },
      "title": "제목",
      "location": "장소",
      "zone": "구역",
      "category": "카테고리",
      "profiles": "여행 스타일",
      "price": "가격(달러)",
      "vacancies": "공석",
      "duration": "기간",
      "half_day": "반나절",
      "full_day": "전일",
      "multiple_days": "수일",
      "duration_days": "일",
      "duration_hours": "시간",
      "days": {
        "zero": "일",
        "one": "일",
        "other": "일"
      },
      "hours": {
        "zero": "시간",
        "one": "시간",
        "other": "시간"
      },
      "add_images_(minimum_3)": "사진(최소 3장)",
      "disclaimer": "면책 조항",
      "description": "개요",
      "body": "우리의 여행 일정",
      "useful_information": "유용한 정보",
      "what's_included?": "포함됨",
      "what's_not_included?": "포함되지 않음",
      "meeting_instruction": "출발 장소",
      "meeting_address": "주소",
      "policies": "정책",
      "save_excursion": "여행 저장",
      "what_we'll_do": "개요",
      "our_itinerary": "여행 일정",
      "faqs": "자주 묻는 질문",
      "images": "이미지",
      "edit_excerpt": "공급업체 프로필을 생성하기 위해 요청된 모든 정보는 Outdoor Index와의 상업적 연결을 구축하는 데 필수적입니다. 가능한 한 신뢰할 수 있는 정보를 입력하십시오.",
      "other_excursions_from_this_tour_company": "이 공급업체의 다른 경험",
      "create_excursions": "여행 생성",
      "more": "더 보기",
      "less": "덜 보기",
      "best_excursions_for_the_next_season": "이번 시즌 추천",
      "add_extras": "추가 사항 추가",
      "price_per_reservations": "예약당 가격",
      "extra_description": "활동",
      "macro_zone": "매크로 구역",
      "meta_title": "메타 제목",
      "meta_description": "메타 설명",
      "time": "시간",
      "prices": "가격",
      "included": "무엇이 포함되었습니까?",
      "locations": "위치",
      "alternative_names": "여행은 다음 이름으로도 알려져 있습니다",
      "breadcrumb_catalog": "투어 및 여행"
    },
    "hotels": {
      "twin": "Twin",
      "double": "Double",
      "double_twins": "Double twin",
      "room_reserved": "room reserved",
      "edit_your_booking": "Edit your booking"
    },
    "reservations": {
      "add_guest_details": "여행자 정보 추가",
      "traveler_data_card_title": "여행자 정보",
      "traveler_data_badge_missing": "정보 부족",
      "traveler_data_badge_complete": "완료",
      "traveler_data_badge_ready_details": "정보 완료",
      "traveler_data_intro": "예약을 확정하려면 아래 정보가 필요합니다.",
      "traveler_data_complete_button": "여행자 정보",
      "detach_guest_confirm": "이 예약에서 해당 여행자를 제거할까요?",
      "guest_slots_full": "이 예약에는 이미 필요한 인원의 여행자가 모두 등록되어 있습니다.",
      "organize_your_itinerary": "1) 여행 일정 >",
      "create_your_travel_group": "2) 여행 그룹 >",
      "assign_tourists": "3) 여행자 배정",
      "new_checkout_excerpt": "여기에서 상품 목록을 찾을 수 있습니다. 해당 여행에 참여하는 게스트의 정보를 추가하는 것을 잊지 마십시오. 구매하기 전에 예약 수와 비용을 확인하십시오. 취소 정책을 읽어주십시오.",
      "cart_title": "여행 정보",
      "checkout_page_title": "예약을 확인하고 결제를 진행하세요",
      "checkout_page_intro": "여행 정보를 확인하고 여행자 정보를 입력한 뒤 결제 수단을 선택하세요.",
      "checkout_trip_summary_heading": "여행 요약",
      "pay_with": "결제 수단",
      "cart_subtitle": "배낭에 있는 모든 상품 목록",
      "itinerary_excerpt": "여기에서 모든 상품 목록을 찾을 수 있습니다. 다음 단계로 진행하기 전에 정보가 올바른지 확인하십시오. 중요: 모든 시간과 날짜는 현지 시간으로 표시됩니다.",
      "assign_excerpt": "이 섹션에서는 어떤 여행자가 어떤 여행에 참여할지 지정합니다. 그렇게 하면 최상의 경험을 제공하는 데 필요한 모든 정보를 얻을 수 있습니다.",
      "list_of_products": "상품 목록",
      "reservations_made": "#",
      "assing_tourists": "여행자 배정",
      "go_to_checkout": "계속",
      "a_list_of_all_your_reservations": "모든 예약",
      "my_group": "나의 그룹",
      "people_(including_you)": "인원(본인 포함)",
      "(me)": "(나)",
      "team_member": "팀원",
      "actions": "작업",
      "you_have_no_reservations": "예약이 없습니다",
      "tourists_group": "이 섹션에서는 동행할 모든 사람의 정보를 추가해야 합니다. 첨부된 정보는 가능한 한 신뢰할 수 있어야 합니다.",
      "edit_your_reservation": "예약 편집",
      "cancel_date": "취소 날짜",
      "departure_date": "출발 날짜",
      "reserves": "예약",
      "update": "업데이트",
      "not_enough": "충분하지 않음",
      "too_many": "너무 많음",
      "product_for": "상품 대상",
      "tourists_assigned": "배정된 여행자",
      "many_few_tourists": "배정된 여행자가 예약 수와 일치하지 않습니다",
      "select_your_extras": "추가 사항 선택:",
      "product_variants": "옵션",
      "select_date_first": "먼저 날짜 선택",
      "total_price": "총 가격",
      "see_details": "세부 정보 보기",
      "price_chilean": "칠레 거주자 총액:",
      "price_no_chilean": "비칠레 거주자 총액:",
      "single_supplement": "싱글 서플리먼트:",
      "people": "인원:",
      "details_of_purchase": "구매 내역",
      "confirmed_excerpt": "저희와 함께 여행해 주셔서 감사합니다!",
      "confirmed_excerpt_litle": "바우처를 확인하여 구매 내역을 확인하십시오.",
      "cart_empty": "배낭이 비어 있습니다"
    },
    "checkout": {
      "do_checkout": "결제",
      "confirm_checkout_excerpt": "계속하기 전에 모든 것이 올바른지 확인하십시오. 이 주문을 수락하면 변경할 수 없습니다.",
      "confirm_checkout_excerpt_2": "(새 주문을 생성할 수는 있습니다.)",
      "please_confirm_your_details": "세부 정보를 확인하십시오",
      "i_need_to_change_something": "변경해야 할 사항이 있습니다",
      "everything_looks_fine": "모든 것이 좋아 보입니다",
      "after_this_step": "이 단계 후 Outdoor Index는 모든 제공업체에 연락합니다.",
      "providers_confirm_availability": "모든 제공업체가 주문을 확인하면 연락을 드립니다.",
      "payment_excerpt": "구매하기 전에 상품의 모든 세부 정보가 올바른지 확인하십시오. 예약 수와 비용을 확인하십시오. 취소 정책을 읽어주십시오.",
      "your_details_confirmation_and_payment": "상품 및 결제 세부 정보",
      "important!": "중요",
      "all_transactions_have_an_extra": "은행과 합의한 할부로 직불 카드 또는 신용 카드를 사용하여 결제할 수 있습니다. Outdoor Index는 판매 전액을 받습니다.",
      "get_a_refund_if": "구매 후 24시간 이내에 취소하면 환불받을 수 있습니다.",
      "pay_now": "결제 확인",
      "confirm_and_pay": "확인 후 결제",
      "wetravel_link_not_ready": "잠시 후 다시 시도하거나 WeTravel을 다시 선택해 주세요.",
      "mercado_wallet_not_ready": "Mercado Pago 버튼을 불러오는 중입니다. 잠시 후 다시 시도해 주세요.",
      "payment_summary": "결제 요약",
      "payment_method_title": "결제 수단",
      "payment_methods_locked_until_traveler_details": "결제 수단을 선택하기 전에 여행자 정보를 모두 입력해 주세요.",
      "payment_method_recommended": "추천",
      "payment_method_blurb": {
        "wetravel": "USD 국제 결제",
        "mercado_pago": "현지 카드 결제 및 은행 조건에 따른 할부",
        "webpay": "Webpay 은행카드 결제",
        "payu": "PayU 결제",
        "paypal": "PayPal 결제",
        "google_pay": "Google Pay 결제",
        "apple_pay": "Apple Pay 결제"
      },
      "total_to_pay": "결제할 금액",
      "secure_payment_note": "100% 안전한 암호화 결제",
      "help_widget_title": "맞춤 지원이 필요하신가요?",
      "help_widget_body": "Outdoor Index 가이드와 상담하여 맞춤형 안내를 받아보세요.",
      "help_widget_cta": "전문가와 상담하기",
      "help_widget_online": "온라인",
      "terms_toggle_line_html": "%{terms} 및 %{policy}에 동의합니다.",
      "terms_toggle_word_terms": "이용약관",
      "terms_toggle_word_policy": "개인정보 처리방침",
      "review": "검토",
      "ready": "준비",
      "choose_payment": "원하는 결제 방식 선택",
      "only_for_reservation": "예약",
      "complete_payment": "전액 결제",
      "30_p": "30%",
      "30_per": "30% 지불됨",
      "30_pers": "30% 지불됨",
      "100_p": "100%",
      "100_per": "100% 지불됨",
      "100_pers": "100% 지불됨",
      "i_hereby_accept": "\"결제 확인\"을 클릭하면",
      "and_confirm": "에 동의하고",
      "and_our": "및 당사의",
      "your_itinerary": "상세 일정",
      "continue_shopping": "쇼핑 계속하기",
      "not_available": "사용 불가",
      "disclaimer": "예약 정보",
      "some_products_deleted": "일부 상품은 더 이상 사용할 수 없습니다",
      "accept": "예, 동의합니다",
      "cancel": "취소",
      "must_have_tourist": "이메일과 전화번호가 추가된 여행자가 최소 1명 있어야 합니다.",
      "wetravel_partial_error": "여행 날짜가 너무 가까워 부분 결제를 이용할 수 없습니다. 전액 결제를 선택해 주세요."
    },
    "vouchers": {
      "active_excerpt": "바우처 세부 정보입니다. 검토하고 인쇄하십시오. 예약 주문 번호가 포함된 바우처를 제공해야 합니다.",
      "all_of_your_vouchers": "모든 바우처",
      "confirmed_excerpt": "구매해 주셔서 감사합니다. 아름다운 여행이 되시기를 바랍니다. 바우처를 인쇄하여 항상 소지하는 것을 잊지 마십시오. 질문이나 예상치 못한 상황이 발생하면 주저하지 말고 문의하십시오.",
      "active_vouchers": "활성 바우처",
      "disclaimer": "이 PDF에는 상품에 대한 모든 정보가 포함되어 있습니다. 문서를 확인하고 질문이 있으면 문의하십시오. 여행을 즐기십시오.",
      "get_your_voucher": "바우처 받기",
      "voucher": "바우처",
      "payment_error": "결제 오류.",
      "error": "결제 과정에서 문제가 발생했습니다. 나중에 다시 시도하거나 다른 결제 옵션에 대해 문의하십시오.",
      "restart_payment": "결제 다시 시작",
      "payment_rejected": "결제 거부됨",
      "rejected": "PayU/Paypal에서 결제가 거부되었습니다. 세부 정보를 확인하고 다시 시도하거나 다른 결제 옵션에 대해 문의하십시오.",
      "home": "홈",
      "order_number": "주문 번호:",
      "view": "보기",
      "print": "인쇄",
      "complete": "완료",
      "incomplete": "미완료",
      "activities": "활동",
      "was_partial_payment": "(2)"
    },
    "categories": {
      "search": "검색",
      "general": "일반",
      "general_category_search": "%{category_name} 일반 검색",
      "other_excursions_to_do": "%{zone_name}에서 할 수 있는 다른 경험",
      "general_zone_search": "%{zone_name}의 검색 제안",
      "recommended_for_you": "%{zone_name}의 경험"
    },
    "tourist": {
      "new_tourist_excerpt": "이 섹션에서는 동행할 모든 사람의 프로필 정보를 추가할 수 있습니다. 첨부된 정보는 가능한 한 신뢰할 수 있어야 합니다.",
      "personal_info": "개인 정보",
      "checkout_minimum_one_pax_notice": "계속하려면 한 명분의 정보가 있으면 됩니다. 나머지는 나중에 입력하셔도 됩니다.",
      "add_another_pax": "다른 동행자 추가",
      "info_pax_card_title": "동행자 정보",
      "name": "이름",
      "last_name": "성",
      "date_of_birth": "생년월일",
      "nationality": "국적",
      "passport": "여권",
      "hometown": "고향",
      "phone": "전화번호",
      "email": "이메일",
      "emergency_contact": "비상 연락처",
      "allergies": "알레르기",
      "medical_conditions": "의료 상태",
      "food_restrictions": "음식 제한",
      "pending": "보류 중",
      "ready": "준비 완료",
      "you_have_no_vouchers": "활성 바우처가 없습니다",
      "no_reservations_to_assign": "할당할 예약이 없습니다"
    },
    "footer": {
      "about_us": "회사 소개",
      "statement": "미션 선언문 읽기",
      "go_to_suscribe": "구독하기",
      "suscribe_text": "새로운 이야기와 여행 할인에 대한 업데이트를 격주로 보내드립니다.",
      "terms_&_conditions": "약관",
      "privacy_&_cookies": "개인정보",
      "contact_us": "문의하기",
      "edit_endorsement": "Outdoor Index는 푸에르토 나탈레스(칠레 남부 파타고니아)에 본사를 두고 있으며 40개 이상의 공급업체의 지원을 받고 있습니다.",
      "all_rights_reserved": "All rights reserved. 허가 없이 이 사이트의 어떤 부분도 복제할 수 없습니다.",
      "spanish": "스페인어",
      "english": "영어",
      "portuguese": "포르투갈어",
      "french": "프랑스어",
      "german": "독일어",
      "english_corto": "영",
      "spanish_corto": "서",
      "portuguese_corto": "포",
      "french_corto": "프",
      "german_corto": "독",
      "clp": "$ 칠레 페소 (CLP)",
      "usd": "$ 미국 달러 (USD)",
      "survey": "설문조사",
      "endorsement": {
        "support_local_comunity": "지역 지원, 지속 가능성 장려",
        "when_you_buy": "Outdoor Index에서 구매하면 35개 이상의 지역 공급업체의 품질 및 지속 가능한 관리를 장려하게 됩니다.",
        "instant_booking": "인증된 가이드가 100% 지원 가능",
        "by_entering_your": "체험 전, 도중, 후에 문의 사항을 해결하고 다음 모험을 계획하는 데 도움을 줍니다.",
        "payment_protection": "지금은 30%만 지불하세요. 나머지는 나중에",
        "we_comply_with_all": "과도한 지불 없이 계획을 가볍게 세우십시오. 지금 30%만 지불하여 예약을 확정하고 나머지는 날짜가 가까워지면 지불하십시오."
      },
      "covid": "Covid",
      "secure": "이 웹사이트를 통해 처리되는 모든 예약은 주요 파트너에 의해 보호됩니다.",
      "titles": {
        "book": "안심하고 예약하세요",
        "destinations": "인기 목적지",
        "activities": "인기 활동"
      },
      "lang-currency": "언어 및 통화"
    },
    "chat": {
      "hi": "안녕하세요",
      "our_chat_service": "채팅 서비스는 월요일부터 금요일, 오전 10시부터 오후 6시(UTC / GMT -3)까지 이용 가능합니다. 이 시간 내에 글을 남겨주시면 몇 분 안에 답변해 드리겠습니다.",
      "new-message": "새 메시지",
      "messages": "메시지",
      "enter_your_name": "이름 입력...",
      "enter_email": "이메일 입력...",
      "enter_message": "메시지 입력...",
      "create_message": "메시지 보내기",
      "begin": "시작",
      "user": "사용자",
      "need_help": "도움이 필요하십니까?",
      "talk_to_local_guide": "현지 가이드와 대화"
    },
    "registration": {
      "edit_user": "사용자 편집",
      "email": "이메일",
      "name": "이름",
      "lastname": "성",
      "confirm_password": "비밀번호 확인",
      "current_password": "현재 비밀번호",
      "new_password": "새 비밀번호",
      "profile_picture": "프로필 사진",
      "profiles": "프로필(하나 이상 선택)",
      "interests": "관심사(하나 이상 선택)",
      "notification": "알림 설정",
      "save_settings": "저장",
      "update_account": "계정 업데이트",
      "registration_excerpt": "원하는 대로 프로필을 관리하십시오. 알림을 활성화하거나 비활성화합니다. 이렇게 하면 Outdoor Index에서 받는 콘텐츠를 사용자 정의할 수 있습니다.",
      "vouchers": "바우처",
      "all_vouchers": "모든 바우처",
      "change_your_password": "비밀번호 재설정 또는 변경",
      "change_my_password": "비밀번호 변경",
      "confirm_new_password": "비밀번호 확인",
      "subtitle_password": "문자와 숫자를 포함하여 최소 8자 이상의 새 비밀번호를 만드십시오.",
      "password_requirements": "비밀번호가 유효하지 않습니다.",
      "passwords_dont_match": "비밀번호가 일치하지 않습니다."
    },
    "responsive": {
      "more": "More..."
    },
    "uploader": {
      "upload_a_file": "Upload a file",
      "drop_files_here": "Drop files here",
      "processing_dropped_files": "Processing dropped files..."
    },
    "sidebar_single": {
      "no_dates_available": "이용 가능한 날짜 없음",
      "disclaimer": "<strong>총 예약 금액의 30%</strong>만 지불하여 지금 자리를 확보하십시오.",
      "select_dates": "지금 예약",
      "share": "여행에 대해 질문이 있으십니까?",
      "to_make_a": "예약하려면 ",
      "log_in": "로그인",
      "or": "또는",
      "sign_up": "가입",
      "if_you_are": "신규 사용자인 경우.",
      "price_for": "1인당",
      "from": "가격",
      "contact_viewnia": "문의하기",
      "rates": "CLP 요금에는 VAT가 포함됩니다. USD 요금에는 VAT가 포함되지 않습니다. 외국 비거주자는 USD로 결제 시 면제됩니다."
    },
    "request_form": {
      "title": "Request Excursion",
      "contact_viewnia_subtitle": "Fill the form below to begin the process that will allow us to coordinate your excursion with our field specialist."
    },
    "modal_manage_date": {
      "discount": "Add a discount",
      "manage_date": "Manage date",
      "date": "Date",
      "starting_time": "Starting time",
      "price": "Price",
      "vacancies": "Vacancies",
      "save": "Save",
      "cancel_date": "Cancel date",
      "available_ammount": "Available amount",
      "month_form": {
        "edit_month": "Edit month",
        "delete_month": "Delete month",
        "populate_month": "Populate Month",
        "disclaimer_1": "You are about to edit <strong>an entire month</strong>, this action is <strong>hard to reverse</strong>.",
        "disclaimer_2": "Please double check your current calendar before you proceed, in order to avoid duplicates or other problems.",
        "accept": "Accept",
        "month": "Month",
        "week_days": "Week days",
        "continue": "Continue",
        "final_notice_header": "Please read carefully:",
        "final_notice_1": "Add a departure date for excursion <strong id='fn_title'></strong>, every <strong id='fn_week_days'></strong>  of <strong id='fn_month'></strong>.",
        "final_notice_2": "Each departure will start at <strong><span id='fn_starting_time_4i'></span>:<span id='fn_starting_time_5i'></span></strong>, have <strong id='fn_vacancies'></strong> and discount <strong id='fn_discount'></strong>.",
        "confirm": "Save",
        "back": "Back",
        "delete_month_disclaimer": "You are about to delete all departures for the following month, this action is <strong>irreversible</strong>.",
        "vacancies": "vacantes"
      }
    },
    "checkout_bar": {
      "itinerary": "여행 일정",
      "tourists": "그룹",
      "assign_tourists": "배정",
      "checkout": "결제",
      "voucher": "바우처"
    },
    "reviews": {
      "title": "리뷰",
      "more": "더 보기",
      "reviewing_excursion": "상품 리뷰",
      "thanks_for_submitting": "리뷰를 제출해 주셔서 감사합니다",
      "review": "리뷰",
      "footer": "Trustpilot에서 보기"
    },
    "newsletter": {
      "sign_up_at": "파타고니아의 어드벤처 여행 마켓플레이스",
      "we_value_your_privacy": "지속 가능하고 개인화되었으며 모험으로 가득한 경험을 즐기세요",
      "sign_up_now": "지금 가입하기",
      "view_preferences": "환경설정",
      "subscribe_to_our": "뉴스레터 구독",
      "email_address": "이메일 주소",
      "subscribe": "구독",
      "we_are_travel_and_growth": "최고의 투어와 여행으로 칠레와 그 풍경을 발견하세요. 잊을 수 없는 환경에서 좋아하는 일을 하며 현지 경험을 하세요."
    },
    "modal": {
      "first_section": "날짜 선택",
      "product_variants": "옵션 선택",
      "second_section": "승객",
      "no_daily_quota": "이 날짜에는 좌석이 충분하지 않습니다",
      "date": "날짜",
      "wrong_name": "잘못된 이름 또는 비밀번호",
      "per_person": " 1인당",
      "departure_time": "출발:",
      "spot_left": "남은 자리",
      "add_reserves": "게스트 수",
      "select": "선택",
      "select_date": "날짜 선택",
      "select_date_text": "캘린더에서 가능한 날짜를 선택하고 단계에 따라 예약을 생성하세요.",
      "check_in": "체크인",
      "check_out": "체크아웃",
      "guests": "게스트",
      "child_guests": "어린이",
      "guest_text": "13세 이상",
      "child_text": "12세 이하",
      "twins": "트윈",
      "doubles": "더블",
      "doubles_twin": "트윈 2개",
      "add_rooms_for": "방 추가",
      "guest": "게스트",
      "add_to_itinerary": "선택",
      "start": "시작",
      "ends": "종료",
      "leave_your_review": "리뷰 남기기",
      "describe_your_experience": "전체적인 경험 설명",
      "add": "추가",
      "next": "다음",
      "load_earlier_dates": "이전 날짜 로드 ...",
      "load_later_dates": "이후 날짜 로드 ...",
      "is_resident": "칠레 거주자",
      "is_not_resident": "비거주자",
      "language_title": "국가 및 통화 선택",
      "language_subtitle": "목록에서 언어를 선택하세요",
      "currency_subtitle": "통화를 선택하세요",
      "current_language": "국가 및 언어",
      "other_languages": "다른 국가 및 언어"
    },
    "alert": {
      "invalid_changes": "잘못된 변경",
      "invalid_action": "잘못된 작업: 금액은 0보다 작을 수 없습니다",
      "not_enough_availability": "해당 날짜 범위에 충분한 가용성이 없습니다. 다른 숙소를 확인하거나 예약 단위를 줄이세요.",
      "something_went_wrong": "문제가 발생했습니다. 다시 시도하거나 문의해 주세요.",
      "review_already_submitted": "리뷰가 이미 제출되었습니다",
      "couldn't_send_review": "리뷰를 보낼 수 없습니다",
      "you_must_agree_to": "이용 약관에 동의해야 합니다",
      "no_products_in_your_order": "주문에 상품이 없습니다",
      "please_sign_the_waiver": "이름으로 면책 동의서에 서명해 주세요.",
      "signature_and_tourist": "서명과 여행자 이름이 동일해야 합니다.",
      "couldn't_save": "저장할 수 없습니다. 나중에 다시 시도해 주세요.",
      "invalid_language": "잘못된 언어",
      "confirm_to": "로봇이 아님을 확인해야 합니다.",
      "error": "비밀번호는 최소 8자 이상이어야 하며, 문자와 숫자를 하나씩 포함해야 합니다."
    },
    "notice": {
      "your_account_has": "계정에 에이전시가 없습니다. 문의해 주세요",
      "session_expired": "세션이 만료되었습니다. 로그인해 주세요.",
      "changes_submitted": "변경 사항이 제출되었습니다!",
      "new_product_created": "새 상품이 생성되었으며 승인 대기 중입니다",
      "invalid_request": "잘못된 요청입니다. 다시 시도하거나 문의해 주세요.",
      "have_excursions": "에이전시에 여행 상품이 있습니다. 삭제하기 전에 다른 에이전시에 할당하세요",
      "updated_information": "정보가 업데이트되었습니다",
      "date_no_longer": "날짜를 더 이상 사용할 수 없습니다",
      "availability_updated": "가용성이 업데이트되었습니다",
      "review_sent": "리뷰 전송됨!",
      "bookings_made_for": "예약이 성공적으로 완료되었습니다!",
      "profile_picture_updated": "프로필 사진이 업데이트되었습니다!",
      "tourist_information_saved": "정보가 저장되었습니다",
      "enabled": "활성화됨",
      "diabled": "비활성화됨",
      "was": "였습니다",
      "settings_updated": "설정이 업데이트되었습니다!",
      "language_updated": "언어가 업데이트되었습니다!",
      "account_updated": "계정이 업데이트되었습니다!",
      "reserves_added_for": " 예약이 추가되었습니다 ",
      "product_was_enabled": "상품이 활성화되었습니다",
      "product_was_disabled": "상품이 비활성화되었습니다"
    },
    "more": {
      "the_best_products": "Outdoor Index 최고의 경험",
      "all_recommendations_in_puerto_natales": "푸에르토 나탈레스의 모든 경험",
      "all_recommendations_in_punta_arenas": "푼타 아레나스의 모든 경험",
      "all_recommendations_in_zone": "%{zone_name}의 모든 제안",
      "all_adventure_products": "모든 어드벤처 경험",
      "all_standard_products": "모든 변혁적 경험",
      "all_scientific_products": "모든 발견 경험",
      "all_family_products": "모든 가족/그룹 경험",
      "all_luxury_products": "모든 세련된 경험",
      "all_promotions_products": "모든 할인 및 제안 경험",
      "all_ota_products": "모든 OTA 경험",
      "a_selection_of_the_best": "Outdoor Index가 선정한 최고의 경험",
      "other_activities_that": "경험을 보완하는 다른 활동",
      "all_north_patagonia_products": "북부 파타고니아의 모든 상품",
      "all_south_patagonia_products": "남부 파타고니아의 모든 상품",
      "all_lagos_region_products": "호수와 강 지역의 모든 상품"
    },
    "searches": {
      "no_result_to": "죄송합니다. \"%{zone_name}\"의 \"%{category_name}\"에 대한 결과가 없습니다.",
      "recommended_for_you": "\"%{zone_name}\"에서 할 수 있는 경험",
      "category_products_in_zone": "\"%{zone_name}\"의 \"%{category_name}\" 경험",
      "category_products_in_zone_no_result": "죄송합니다. 현재 \"%{zone_name}\"에 \"%{category_name}\" 경험이 없습니다.",
      "all_products_in_zone": "\"%{zone_name}\"의 모든 경험",
      "all_products_in_zone_no_result": "죄송합니다. 현재 \"%{zone_name}\"에 경험이 없습니다.",
      "all_category_products": "모든 \"%{category_name}\" 경험",
      "all_category_products_no_result": "죄송합니다. 현재 \"%{category_name}\" 경험이 없습니다.",
      "please_select_category_or_zone": "카테고리 또는 지역을 선택하세요"
    },
    "guidebook": {
      "download_our_guide_book": "가이드북을 다운로드하고 Outdoor Index와 함께 여행을 시작하세요",
      "find_out_everything": "칠레 남부 파타고니아에 대한 모든 것을 알아보세요."
    },
    "banner": {
      "do_you_need_travel_insurance": "여행자 보험이 필요하십니까?",
      "in_partnership_with_world": "Outdoor Index는 World Nomads와 제휴하여 칠레 파타고니아 최고의 보험을 제공합니다.",
      "get_a_quote": "견적 받기"
    },
    "blog": {
      "meta_title": "칠레 여행·자연·모험 블로그 | Outdoor Index",
      "meta_description": "칠레 여행 가이드, 팁, 영감을 탐색하세요. 아웃도어 여행, 자연과의 교감, 모험 체험을 만나보세요.",
      "travel_nature_growth": "여행, 자연, 성장",
      "we_connect_you_with": "자연, 여행, 성장에 관한 글로벌 콘텐츠. 소셜 미디어에서 팔로우하세요!",
      "breadcrumb_aria": "탐색 경로",
      "breadcrumb_home": "홈",
      "breadcrumb_blog": "블로그",
      "guided_tours": "가이드 투어",
      "book_now": "지금 예약",
      "view_more_activities": "더 많은 액티비티 보기",
      "showing_count": "총 %{total}개 중 %{loaded}개 기사 표시",
      "pagination_aria": "블로그 페이지네이션",
      "page_n": "%{n}페이지"
    },
    "mail": {
      "welcome_user_name": "%{user_name}님, Outdoor Index에 오신 것을 환영합니다",
      "leave_your_review": "%{user_name}님, 경험에 대한 리뷰를 남겨주세요",
      "voucher": {
        "your_order_is_ready": "구매해 주셔서 감사합니다. 주문 번호는 %{reference_code}입니다",
        "your_sold_product": "안녕하세요 %{user_provider}님, 경험 중 하나가 판매되었습니다",
        "new_sold": "새로운 판매 %{reference_code}"
      }
    },
    "paypal": {
      "description": "Outdoor Index: 주문 결제 %{reference_code}"
    },
    "payu": {
      "description": "Outdoor Index: 주문 결제 %{reference_code}"
    },
    "pdf": {
      "emergency_contacts": "비상 연락처",
      "congratulations_user_name": "축하합니다 %{user_name}",
      "congratulations_agency_name": "축하합니다 %{agency_name}",
      "here_we_attach": "여기에 여행에 대한 모든 정보를 첨부합니다. 이 바우처에는 상품 상세 내역, 공급업체 연락처, 서명된 면책 동의서, 결제된 상품 영수증(Paypal 또는 PayU)이 포함되어 있습니다. 궁금한 점이 있으면 언제든지 문의해 주세요.",
      "reservation_number": "예약 번호:",
      "product_detail": "상품 상세",
      "departure": "출발",
      "your_suppliers": "공급업체",
      "in_this_section_appear": "이 섹션에는 Outdoor Index에서 받은 결제 내역이 표시됩니다. 이 바우처를 인쇄하여 항상 소지하시기 바랍니다. Outdoor Index를 선택해 주셔서 대단히 감사합니다",
      "payments_detail": "결제 내역",
      "initial_payment": "초기 결제",
      "payment_method": "결제 방법",
      "total_paid": "총 결제 금액",
      "total_order": "주문 총액:",
      "order_date": "주문 날짜",
      "payment_date": "결제 날짜",
      "payment_type": "결제 유형",
      "payment_complete": "결제 완료",
      "print_this_voucher": "이 바우처를 인쇄하여 여행 중 항상 소지하세요",
      "at_all_times": "여행 중 항상.",
      "you_check": "체크인 시 제시하세요.",
      "we_have_received": "상품에 대한 새로운 예약 요청을 받았습니다. 아래는 이에 대한 세부 정보와 승객 정보입니다. 이제부터 승객에게 직접 연락하거나 원하는 경우 Outdoor Index에 연락하도록 지시할 수 있습니다. 예약이 성공적으로 완료되었음을 알리는 이메일을 보내는 것이 좋습니다. 좋은 공급업체로 돋보일 것입니다. 초과 예약 문제가 발생하지 않도록 자체 시스템에서 예약 할당량을 업데이트하는 것을 잊지 마세요. 수고하셨습니다!",
      "guests": "게스트",
      "your_guests": "귀하의 게스트",
      "date_of_birth": "생년월일:",
      "origin": "출신지:",
      "document_number": "문서 번호:",
      "phone": "전화",
      "email": "이메일",
      "emergency_number": "비상 전화:",
      "allergies": "알레르기:",
      "medical_conditions": "의료 상태:",
      "food_restrictions": "음식 제한:",
      "dear_user_name": "친애하는 %{user_name}님",
      "service_confirmation": "서비스 확인",
      "according_to_the_reservation": "귀하의 예약 요청에 따라 다음 정보를 확인합니다:",
      "reference_code": "참조 코드",
      "activity": "활동",
      "starting_point": "장소",
      "starting_date": "시작 날짜",
      "starting_time": "시작 시간",
      "client": "클라이언트",
      "excursion": "활동 %{number}",
      "payment_details": "결제 세부 정보",
      "applied": "적용됨",
      "next_payment": "다음 결제 (70%)",
      "purchase_date": "구매 날짜",
      "description": "설명",
      "unit_price": "단가",
      "unit_price_child": "어린이 단가",
      "childen_pax": "어린이",
      "pax": "인원",
      "tax": "세금",
      "about_your_host": "호스트 소개",
      "name": "담당자:",
      "address": "주소:",
      "from": "서비스 시작 날짜",
      "to": "서비스 종료 날짜",
      "tourists": "관광객 정보",
      "guest": "게스트",
      "child_guest": "어린이",
      "guest_price": "게스트 가격",
      "child_guest_price": "어린이 가격",
      "resident": "거주자",
      "no_resident": "비거주자",
      "problem_with_order": "주문에 문제가 있습니까?",
      "complete_remaining_payment_web": "잔액을 결제하려면 outdoorindex.cl에 로그인한 뒤 바우처에서 이 주문을 여세요.",
      "contact_us": "문의하기",
      "guest_s": "게스트",
      "child_guests": "어린이",
      "child_guest_s": "어린이"
    },
    "currency": {
      "displaying_prices_in": "통화 환전 완료!"
    },
    "tourists": {
      "first_create_group": "이런! 승객 정보를 입력하는 것을 잊지 마세요."
    },
    "date": {
      "formats": {
        "default": "%Y/%m/%d",
        "short": "%Y년 %m월 %d일",
        "long": "%Y년 %m월 %d일",
        "calendar_picker": "YYYY/MM/DD",
        "fixed_departure": "YYYY/M/DD",
        "moment": "%Y-%m-%d"
      }
    },
    "time": {
      "formats": {
        "default": "%Y/%m/%d",
        "short": "%Y년 %m월 %d일",
        "long": "%Y년 %m월 %d일",
        "full": "%Y년 %m월 %d일 %a",
        "calendar_picker": "YYYY/MM/DD"
      }
    },
    "activities": {
      "trekking": "트레킹",
      "horseback": "승마",
      "birdwatching": "조류 관찰",
      "mountaineering": "등산",
      "icehike": "아이스 하이킹",
      "kayak": "카약",
      "flyfishing": "플라이 낚시",
      "navigations": "항해",
      "cruises": "크루즈",
      "helicopter": "헬리콥터",
      "multiactivity": "멀티 액티비티",
      "photosafari": "포토 사파리",
      "bikes": "자전거",
      "snowshoes": "스노슈잉",
      "ski": "스키",
      "rafting": "래프팅"
    },
    "filters": {
      "clear_filters": "필터 지우기"
    },
    "lang": {
      "countries": {
        "spain": "스페인",
        "argentina": "아르헨티나",
        "bolivia": "볼리비아",
        "chile": "칠레",
        "colombia": "콜롬비아",
        "costa_rica": "코스타리카",
        "ecuador": "에콰도르",
        "mexico": "멕시코",
        "peru": "페루",
        "paraguay": "파라과이",
        "uruguay": "우루과이",
        "united_states": "미국",
        "england": "영국",
        "australia": "호주",
        "canada": "캐나다",
        "new_zealand": "뉴질랜드",
        "ireland": "아일랜드",
        "portugal": "포르투갈",
        "brazil": "브라질",
        "france": "프랑스",
        "germany": "독일",
        "china": "중국",
        "hong_kong": "홍콩",
        "japan": "일본",
        "korea": "한국",
        "singapore": "싱가포르",
        "taiwan": "대만"
      }
    }
  }
};
